'use strict';

(function () {
    'use strict';

    angular.module('app.service', []);
    angular.module('app.directive', []);
    angular.module('app.filter', ['ngSanitize']);
    angular.module('app', ['ui.bootstrap', 'ngMessages', 'ngAnimate', 'angular-loading-bar', 'ngTouch', 'ngRoute', 'pascalprecht.translate', 'ngSanitize', 'datePicker', 'vcRecaptcha', 'treeControl', 'blockUI', "com.2fdevs.videogular", "com.2fdevs.videogular.plugins.controls", "com.2fdevs.videogular.plugins.overlayplay", "com.2fdevs.videogular.plugins.poster", 'app.service', 'app.directive', 'app.filter']).constant('finacialLicicense', true).constant('sysCode', 'MHR').constant('_sessionDecaySecs', 1200000).config(toastrConfig).config(execptionConfig).config(translateConfig).config(httpConfig).config(blockUIConfig).config(['$locationProvider', function ($locationProvider) {
        $locationProvider.hashPrefix('');
    }]);

    function toastrConfig() {
        toastr.options = {
            'closeButton': true,
            'onclick': null,
            'showDuration': '300',
            'hideDuration': '1000',
            'timeOut': '4000',
            'progressBar': true,
            'positionClass': 'toast-top-right',
            'preventDuplicates': true,
            'newestOnTop': true
        };
    }

    function blockUIConfig(blockUIConfig) {
        // Disable automatically blocking of the user interface
        blockUIConfig.autoBlock = false;
        // Change the default delay to 100ms before the blocking is visible 
        blockUIConfig.delay = 100;
        // Provide a custom template to use
        blockUIConfig.template = '\n        <div class=\'block-ui-overlay\'></div>\n        <div class=\'block-ui-message-container\' aria-live=\'assertive\' aria-atomic=\'true\'>\n\n            <div class="spinner">\n                <div class="bounce1"></div>\n                <div class="bounce2"></div>\n                <div class="bounce3"></div>\n            </div>\n            <!-- <div class=\'block-ui-message\' ng-class=\'$_blockUiMessageClass\'>\n                {{ state.message }}\n            </div> -->\n        </div>\n        ';
    }

    function execptionConfig($provide, apiUrl) {
        $provide.decorator('$exceptionHandler', function ($delegate) {
            return function (exception, cause) {
                $delegate(exception, cause);
                postException(exception, apiUrl);
            };
        });
    }

    function translateConfig($translateProvider, apiUrl) {

        if (!sessionStorage.getItem('userLang')) {

            getDefaultUserLang(apiUrl.tsApi, navigator.systemLanguage).done(function (data) {

                var userLang = data;
                sessionStorage.setItem('userLang', _.replace(userLang, '_', '-'));
                sessionStorage.setItem('langCode', getLangCode(userLang));

                $translateProvider.useSanitizeValueStrategy('escapeParameters');
                $translateProvider.preferredLanguage(sessionStorage['userLang']);
                $translateProvider.useUrlLoader(apiUrl.tsApi + 'getTranslationResource');
            });
        } else {
            $translateProvider.useSanitizeValueStrategy('escapeParameters');
            $translateProvider.preferredLanguage(sessionStorage['userLang']);
            $translateProvider.useUrlLoader(apiUrl.tsApi + 'getTranslationResource');
        }
    }

    function httpConfig($httpProvider) {
        $httpProvider.interceptors.push('httpInterceptor');
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').config(ngRouteConfig);

    function ngRouteConfig($routeProvider) {
        $routeProvider.when('/', {
            templateUrl: 'controller/home/home.index.html',
            controller: 'homeController as vm',
            resolve: {
                viewModel: function viewModel(homeService) {
                    return homeService.getMhr();
                }
            }
        }).when('/login', {
            controller: 'loginController as vm',
            templateUrl: 'controller/login/login.index.html',
            resolve: {
                viewModel: function viewModel(loginService) {
                    return loginService.get();
                }
            }
        }).when('/token:token', {
            controller: 'rootController as vm'
        }).when('/verifyCode/:verifyCode/:email/:sysCode', {
            controller: 'verifyCodeController as vm',
            templateUrl: 'controller/login/login.verifyCode.html'
        }).when('/login/forceEditPwd', {
            controller: 'loginForceEditPwdController as vm',
            templateUrl: 'controller/login/login.forceEditPwd.html'
        }).when('/login/directEditPwd/:userAccount/:verifyCode/:mobilTel?', {
            controller: 'loginDirectEditPwdController as vm',
            templateUrl: 'controller/login/login.directEditPwd.html'
        }).when('/login/forgetPwdDirectEditPwd/:userAccount/:verifyCode', {
            templateUrl: 'controller/login/login.forgetPwdDirectEditPwd.html',
            controller: 'loginForgetPwdDirectEditPwdController as vm'
        }).when('/tsu/', {
            controller: 'tsunHomeController as vm',
            templateUrl: 'controller/tsun/home/home.index.html',
            resolve: {
                viewModel: function viewModel(homeService) {
                    return homeService.getTsu();
                }
            }
        }).when('/tsu/course', {
            templateUrl: 'controller/tsun/training/course/course.index.html',
            controller: 'tsunCourseController as vm',
            resolve: {
                // translate: function (translateService) {
                //     return translateService.getTranslates()
                //         .then(function (data) { return data; });
                // },
                userInfo: function userInfo(loginService, $rootScope) {
                    return loginService.getSsoInfo().then(function (data) {
                        $rootScope.userInfo = data.data;
                        return $rootScope.userInfo;
                    });
                },
                urlParam: function urlParam($routeParams) {
                    return $routeParams;
                }
            }
        }).when('/tsu/training', {
            templateUrl: 'controller/tsun/training/myTraining/myTraining.index.html',
            controller: 'tsunMyTrainingController as vm',
            resolve: {
                // translate: function (translateService) {
                //     return translateService.getTranslates()
                //         .then(function (data) { return data; });
                // },
                ssoInfo: function ssoInfo(loginService, $rootScope) {
                    return loginService.getSsoInfo().then(function (data) {
                        $rootScope.userInfo = data.data;
                        return data.data;
                    });
                }
            }
        }).when('/tsu/shoppingCart', {
            templateUrl: 'controller/tsun/training/courseCollection/shoppingCart.index.html',
            controller: 'tsunShoppingCartController as vm',
            resolve: {
                // translate: function (translateService) {
                //     return translateService.getTranslates()
                //         .then(function (data) { return data; });
                // },
                ssoInfo: function ssoInfo(loginService, $rootScope) {
                    return loginService.getSsoInfo().then(function (data) {
                        $rootScope.userInfo = data.data;
                        return data.data;
                    });
                }
            }
        }).when('/tsu/recommend2', {
            templateUrl: 'controller/tsun/training/recommend/recommend.index.html',
            controller: 'tsunRecommendController as vm',
            resolve: {
                // translate: function (translateService) {
                //     return translateService.getTranslates()
                //         .then(function (data) { return data; });
                // },
                activeType: function activeType() {
                    return 2;
                }
            }
        }).when('/tsu/recommend3', {
            templateUrl: 'controller/tsun/training/recommend/recommend.index.html',
            controller: 'tsunRecommendController as vm',
            resolve: {
                // translate: function (translateService) {
                //     return translateService.getTranslates()
                //         .then(function (data) { return data; });
                // },
                activeType: function activeType() {
                    return 3;
                }
            }
        }).when('/tsu/recommendHTML', {
            templateUrl: 'controller/tsun/training/recommend/recommend.Doc.html',
            controller: 'tsunRecommendDocController as vm',
            resolve: {}
        }).when('/tsu/visualpage/:pageSerilNo', {
            templateUrl: 'controller/tsun/visualpage/visualpage.index.html',
            controller: 'visualpageController as vm',
            resolve: {
                viewModel: function viewModel(visualPageService, $route) {
                    return visualPageService.get($route.current.params.pageSerilNo);
                }
            }
        }).when('/tsu/bulletin/more', {
            templateUrl: 'controller/tsun/bulletin/bulletin.more.html',
            controller: 'tsunBulletinMoreController as vm',
            resolve: {
                viewModel: function viewModel(bulletinService) {
                    return bulletinService.getNoticeMore();
                }
            }
        }).when('/tsu/bulletin/noticeDetail/:no?/:isBulletin?', {
            templateUrl: 'controller/tsun/bulletin/bulletin.noticeDetail.html',
            controller: 'tsunBulletinNoticeDetailController as vm',
            resolve: {
                viewModel: function viewModel(bulletinService, $route) {
                    return bulletinService.getByNoForTsun($route.current.params.no);
                }
            }
        }).when('/bulletin/more/:isHistory?', {
            templateUrl: 'controller/bulletin/bulletin.more.html',
            controller: 'bulletinMoreController as vm',
            resolve: {
                viewModel: function viewModel(bulletinService, enumService, $route) {
                    return bulletinService.getMore(enumService.siteCode.hrOutside, $route.current.params.isHistory);
                }
            }
        }).when('/bulletin/detail/:no', {
            templateUrl: 'controller/bulletin/bulletin.detail.html',
            controller: 'bulletinDetailController as vm',
            resolve: {
                viewModel: function viewModel(bulletinService, $route) {
                    return bulletinService.getByNo($route.current.params.no);
                }
            }
        }).when('/header/searchResult/:keyword?/:siteCode?', {
            templateUrl: 'controller/header/header.searchResult.html',
            controller: 'headerSearchResultController as vm',
            resolve: {
                viewModel: function viewModel(headerService, $route) {
                    return headerService.getSearchResult($route.current.params.keyword, 1 /*page*/, 1 /*all*/, $route.current.params.siteCode, true /*need Keyword Log*/);
                },
                siteCode: function siteCode($route) {
                    return $route.current.params.siteCode;
                }
            }
        }).when('/schedule', {
            templateUrl: 'controller/schedule/schedule.index.html',
            controller: 'scheduleController as vm',
            resolve: {
                viewModel: function viewModel(scheduleService) {
                    return scheduleService.getCalendarArea();
                }
            }
        }).when('/nextMenu', {
            templateUrl: 'controller/nextMenu/nextMenu.index.html',
            controller: 'nextMenuController as vm',
            resolve: {
                viewModel: function viewModel(homeService) {
                    return homeService.getNext();
                }
            }
        }).when('/nextMenu/detail/:no', {
            templateUrl: 'controller/nextMenu/nextMenu.detail.html',
            controller: 'nextMenuDetailController as vm',
            resolve: {
                viewModel: function viewModel(bulletinService, $route) {
                    return bulletinService.getByNo($route.current.params.no);
                }
            }
        }).when('/mobile/trigger/', {
            templateUrl: 'controller/mobile/mobile.trigger.html',
            controller: 'mobileTriggerController as vm'
        }).when('/common/index/', {
            templateUrl: 'controller/common/common.index.html',
            controller: 'commonController as vm'
        }).when('/external', {
            templateUrl: 'controller/external/external.index.html',
            controller: 'externalController as vm'
        }).when('/external/schemaTransfer', {
            templateUrl: 'controller/external/external.schemaTransfer.html',
            controller: 'externalSchemaTransferController as vm'
        }).otherwise({
            redirectTo: '/'
        });
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').run(run);

    function run($rootScope, $location, $uibModalStack) {

        $rootScope.$on('$routeChangeStart', function (event, current) {

            $('#taishinExternal').empty().remove();
            $('#captcha iframe').empty().remove();

            // 如果登入後到 login 頁需要轉到預設頁面
            // 是參考 taiHeader.directive 的判斷登入邏輯
            var isLogin = !_.isEmpty(sessionStorage.getItem('perSerilNo')) && !sessionStorage.getItem('isForce');
            var currentPage = current.originalPath;
            if (currentPage === '/login' && isLogin) {
                $location.path('/').search({});
            }
        });

        $rootScope.$on('$routeChangeSuccess', function (event, current) {

            // When the user clicks on the button, scroll to the top of the document
            document.body.scrollTop = 0; // For Chrome, Safari and Opera 
            document.documentElement.scrollTop = 0; // For IE and Firefox


            $(".ui-blackCover").css("display", "none");

            // 移除目前所有 modal 視窗 (避免殘存) 
            $uibModalStack.dismissAll();

            // 解決表單有時在IE無法輸入問題
            fixIeNotAbleToInput();

            var isForce = sessionStorage.getItem('isForce');
            var currentPage = current.originalPath;
            //var prevPage = prev ? prev.originalPath : null;
            $rootScope.cName = sessionStorage.getItem('cName');

            if (isForce) {
                $location.path('/login/forceEditPwd');
            } else {
                if (currentPage === '/login/forceEditPwd' && !isForce) {
                    $location.path('/login');
                }
            }

            if (currentPage === '/' && !sessionStorage.getItem('token')) {
                $location.path('/login').search({});
            }
        });
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').constant('isTestMode', false).constant('iAmNotRobot', true).constant('apiUrl', {
        tsApi: '//hr.taishinholdings.com.tw/api/',
        ssoApi: '//hr.taishinholdings.com.tw/sso/api/',
        ctmsApi: '//hr.taishinholdings.com.tw/ap/ctms/',
        pafUrl: '//hr.taishinholdings.com.tw/hrapp/TSDG_PDF_Web/?pdf='
    });
})();
'use strict';

var DEVICE_TYPE = null; //手機裝置才會給予內容值
var DEVICE_TOKEN = null; //手機裝置才會給予內容值
var DEVICE_ID = null; //手機裝置才會給予內容值
var USER_ID = null; //手機裝置才會給予內容值
//2023-07-10 Johnson 資安2023
var PWD = eval(function (p, a, c, k, e, r) {
    e = String;if (!''.replace(/^/, String)) {
        while (c--) {
            r[c] = k[c] || c;
        }k = [function (e) {
            return r[e];
        }];e = function e() {
            return '\\w+';
        };c = 1;
    };while (c--) {
        if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
    }return p;
}('0;', 2, 1, 'null'.split('|'), 0, {})); //手機裝置才會給予內容值
var APP_VERSION = -1; //
var IOS_VERSION = null;

function setSsoInfo(data) {
    sessionStorage.setItem('token', data.Token);
    sessionStorage.setItem('cName', data.CName);
    sessionStorage.setItem('perSerilNo', data.PerSerilNo || data.PerserilNo);
}

function removeSsoInfo() {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('perSerilNo');
    sessionStorage.removeItem('cName');
    sessionStorage.removeItem('isForce');
}

var errorMsgs = [];

// 判斷相同錯誤是否已經提報伺服端
// 避免無窮迴圈的錯誤不斷發送攻擊
function isAlreadyReport(mewMsg) {
    if (errorMsgs.length > 0) {
        for (var index = 0; index < errorMsgs.length; index++) {
            var msg = errorMsgs[index];
            if (msg == mewMsg) {
                return true;
            }
        }
    }
    return false;
}

//filter the exception that no use
var isNoUseErrors = ['$digest already in progress'];

function isNoUseError(msg) {
    var result = false;
    for (var i = 0; i <= isNoUseErrors.length - 1; i++) {
        if (msg.indexOf(isNoUseErrors[i]) > -1) {
            result = true;
            break;
        }
    }
    return result;
}

function postException(exception, apiUrl) {
    var param = {
        exception: exception,
        route: location.href,
        perSerilNo: sessionStorage.getItem('perSerilNo')
    };

    // 發送到後端記錄錯誤LOG (重複的LOG就不要再直直送了)
    if (isAlreadyReport(param.exception) == false && !isNoUseError(param.exception)) {
        errorMsgs.push(param.exception);

        console.log("call postException");
        //console.log(data);

        // 20181002 停止使用前端 Log 機制，因為無意義的錯誤紀錄會造成誤解，此外也無法透過此機制得到任何除錯幫助
        // $.post(apiUrl.tsApi + 'log/PostFront', param).then(function(data) {
        //     //console.log("call postException ["+apiUrl.tsApi + 'log/PostFront'+"],result:", data);
        // });
    }
}

function queryString(name) {
    // console.log("queryString");
    // console.log("location.href",location.href);
    //2023-07-10 Johnson 資安2023
    var AllVars = eval(function (p, a, c, k, e, r) {
        e = function e(c) {
            return c.toString(a);
        };if (!''.replace(/^/, String)) {
            while (c--) {
                r[e(c)] = k[c] || e(c);
            }k = [function (e) {
                return r[e];
            }];e = function e() {
                return '\\w+';
            };c = 1;
        };while (c--) {
            if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
        }return p;
    }('3.4.5(\'?\')[1].0(/</2,\'&6\').0(/>/2,\'&7\').0(/"/2,\'&8\').0(/\'/2,\'&#9\').0(/[<>!]|(\\(\\))|((a|b|c)\\d*\\(.*\\))/2,\'\')', 14, 14, 'replace||g|location|href|split|lt|gt|quot|x27|for|while|if|s'.split('|'), 0, {}));
    var Vars = AllVars.split('&');
    for (var i = 0; i < Vars.length; i++) {
        var Var = Vars[i].split("=");
        if (Var[0] == name) {
            return Var[1];
        }
    }
    return "";
}

function getMenuQueryString() {
    if (location.href.split('menu=').length > 1) {
        return location.href.split('menu=')[1];
    }
    return undefined;
}

function showSystemError() {
    var errorMessage;
    switch (sessionStorage['userLang']) {
        case 'zh-TW':
            errorMessage = '很抱歉！此頁面發生了一些錯誤，系統已自動通知網站管理員，將儘速為您處理，請您稍後再使用本功能。';
            break;
        case 'zh-CN':
            errorMessage = '很抱歉！此页面发生了一些错误，系统已自动通知网站管理员，将尽速为您处理，请您稍后再使用本功能。 ';
            break;
        case 'en-US':
            errorMessage = 'very sorry! Some errors occurred on this page, the system automatically notify your webmaster will process as soon as possible for you, please try again later with this function. ';
            break;
    }

    toastr.error(errorMessage);
}
// function getDefaultLangCode() {
//     var langSerilNo = 1;
//     var userLang = navigator.language || navigator.userLanguage;
//     sessionStorage.setItem('userLang', userLang);
//     userLang = _.replace(userLang, '_', '-');
//     switch (userLang.toLowerCase()) {
//         case 'zh-cn':
//             langSerilNo = 2;
//             break;
//         case 'en-us':
//             langSerilNo = 3;
//             break;
//         case 'zh-tw':
//             langSerilNo = 1;
//             break;
//     }
//     sessionStorage.setItem('langCode', langSerilNo);
//     return langSerilNo;
// }

function getLangCode(userLang) {

    var langSerilNo = 1;
    sessionStorage.setItem('userLang', userLang);
    userLang = _.replace(userLang, '_', '-');
    switch (userLang.toLowerCase()) {
        case 'zh-cn':
            langSerilNo = 2;
            break;
        case 'en-us':
            langSerilNo = 3;
            break;
        case 'zh-tw':
            langSerilNo = 1;
            break;
    }
    sessionStorage.setItem('langCode', langSerilNo);
    return langSerilNo;
}

function getDefaultUserLang(tsApiUrl, ieSystemLang) {
    return jQuery.ajax({
        type: "GET",
        url: tsApiUrl + 'header/acceptSupportedLanguage?ieSystemLang=' + ieSystemLang,
        async: false
    });
}

function intConvertTime(intTimeSpan) {
    var sec_num;
    try {
        sec_num = parseInt(intTimeSpan, 10); // don't forget the second param
    } catch (exp) {
        sec_num = 0;
    }
    var hours = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - hours * 3600) / 60);
    var seconds = sec_num - hours * 3600 - minutes * 60;

    if (hours < 10) {
        hours = "0" + hours;
    }
    if (minutes < 10) {
        minutes = "0" + minutes;
    }
    if (seconds < 10) {
        seconds = "0" + seconds;
    }
    return hours + ':' + minutes + ':' + seconds;
}

function appCallback(method, params) {
    var Base64 = {
        _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
        encode: function encode(e) {
            var t = "";
            var n, r, i, s, o, u, a;
            var f = 0;
            e = Base64._utf8_encode(e);
            while (f < e.length) {
                n = e.charCodeAt(f++);
                r = e.charCodeAt(f++);
                i = e.charCodeAt(f++);
                s = n >> 2;
                o = (n & 3) << 4 | r >> 4;
                u = (r & 15) << 2 | i >> 6;
                a = i & 63;
                if (isNaN(r)) {
                    u = a = 64;
                } else if (isNaN(i)) {
                    a = 64;
                }
                t = t + this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
            }
            return t;
        },
        decode: function decode(e) {
            var t = "";
            var n, r, i;
            var s, o, u, a;
            var f = 0;
            e = e.replace(/[^A-Za-z0-9+/=]/g, "");
            while (f < e.length) {
                s = this._keyStr.indexOf(e.charAt(f++));
                o = this._keyStr.indexOf(e.charAt(f++));
                u = this._keyStr.indexOf(e.charAt(f++));
                a = this._keyStr.indexOf(e.charAt(f++));
                n = s << 2 | o >> 4;
                r = (o & 15) << 4 | u >> 2;
                i = (u & 3) << 6 | a;
                t = t + String.fromCharCode(n);
                if (u != 64) {
                    t = t + String.fromCharCode(r);
                }
                if (a != 64) {
                    t = t + String.fromCharCode(i);
                }
            }
            t = Base64._utf8_decode(t);
            return t;
        },
        _utf8_encode: function _utf8_encode(e) {
            e = e.replace(/rn/g, "n");
            var t = "";
            for (var n = 0; n < e.length; n++) {
                var r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r);
                } else if (r > 127 && r < 2048) {
                    t += String.fromCharCode(r >> 6 | 192);
                    t += String.fromCharCode(r & 63 | 128);
                } else {
                    t += String.fromCharCode(r >> 12 | 224);
                    t += String.fromCharCode(r >> 6 & 63 | 128);
                    t += String.fromCharCode(r & 63 | 128);
                }
            }
            return t;
        },
        _utf8_decode: function _utf8_decode(e) {
            var t = "";
            var n = 0;
            var r = c1 = c2 = 0;
            while (n < e.length) {
                r = e.charCodeAt(n);
                if (r < 128) {
                    t += String.fromCharCode(r);
                    n++;
                } else if (r > 191 && r < 224) {
                    c2 = e.charCodeAt(n + 1);
                    t += String.fromCharCode((r & 31) << 6 | c2 & 63);
                    n += 2;
                } else {
                    c2 = e.charCodeAt(n + 1);
                    c3 = e.charCodeAt(n + 2);
                    t += String.fromCharCode((r & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                    n += 3;
                }
            }
            return t;
        }
    };
    var encParams = Base64.encode(JSON.stringify(params));
    if (method.match('CloseWebView')) {
        method = 'CloseWebView';
    };
    var tmpFrame = document.createElement("frame");
    document.documentElement.appendChild(tmpFrame);
    tmpFrame.src = "app://[method]?p=[params]".replace("[method]", method).replace("[params]", encParams);
    setTimeout(function () {
        document.documentElement.removeChild(tmpFrame);
    }, 0);
}

function p(jstr) {
    try {
        return JSON.parse(jstr);
    } catch (e) {
        return {};
    };
}

function fixIeNotAbleToInput() {
    var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';


    setTimeout(function () {
        $(selector + ' input').each(function () {
            // $(this).attr("placeholder", window.location);
            // $(this).css({ "background-color": "blue" });
            $(this).focus(function () {
                $(this).select();
            });
        });

        $(selector + ' textarea').each(function () {
            // $(this).attr("placeholder", window.location);
            // $(this).css({ "background-color": "blue" });
            $(this).focus(function () {
                $(this).select();
            });
        });
    }, 500);
}

function infoDebug(msg) {
    var param = {
        Command: msg
    };
    window.webkit.messageHandlers.msgHandler.postMessage(JSON.stringify(param));
}
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('rootCtrl', rootCtrl);

    function rootCtrl($q, $location, $rootScope, $timeout, modalService, loginService, headerService, sysCode, translateService, $window, $scope, trainingInnerService, mobileService) {
        var vm = this;
        vm.view = {
            loaded: false //檢查是否將必要資源讀取完畢
        };
        vm.getBodyClass = getBodyClass;
        vm.appVersion = null;
        vm.appCurrentVersion = null;
        vm.getDeviceInfo = getDeviceInfo;
        vm.updateConfirmWording = null;
        vm.conAppVer = null;
        vm.conCurVer = null;

        var mobile = {
            Android: function Android() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function BlackBerry() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function iOS() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function Opera() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function Windows() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function any() {
                return mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows();
            }
        };

        onInit();
        eventBus();

        function onInit() {
            var promiseList = [loadTranslate(), loadSsoInfo()];
            $q.all(promiseList).then(function () {
                vm.view.loaded = true;
            });

            //只在首頁判斷版本
            if (mobile.iOS() && window.webkit) {
                //if (true) {
                getDeviceInfo();
                //console.log('appVer:',APP_VERSION);
                //console.log('AppUpdateRemind:',sessionStorage.getItem('AppUpdateRemind'));
                if (!sessionStorage.getItem('AppUpdateRemind')) {
                    sessionStorage.setItem('AppUpdateRemind', 'N');
                }
                console.log('AppUpdateRemind:', sessionStorage.getItem('AppUpdateRemind'));
                if (sessionStorage.getItem('AppUpdateRemind') && sessionStorage.getItem('AppUpdateRemind') === 'N') {
                    //getDeviceInfo那邊設定3秒call 6 次，這邊改為5秒後再執行版本確認
                    setTimeout(function () {
                        checkAppVersion();
                    }, 5000);
                }
            }

            // 外網沒有這個需求 所以不用處理跨系統轉 token 這類事情
            // 也可以避免分享網址時 就在別人家的瀏覽器自動登入了
            // checkTokenFromOtherDomain();

            try {
                self.moveTo(0, 0);
                self.resizeTo(screen.availWidth, screen.availHeight);
            } catch (e) {
                // 不是重要的功能(失效也不會影響網站功能)
                // 在IE有時候不知道為什麼會造成錯誤，讓畫面無法繼續進行
                // 所以針對此問題先隱蔽
            }

            setUrl();
            setFontSize();
            $rootScope.styleUrl = '/css/edit.css';
            $rootScope.isTest = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
            checkSmallView();
        }

        function loadTranslate() {
            return translateService.getTranslates().then(function (data) {
                //console.log(data.iosAppUpdateConfirm);
                vm.updateConfirmWording = data.iosAppUpdateConfirm;
                $rootScope.translate = data;
                return true;
            });
        }

        function loadSsoInfo() {}

        function checkSmallView() {
            if ($window.innerWidth < 470) {
                $rootScope.isSmallView = true;
            } else {
                $rootScope.isSmallView = false;
            }
        }

        function checkTokenFromOtherDomain() {
            //undone 跨token的部份
            var originUrl = location.href.split('?tkn=')[0];
            var urlSearch = location.href.split('?tkn=')[1];
            if (urlSearch) {
                var getToken = queryString('tkn');
                var getMenu = queryString('menu');
                var isMobile = queryString('isMobile');
                if (isMobile) {
                    // sessionStorage.setItem('isMobile', true);
                }
                if (getToken) {
                    // removeSsoInfo();
                    getToken = getToken === undefined ? sessionStorage.getItem('token') : getToken;
                    sessionStorage.setItem('token', getToken);
                    var params = {
                        token: getToken,
                        sysCode: sysCode
                    };
                    loginService.checkToken(params).then(function (data) {
                        removeSsoInfo();
                        if (data.data) {
                            data.data.Token = getToken;
                            setSsoInfo(data.data);
                            translateService.getLanguage().then(function (languageItems) {
                                var defaultLangItem = _.find(languageItems.data, {
                                    selected: true
                                });
                                translateService.change(defaultLangItem).then(function () {
                                    if (getMenu) {
                                        $window.location.href = originUrl + '?menu=' + getMenu;
                                    } else {
                                        $window.location.href = originUrl;
                                    }
                                });
                            });
                        }
                    });
                }
            } else {
                if (location.href.indexOf('&isMobile=') > -1) {
                    originUrl = location.href.split('?menu=')[0];
                    // sessionStorage.setItem('isMobile', queryString('isMobile'));
                    //2023-07-10 Johnson 資安2023
                    location.href = eval(function (p, a, c, k, e, r) {
                        e = function e(c) {
                            return c.toString(a);
                        };if (!''.replace(/^/, String)) {
                            while (c--) {
                                r[e(c)] = k[c] || e(c);
                            }k = [function (e) {
                                return r[e];
                            }];e = function e() {
                                return '\\w+';
                            };c = 1;
                        };while (c--) {
                            if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                        }return p;
                    }('3+\'?2=\'+4(\'2\').0(/</1,\'&5\').0(/>/1,\'&6\').0(/"/1,\'&7\').0(/\'/1,\'&#8\').0(/[<>!]|(\\(\\))|((9|a|b)\\c*\\(.*\\))/1,\'\')', 13, 13, 'replace|g|menu|originUrl|queryString|lt|gt|quot|x27|for|while|if|s'.split('|'), 0, {}));
                }
                translateService.getLanguage().then(function (languageItems) {
                    var defaultLangItem = _.find(languageItems.data, {
                        selected: true
                    });
                    translateService.change(defaultLangItem);
                });
            }
        }

        function setUrl() {
            var checkList = {
                ctmsFileUrl: sessionStorage.getItem('ctmsFileUrl'),
                mhrFileUrl: sessionStorage.getItem('mhrFileUrl'),
                VcUrl: sessionStorage.getItem('VcUrl')
            };
            headerService.getUrlSetting().then(function (data) {
                _.forEach(checkList, function (checkItem, key) {
                    switch (key) {
                        case 'ctmsFileUrl':
                            sessionStorage.setItem('ctmsFileUrl', data.data.ctmsFileUrl);
                            break;
                        case 'mhrFileUrl':
                            sessionStorage.setItem('mhrFileUrl', data.data.mhrFileUrl);
                            break;
                        case 'VcUrl':
                            if (data.data.vcUrl.indexOf(location.protocol) == -1) {
                                if (location.protocol == "https:") sessionStorage.setItem('VcUrl', data.data.vcUrl.replace("http:", location.protocol));else sessionStorage.setItem('VcUrl', data.data.vcUrl.replace("https:", location.protocol));
                            } else sessionStorage.setItem('VcUrl', data.data.vcUrl);

                            break;
                        default:
                            checkItem = 'empty';
                            break;
                    }
                });
            });
            console.log(sessionStorage.getItem('VcUrl'));
        }

        function setFontSizeProcess(fontsize) {
            switch (fontsize) {
                case 14:
                    vm.fontSizeClass = 'small';
                    break;
                case 16:
                    vm.fontSizeClass = 'medium';
                    break;
                case 18:
                    vm.fontSizeClass = 'big';
                    break;
                default:
                    //use recursive to process default;
                    if (fontsize < 14) {
                        setFontSizeProcess(14);
                    } else if (fontsize > 14) {
                        setFontSizeProcess(18);
                    } else {
                        setFontSizeProcess(14);
                    }
                    break;
            }
        }

        function setFontSize() {
            $rootScope.$watch('fontSize', function (newValue) {
                if (newValue) {
                    if (_.isString(newValue)) {
                        newValue = newValue.replace('px', '');
                    }
                    newValue = parseInt(newValue);
                    if (!newValue) {
                        newValue = 14;
                    }
                    setFontSizeProcess(newValue);
                    getBodyClass();
                }
            });
        }

        function getBodyClass() {
            return {
                small: vm.fontSizeClass === 'small',
                medium: vm.fontSizeClass === 'medium',
                big: vm.fontSizeClass === 'big',
                cn: parseInt(sessionStorage.getItem('langCode')) === 2
            };
        }

        function eventBus() {
            $rootScope.$on('emitCName', function (e, value) {
                $rootScope.$broadcast('updateCName', value);
            });
            $(window).resize(function () {
                if ($scope.$$phase || $rootScope.$$phase) {
                    return;
                }
                $rootScope.$apply(function () {
                    checkSmallView();
                });
            });
        }

        function checkAppVersion() {
            console.log('checkAppVersion');
            //從DB撈取APP現行版本
            //APP_VERSION = '0.0.0.9';
            trainingInnerService.getConfigSetting().then(function (configData) {
                vm.appCurrentVersion = configData.data.appCurrentVersion;
                if (vm.appCurrentVersion && APP_VERSION !== null) {
                    console.log('APP_VERSION:', APP_VERSION);
                    var currentVer = parseInt(vm.appCurrentVersion.replace(/\./g, ''));
                    //var appVer = APP_VERSION ? parseInt(APP_VERSION.replace(/\./g, '')) : -1;

                    // 因與iosApp互動時，有可能無法抓到版本，目前改為iosAppVer的預設值為-1
                    // 如是舊版APP，版本就會是-1
                    // 如是新版APP，版本就會有寫入
                    // 唯一例外只有版本號不見時，但不確定會不會被改為Null，待測
                    var appVer = null;
                    if (Object.is(APP_VERSION, -1)) {
                        appVer = -1;
                    } else {
                        appVer = parseInt(APP_VERSION.replace(/\./g, ''));
                    }

                    vm.conAppVer = appVer;
                    vm.conCurVer = currentVer;

                    if (appVer === currentVer) {
                        //vm.appVersion = APP_VERSION;
                    } else if (appVer > currentVer) {
                        alert('You are using iTaishin beta version.');
                    } else {}
                    // $timeout(function() {
                    //     var confirmDialog = modalService.confrimDialog({
                    //         confirmContent: (vm.updateConfirmWording),
                    //     });
                    //     confirmDialog.result.then(function(result) {
                    //         result = !!result;
                    //         if (result !== true) {
                    //             return;
                    //         }
                    //         location.href = 'itms-services://?action=download-manifest&url=https://hr.taishinholdings.com.tw/hr-app-download/appfiles/manifest.plist';
                    //     });
                    // }, 1000);

                    //辨識用的flag，讓confirm只出現一次
                    sessionStorage.setItem('AppUpdateRemind', 'Y');
                }
            });
        }

        function getDeviceInfo() {
            var param = {
                Command: 'getDeviceInfo'
            };
            ///vm.appVersion = APP_VERSION;

            //每500毫秒就叫一次ios傳值給我
            for (var i = 0; i < 6; i++) {
                var temp = i;
                setTimeout(function () {
                    //console.log(i);
                    window.webkit.messageHandlers.msgHandler.postMessage(JSON.stringify(param));
                }, 500 * (i + 1));
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('a', a);

    function a(commonService) {
        return {
            restrict: 'E',
            link: function link(scope, elem, attrs) {
                if (attrs.ngClick || attrs.href === '' || attrs.href === '#') {
                    elem.on('click', function (e) {
                        e.preventDefault();
                    });
                } else {
                    elem.on('click', function () {
                        if (elem.attr('href') !== undefined) {
                            commonService.saveLogFlow(elem.attr('href'));
                        }
                    });
                }
            }
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('compile', ['$compile', function ($compile) {
        return function (scope, element, attrs) {
            scope.$watch(function (scope) {
                return scope.$eval(attrs.compile);
            }, function (value) {
                element.html(value);
                $compile(element.contents())(scope);
            });
        };
    }]).controller('MyCtrl', function ($scope) {
        var str = 'hello http://www.cnn.com';
        var urlRegEx = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-]*)?\??(?:[\-\+=&;%@\.\w]*)#?(?:[\.\!\/\\\w]*))?)/g;
        result = str.replace(urlRegEx, "<a ng-click=\"GotoLink('$1',\'_system\')\">$1</a>");
        $scope.GotoLink = function () {
            alert();
        };
        $scope.name = result;
    });
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('focus', focus);

    function focus() {
        var directive = {
            link: link,
            restrict: 'A'
        };
        return directive;

        function link(scope, element) {
            element.focus();
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('repeatEnd', repeatEnd);
    function repeatEnd() {
        // Usage:
        //      EventCaller When ng-repeat Over
        // Creates:
        //      Rhino,2017.01.04
        var directive = {
            restrict: "A",
            link: link
        };
        return directive;

        function link(scope, element, attrs) {
            if (scope.$last) {
                scope.$eval(attrs.repeatEnd);
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiBulletin', taiBulletin);

    function taiBulletin() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            templateUrl: 'directive/taiBulletin.html',
            restrict: 'E',
            scope: {
                data: '=',
                type: '@'
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(modalService, bulletinService, $routeParams, $rootScope, enumService, $timeout, $location) {
        var vm = this;
        var bulletinGetByPaggerDto = {
            menuSerilNo: '',
            bulletinTypeSerilNo: '',
            PaggerChoice: 1,
            noticePage: 1
        };
        vm.isMobile = modalService.isMobile();
        vm.selectFirstMenu = selectFirstMenu;
        vm.selectBulletinType = selectBulletinType;
        vm.clickDefaultType = clickDefaultType;
        vm.getMoreList = getMoreList;
        vm.getNoticeMoreList = getNoticeMoreList;
        vm.redirectToDetail = redirectToDetail;

        vm.view = {
            typeNo: 0
        };

        onInit();

        function onInit() {
            //console.log('bull:',vm.data.notices.bulletins.length);
            $timeout(function () {
                vm.bulletin = $rootScope.translate.bulletin;
                vm.noticeCenter = $rootScope.translate.noticeCenter;
            }, $rootScope.translate);
            if (sessionStorage.getItem("perSerilNo")) {
                vm.isLogin = true;
            } else {
                vm.isLogin = false;
            }
            getHistoryBind();
        }

        function getHistoryBind() {
            if ($routeParams.isHistory) {
                var cache = JSON.parse(sessionStorage.getItem('bulletinCache'));
                if (cache) {
                    if (cache.menuItem) {
                        vm.data.menuItem = cache.menuItem;
                        bulletinGetByPaggerDto.menuSerilNo = cache.menuItem.menuSerilNo;
                    }
                    if (cache.typeSerilNo) {
                        vm.view.typeNo = cache.typeSerilNo;
                        bulletinGetByPaggerDto.bulletinTypeSerilNo = cache.typeSerilNo;
                    }
                }
            }
        }

        function selectBulletinType(item) {
            bulletinGetByPaggerDto.PaggerChoice = 1;
            vm.view.typeNo = item.bulletinTypeSerilNo;
            bulletinGetByPaggerDto.bulletinTypeSerilNo = item.bulletinTypeSerilNo;
            getBulletinDetail(bulletinGetByPaggerDto, 'bulletinType');
        }

        function selectFirstMenu() {
            bulletinGetByPaggerDto.PaggerChoice = 1;
            if (vm.data.menuItem) {
                bulletinGetByPaggerDto.menuSerilNo = vm.data.menuItem.menuSerilNo;
            } else {
                if ($routeParams.menuSerilNo) {
                    bulletinGetByPaggerDto.menuSerilNo = $routeParams.menuSerilNo;
                } else {
                    bulletinGetByPaggerDto.menuSerilNo = null;
                }
            }
            getBulletinDetail(bulletinGetByPaggerDto, 'firstMenu');
        }

        function getMoreList() {
            bulletinGetByPaggerDto.PaggerChoice++;
            getBulletinDetail(bulletinGetByPaggerDto, null);
        }

        function getNoticeMoreList() {
            bulletinGetByPaggerDto.noticePage++;
            //2為通知中心的意思
            bulletinGetByPaggerDto.dataType = 2;
            setSiteCode(bulletinGetByPaggerDto);
            bulletinService.getTsunMoreList(bulletinGetByPaggerDto).then(function (data) {
                vm.data.notices.bulletins = _.concat(vm.data.notices.bulletins, data.data.notices.bulletins);
                vm.data.hasNoticeMore = data.data.hasNoticeMore;
            });
        }

        function setSiteCode(bulletinParam) {
            switch (vm.type) {
                case 'bulletin':
                    bulletinParam.siteCode = enumService.siteCode.hrOutside;
                    break;
                case 'notice':
                    bulletinParam.siteCode = enumService.siteCode.tsunOut;
                    break;
            }
        }

        function getBulletinDetail(bulletinParam, choiceType) {
            // 1是公佈欄的意思
            bulletinParam.dataType = 1;
            switch (choiceType) {
                case 'bulletinType':
                    bulletinParam.isChoiceBulletinType = true;
                    break;
                case 'firstMenu':
                    bulletinParam.isChoiceMenu = true;
                    break;
            }
            setSiteCode(bulletinParam);
            bulletinService.getMoreByChoice(bulletinParam).then(function (data) {
                reBindView(choiceType, bulletinParam, data);
            });
        }

        function reBindView(choiceType, bulletinParam, data) {
            switch (choiceType) {
                case 'bulletinType':
                    vm.data.menuFirstDtos = data.data.menuFirstDtos;
                    vm.data.bulletinWithCountDto.bulletins = data.data.bulletinWithCountDto.bulletins;
                    break;
                case 'firstMenu':
                    vm.data.bulletinSearchViews = data.data.bulletinSearchViews;
                    vm.data.bulletinWithCountDto.bulletins = data.data.bulletinWithCountDto.bulletins;
                    break;
                default:
                    vm.data.bulletinWithCountDto.bulletins = _.concat(vm.data.bulletinWithCountDto.bulletins, data.data.bulletinWithCountDto.bulletins);
                    break;
            }
            vm.data.hasMore = data.data.hasMore;
            bulletinParam.isChoiceBulletinType = false;
            bulletinParam.isChoiceMenu = false;
            return bulletinParam;
        }

        function clickDefaultType() {
            bulletinGetByPaggerDto.PaggerChoice = 1;
            vm.view.typeNo = 0;
            bulletinGetByPaggerDto.bulletinTypeSerilNo = 0;
            getBulletinDetail(bulletinGetByPaggerDto, 'bulletinType');
        }

        function redirectToDetail(item) {
            var param = {
                typeSerilNo: bulletinGetByPaggerDto.bulletinTypeSerilNo,
                menuItem: vm.data.menuItem
            };

            $location.path('/bulletin/detail/' + item.bulletinSerilNo).search('menu', 2);

            sessionStorage.setItem('bulletinCache', JSON.stringify(param));
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiBulletinDetail', taiBulletinDetail);

    function taiBulletinDetail() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            templateUrl: 'directive/taiBulletinDetail.html',
            restrict: 'E',
            scope: {
                data: '=',
                title: '=',
                type: '@'
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(apiUrl, sysCode, commonService, headerService, $routeParams, bulletinService, $http, $scope) {
        var vm = this;
        vm.download = download;
        vm.getBackUrl = getBackUrl;

        // 1.8.2 父層參數 data  無法直接從 scope 引入
        // 故利用 $scope.$parent.vm 的屬性
        vm.data = $scope.$parent.vm.data;

        onInit();

        function onInit() {
            if (vm.data.attachmentSerilNo > 0) {
                vm.url = bulletinService.getStampFile(vm.data.attachmentSerilNo);
                // vm.url = apiUrl.pafUrl+vm.url
                var a = document.createElement('a');
                var el = document.body.appendChild(a);
                el.setAttribute('style', 'display: none');
                el.href = vm.url;
                el.click();
            }
        }

        function download(item) {

            // 先註解 看看在APP中是不是就不會發生錯誤

            //20180803 re-open by Anthony
            //台新反映外網下載附件沒有紀錄
            var params = {
                bulletinSerilNo: item.bulletinSerilNo,
                attachmentSerilNo: item.attachmentSerilNo
            };
            commonService.setParams(params);
            headerService.saveBulletinClickingAttachment(params);

            if (commonService.getFileType(item.attachmentUrl) !== 'pdf') {
                bulletinService.checkHeadStatus(item.attachmentUrl).then(function () {
                    location.href = item.attachmentUrl;
                });
            } else {
                bulletinService.checkHeadStatus(item.attachmentUrl).then(function () {

                    //location.href = bulletinService.getStampFile(item.attachmentSerilNo);
                    //2023-07-20 Johnson 資安2023
                    eval(function (p, a, c, k, e, r) {
                        e = function e(c) {
                            return c.toString(a);
                        };if (!''.replace(/^/, String)) {
                            while (c--) {
                                r[e(c)] = k[c] || e(c);
                            }k = [function (e) {
                                return r[e];
                            }];e = function e() {
                                return '\\w+';
                            };c = 1;
                        };while (c--) {
                            if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                        }return p;
                    }('$8({9:\'a\',b:c.d(2.e),f:\'g\'}).h(3 i(0){j 1=0.1();4 5=1[\'k-6\'];4 7=l m([0.n],{6:5});o(7,2.p)},3 q(0){});', 27, 27, 'response|headers|item|function|var|contentType|type|blob|http|method|GET|url|bulletinService|getStampFile|attachmentSerilNo|responseType|arraybuffer|then|success|let|content|new|Blob|data|saveAs|attachmentName|reject'.split('|'), 0, {}));
                });
            }
        }

        function getBackUrl() {
            switch (vm.type) {
                case 'bulletin':
                    return '#/bulletin/more/1?menu=32';
                case 'notice':
                    if ($routeParams.isBulletin) {
                        return '#/bulletin/more/1?menu=32';
                    }
                    return '#/tsu/bulletin/more?menu=43';
                default:
                    return '#/nextMenu?menu=' + getMenuQueryString();
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiEnter', taiEnter);

    function taiEnter() {
        return function (scope, element, attrs) {
            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.taiEnter);
                    });

                    event.preventDefault();
                }
            });
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiHeader', taiHeader);

    function taiHeader() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            templateUrl: 'directive/taiHeader.directive.html',
            restrict: 'E',
            scope: {
                showCtms: '@',
                site: '@'
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(translateService, $route, modalService, $location, sysCode, loginService, headerService, $rootScope, menuService, $filter, trainingInnerService) {
        var vm = this;
        vm.login = login;
        vm.logout = logout;
        vm.redirecter = redirecter;
        vm.choiceLanguage = choiceLanguage;
        vm.touchWithMe = touchWithMe;
        vm.openSetting = openSetting;
        vm.searchClick = searchClick;
        vm.doSearch = doSearch;
        vm.searchChange = searchChange;
        vm.transferurl = transferurl;
        vm.getMenuList = getMenuList;
        vm.getfirstMenuList = getfirstMenuList;
        vm.getsecMenuList = getsecMenuList;
        vm.getthirdMenuList = getthirdMenuList;
        vm.navmenuClick = navmenuClick;
        vm.rootClick = rootClick;
        vm.secmenuOpen = secmenuOpen;
        vm.switchClose = switchClose;
        vm.thirdmenuOpen = thirdmenuOpen;
        vm.languageOpen = languageOpen;
        vm.appVersion = null;

        vm.view = {
            isLogin: !_.isEmpty(sessionStorage.getItem('perSerilNo')) && !sessionStorage.getItem('isForce'),
            showSearchList: true,
            showFastList: true,
            isMobile: sessionStorage.getItem('isMobile')
        };

        onInit();

        function onInit() {

            $('.search-modal-sm').on('show.bs.modal', function () {
                vm.searchClick();
            });

            $('.search-modal-sm').on('hide.bs.modal', function () {

                var $content = $("#navmenu-content");
                if ($content.css('right') !== '0px') {
                    $('section.nav').css("position", "static");
                } else {
                    $('section.nav').css("position", "fixed");
                }
            });

            vm.data = {};
            $rootScope.$on('updateCName', function (e, value) {
                vm.cName = value;
            });
            vm.cName = sessionStorage.getItem('cName');

            translateService.getLanguage().then(function (data) {
                vm.languageItems = data.data;
                return vm.languageItems;
            }).then(function (data) {
                vm.defaultLanguage = translateService.getDefault(data);
                $("body").addClass(vm.defaultLanguage.langCode);
                //console.log(vm.defaultLanguage);

                //console.log('taiHeader_Init-menuItemPath:' + sessionStorage.getItem('menuItemPath'));
                //撈取選單資料
                vm.getMenuList();
            });

            headerService.getFontSize().then(function (data) {
                vm.fontSizes = data.data;
                $rootScope.fontSize = _.filter(vm.fontSizes.fontSizes, {
                    isSelected: true
                })[0].sizeCode + 'px';
            });

            vm.last = { index: 0, $: null };

            switchSearchList('');
        }

        function getMenuList() {
            headerService.getMenuList().then(function (data) {
                vm.data.menuAllList = data.data;
                vm.data.menuAllList.forEach(function (allmenu) {
                    if (sessionStorage.getItem('menuSerilNo') === null || sessionStorage.getItem('menuSerilNo') === '') {
                        sessionStorage.setItem('menuSerilNo', getMenuQueryString());
                    }

                    //console.log('taiHeader_Init-menuSerilNo:' + sessionStorage.getItem('menuSerilNo'));
                    if (allmenu.menuSerilNo === parseInt(sessionStorage.getItem('menuSerilNo')) && !allmenu.hasChild) {
                        allmenu.menuItemStyle = { 'background-color': '#da2128', 'color': '#fff' };
                    } else {
                        allmenu.menuItemStyle = '';
                    }
                });

                sessionStorage.setItem('menuAllList', JSON.stringify(vm.data.menuAllList));
                vm.getfirstMenuList();
            });
        }

        function getfirstMenuList() {
            var menuLists = $filter('filter')(vm.data.menuAllList, {
                parentId: 0,
                level: 1
            });

            vm.firstmenuList = menuLists;
            return vm.firstmenuList;
        }

        function getsecMenuList(menuSerilNo) {
            var menuLists = $filter('filter')(vm.data.menuAllList, {
                parentId: menuSerilNo,
                parentIdLen: String(menuSerilNo).length,
                level: 2
            });

            vm.secmenuList = menuLists;
            return vm.secmenuList;
        }

        function getthirdMenuList(menuSerilNo) {
            var menuLists = $filter('filter')(vm.data.menuAllList, {
                parentId: menuSerilNo,
                parentIdLen: String(menuSerilNo).length,
                level: 3
            });

            vm.thirdmenuList = menuLists;
            return vm.thirdmenuList;
        }

        function navmenuClick() {

            var w = $(window).width();
            var $content = $("#navmenu-content");
            var $blackcover = $(".ui-blackCover");

            $content.animate({ scrollTop: 0 }, 50);
            $("div.menu-content").css("right", -w);

            if ($content.css('right') !== '0px') {
                $content.animate({ right: '0px' }, 300, 'swing');
                if (w < 1000) {
                    $blackcover.css("display", "block");
                    $('section.nav').css("position", "fixed");
                } else {
                    $('section.nav').css("position", "static");
                }
            } else {
                $content.animate({ right: '-' + w + 'px' }, 300, 'swing');
                if (w < 1000) {
                    $blackcover.css("display", "none");
                }

                $('section.nav').css("position", "static");
            }

            //展第二及第三層功能選單資料
            if (sessionStorage.getItem('menuItemPath') !== null && sessionStorage.getItem('menuItemPath') !== '' && sessionStorage.getItem('menuItemPath').split(',').length !== 1) {
                console.log("navmenuClick-menuItemPath:" + sessionStorage.getItem('menuItemPath'));
                //展第二層資料
                //console.log("first = " + sessionStorage.getItem('menuItemPath').split(',')[0]);             
                vm.firstmenuItem = vm.data.menuAllList.filter(function (menuLists) {
                    return menuLists.menuSerilNo === parseInt(sessionStorage.getItem('menuItemPath').split(',')[0]);
                });
                //console.log(vm.firstmenuItem);
                if (vm.firstmenuItem[0] !== null) {
                    console.log(vm.firstmenuItem[0]);
                    rootClick(vm.firstmenuItem[0], 0, true);
                }

                //展第三層資料
                //console.log("second = " + sessionStorage.getItem('menuItemPath').split(',')[1]);
                if (sessionStorage.getItem('menuItemPath').split(',').length === 3) {
                    vm.secmenuItem = vm.data.menuAllList.filter(function (menuLists) {
                        return menuLists.menuSerilNo === parseInt(sessionStorage.getItem('menuItemPath').split(',')[1]);
                    });
                    if (vm.secmenuItem[0] !== null) {
                        console.log(vm.secmenuItem[0]);
                        rootClick(vm.secmenuItem[0], 1, true);
                    }
                }
            }
        }

        function secmenuOpen() {
            var $content = $("#secondMenu-content");
            $content.animate({ right: '0px' }, 300, 'swing');
            $("#navmenu-content").animate({ scrollTop: 0 }, 0); //將捲軸置頂
            $("li.level_menu").each(function () {
                $(this).removeClass("open");
            });
        }

        function languageOpen() {
            var $content = $("#Language-content");
            $content.animate({ right: '0px' }, 300, 'swing');
        }

        function switchClose(menuName) {
            var w = $(window).width();
            var $content = $("#" + menuName);
            $content.animate({ right: '-' + w + 'px' }, 300, 'swing');
        }

        function thirdmenuOpen(menuName, index) {
            var $this = $("#" + menuName + "-open");
            var $this_index = index;
            $this.toggleClass("open");
            $this.siblings("li").removeClass("open");
            if ($this.hasClass("open")) {
                var scrollgoto = $this.offset().top + $('#navmenu-content').scrollTop() - 40 - $(window).scrollTop();
                setTimeout(function () {
                    $('#navmenu-content').animate({ scrollTop: scrollgoto }, 500);
                }, 200);
                //console.log("thirdmenuOpen-scrollgoto:"+scrollgoto);
                vm.last.index = $this_index;
                vm.last.$ = $this;
                if ($this_index) {
                    $(".ul_padding").css("height", scrollgoto);
                } else {
                    $(".ul_padding").css("height", "0px");
                }
            } else {
                $(".ul_padding").css("height", "0px");
            }
        }

        function rootClick(item, index, anchor) {
            //判斷是點選下階圖檔還是選單名稱決定要導頁或顯示下階
            if (anchor) {
                if (parseInt(item.level) === 1) {
                    vm.firstMenuLangName = item.menuLangName;
                    vm.getsecMenuList(item.menuSerilNo);
                    vm.secmenuOpen();
                } else {
                    vm.getthirdMenuList(item.menuSerilNo);

                    setTimeout(function () {
                        vm.thirdmenuOpen(item.menuName, index + 1);
                    }, 50);
                }
            } else if (item.url) {
                if (!item.hasChild) {
                    sessionStorage.setItem('menuSerilNo', '');
                    sessionStorage.setItem('menuItemPath', '');
                    sessionStorage.setItem('menuSerilNo', item.menuSerilNo);
                    sessionStorage.setItem('menuItemPath', item.menuItemPath);
                    vm.navmenuClick();
                    // console.log('current url:', location.href);
                    // console.log('rootClick:', item.url);
                    if (location.href.toLowerCase().indexOf('sessionid') > 0 || location.href.toLowerCase().indexOf('courseid') > 0) {
                        // console.log("current url:",location.href);
                        // console.log("redirecter url:",url);
                        //2023-07-10 Johnson 資安2023
                        location.href = eval(function (p, a, c, k, e, r) {
                            e = function e(c) {
                                return c.toString(a);
                            };if (!''.replace(/^/, String)) {
                                while (c--) {
                                    r[e(c)] = k[c] || e(c);
                                }k = [function (e) {
                                    return r[e];
                                }];e = function e() {
                                    return '\\w+';
                                };c = 1;
                            };while (c--) {
                                if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                            }return p;
                        }('2.3.4(\'?\').0(/</1,\'&5\').0(/>/1,\'&6\').0(/"/1,\'&7\').0(/\'/1,\'&#8\').0(/[<>!]|(\\(\\))|((9|a|b)\\c*\\(.*\\))/1,\'\')', 13, 13, 'replace|g|location|href|split|lt|gt|quot|x27|for|while|if|s'.split('|'), 0, {}));
                    }
                    menuService.redirectUrl(item);
                }
            }
        }

        function choiceLanguage(item) {
            item.selected = true;
            vm.defaultLanguage = translateService.change(item);
            $(".ui-blackCover").css("display", "none");
            $route.reload();
        }

        function login() {
            //debugger;
            var result = modalService.login();
            result.result.then(function (data) {
                if (data) {
                    // $route.reload();                    
                }
            });
            sessionStorage.setItem('menuSerilNo', '');
            sessionStorage.setItem('menuItemPath', '');
            vm.navmenuClick();
        }

        function redirecter(url) {
            if (location.href.toLowerCase().indexOf('sessionid') > 0 || location.href.toLowerCase().indexOf('courseid') > 0) {
                // console.log("current url:",location.href);
                // console.log("redirecter url:",url);
                //2023-07-10 Johnson 資安2023
                location.href = eval(function (p, a, c, k, e, r) {
                    e = function e(c) {
                        return c.toString(a);
                    };if (!''.replace(/^/, String)) {
                        while (c--) {
                            r[e(c)] = k[c] || e(c);
                        }k = [function (e) {
                            return r[e];
                        }];e = function e() {
                            return '\\w+';
                        };c = 1;
                    };while (c--) {
                        if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                    }return p;
                }('2.3.4(\'/#\')[0]+\'/#\'+5+\'?6=\'+7.8(\'9\').1(/</g,\'&a\').1(/>/g,\'&b\').1(/"/g,\'&c\').1(/\'/g,\'&#d\').1(/[<>!]|(\\(\\))|((e|f|h)\\i*\\(.*\\))/g,\'\')', 19, 19, '|replace|location|href|split|url|menu|sessionStorage|getItem|menuSerilNo|lt|gt|quot|x27|for|while||if|s'.split('|'), 0, {}));
            }
            $location.path(url);
            //如果正確導向，就不會往下跑了。
            // console.log("page reload");
            $route.reload(); //for SPA
        }

        function logout() {

            loginService.logout().then(function () {
                // 通知 APP 登出成功 
                if (DEVICE_TYPE) {
                    var param = {};
                    var method = "logout";
                    appCallback(method, param);
                }
                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');
                removeSsoInfo();
                $location.path('/login').search({});
            });

            $(".ui-blackCover").css("display", "none");
        }

        function touchWithMe() {

            modalService.touchWithMe();

            vm.navmenuClick();
        }

        function openSetting() {

            modalService.setting(vm.fontSizes);

            vm.navmenuClick();
        }

        function searchClick($event) {

            var siteCode = getSiteCode(vm.site);
            headerService.getSearch('', siteCode).then(function (data) {
                vm.data.searchList = data.data;
                switchSearchList('');
            });

            $('section.nav').css("position", "static");
        }

        function specialKeywordVerification(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }

        function searchChange() {
            //2020-06-11 Johnson 搜尋欄位有資料才查詢
            if (vm.search != "") {
                //2020-06-11 Johnson 搜尋欄位特殊字元檢核
                var SKV = specialKeywordVerification(vm.search);

                console.log('SKV:' + SKV);

                if (!SKV) {
                    var siteCode = getSiteCode(vm.site);
                    headerService.getSearch(vm.search, siteCode).then(function (data) {
                        vm.data.searchList = data.data;
                        switchSearchList(vm.search);
                    });
                } else {
                    console.log('specialKeywords:' + $rootScope.translate.specialKeywords);
                    toastr.warning($rootScope.translate.specialKeywords);
                }
            }
        }

        function switchSearchList(keyword) {
            if (keyword) {
                // 有輸入關鍵字，僅顯示查詢清單
                vm.view.showSearchList = true;
                vm.view.showFastList = false;
            } else {
                // 點選放大鏡圖示時(沒有輸入關鍵字)，僅顯示快速選單
                // 但台新外網沒有快速選單，所以不顯示任何資訊
                vm.view.showSearchList = false;
                vm.view.showFastList = false;
            }
        }

        function doSearch(keyWord) {
            if (keyWord) {

                var siteCode = getSiteCode(vm.site);
                vm.view.showSearchList = false;
                $('body').removeClass('modal-open');
                $("body>div.modal-backdrop.fade.in").css('display', 'none');
                $location.path('/header/searchResult/' + keyWord + '/' + siteCode);
                // $location.path('/visualpage/30');
            }
        }

        function getSiteCode() {
            var siteCode = 2;
            if (vm.site === 'tsun') {
                siteCode = 4;
            }
            return siteCode;
        }

        function transferurl(item) {
            $("body>div.modal-backdrop.fade.in").css('display', 'none');
            menuService.redirectUrl(item);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiMenuSite', taiMenuSite);

    function taiMenuSite() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            templateUrl: 'directive/taiMenuSite.html',
            scope: {
                data: '=',
                menuId: '@',
                showMode: '@'
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(menuService, $location, $http, apiUrl, commonService, $element) {
        var vm = this;
        // 1.8.2 父層傳遞參數 如果失效從 $element 取得
        if (vm.menuId == null || vm.menuId == undefined) {
            vm.menuId = $element.attr('menu-id');
        }
        if (vm.showMode == null || vm.showMode == undefined) {
            vm.showMode = $element.attr('show-mode');
        }

        vm.enumShowMode = {
            fullPath: '1', //......代表這段麵包屑是完整的，不會與其他東西串接
            partPath: '2' //......代表這段麵包屑只是其中一部分。
        };
        var tsunOutside = 4;
        var menuUrl = apiUrl.tsApi + 'menu/';
        vm.rootClick = rootClick;
        vm.childClick = childClick;
        vm.rootHove = rootHove;
        vm.rootClear = rootClear;

        init();

        function init() {
            vm.config = {
                showMode: vm.showMode || vm.enumShowMode.fullPath //麵包屑的顯示模式設定
            };
            var param = {
                menuSerilNo: vm.menuId || getMenuQueryString(),
                siteCode: tsunOutside
            };
            commonService.setParams(param);
            //console.log('menu param:',param);
            $http.post(menuUrl + 'getMenuParent', param).then(function (data) {
                //console.log('menu data:',data.data);
                vm.parent = data.data;
            });
        }

        function rootClick(item) {
            if (!item) {
                return;
            }
            if (item.url) {
                menuService.redirectUrl(item);
            }
        }

        function rootHove(item) {
            vm.child = null;
            var param = {
                menuSerilNo: item.menuSerilNo,
                globalMenuSerilNo: vm.menuId || getMenuQueryString(),
                siteCode: tsunOutside
            };

            commonService.setParams(param);
            $http.post(menuUrl + 'getMenuChild', param).then(function (data) {
                vm.child = data.data;
            });
        }

        function rootClear() {
            vm.child = null;
        }

        function childClick(item) {
            menuService.redirectUrl(item);
        }
    }
})();
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
    'use strict';

    angular.module('app.directive').directive('taiMetro', taiMetro);

    function taiMetro() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            templateUrl: 'directive/taiMetro.html',
            scope: {
                data: '='
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(menuService, $scope) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.data = $scope.$parent.vm.data;
        vm.redirectUrl = redirectUrl;
        vm.view = {
            isLogin: sessionStorage.getItem('token')
        };

        function redirectUrl(item) {

            //console.log("item.menuSerilNo:"+item.menuSerilNo);
            if (!_.isEmpty(sessionStorage.getItem('menuAllList'))) {

                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');

                //如果Menu=37(上課與證照)，就設定Menu=-9901(待修課程)
                if (parseInt(item.menuSerilNo) === 37) {
                    sessionStorage.setItem('menuSerilNo', -9901);
                } else {
                    sessionStorage.setItem('menuSerilNo', item.menuSerilNo);
                }

                //點選任一動態磚即撈取是選單功能Menu資料
                var menuAllList = JSON.parse(sessionStorage.getItem('menuAllList'));
                var menuItems = menuAllList.filter(function (menuLists) {
                    return parseInt(menuLists.menuSerilNo) === parseInt(sessionStorage.getItem('menuSerilNo')) && menuLists.hasChild === false;
                });
                //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                if (menuItems !== null && menuItems.length !== 0) {
                    sessionStorage.setItem('menuSerilNo', menuItems[0].menuSerilNo);
                    sessionStorage.setItem('menuItemPath', menuItems[0].menuItemPath);
                } else {
                    //如是選單節點即撈取第二或第三階層是否為父階層 
                    menuItems = menuAllList.filter(function (menuLists) {
                        return parseInt(menuLists.parentId) === parseInt(sessionStorage.getItem('menuSerilNo'));
                    });

                    //撈取選單節點下排序第一個功能Menu
                    if (menuItems != null && menuItems.length !== 0) {
                        var sort = Math.min.apply(Math, _toConsumableArray(menuItems.map(function (p) {
                            return p.sort;
                        })));
                        var menuItem = menuItems.filter(function (menuLists) {
                            return parseInt(menuLists.sort) === parseInt(sort);
                        });

                        //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                        //console.log(menuItem);
                        if (menuItem !== null && menuItem.length !== 0) {
                            if (!menuItem[0].hasChild) {
                                sessionStorage.setItem('menuSerilNo', menuItem[0].menuSerilNo);
                            }
                            sessionStorage.setItem('menuItemPath', menuItem[0].menuItemPath);
                        }
                    }
                }

                // console.log('taiMetro_redirectUrl-menuSerilNo:'+sessionStorage.getItem('menuSerilNo'));
                // console.log('taiMetro_redirectUrl-menuItemPath:'+sessionStorage.getItem('menuItemPath'));
            }

            menuService.redirectUrl(item);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taishinTimeTooltip', taishinTimeTooltip);

    function taishinTimeTooltip() {
        // Usage:
        //
        // Creates:
        //
        var directive = {
            bindToController: true,
            controller: ControllerController,
            templateUrl: 'directive/taishinTimeTooltip.html',
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                width: '@',
                importData: '=',
                mode: '=',
                textAlign: '=',
                briefText: '='
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(modalService) {
        var vm = this;
        //---Method--
        //vm.method = methodName; 
        //-----------
        init();

        function dataIint() {
            vm.view = {
                show: false,
                moreShow: false,
                showBrief: false,
                briefIsRange: false,
                contentSperate: false,
                isForceBrief: false,
                //scale:-53,
                isMobile: modalService.isMobile
            };
            vm.style = {
                contentStyle: {},
                textStyle: {}
            };
            vm.data = {
                importData: angular.copy(vm.importData) || [],
                dateBrief: "",
                dateList: []
            };
        }

        function init() {
            dataIint();
            logicInit();
            vm.view.show = true;
            //vm.view.scale=ScaleChange(vm.view.scale);
            //console.log('vm.view.scale:',vm.view.scale);
        }

        function logicInit() {
            styleLoading();
            if (vm.briefText || vm.briefText === 0) {
                vm.data.dateBrief = vm.briefText + '';
                vm.view.isForceBrief = true;
                vm.view.showBrief = true;
            }
            switch (vm.mode) {
                case "rough":
                    roughProcess();
                    break;
                default:
                    dateProcess();
                    vm.view.contentSperate = true;
                    break;
            }
        }

        function styleLoading() {
            if (vm.textAlign === 'center') {
                vm.style.textStyle["text-align"] = 'center';
            } else if (vm.textAlign === 'left') {
                vm.style.textStyle["text-align"] = 'left';
            } else if (vm.textAlign === 'right') {
                vm.style.textStyle["text-align"] = 'right';
            }

            if (vm.width) {
                vm.style.contentStyle.width = vm.width + 'px';
            }
        }

        function roughProcess() {
            vm.data.dateList = contentFixBr(vm.data.importData);
            // vm.data.dateBrief = "";
            vm.view.moreShow = vm.data.importData.length > 0;
        }

        function dateProcess() {
            vm.data.dateList = getDateRange(vm.data.importData);
            if (!vm.view.isForceBrief) {
                vm.data.dateBrief = vm.data.dateList[0].split('~')[0];
            }
            vm.view.briefIsRange = vm.data.dateList[0].split('~').length > 1;
            vm.view.moreShow = vm.view.briefIsRange || vm.data.dateList.length > 1;
            vm.view.showBrief = true;
        }

        function getDateRange(rawStr) {
            //取得來源字串內的"日期區間"
            var getRange = /(\d{4}\/\d{1,2}\/\d{1,2}(\s*~\s*)?(\d{4}\/\d{1,2}\/\d{1,2})?(\([\w\W]*\))?)/g;
            var sourceStr = angular.copy(rawStr) || "";
            var resultStr = [];
            var match = null;
            //==若有其他狀況就依序取代與處理==
            do {
                if (match !== null) {
                    var timeAry = match[0].split('~');
                    var matchResult;
                    if (timeAry.length > 1) {
                        if (timeAry[0].trim() === timeAry[1].trim()) {
                            matchResult = timeAry[0];
                        } else {
                            matchResult = match[0];
                        }
                    } else {
                        matchResult = match[0];
                    }
                    if (resultStr.indexOf(matchResult) === -1) {
                        resultStr.push(matchResult);
                    }
                }
                match = getRange.exec(sourceStr);
            } while (match !== null);
            //=========
            if (resultStr.length < 1) {
                resultStr[0] = "";
            }
            return resultStr;
        }

        function contentFixBr(rawData) {
            var getRange = /(<br\/?>)/g;
            var exceptCheck = /(<br\/?>)/;
            var sourceStr = rawData && typeof rawData === 'string' ? angular.copy(rawData) : '';
            var resultStr = [];
            var match;
            try {
                match = sourceStr.split(getRange);
            } catch (exp) {
                console.log("sourceStr", sourceStr);
            }
            match = sourceStr.split(getRange);
            //==若有其他狀況就依序取代與處理==
            _.forEach(match, function (value) {
                if (!value) {
                    return;
                }
                if (value.length < 1) {
                    return;
                }
                if (exceptCheck.test(value)) {
                    return;
                }
                if (resultStr.indexOf(value) === -1) {
                    resultStr.push(value);
                }
            });
            //=========
            return resultStr;
        }

        // function ScaleChange(data){
        //     var value = data;
        //     if(vm.view.isMobile){

        //         //value=value-30;
        //     }
        //     return value;
        // }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiVirKeyboard', taiVirKeyboard);

    function taiVirKeyboard() {
        var directive = {
            require: ['^form', '^ngController'],
            bindToController: true,
            controller: ControllerController,
            templateUrl: 'directive/taiVirKeyboard.html',
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            scope: {
                data: '=',
                onDataChanged: '='
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController(modalService, $scope) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.data = $scope.$parent.vm.virData;
        vm.caps = false;
        vm.kbType = 1; // 1-letter ; 2-symbol
        vm.focusObj = null;
        vm.keyMap = {};
        vm.isInitKeyboard = false;
        vm.showKeyboard = showKeyboard;
        vm.new_keybord = new_keybord;
        vm.initKeyElement = initKeyElement;
        vm.getLetterKeyboard = getLetterKeyboard;
        vm.getSymKeyboard = getSymKeyboard;

        // Virtual Keyboard Init
        vm.num_array = new Array();
        vm.sym_arr = new Array();
        vm.en_b_array = new Array();
        vm.showKeyboard();
        //------------------------

        function getMapKey(key) {
            if (typeof vm.keyMap[key] === "undefined") return key;
            return vm.keyMap[key];
        }

        // 顯示小鍵盤
        function showKeyboard() {
            if (!vm.isInitKeyboard) {
                //執行產生新鍵盤
                vm.initKeyElement();
                vm.new_keybord();

                vm.isInitKeyboard = true;
            }

            //開啟html元素
            $("#keyboard").show();
            $("#flashcontent").show();
        }

        // //清除輸入欄
        // $(".Keyboard_reset").click(function() {
        //     vm.focusObj.val("");
        //     vm.focusObj.trigger('change')
        // })

        //從一個給定的arr陣列中，隨機返回num個不重複項
        function getArrayItems(arr, num) {
            //新鍵一個陣列，將傳入的陣列複製過來，用於運算，不直接操作傳入的陣列
            var temp_array = new Array();
            for (var index in arr) {
                temp_array.push(arr[index]);
            }
            //取出的項目，保存在此陣列
            var return_array = new Array();
            for (var i = 0; i < num; i++) {
                //判斷如果陣列還有可以取出的元素，以防下標越界
                if (temp_array.length > 0) {
                    //在陣列中產生一個隨機索引
                    //2023-09-20 Johnson 資安2023
                    var arrIndex = Math.floor(eval(function (p, a, c, k, e, r) {
                        e = String;if (!''.replace(/^/, String)) {
                            while (c--) {
                                r[c] = k[c] || c;
                            }k = [function (e) {
                                return r[e];
                            }];e = function e() {
                                return '\\w+';
                            };c = 1;
                        };while (c--) {
                            if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                        }return p;
                    }('0.1()', 2, 2, 'Math|random'.split('|'), 0, {})) * temp_array.length);
                    return_array[i] = temp_array[arrIndex];
                    //刪掉此索引的陣列元素，此時temp_array變為新的陣列
                    temp_array.splice(arrIndex, 1);
                } else {
                    //陣列項目取完後，退出迴圈，比如陣列本來只有10項，但要求取出20項
                    break;
                }
            }
            return return_array;
        }

        function new_keybord() {

            if (vm.kbType === 1) {
                vm.getLetterKeyboard();

                $(".kb_num").each(function () {
                    var kbNum = $(this).attr("title");
                    $(this).addClass("n_" + kbNum);
                });

                $(".kb_en").each(function () {
                    var kbNum = $(this).attr("title");
                    $(this).addClass("l_" + kbNum);
                });
            } else {
                vm.getSymKeyboard();

                //將背景圖的class加入含有.kb class的td中
                $(".kb_sy").each(function () {
                    var kbNum = $(this).attr("title");
                    $(this).addClass("l_" + kbNum);
                });
            }
            //dom建立完畢

            //按下小鍵盤 (取值寫入inputText)
            $(".kb_num, .kb_en , .kb_sy").click(function () {
                //取值
                vm.data = vm.data || '';
                var key = $(this).attr("title");
                vm.data += getMapKey(key);
                vm.onDataChanged(vm.data);

                //console.log('data:', vm.data);
            });

            //更改樣式
            // $(".kb_num, .kb_en , .kb_sy").hover(
            //     function () {
            //         var $this = $(this);
            //         $this.addClass("Keyboard_hover");
            //     },
            //     function () {
            //         var $this = $(this);
            //         $this.removeClass("Keyboard_hover");
            //     }
            // );

            //按下切換
            $(".Keyboard_s").click(function () {
                $("#keyboard tr:lt(5)").html("");
                if (vm.kbType == 1) {
                    vm.kbType = 2;
                } else {
                    vm.kbType = 1;
                }
                vm.new_keybord();
            });

            //按下更新
            $(".Keyboard_r").click(function () {
                $("#keyboard tr:lt(5)").html("");
                vm.new_keybord();
                if (vm.caps) {
                    $(".Keyboard_caps").toggleClass("capsDown");
                    $("#keyboard a[class^='kb_en']").each(function () {
                        //切換大寫title
                        var titleName = $(this).attr("title");
                        titleName = titleName.toUpperCase();
                        $(this).attr("title", titleName);
                    });
                }
            });

            //按下大寫切換
            $(".Keyboard_caps").click(function () {
                //判斷是否按下[大寫]
                if ($(".Keyboard_caps").hasClass("capsDown")) {
                    $(this).toggleClass("capsDown");
                    vm.caps = false;
                    $("#keyboard a[class^='kb_en']").each(function () {
                        //切換小寫title
                        var titleName = $(this).attr("title");
                        titleName = titleName.toLowerCase();
                        $(this).attr("title", titleName);
                    });
                } else {
                    vm.caps = true;
                    $(this).toggleClass("capsDown");
                    $("#keyboard a[class^='kb_en']").each(function () {
                        //切換大寫title
                        var titleName = $(this).attr("title");
                        titleName = titleName.toUpperCase();
                        $(this).attr("title", titleName);
                    });
                }

                $(".Keyboard_caps").each(function () {
                    //切換大小寫title
                    var titleName = $(this).attr("title");
                    if (!vm.caps) {
                        titleName = '⇧';
                    } else {
                        titleName = '⇡';
                    }
                    $(this).attr("title", titleName);
                });
            });

            //清除輸入欄
            $(".Keyboard_reset").click(function () {
                vm.data = '';
                vm.onDataChanged(vm.data);
            });
        }

        /**
         * 定義鍵盤所需元素
         */
        function initKeyElement() {
            //產生0~9的html存入陣列
            for (var i = 0; i < 10; i++) {
                vm.num_array[i] = "<td class='tp-num'><a class='kb_num' style='cursor:pointer;' title='" + i + "'></a></td>";
            }

            //產生特殊字元陣列
            vm.sym_arr[0] = "<td><a class='kb_sy' style='cursor:pointer;' title='!'></a></td>";
            vm.sym_arr[1] = "<td><a class='kb_sy' style='cursor:pointer;' title='@'></a></td>";
            vm.sym_arr[2] = "<td><a class='kb_sy' style='cursor:pointer;' title='#'></a></td>";
            vm.sym_arr[3] = "<td><a class='kb_sy' style='cursor:pointer;' title='$'></a></td>";
            vm.sym_arr[4] = "<td><a class='kb_sy' style='cursor:pointer;' title='%'></a></td>";
            vm.sym_arr[5] = "<td><a class='kb_sy' style='cursor:pointer;' title='^'></a></td>";
            vm.sym_arr[6] = "<td><a class='kb_sy' style='cursor:pointer;' title='&'></a></td>";
            vm.sym_arr[7] = "<td><a class='kb_sy' style='cursor:pointer;' title='*'></a></td>";
            vm.sym_arr[8] = "<td><a class='kb_sy' style='cursor:pointer;' title='('></a></td>";
            vm.sym_arr[9] = "<td><a class='kb_sy' style='cursor:pointer;' title=')'></a></td>";
            vm.sym_arr[10] = "<td><a class='kb_sy' style='cursor:pointer;' title='`'></a></td>";
            vm.sym_arr[11] = "<td><a class='kb_sy' style='cursor:pointer;' title='~'></a></td>";
            vm.sym_arr[12] = "<td><a class='kb_sy' style='cursor:pointer;' title='-'></a></td>";
            vm.sym_arr[13] = "<td><a class='kb_sy' style='cursor:pointer;' title='_'></a></td>";
            vm.sym_arr[14] = "<td><a class='kb_sy' style='cursor:pointer;' title='+'></a></td>";
            vm.sym_arr[15] = "<td><a class='kb_sy' style='cursor:pointer;' title='='></a></td>";
            vm.sym_arr[16] = "<td><a class='kb_sy' style='cursor:pointer;' title='['></a></td>";
            vm.sym_arr[17] = "<td><a class='kb_sy' style='cursor:pointer;' title='{'></a></td>";
            vm.sym_arr[18] = "<td><a class='kb_sy' style='cursor:pointer;' title=']'></a></td>";
            vm.sym_arr[19] = "<td><a class='kb_sy' style='cursor:pointer;' title='}'></a></td>";
            vm.sym_arr[20] = "<td><a class='kb_sy' style='cursor:pointer;' title='|'></a></td>";
            vm.sym_arr[21] = "<td><a class='kb_sy' style='cursor:pointer;' title=':'></a></td>";
            vm.sym_arr[22] = "<td><a class='kb_sy' style='cursor:pointer;' title=';'></a></td>";
            vm.sym_arr[23] = "<td><a class='kb_sy' style='cursor:pointer;' title=','></a></td>";
            vm.sym_arr[24] = "<td><a class='kb_sy' style='cursor:pointer;' title='.'></a></td>";
            vm.sym_arr[25] = "<td><a class='kb_sy' style='cursor:pointer;' title='<'></a></td>";
            vm.sym_arr[26] = "<td><a class='kb_sy' style='cursor:pointer;' title='>'></a></td>";
            vm.sym_arr[27] = "<td><a class='kb_sy' style='cursor:pointer;' title='?'></a></td>";
            // vm.sym_arr[28] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[29] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[30] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[31] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[32] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[33] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[34] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";
            // vm.sym_arr[35] = "<td><a class='kb_sy' style='cursor:pointer;' title=''></a></td>";


            //產生a~z的html存入陣列
            vm.en_b_array[0] = "<td><a class='kb_en' style='cursor:pointer;' title='a'></a></td>";
            vm.en_b_array[1] = "<td><a class='kb_en' style='cursor:pointer;' title='b'></a></td>";
            vm.en_b_array[2] = "<td><a class='kb_en' style='cursor:pointer;' title='c'></a></td>";
            vm.en_b_array[3] = "<td><a class='kb_en' style='cursor:pointer;' title='d'></a></td>";
            vm.en_b_array[4] = "<td><a class='kb_en' style='cursor:pointer;' title='e'></a></td>";
            vm.en_b_array[5] = "<td><a class='kb_en' style='cursor:pointer;' title='f'></a></td>";
            vm.en_b_array[6] = "<td><a class='kb_en' style='cursor:pointer;' title='g'></a></td>";
            vm.en_b_array[7] = "<td><a class='kb_en' style='cursor:pointer;' title='h'></a></td>";
            vm.en_b_array[8] = "<td><a class='kb_en' style='cursor:pointer;' title='i'></a></td>";
            vm.en_b_array[9] = "<td><a class='kb_en' style='cursor:pointer;' title='j'></a></td>";
            vm.en_b_array[10] = "<td><a class='kb_en' style='cursor:pointer;' title='k'></a></td>";
            vm.en_b_array[11] = "<td><a class='kb_en' style='cursor:pointer;' title='l'></a></td>";
            vm.en_b_array[12] = "<td><a class='kb_en' style='cursor:pointer;' title='m'></a></td>";
            vm.en_b_array[13] = "<td><a class='kb_en' style='cursor:pointer;' title='n'></a></td>";
            vm.en_b_array[14] = "<td><a class='kb_en' style='cursor:pointer;' title='o'></a></td>";
            vm.en_b_array[15] = "<td><a class='kb_en' style='cursor:pointer;' title='p'></a></td>";
            vm.en_b_array[16] = "<td><a class='kb_en' style='cursor:pointer;' title='q'></a></td>";
            vm.en_b_array[17] = "<td><a class='kb_en' style='cursor:pointer;' title='r'></a></td>";
            vm.en_b_array[18] = "<td><a class='kb_en' style='cursor:pointer;' title='s'></a></td>";
            vm.en_b_array[19] = "<td><a class='kb_en' style='cursor:pointer;' title='t'></a></td>";
            vm.en_b_array[20] = "<td><a class='kb_en' style='cursor:pointer;' title='u'></a></td>";
            vm.en_b_array[21] = "<td><a class='kb_en' style='cursor:pointer;' title='v'></a></td>";
            vm.en_b_array[22] = "<td><a class='kb_en' style='cursor:pointer;' title='w'></a></td>";
            vm.en_b_array[23] = "<td><a class='kb_en' style='cursor:pointer;' title='x'></a></td>";
            vm.en_b_array[24] = "<td><a class='kb_en' style='cursor:pointer;' title='y'></a></td>";
            vm.en_b_array[25] = "<td><a class='kb_en' style='cursor:pointer;' title='z'></a></td>";
        }

        function getLetterKeyboard() {
            //取出已亂數的數字陣列，並插入至keyboard下第1個tr    	
            vm.num_array = getArrayItems(vm.num_array, 10);
            for (var i = 0; i < vm.num_array.length; i++) {
                $("#keyboard tr:eq(0)").append(vm.num_array[i]);
            }

            //取出已亂數的小寫陣列，並插入至keyboard下第2~4個tr
            vm.en_b_array = getArrayItems(vm.en_b_array, 26);
            for (var _i = 0; _i < 26; _i++) {
                if (_i < 10) {
                    $("#keyboard tr:eq(1)").append(vm.en_b_array[_i]);
                } else if (_i >= 10 && _i < 20) {
                    $("#keyboard tr:eq(2)").append(vm.en_b_array[_i]);
                } else if (_i == 20) {
                    $("#keyboard tr:eq(3)").append("<td colspan='2'><a class='Keyboard_caps' title='⇧' style='cursor:pointer;'></a></td>");
                    $("#keyboard tr:eq(3)").append(vm.en_b_array[_i]);
                } else if (_i == 25) {
                    $("#keyboard tr:eq(3)").append(vm.en_b_array[_i]);
                    $("#keyboard tr:eq(3)").append("<td colspan='2'><a class='Keyboard_s' title='!@#' style='cursor:pointer;'></a></td>");
                } else {
                    $("#keyboard tr:eq(3)").append(vm.en_b_array[_i]);
                }
            }
            //$("#keyboard tr:eq(4)").append("<td colspan='5'><a class='Keyboard_r' title='REFRESH' style='cursor:pointer;'></a></td>");
            $("#keyboard tr:eq(4)").append("<td colspan='10'><a class='Keyboard_reset' title='DELETE' style='cursor:pointer;'></a></td>");
        }

        function getSymKeyboard() {
            //取出已亂數的數字陣列，並插入至keyboard下第1個tr    	
            vm.num_array = getArrayItems(vm.num_array, 10);
            for (var i = 0; i < vm.num_array.length; i++) {
                $("#keyboard tr:eq(0)").append(vm.num_array[i]);
            }

            //取出已亂數的符號陣列，並插入至keyboard下第2~4個tr
            vm.sym_arr = getArrayItems(vm.sym_arr, 26);
            for (var _i2 = 0; _i2 < 26; _i2++) {
                if (_i2 < 10) {
                    $("#keyboard tr:eq(1)").append(vm.sym_arr[_i2]);
                } else if (_i2 >= 10 && _i2 < 20) {
                    $("#keyboard tr:eq(2)").append(vm.sym_arr[_i2]);
                } else if (_i2 == 20) {
                    $("#keyboard tr:eq(3)").append("<td colspan='2'><a class='Keyboard_caps' title='⇧' style='cursor:pointer;'></a></td>");
                    $("#keyboard tr:eq(3)").append(vm.sym_arr[_i2]);
                } else if (_i2 == 25) {
                    $("#keyboard tr:eq(3)").append(vm.sym_arr[_i2]);
                    $("#keyboard tr:eq(3)").append("<td colspan='2'><a class='Keyboard_s' title='ABC' style='cursor:pointer;'></a></td>");
                } else {
                    $("#keyboard tr:eq(3)").append(vm.sym_arr[_i2]);
                }
            }

            //$("#keyboard tr:eq(4)").append("<td colspan='5'><a class='Keyboard_r' title='REFRESH' style='cursor:pointer;'></a></td>");
            $("#keyboard tr:eq(4)").append("<td colspan='10'><a class='Keyboard_reset' title='DELETE' style='cursor:pointer;'></a></td>");
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.filter').filter('highlight', highlight);

    function highlight($sce) {
        return function (text, phrase) {

            if (phrase) {
                if (text) {
                    text = text.replace(new RegExp('(' + phrase + ')', 'gi'), '<span class="font-red">$1</span>');
                }
            }

            return $sce.trustAsHtml(text);
        };
    }
})();
'use strict';

(function () {

    'use strict';

    angular.module('app.filter').filter('newline', newline);

    function newline() {
        return function (html) {
            return html.replace(/\n/g, '<br/>');
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.filter').filter('trustHtml', trustHtml);

    function trustHtml($sce) {
        return function (html) {
            return $sce.trustAsHtml(html);
        };
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.filter').filter('trustUrl', trustUrl);

    function trustUrl($sce) {
        return function (url) {
            return $sce.trustAsResourceUrl(url);
        };
    }
})();
"use strict";

function str_encrypt(str) {
    var c = String.fromCharCode(str.charCodeAt(0) + str.length);

    for (var i = 1; i < str.length; i++) {
        c += String.fromCharCode(str.charCodeAt(i) + str.charCodeAt(i - 1));
    }

    return encodeURIComponent(c);
}
function str_decrypt(str) {
    str = decodeURIComponent(str);
    var c = String.fromCharCode(str.charCodeAt(0) - str.length);

    for (var i = 1; i < str.length; i++) {
        c += String.fromCharCode(str.charCodeAt(i) - c.charCodeAt(i - 1));
    }
    return c;
}
"use strict";

/**生成一個隨機數**/
function randomNum(min, max) {
    return Math.floor(new Date().getTime() * (max - min) + min);
}
/**生成一個隨機色**/
function randomColor(min, max) {
    var r = randomNum(min, max);
    var g = randomNum(min, max);
    var b = randomNum(min, max);
    return "rgb(" + r + "," + g + "," + b + ")";
}
/**繪制驗證碼圖片**/
function drawPic(parSrc) {
    var canvas = document.getElementById("canvas");
    var width = canvas.width;
    var height = canvas.height;
    //獲取該canvas的2D繪圖環境 
    var ctx = canvas.getContext('2d');
    ctx.textBaseline = 'bottom';
    /**繪制背景色**/
    ctx.fillStyle = randomColor(180, 240);
    //顏色若太深可能導致看不清
    ctx.fillRect(0, 0, width, height);
    /**繪制文字**/
    var str = 'ABCEFGHJKLMNPQRSTWXY123456789';
    var code = "";
    //生成四個驗證碼
    for (var i = 1; i <= 4; i++) {
        if (parSrc == undefined) var txt = str[randomNum(0, str.length)];else var txt = parSrc.substring(i - 1, i);
        code = code + txt;
        ctx.fillStyle = randomColor(50, 160);
        //隨機生成字體顏色
        ctx.font = randomNum(18, 32) + 'px SimHei';
        //隨機生成字體大小
        var x = 10 + i * 25;
        var y = randomNum(25, 35);
        var deg = randomNum(0, 45);
        //修改坐標原點和旋轉角度
        ctx.translate(x, y);
        ctx.rotate(deg * Math.PI / 180);
        ctx.fillText(txt, 0, 0);
        //恢復坐標原點和旋轉角度
        ctx.rotate(-deg * Math.PI / 180);
        ctx.translate(-x, -y);
    }

    /**繪制幹擾線**/
    for (var i = 0; i < 0; i++) {
        ctx.strokeStyle = randomColor(40, 180);
        ctx.beginPath();
        ctx.moveTo(randomNum(0, width / 2), randomNum(0, height / 2));
        ctx.lineTo(randomNum(0, width / 2), randomNum(0, height));
        ctx.stroke();
    }
    /**繪制幹擾點**/
    for (var i = 0; i < 30; i++) {
        ctx.fillStyle = randomColor(255);
        ctx.beginPath();
        ctx.arc(randomNum(0, width), randomNum(0, height), 1, 0, 2 * Math.PI);
        ctx.fill();
    }
}

function callVerify() {
    var ajax_url = sessionStorage.getItem('VcUrl').replace("undefined", "") + 'Sso/verifyCode';

    $.ajax({
        url: ajax_url,
        type: 'POST',
        error: function error() {
            console.log('error');
        },
        success: function success(e) {

            $("#codeimage").attr("src", "data:image/jpg;base64," + e.isPass);
            $('#isPass').val(e.SecretKey);
        }
    });
}
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('bulletinService', bulletinService);

    function bulletinService(apiUrl, $http, sysCode, commonService, $q, headerService) {
        var service = {
            getByNo: getByNo,
            getMore: getMore,
            getNoticeMore: getNoticeMore,
            getMoreByChoice: getMoreByChoice,
            getByNoForTsun: getByNoForTsun,
            donwloadStampForUrl: donwloadStampForUrl,
            checkHeadStatus: checkHeadStatus,
            getStampFile: getStampFile,
            getTsunMoreList: getTsunMoreList
        };

        var url = apiUrl.tsApi + 'bulletin/';
        var noticeUrl = apiUrl.tsApi + 'notifyCenter/';

        function getByNo(bulletinSerilNo) {
            var param = {
                bulletinSerilNo: bulletinSerilNo
            };
            commonService.setParams(param);
            headerService.saveEnforcementReadRecord(bulletinSerilNo);
            return $http.post(url + 'bulletin', param);
        }

        function getByNoForTsun(notifySerilNo) {
            var param = {
                notifySerilNo: notifySerilNo,
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            headerService.saveEnforcementReadRecord(notifySerilNo);
            return $http.post(noticeUrl + 'noticeGetForPerson', param);
        }

        function getMore(siteCode, isHistory) {
            var param = {
                siteCode: siteCode,
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            if (isHistory) {
                var bulletinCache = JSON.parse(sessionStorage.getItem('bulletinCache'));
                if (bulletinCache) {
                    if (bulletinCache.menuItem) {
                        param.menuSerilNo = bulletinCache.menuItem.menuSerilNo;
                    }
                    if (bulletinCache.typeSerilNo) {
                        param.bulletinTypeSerilNo = bulletinCache.typeSerilNo;
                    }
                }
            }
            return $http.post(url + 'more', param);
        }

        function getTsunMoreList(param) {

            commonService.setParams(param);
            return $http.post(url + 'noticeMoreList', param);
        }

        function getNoticeMore() {
            var param = {
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            return $http.post(url + 'noticeMore', param);
        }

        function getMoreByChoice(param) {
            commonService.setParams(param);
            return $http.post(url + 'bulletinChoiceByLogin', param);
        }

        function checkHeadStatus() {

            return $q.when(true);
        }

        function donwloadStampForUrl(param) {
            //2023-07-21 Johnson ��w2023
            console.log('donwloadStampForUrl:visualpageController�w����');
        }

        function getStampFile(attachmentSerilNo) {
            // console.log(format('{0}download/{1}/{2}/{3}/{4}/{5}',
            //     url, attachmentSerilNo, sysCode, getMenuQueryString(),
            //     sessionStorage.getItem('token'), sessionStorage.getItem('perSerilNo')))
            return format('{0}download/{1}/{2}/{3}/{4}/{5}', url, attachmentSerilNo, sysCode, getMenuQueryString(), sessionStorage.getItem('token'), sessionStorage.getItem('perSerilNo'));
        }

        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('commonService', commonService);

    function commonService(sysCode, $rootScope, $http, apiUrl) {
        var service = {
            setParams: setParams,
            getFileType: getFileType,
            setCtmsParams: setCtmsParams,
            saveLogFlow: saveLogFlow,
            ctmsFilePath: ctmsFilePath,
            showImg: showImg,
            showVedio: showVedio,
            windowChecker: windowChecker,
            setOneWindow: setOneWindow,
            fetchDecyrptForDirectModifyDto: fetchDecyrptForDirectModifyDto,
            URLCheck: URLCheck
        };
        return service;

        function setOneWindow(varWindow) {
            //因為整個外網要共用同一個另開分頁(new Window)，因此要統一由這邊判斷。
            if (!windowChecker(varWindow)) {
                varWindow = window.open();
            }
            if (!$rootScope.newWindows) {
                $rootScope.newWindows = [];
            }
            _.forEach($rootScope.newWindows, function (perWindow) {
                if (windowChecker(perWindow)) {
                    perWindow.close();
                }
            });
            $rootScope.newWindows = [varWindow];
            return varWindow;
        }

        function windowChecker(varWindow) {
            //驗證是否為視窗。
            var windowChecker = varWindow || {};
            return windowChecker.self === windowChecker;
        }

        function ctmsFilePath(path) {
            var returnPath = sessionStorage.getItem('ctmsFileUrl') + path;
            return returnPath.replace("\\", "/");
        }

        function saveLogFlow(url) {
            url = url.split('?');
            if (url.length > 1) {
                _(url).forEach(function (item) {
                    if (item.match('menu') !== null) {
                        var menuSerilNo = parseInt(item.split('=')[1]);
                        var param = {
                            menuSerilNo: menuSerilNo,
                            menuClickLogCreatePerSerilNo: sessionStorage.getItem('perSerilNo'),
                            langSerilNo: sessionStorage.getItem('langCode')
                        };
                        $http.post(apiUrl.tsApi + 'log/postFlow', param);
                    }
                });
            }
        }
        function URLCheck(url) {
            return url.replace(/</g, '&lt').replace(/>/g, '&gt').replace(/"/g, '&quot').replace(/'/g, '&#x27').replace(/[<>!]|(\(\))|((for|while|if)\s*\(.*\))/g, '');
        }

        function setParams(param) {
            if (sessionStorage.getItem('langCode')) {
                param.langSerilNo = sessionStorage.getItem('langCode');
            } else {
                param.langSerilNo = 1;
            }

            if (sessionStorage.getItem('token')) {
                param.token = sessionStorage.getItem('token');
            } else {
                param.token = "";
            }

            if (sessionStorage.getItem('perSerilNo')) {
                param.perSerilNo = sessionStorage.getItem('perSerilNo');
            } else {
                param.perSerilNo = "";
            }
            param.sysCode = sysCode;
        }

        function setCtmsParams(param) {
            param.UserId = $rootScope.userInfo.userAccount;
            param.LanguageCode = sessionStorage.getItem('userLang');
            param.tkn = sessionStorage.getItem('token');
        }

        function getFileType(fileName) {
            return fileName.split('.')[fileName.split('.').length - 1];
        }

        function showImg(attachmentType) {
            if (attachmentType) {
                switch (attachmentType.toLocaleLowerCase()) {
                    case 'png':
                        return true;
                    case "jpg":
                        return true;
                    case 'jpeg':
                        return true;
                    case 'gif':
                        return true;
                    default:
                        return false;
                }
            }
        }

        function showVedio(attachmentType) {
            if (attachmentType) {
                switch (attachmentType.toLocaleLowerCase()) {
                    case 'mp4':
                        return true;
                    default:
                        return false;
                }
            }
        }

        function fetchDecyrptForDirectModifyDto(param) {
            var newApiURL = apiUrl.tsApi + 'function/fetchDecyrptForDirectModifyDto';
            newApiURL = URLCheck(newApiURL);
            //2023-07-18 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$0.1(2,{3:4});', 5, 5, 'http|get|newApiURL|params|param'.split('|'), 0, {}));
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('ctmsService', ctmsService);

    function ctmsService(commonService, isTestMode, $http, apiUrl, enumService, testData, $rootScope, $q, blockUI) {
        var service = {
            MyTrainingPoint: MyTrainingPoint,
            SysTypesList: SysTypesList,
            ActivityTypesUnderClassification: ActivityTypesUnderClassification,
            FCLicenseList: FCLicenseList,
            CourseItem: CourseItem,
            PublishedActivity: PublishedActivity,
            CourseSession: CourseSession,
            ExamSurveyContent: ExamSurveyContent,
            InteractionData: InteractionData,
            MyUnfinishedActivities: MyUnfinishedActivities,
            MyFinishedActivities: MyFinishedActivities,
            EnrollmentAvailableAction: EnrollmentAvailableAction,
            EnrollmentAction: EnrollmentAction,
            FCCertificatedLicenseAdd: FCCertificatedLicenseAdd,
            FCCertificatedLicenseList: FCCertificatedLicenseList,
            FCAuthorizedHoursList: FCAuthorizedHoursList,
            ExternalTrainingApplication: ExternalTrainingApplication,
            FCEnrollableActivities: FCEnrollableActivities,
            LearningRecordCommit: LearningRecordCommit,
            getStampFile: getStampFile
        };
        return service;
        function MyTrainingPoint(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.MyTrainingPoint(params.Annual);
            } else {
                apiResult = callCtmsApi('MyTrainingPoint.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'MyTrainingPoint.do');
                return returnResult;
            });
        }

        function SysTypesList(params) {
            var apiResult;
            // console.log("SysTypesList params:",params);
            if (isTestMode) {
                apiResult = testData.SysTypesList(params.Type);
            } else {
                apiResult = callCtmsApi('SysTypesList.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'SysTypesList.do');
                return returnResult;
            });
        }

        function ActivityTypesUnderClassification(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = null;
            } else {
                apiResult = callCtmsApi('ActivityTypesUnderClassification.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'ActivityTypesUnderClassification.do');
                return returnResult;
            });
        }

        function FCLicenseList(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCLicenseList(params);
            } else {
                apiResult = callCtmsApi('FCLicenseList.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'FCLicenseList.do');
                return returnResult;
            });
        }

        function CourseItem(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.CourseItem(params);
            } else {
                apiResult = callCtmsApi('CourseItem.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'CourseItem.do');
                return returnResult;
            });
        }

        function PublishedActivity(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.PublishedActivity(params);
            } else {
                apiResult = callCtmsApi('PublishedActivity.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'PublishedActivity.do');
                return returnResult;
            });
        }

        function CourseSession(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.CourseSession(params.CourseType);
            } else {
                apiResult = callCtmsApi('CourseSession.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'CourseSession.do');
                //console.log('sunnet CourseSession result:',returnResult);
                return returnResult;
            });
        }

        function ExamSurveyContent(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.ExamSurveyContent(params);
            } else {
                apiResult = callCtmsApi('ExamSurveyContent.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'ExamSurveyContent.do');
                return returnResult;
            });
        }

        function InteractionData(params) {
            blockUI.start();
            var apiResult;
            if (isTestMode) {
                apiResult = testData.InteractionData(params);
            } else {
                apiResult = callCtmsApi('InteractionData.do', params);
                // apiResult = $http.post(apiUrl.tsApi+'ctms/InteractionData', params);
            }
            return $q.when(apiResult).then(function (data) {
                blockUI.stop();
                var returnResult = ctmsResultFormat(data, 'InteractionData.do');
                return returnResult;
            });
        }

        function MyUnfinishedActivities(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.MyUnfinishedActivities(params);
            } else {
                apiResult = callCtmsApi('MyUnfinishedActivities.do', params);
            }
            return $q.when(apiResult).then(function (data) {

                var returnResult = ctmsResultFormat(data, 'MyUnfinishedActivities.do');
                return returnResult;
            });
        }

        function MyFinishedActivities(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.MyFinishedActivities(params);
            } else {
                apiResult = callCtmsApi('MyFinishedActivities.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'MyFinishedActivities.do');
                return returnResult;
            });
        }

        function EnrollmentAvailableAction(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.EnrollmentAvailableAction(params);
            } else {
                apiResult = callCtmsApi('EnrollmentAvailableAction.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'EnrollmentAvailableAction.do');
                return returnResult;
            });
        }

        function EnrollmentAction(params) {

            // 測試錯誤情況
            // params.IsProgram = 1;

            // Block the user interface
            blockUI.start();

            var apiResult;
            if (isTestMode) {
                apiResult = testData.EnrollmentAction(params);
            } else {
                apiResult = callCtmsApi('EnrollmentAction.do', params);
            }
            return $q.when(apiResult).then(function (data) {

                // Unblock the user interface
                blockUI.stop();

                // console.log('####################')
                // console.log(data)
                var returnResult = ctmsResultFormat(data, 'EnrollmentAction.do');
                if (typeof returnResult.success !== 'undefined' && !returnResult.success) {
                    //代表動作失敗
                    //var errorMsg = returnResult.failMessage || '';
                    var errorMsg = '';
                    var errorCode = returnResult.failCode || '0';
                    errorCode = errorCode + '';
                    switch (errorCode) {
                        case '0':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll0;
                            break;
                        case '1':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll1;
                            break;
                        case '2':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll2;
                            break;
                        case '3':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll3;
                            break;
                        case '4':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll4;
                            break;
                        case '5':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll5;
                            break;
                        case '6':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll6;
                            break;
                        case '7':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll7;
                            break;
                        case '8':
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll8;
                            break;
                        default:
                            errorMsg += $rootScope.translate.tsunErrorCourseEnroll0;
                            break;
                    }
                    toastr.warning($rootScope.translate.tsunSendError + ":" + errorMsg);
                    //==
                    return false;
                }
                return returnResult;
            });
        }

        function FCCertificatedLicenseAdd(params) {
            blockUI.start();
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCCertificatedLicenseAdd(params);
            } else {
                apiResult = callCtmsApi('FCCertificatedLicenseAdd.do', params);
                // apiResult = $http.post(apiUrl.tsApi+'ctms/FinacialLicienceApply', params);
            }
            return $q.when(apiResult).then(function (data) {
                blockUI.stop();
                var returnResult = ctmsResultFormat(data, 'FCCertificatedLicenseAdd.do');
                // console.log('FCCertificatedLicenseAdd returnResult:',returnResult);
                return returnResult;
            });
        }

        function FCCertificatedLicenseList(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCCertificatedLicenseList(params);
            } else {
                apiResult = callCtmsApi('FCCertificatedLicenseList.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'FCCertificatedLicenseList.do');
                return returnResult;
            });
        }

        function FCAuthorizedHoursList(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCAuthorizedHoursList(params);
            } else {
                apiResult = callCtmsApi('FCAuthorizedHoursList.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'FCAuthorizedHoursList.do');
                return returnResult;
            });
        }

        function ExternalTrainingApplication(params) {
            blockUI.start();
            var apiResult;
            if (isTestMode) {
                apiResult = testData.ExternalTrainingApplication(params);
            } else {
                apiResult = callCtmsApi('ExternalTrainingApplication.do', params);
                // apiResult = $http.post(apiUrl.tsApi+'ctms/ExternalCourseApply', params);
            }
            return $q.when(apiResult).then(function (data) {
                blockUI.stop();
                var returnResult = ctmsResultFormat(data, 'ExternalTrainingApplication.do');
                // console.log("ExternalTrainingApplication return data:",returnResult);
                //=========
                var isSuccess = returnResult.failCode + '' === '-1';
                if (isSuccess === false) {
                    var errorMsg = '';
                    var errorCode = returnResult.failCode || '0';
                    errorCode = errorCode + '';
                    switch (errorCode) {
                        case '0':
                            errorMsg += $rootScope.translate.tsunErrorExternalApplication0;
                            break;
                        case '1':
                            errorMsg += $rootScope.translate.tsunErrorExternalApplication1;
                            break;
                        case '2':
                            errorMsg += $rootScope.translate.tsunErrorExternalApplication2;
                            break;
                        case '3':
                            errorMsg += $rootScope.translate.tsunErrorExternalApplication3;
                            break;
                    }
                    toastr.warning($rootScope.translate.tsunSendError + ":" + errorMsg);
                }
                return isSuccess;
            });
        }

        function FCEnrollableActivities(params) {
            var apiResult;
            if (isTestMode) {
                apiResult = testData.FCEnrollableActivities(params);
            } else {
                apiResult = callCtmsApi('FCEnrollableActivities.do', params);
            }
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'FCEnrollableActivities.do');
                return returnResult;
            });
        }
        function LearningRecordCommit(params) {

            // chris: log for mobile
            //postException(`ctms-learning-record: ${JSON.stringify(params)}`, apiUrl)

            console.log('LearningRecordCommit param:', params);
            var apiResult;
            if (isTestMode) {
                apiResult = testData.LearningRecordCommit(params);
            } else {
                apiResult = callCtmsApi('LearningRecordCommit.do', params);
            }

            //console.log('LearningRecordCommit Result:',apiResult);
            return $q.when(apiResult).then(function (data) {
                var returnResult = ctmsResultFormat(data, 'LearningRecordCommit.do');
                return returnResult;
            });
        }
        function callCtmsApi(action, params) {
            var actionUrl = apiUrl.ctmsApi + action;
            return $http.post(actionUrl, params, {
                headers: { 'Content-Type': 'application/json' }
            });
        }

        function ctmsResultFormat(result, apiAction) {
            var resultData = result.data;
            var returnResult = null;
            switch (resultData.Status + '') {
                case '200':
                    if (resultData.ErrorMessage) {
                        toastr.warning(resultData.ErrorMessage);
                    } else {
                        returnResult = resultData.Data || {};
                    }
                    //console.log('returnResult 200 :',resultData.Data);
                    break;
                case '400':
                    // toastr.warning($rootScope.translate.tsunSendError + "Api[" + apiAction + "]," + resultData.ErrorMessage);
                    toastr.warning($rootScope.translate.tsunSendError + ':' + resultData.ErrorMessage);
                    returnResult = false;
                    break;
                default:
                    apiAction = apiAction || '';
                    var errorLog = " Error,call sunNet Api[" + apiAction + "], msg:" + resultData.ErrorMessage;
                    postException(errorLog, apiUrl);
                    showSystemError();
                    returnResult = false;
                    break;
            }
            //console.log('returnResult:',returnResult);
            return returnResult;
        }

        function getStampFile(attachmentPath, attachmentName) {

            console.log('getStampFile apiUrl:', apiUrl.tsApi + 'ctms/DownloadPdf');
            console.log('getStampFile token:', sessionStorage.getItem('token'));
            console.log('getStampFile SysCode:', 'MHR');
            console.log('getStampFile attachmentPath:', attachmentPath.replace(".pdf", ""));
            console.log('getStampFile attachmentName', attachmentName);
            console.log('getStampFile attachmentPath:', attachmentPath.replace("/", "_").replace("\\", "_").replace(".pdf", ""));

            return format('{0}/{1}/{2}/{3}/{4}', apiUrl.tsApi + 'ctms/DownloadPdf', sessionStorage.getItem('token'), "MHR", attachmentPath.replaceAll("/", "_").replaceAll("\\", "_").replace(".pdf", ""), attachmentName);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('e2eService', e2eService);

    function e2eService() {
        var service = {
            login: login,
            forgetPwd: forgetPwd,
            forceEditPwd: forceEditPwd,
            register: register,
            editPwdModal: editPwdModal,
            contactMe: contactMe,
            directEditPwd: directEditPwd
        };

        return service;

        ////////////////
        function login(param) {
            //2023-07-10 Johnson ��w2023
            return param;
        }

        function forgetPwd(param) {
            //2023-07-10 Johnson ��w2023
        }

        function forceEditPwd(params) {
            //2023-07-10 Johnson ��w2023
        }

        function register(params) {
            //2023-07-10 Johnson ��w2023
        }

        function editPwdModal(params) {
            //2023-07-10 Johnson ��w2023
        }

        function contactMe(params) {
            //2023-07-10 Johnson ��w2023
        }

        function directEditPwd(param) {
            //2023-07-10 Johnson ��w2023
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('enumService', enumService);

    function enumService() {
        var service = {
            sso: {},
            redirectType: {},
            target: {},
            sendTarget: {},
            siteCode: {},
            courseType: {}
        };

        service.sso = {
            success: '100',
            notExist: '201',
            disable: '202',
            isLock: '203',
            lockUnReslove: '204',
            dwpError: '205', //2023-07-10 Johnson 資安2023
            tokenNotExist: '206',
            notHaveEmail: '210',
            notHavePhone: '211',
            notFindAccount: '212',
            emailAlreadyRegister: '219',
            dwpMustBigThan: '220', //2023-07-10 Johnson 資安2023
            dwpNotSameAccount: '221', //2023-07-10 Johnson 資安2023
            dwpJustEnAndNumber: '222', //2023-07-10 Johnson 資安2023
            dwpNeedContainEnAndNumber: '223', //2023-07-10 Johnson 資安2023
            dwpNotContainueThree: '224', //2023-07-10 Johnson 資安2023
            dwpNotContainueThreeOrderAndDesc: '225', //2023-07-10 Johnson 資安2023
            dwpNotSameRecent: '226', //2023-07-10 Johnson 資安2023
            accountIsNotActive: '227',
            verifyCodeNotExist: '228',
            verifyCodeExpired: '229',
            dwpModifyWeek: '230', //2023-07-10 Johnson 資安2023
            dwpErrorIsLock: '231', //2023-07-10 Johnson 資安2023
            mustModifydwP: '232', //2023-07-10 Johnson 資安2023
            verifyCodeNotPass: '234',
            illegalRegister: '235',
            newdwPNotSameOlddwP: '236',
            userAlreadyValidate: '237',
            waitForLock: '238',
            error: '300',
            verifyCodeInValid: '500',
            isTaiEmail: '301',
            reCaptchaFail: '999'
        };

        service.redirectType = {
            direct: 0,
            open: 1
        };

        service.target = {
            open: 1,
            wrap: 2,
            direct: 3
        };

        service.sendTarget = {
            email: 1,
            sms: 2
        };

        service.siteCode = {
            hrInside: 1,
            hrOutside: 2,
            hrAdmin: 3,
            tsunOut: 4,
            tsunInside: 5
        };

        service.courseType = {
            webCourse: 1,
            classCourse: 2,
            externalCourse: 3,
            webTest: 4,
            classTest: 5,
            questList: 6,
            courage: 7
        };

        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('headerService', headerService);

    function headerService(apiUrl, $http, commonService, loginService) {
        var service = {
            getSearch: getSearch,
            getMenuName: getMenuName,
            getSearchResult: getSearchResult,
            searchMsg: searchMsg,
            getRelatedFunctions: getRelatedFunctions,
            getMenuManagers: getMenuManagers,
            contactMe: contactMe,
            getUrlSetting: getUrlSetting,
            setFontSize: setFontSize,
            getFontSize: getFontSize,
            saveEnforcementReadRecord: saveEnforcementReadRecord,
            saveBulletinClickingAttachment: saveBulletinClickingAttachment,
            saveMenuClickingAttachment: saveMenuClickingAttachment,
            saveLearnLog: saveLearnLog,
            getMenuList: getMenuList
        };

        var headerUrl = apiUrl.tsApi + 'header/';

        function getSearch(keyWord, siteCode) {

            var param = {
                keyWord: keyWord,
                SiteCode: siteCode,
                CurrentMenuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            return $http.post(headerUrl + 'getSearch/', param);
        }

        function getSearchResult(keyWord, currentPage, searchResultType, siteCode, needLog) {
            var param = {
                keyWord: keyWord,
                SiteCode: siteCode,
                currentPage: currentPage,
                searchResultEnum: searchResultType,
                needKeywordLog: needLog
            };
            commonService.setParams(param);
            return $http.post(headerUrl + 'getSearchResult/', param);
        }

        function getMenuName(menuId) {
            var newApiURL = headerUrl + 'getMenuName/' + menuId;
            newApiURL = commonService.URLCheck(newApiURL);
            //2023-07-20 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}));
        }

        function searchMsg(msg) {
            return msg;
        }

        function getRelatedFunctions(menuId) {
            var newApiURL = headerUrl + 'getRelatedFunctions/2/' + menuId;
            newApiURL = commonService.URLCheck(newApiURL);
            //2023-07-20 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}));
        }

        function getMenuManagers(menuId) {
            var newApiURL = headerUrl + 'getMenuManagers/' + menuId;
            newApiURL = commonService.URLCheck(newApiURL);
            //2023-07-20 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}));
        }

        function contactMe(param) {
            //recaptcha.response = recaptcha.response + 'ee';

            return $http.post(headerUrl + 'PostContactMe', param).then(function (res) {
                if (res.data === true) {
                    return true;
                } else {
                    return false;
                }
            });

            //未登入狀態下，先做reCaptcha驗證
            // return $http.post(apiUrl.tsApi + 'validate/gRecaptchaValidate', vm.reCaptcha).then(function (verifyResult) {
            //     if (verifyResult.data.success) {
            //         headerService.contactMe(vm.data).then(function () {
            //             toastr.success($rootScope.translate.sendMailSuccess);
            //             $uibModalInstance.dismiss('cancel');
            //         });
            //     } else {
            //         //Error Handler write here
            //         toastr.warning($rootScope.translate.commonReCaptchaFail);
            //         return false;
            //     }
            // });
        }

        function getUrlSetting() {
            var param = {};
            commonService.setParams(param);
            return $http.post(headerUrl + 'getUrlSetting', param);
        }

        function setFontSize(fontSize) {
            var param = {
                fontSize: fontSize
            };
            commonService.setParams(param);
            return $http.post(headerUrl + 'setFontSize', param);
        }

        function getFontSize() {
            if (sessionStorage.getItem('perSerilNo')) {
                var newApiURL = headerUrl + 'getFontSize/' + sessionStorage.getItem('langCode') + '/' + sessionStorage.getItem('perSerilNo');
                newApiURL = commonService.URLCheck(newApiURL);
                //2023-07-20 Johnson 資安2023
                return eval(function (p, a, c, k, e, r) {
                    e = String;if (!''.replace(/^/, String)) {
                        while (c--) {
                            r[c] = k[c] || c;
                        }k = [function (e) {
                            return r[e];
                        }];e = function e() {
                            return '\\w+';
                        };c = 1;
                    };while (c--) {
                        if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                    }return p;
                }('$2.3(4+\'5/\'+0.1(\'6\')+\'/\'+0.1(\'7\'));', 8, 8, 'sessionStorage|getItem|http|get|headerUrl|getFontSize|langCode|perSerilNo'.split('|'), 0, {}));
            } else {
                var _newApiURL = headerUrl + 'getFontSize/' + sessionStorage.getItem('langCode');
                _newApiURL = commonService.URLCheck(_newApiURL);
                //2023-07-20 Johnson 資安2023
                return eval(function (p, a, c, k, e, r) {
                    e = String;if (!''.replace(/^/, String)) {
                        while (c--) {
                            r[c] = k[c] || c;
                        }k = [function (e) {
                            return r[e];
                        }];e = function e() {
                            return '\\w+';
                        };c = 1;
                    };while (c--) {
                        if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                    }return p;
                }('$0.1(2+\'3/\'+4.5(\'6\'));', 7, 7, 'http|get|headerUrl|getFontSize|sessionStorage|getItem|langCode'.split('|'), 0, {}));
            }
        }

        function saveEnforcementReadRecord(bulletinSerilNo) {
            var param = {
                bulletinSerilNo: bulletinSerilNo,
                perSerilNo: sessionStorage.getItem('perSerilNo')
            };
            return $http.post(headerUrl + 'saveEnforcementReadRecord/', param);
        }

        function saveBulletinClickingAttachment(params) {
            $http.post(apiUrl.tsApi + 'log/saveBulletinClickingAttachment', params);
        }

        function saveMenuClickingAttachment(param) {
            $http.post(apiUrl.tsApi + 'log/saveMenuClickingAttachment', param);
        }

        function saveLearnLog(str) {
            $http.post(apiUrl.tsApi + 'log/saveLearnLog', str);
        }

        function getMenuList() {
            var menuparam = {
                LangSerilNo: sessionStorage.getItem('langCode'),
                userLang: sessionStorage.getItem('userLang'),
                SiteCode: "2,4",
                PerSerilNo: sessionStorage.getItem('perSerilNo'),
                IsNormal: true,
                IsSpecial: false,
                IsSetting: false
            };
            return $http.post(apiUrl.tsApi + 'menu/getMobileMenuList', menuparam);
        }

        return service;
    }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app.service').factory('homeService', homeService);

	function homeService(commonService, $http, apiUrl) {
		var service = {
			getMhr: getMhr,
			getTsu: getTsu,
			getNext: getNext,
			getNextMore: getNextMore
		};

		var homeUrl = apiUrl.tsApi + 'home/';

		function getMhr() {
			var param = {
				menuSerilNo: getMenuQueryString()
			};
			commonService.setParams(param);
			return $http.post(homeUrl + 'getMhr', param);
		}

		function getTsu() {
			var param = {
				menuSerilNo: getMenuQueryString(),
				siteCode: 4
			};
			commonService.setParams(param);
			return $http.post(homeUrl + 'getTsu', param);
		}

		function getNext() {
			var param = {
				menuSerilNo: getMenuQueryString(),
				siteCode: 2

			};
			commonService.setParams(param);

			return $http.post(homeUrl + 'getNext', param);
		}

		function getNextMore(currentPage) {
			var param = {
				currentPage: currentPage,
				menuSerilNo: getMenuQueryString(),
				siteCode: 2
			};
			commonService.setParams(param);
			return $http.post(homeUrl + 'getNextMore', param);
		}

		return service;
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('loginService', loginService);

    function loginService($http, apiUrl, enumService, $rootScope, sysCode, commonService) {
        var service = {
            login: login,
            loginByPerSerilNo: loginByPerSerilNo,
            logout: logout,
            tokenTransfer: tokenTransfer,
            tokenTransferByAccount: tokenTransferByAccount,
            modifyUserPassword: modifyUserPassword,
            forgetPWD: forgetPWD,
            directModifyUserPassword: directModifyUserPassword,
            registerOutsideUser: registerOutsideUser,
            checkToken: checkToken,
            getSsoInfo: getSsoInfo,
            setSsoParams: setSsoParams,
            get: get,
            editUserProfile: editUserProfile,
            sendVerifyCodeFromPhone: sendVerifyCodeFromPhone,
            verifyCodeCheckFromPhone: verifyCodeCheckFromPhone,
            validateTel: validateTel,
            getPwdConstrain: getPwdConstrain,
            checkVerifyCode: checkVerifyCode,
            produceVerifyCodeFromSignUp: produceVerifyCodeFromSignUp,
            verifyCodeCheckFromSignUp: verifyCodeCheckFromSignUp
            // QueryCaptcha: QueryCaptcha,
            // chkCaptcha: chkCaptcha,

        };

        function replaceFunc(data) {
            if (editPwdErrorLogic(data.data.Result, data.data.ResultValue)) {
                return data.data;
            }
        }

        function basicFunc(data) {
            if (handleSsoLogic(data.data.Result)) {
                return data.data;
            }
        }

        function multipleSerNoFunc(data) {
            if (data.data.length === 1 && handleSsoLogic(data.data[0].Result, data.data[0].ResultValue)) {
                return data.data[0];
            } else if (data.data.length > 1) {
                return data.data;
            }
        }

        function setSsoParams(param) {
            param.sysCode = sysCode;
            if (sessionStorage.getItem('token')) {
                param.token = sessionStorage.getItem('token');
            }
        }

        function get() {
            var param = {
                langSerilNo: 1
            };

            return $http.post(apiUrl.tsApi + 'login', param);
        }

        function handleSsoLogic(ssoCode, resultNumber) {
            if (!resultNumber) {
                resultNumber = 1;
            }

            switch (ssoCode) {
                case enumService.sso.success:
                    return true;
                case enumService.sso.error:
                    toastr.error($rootScope.translate.commonErrorMessage);
                    return false;
                case enumService.sso.mustModifydwP:
                    //2023-07-10 Johnson 資安2023
                    toastr.info($rootScope.translate.ssoMustModifyPwd);
                    return true;
                case enumService.sso.commonErrorMessage:
                    toastr.error($rootScope.translate.commonErrorMessage);
                    return false;
                case enumService.sso.notExist:
                    //toastr.error($rootScope.translate.ssoAccountNotExist);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.disable:
                    //toastr.error($rootScope.translate.commonDisable);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.isLock:
                    toastr.error($rootScope.translate.commonIsLock);
                    return false;
                case enumService.sso.tokenNotExist:
                    toastr.error($rootScope.translate.commonNotExistToken);
                    return false;
                case enumService.sso.dwpError:
                    //2023-07-10 Johnson 資安2023
                    //toastr.error($rootScope.translate.commonNotExist);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.notFindAccount:
                    toastr.error($rootScope.translate.ssoNotFindAccount);
                    return false;
                case enumService.sso.accountIsNotActive:
                    //toastr.error($rootScope.translate.ssoAccountIsNotActive);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.illegalRegister:
                    toastr.error($rootScope.translate.illegalRegister);
                    return false;
                case enumService.sso.dwpErrorIsLock:
                    //2023-07-10 Johnson 資安2023
                    //toastr.error($rootScope.translate.ssoPwdErrorIsLock);
                    toastr.error($rootScope.translate.ssoErrorInCommonUse);
                    return false;
                case enumService.sso.lockUnReslove:
                    var commonUnLock = _.replace($rootScope.translate.commonUnLock, '?', resultNumber);
                    toastr.error(commonUnLock);
                    return false;
                case enumService.sso.waitForLock:
                    toastr.error($rootScope.translate.waitForLock);
                    return false;
                case enumService.sso.isTaiEmail:
                    toastr.warning($rootScope.translate.ssoIsTaiEmail);
                    return false;
                case enumService.sso.reCaptchaFail:
                    toastr.warning($rootScope.translate.commonReCaptchaFail);
                    return false;
            }
        }

        function editPwdErrorLogic(ssoCode, resultNumber) {
            var ssoPwdMustBigThan = _.replace($rootScope.translate.ssoPwdMustBigThan, '?', resultNumber);
            var ssoPwdNotSameRecent = _.replace($rootScope.translate.ssoPwdNotSameRecent, '?', resultNumber);
            var ssoPwdModifyWeek = _.replace($rootScope.translate.ssoPwdModifyWeek, '?', resultNumber);

            switch (ssoCode) {
                case enumService.sso.userAlreadyValidate:
                    toastr.info($rootScope.translate.userAlreadyValidate);
                    return false;
                case enumService.sso.dwpError:
                    //2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.commonPwdError);
                    return false;
                case enumService.sso.dwpJustEnAndNumber:
                    //2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdJustEnAndNumber);
                    return false;
                case enumService.sso.dwpMustBigThan:
                    //2023-07-10 Johnson 資安2023
                    toastr.error(ssoPwdMustBigThan);
                    return false;
                case enumService.sso.dwpNeedContainEnAndNumber:
                    //2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdNeedContainEnAndNumber);
                    return false;
                case enumService.sso.notExist:
                    toastr.error($rootScope.translate.ssoAccountNotExist);
                    return false;
                case enumService.sso.dwpNotContainueThree:
                    //2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdNotContainueThree);
                    return false;
                case enumService.sso.dwpNotContainueThreeOrderAndDesc:
                    //2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdNotContainueThreeOrderAndDesc);
                    return false;
                case enumService.sso.dwpNotSameAccount:
                    //2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.ssoPwdNotSameAccount);
                    return false;
                case enumService.sso.dwpNotSameRecent:
                    //2023-07-10 Johnson 資安2023
                    toastr.error(ssoPwdNotSameRecent);
                    return false;
                case enumService.sso.accountNotExist:
                    toastr.error($rootScope.translate.ssoAccountNotExist);
                    return false;
                case enumService.sso.verifyCodeExpired:
                    toastr.error($rootScope.translate.ssoVerifyCodeExpired);
                    return false;
                case enumService.sso.verifyCodeNotExist:
                    toastr.error($rootScope.translate.ssoVerifyCodeNotExist);
                    return false;
                case enumService.sso.emailAlreadyRegister:
                    toastr.error($rootScope.translate.emailAlreadyRegister);
                    return false;
                case enumService.sso.dwpModifyWeek:
                    //2023-07-10 Johnson 資安2023
                    toastr.error(ssoPwdModifyWeek);
                    return false;
                case enumService.sso.verifyCodeInValid:
                    toastr.error($rootScope.translate.ssoVerifyCodeInValid);
                    return false;
                case enumService.sso.verifyCodeNotPass:
                    toastr.error($rootScope.translate.verifyCodeNotPass);
                    return false;
                case enumService.sso.newdwPNotSameOlddwP:
                    //2023-07-10 Johnson 資安2023
                    //2023-07-10 Johnson 資安2023
                    toastr.error($rootScope.translate.newdwPNotSameOlddwP);
                    return false;
                case enumService.sso.notHavePhone:

                    toastr.error($rootScope.translate.ssoNotHavePhone);
                    return false;
                case enumService.sso.notHaveEmail:
                    toastr.error($rootScope.translate.ssoNotHaveEmail);
                    return false;
                default:
                    return handleSsoLogic(ssoCode);
            }
        }

        function login(params) {
            setSsoParams(params);
            //test error situation
            //recaptcha.response = recaptcha.response + 'ee';
            //console.log('params:', params);

            return $http.post(apiUrl.ssoApi + 'sso/login', params).then(function (data) {
                //console.log('response:', data);
                if (data) {
                    return multipleSerNoFunc(data);
                }
            });
        }

        function loginByPerSerilNo(params) {
            setSsoParams(params);
            return $http.post(apiUrl.ssoApi + 'sso/loginByPerSerilNo', params).then(function (data) {
                return basicFunc(data);
            });
        }

        function logout() {
            var params = {
                'sysCode': sysCode,
                'token': sessionStorage.getItem('token')
            };
            return $http.post(apiUrl.ssoApi + 'sso/logout', params).then(function (data) {
                return basicFunc(data);
            });
        }

        function tokenTransfer(params) {
            return $http.post(apiUrl.ssoApi + 'sso/tokenTransfer', params).then(function (data) {
                return multipleSerNoFunc(data);
            });
        }

        function tokenTransferByAccount(params) {
            return $http.post(apiUrl.ssoApi + 'sso/tokenTransferByAccount', params).then(function (data) {
                return multipleSerNoFunc(data);
            });
        }

        function modifyUserPassword(params) {
            return getSsoInfo().then(function (data) {
                return data.data.userAccount;
            }).then(function (account) {
                params.userAccount = account;
                return $http.post(apiUrl.ssoApi + 'Password/ModifyUserPassword', params).then(function (data) {
                    return replaceFunc(data);
                });
            });
        }

        function forgetPWD(params, recaptcha) {
            //test error situation
            //recaptcha.response = recaptcha.response + 'ee';
            return $http.post(apiUrl.ssoApi + 'Password/ForgetPWD', params).then(function (data) {
                //console.log('resData:', data.data);
                if (data.data) {
                    if (editPwdErrorLogic(data.data.Result, 0)) {
                        return data.data;
                    }
                }
            });
        }

        function directModifyUserPassword(params) {
            return $http.post(apiUrl.ssoApi + 'Password/directModifyUserPassword', params).then(function (data) {
                return replaceFunc(data);
            });
        }

        function checkToken() {
            var param = {};
            setSsoParams(param);
            return $http.post(apiUrl.ssoApi + 'sso/checkToken', param);
        }

        function registerOutsideUser(params) {
            //alert('apiUrl.ssoApi:'+apiUrl.ssoApi);
            return $http.post(apiUrl.ssoApi + 'user/registerOutsideUser', params).then(function (data) {
                if (editPwdErrorLogic(data.data.Result, data.data.ResultValue)) {
                    return data.data;
                }
            });
        }

        function getSsoInfo() {
            var param = {
                perSerilNo: sessionStorage.getItem('perSerilNo'),
                sysCode: sysCode,
                token: sessionStorage.getItem('token')
            };
            return $http.post(apiUrl.tsApi + 'employee/ssoInfo', param);
        }

        function editUserProfile(param) {
            setSsoParams(param);
            param.perSerilNo = sessionStorage.getItem('perSerilNo');
            $http.post(apiUrl.tsApi + 'employee/editProfile', param).then(function () {
                sessionStorage.setItem('cName', param.cName);
                $rootScope.$emit('emitCName', param.cName);
                toastr.success($rootScope.translate.commonSaveSuccess);
            });
        }

        function sendVerifyCodeFromPhone(account, recaptcha) {
            var param = {
                userAccount: account
            };
            commonService.setParams(param);
            return $http.post(apiUrl.ssoApi + 'sso/produceVerifyCodeFromPhone', param).then(function (data) {
                return handleSsoLogic(data);
            });
        }

        function verifyCodeCheckFromPhone(param) {
            commonService.setParams(param);
            return $http.post(apiUrl.ssoApi + 'sso/VerifyCodeCheckFromPhone', param).then(function (data) {
                return replaceFunc(data);
            });
        }

        function validateTel(param) {
            return $http.post(apiUrl.ssoApi + 'user/ValidateTel', param);
        }

        function getPwdConstrain() {
            var params = {
                langSerilNo: sessionStorage.getItem('langCode'),
                sysCode: sysCode,
                token: sessionStorage.getItem('token')
            };
            return $http.post(apiUrl.ssoApi + 'password/getPwdConstrainForLanguage', params);
        }

        function checkVerifyCode(params) {
            return $http.post(apiUrl.ssoApi + 'user/CheckVerifyCode', params);
        }

        function produceVerifyCodeFromSignUp(param) {
            return $http.post(apiUrl.ssoApi + 'user/produceVerifyCodeFromSignUp', param).then(function (data) {
                return handleSsoLogic(data);
            });
        }

        function verifyCodeCheckFromSignUp(param) {
            return $http.post(apiUrl.ssoApi + 'user/verifyCodeCheckFromSignUp', param).then(function (data) {
                return handleSsoLogic(data);
            });
        }

        // function QueryCaptcha() {
        //     return $http.post(apiUrl.ssoApi + 'sso/QueryCaptcha').then(function (data) {
        //         return handleSsoLogic(data);
        //     });
        // }
        // function chkCaptcha() {
        //     return $http.post(apiUrl.ssoApi + 'sso/chkCaptcha').then(function (data) {
        //         return handleSsoLogic(data);
        //     });
        // }
        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('menuService', menuService);

    function menuService($location, enumService, $http, apiUrl, $window, commonService, $timeout) {
        var service = {
            redirectUrl: redirectUrl,
            generateUrl: generateUrl,
            getInformationBySerilNo: getInformationBySerilNo
        };

        var menuUrl = apiUrl.tsApi + 'menu/';

        function getInformationBySerilNo(menuSerilNo, langSerilNo) {
            var newApiURL = menuUrl + 'getByMenuSerilNo/' + menuSerilNo + '/' + langSerilNo;
            newApiURL = commonService.URLCheck(newApiURL);
            //2023-07-20 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}));
        }

        function redirectUrl(item) {
            var cloneItem = _.cloneDeep(item);
            var param = {
                menuSerilNo: cloneItem.menuSerilNo
            };
            param.menuClickLogCreatePerSerilNo = '';
            param.langSerilNo = '';

            commonService.setParams(param);
            if (sessionStorage.getItem('perSerilNo')) {
                param.menuClickLogCreatePerSerilNo = sessionStorage.getItem('perSerilNo');
            }

            if (sessionStorage.getItem('langCode')) {
                param.langSerilNo = sessionStorage.getItem('langCode');
            }

            $http.post(apiUrl.tsApi + 'log/postFlow', param);
            $http.post(menuUrl + 'checkMenuIsPass', param).then(function () {
                redirectByTarget(cloneItem, sessionStorage.getItem('token'));
            });
        }

        function redirectByTarget(item, token) {

            // 目前外網只有一種轉頁方式: 本頁直接跳轉
            redirectDirect(item, token);

            // if (item.isWindowOpen || item.target === enumService.target.open) {
            //     redirectOpen(item, token);
            //     return;
            // }

            // if (item.target === enumService.target.wrap) {
            //     redirectWrap(item, token);
            //     return;
            // }

            // if (item.target === enumService.target.direct) {
            //     redirectDirect(item, token);
            //     return;
            // }
        }

        // function redirectOpen(item, token) {
        //     generateUrl(item, token);
        //     if (item.isWindowOpen) {
        //         window.open(item.url, 'searchResult');
        //     } else {
        //         window.open(item.url);
        //     }
        // }

        // function redirectWrap(item) {
        //     $location.path('external').search('menu', item.menuSerilNo);
        // }

        function redirectDirect(item, token) {

            if (!isOutSideUrl(item)) {
                $location.path(item.url).search('menu', item.menuSerilNo);
                return;
            }

            if (item.sysCode) {
                //item.url += '?menu=' + item.menuSerilNo;
                generateUrl(item, token);
            }

            $timeout(function () {
                //console.log(item.url);
                $window.location.href = item.url;
            }, 200);
        }

        function generateUrl(item, token) {

            if (!isOutSideUrl(item)) {
                item.url = format('//{0}/#{1}', location.host, item.url);
            }

            if (sessionStorage.getItem('token') && item.sysCode) {

                // 為了避免用戶把網址直接複製給別人
                // 所以如果是自己的功能就不加上Token
                // 如果是其他掛載的頁面，由於不知道是去那裡，所以就給予 token 讓台新其他功能(線上差勤)取用
                var isInitialMenu = item.initialData;

                if (item.url.indexOf('?menu') > -1) {
                    item.url = item.url.split('?menu=')[0];
                    //console.log('1.',item.url);
                    if (isInitialMenu) {
                        item.url += format('?menu={0}', item.menuSerilNo);
                        //console.log('2.',item.url);
                    } else {
                        item.url += format('?tkn={0}&menu={1}', token, item.menuSerilNo);
                        //console.log('3.',item.url);
                    }

                    return;
                }

                if (item.url.indexOf('?') > -1) {

                    if (isInitialMenu) {
                        item.url += format('&menu={0}', item.menuSerilNo);
                        //console.log('4.',item.url);
                    } else {
                        item.url += format('&tkn={0}&menu={1}', token, item.menuSerilNo);
                        //console.log('5.',item.url);
                    }
                    return;
                }

                if (item.url.indexOf('?') === -1) {

                    if (isInitialMenu) {
                        item.url += format('?menu={0}', item.menuSerilNo);
                        //console.log('6.',item.url);
                    } else {
                        item.url += format('?tkn={0}&menu={1}', token, item.menuSerilNo);
                        //console.log('7.',item.url);
                    }
                    return;
                }
            } else {
                if (item.url.indexOf('?menu') > -1) {
                    item.url = item.url.split('?menu=')[0];
                    item.url += format('?menu={0}', item.menuSerilNo);
                    //console.log('8.',item.url);
                    return;
                }

                if (item.url.indexOf('?') > -1) {
                    item.url += format('&menu={0}', item.menuSerilNo);
                    //console.log('9.',item.url);
                    return;
                }

                if (item.url.indexOf('?') === -1) {
                    item.url += format('?menu={0}', item.menuSerilNo);
                    //console.log('10.',item.url);
                    return;
                }
            }
        }

        function isOutSideUrl(item) {

            var result = _.startsWith(item.url, '//') || _.startsWith(item.url, 'http://') || _.startsWith(item.url, 'https://') || _.startsWith(item.url, 'line://');
            return result;
        }

        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('mobileService', mobileService);

    function mobileService(apiUrl, $http, $q) {
        var service = {
            postMobileInfo: postMobileInfo,
            postCourseInfo: postCourseInfo
        };

        return service;

        ////////////////
        function postMobileInfo(data) {
            // 通知 APP 登入成功 (給予 token 資料)
            //alert('DEVICE_TYPE:',DEVICE_TYPE);
            if (DEVICE_TYPE) {
                var params = {
                    token: data.Token
                };
                var method = "login";
                appCallback(method, params);
            }
            var param = {
                DEVICE_TYPE: DEVICE_TYPE,
                DEVICE_TOKEN: DEVICE_TOKEN,
                USER_TOKEN: data.Token,
                PerSerilNo: data.PerSerilNo || data.PerserilNo
            };
            var isMobileApp = true;

            if (!param.DEVICE_TOKEN || DEVICE_TOKEN.length < 1) {
                isMobileApp = false;
            } else {
                if (param.DEVICE_TYPE !== '' && param.DEVICE_TYPE !== '(null)' && param.DEVICE_TYPE.toLowerCase() === 'ios') {
                    var message = { 'DEVICE_TOKEN': param.DEVICE_TOKEN, 'DEVICE_TYPE': param.DEVICE_TYPE };
                    window.webkit.messageHandlers.msgHandler.postMessage(message);
                }
            }
            if (!isMobileApp) {
                return $q.when({});
            }
            $http.post(apiUrl.tsApi + 'mobile', param);
        }

        function postCourseInfo(params) {
            window.webkit.messageHandlers.msgHandler.postMessage(JSON.stringify(params));
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('modalService', modalService);

    function modalService($uibModal, $q, loginService, $timeout) {
        var service = {
            login: login,
            forgetPwd: forgetPwd,
            register: register,
            getChoicePerSerilNo: getChoicePerSerilNo,
            getTaiClass: getTaiClass,
            getWindowClass: getWindowClass,
            isMobile: isMobile,
            isIos: isIos,
            touchWithMe: touchWithMe,
            explanation: explanation,
            setting: setting,
            courseDetail: courseDetail,
            editPwd: editPwd,
            phoneNumber: phoneNumber,
            trainingSelectAction: trainingSelectAction,
            selectActionConfirm: selectActionConfirm,
            confrimDialog: confrimDialog,
            openOptionSelector: openOptionSelector
        };
        return service;
        //=================

        function isMobile() {
            // console.log("check isMobile");
            // console.log("window.orientation:", window.orientation);
            // console.log("navigator.userAgent.indexOf(\"IEMobile\"):", navigator.userAgent.indexOf("IEMobile"));
            return typeof window.orientation !== "undefined" || navigator.userAgent.indexOf("IEMobile") !== -1;
        }

        function isIos() {
            return navigator.userAgent.match(/ip(hone|ad|od)/i) && !navigator.userAgent.match(/(iemobile)[\/\s]?([\w\.]*)/i);
        }

        function getTaiClass() {
            if (service.isMobile()) {
                return 'mobile-modal-dialog,mobile-modal-content';
            }
        }

        function getWindowClass() {
            if (!service.isMobile()) {
                return 'modal-margin-top';
            }
        }

        function getChoicePerSerilNo(param) {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/choicePerSerilNoModal.html',
                controller: 'choicePerSerilNoModalController as vm',
                size: 'sm',
                taiClass: getTaiClass(),
                resolve: {
                    data: function data() {
                        return param;
                    }
                }
            });
            return modal;
        }

        function login() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/loginModal.html',
                controller: 'loginModalController as vm',
                size: 'sm',
                taiClass: getTaiClass()
            });
            modal.closed.then(onDestroy);

            return modal;
            //==
            function onDestroy() {
                var defer = $q.defer();
                var reCaptchaCheckChild = null;
                do {
                    if (reCaptchaCheckChild) {
                        //first round skip
                        var reCaptchaCheck = reCaptchaCheckChild.parentElement;
                        if (reCaptchaCheck && reCaptchaCheck.parentElement) {
                            reCaptchaCheck.parentElement.removeChild(reCaptchaCheck);
                        }
                    }
                    reCaptchaCheckChild = document.getElementsByClassName("g-recaptcha-bubble-arrow")[0];
                } while (reCaptchaCheckChild);

                defer.resolve('Success!');
                return defer.promise;
            }
        }

        function forgetPwd() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/forgetPwdModal.html',
                controller: 'forgetPwdModalController as vm',
                size: 'sm',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function register() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/registerModal.html',
                controller: 'registerModalController as vm',
                size: 'lg',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function touchWithMe() {
            //20180315 Anthony 
            //在開啟這modal時，資料延遲有時間差，所以調整成先拿完資料再開啟

            //20180326 Anthony Add new variable for login/nonLogin
            var delaySec = 1;
            var _userData = {
                cName: null,
                email: null,
                isLogin: false
            };

            if (sessionStorage.getItem('token')) {
                loginService.getSsoInfo().then(function (data) {
                    _userData.cName = sessionStorage.getItem('cName');
                    _userData.email = data.data.email;
                    _userData.isLogin = true;
                });

                delaySec = 1500;
            }

            //sso 資料回傳有延遲，這裡延遲開啟modal
            $timeout(function () {
                var modal = $uibModal.open({
                    templateUrl: 'controller/common/modal/contectModal.html',
                    controller: 'contectModalController as vm',
                    size: 'sm',
                    taiClass: getTaiClass(),
                    resolve: {
                        userData: function userData() {
                            return _userData;
                        }
                    }
                });
                return modal;
            }, delaySec);
        }

        function confrimDialog(_config) {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/confirmDialog/confirmDialog.html',
                controller: 'confirmDialogController as vm',
                size: 'md',
                taiClass: getTaiClass(),
                resolve: {
                    config: function config() {
                        _config = _config || {};
                        var paramConfig = {
                            confirmTitle: _config.confirmTitle || '',
                            confirmContent: _config.confirmContent || '',
                            textButtonOk: _config.textButtonOk || null,
                            textButtonCancel: _config.textButtonCancel || null,
                            promiseAction: _config.promiseAction
                        };
                        return paramConfig;
                    }
                }
            });
            return modal;
        }

        function explanation() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/explanationModal.html',
                controller: 'explanationModalController as vm',
                size: 'lg',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function setting(param) {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/settingModal.html',
                controller: 'settingModalController as vm',
                size: 'lg',
                taiClass: getTaiClass(),
                resolve: {
                    viewModel: function viewModel() {
                        return param;
                    }
                }
            });
            return modal;
        }

        function courseDetail(item, settingModel, defaultTabIndex) {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/courseDetailModal.html',
                controller: 'courseDetailModalController as vm',
                size: 'lg',
                taiClass: getTaiClass(),
                resolve: {
                    courseItem: item,
                    settingModel: settingModel,
                    defaultTabIndex: defaultTabIndex
                }
            });

            modal.rendered.then(function () {

                var modalBootstrap = $(".modal-open > .modal");
                modalBootstrap.scroll(function () {
                    // 改變"回頂端"樣式，只有當下拉選單滾到一定層度才會出現
                    var modalContent = this;
                    var goTop = modalBootstrap.find("div.goTop a");
                    if (!goTop) {
                        return;
                    }
                    if (modalContent.scrollTop < 300) {
                        modalBootstrap.find("div.goTop a").css({ "position": "relative", "top": "0px", "display": "none" });
                    } else {
                        modalBootstrap.find("div.goTop a").css({ "position": "absolute", "top": modalContent.scrollTop, "display": "block" });
                    }
                });
            });
            return modal;
        }

        function editPwd() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/editPwdModal.html',
                controller: 'editPwdModalController as vm',
                size: 'lg',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function phoneNumber() {
            var modal = $uibModal.open({
                templateUrl: 'controller/common/modal/phoneNumberModal.html',
                controller: 'phoneNumberModalController as vm',
                size: 'lg',
                taiClass: getTaiClass()
            });
            return modal;
        }

        function trainingSelectAction(_viewModel) {
            var modal = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/myTrainingSelectActionModal.html',
                controller: 'myTrainingSelectActionModalController as vm',
                size: 'lg',
                keyboard: false,
                backdrop: 'static',
                taiClass: getTaiClass(),
                resolve: {
                    viewModel: function viewModel() {
                        // console.log("trainingSelectAction  viewModel",viewModel);
                        return _viewModel;
                    }
                }
            });

            modal.rendered.then(function () {

                var modalBootstrap = $(".modal-open > .modal");
                modalBootstrap.scroll(function () {
                    // 改變"回頂端"樣式，只有當下拉選單滾到一定層度才會出現
                    var modalContent = this;
                    var goTop = modalBootstrap.find("div.goTop a");
                    if (!goTop) {
                        return;
                    }
                    if (modalContent.scrollTop < 300) {
                        modalBootstrap.find("div.goTop a").css({ "position": "relative", "top": "0px", "display": "none" });
                    } else {
                        modalBootstrap.find("div.goTop a").css({ "position": "absolute", "top": modalContent.scrollTop, "display": "block" });
                    }
                });
            });
            return modal;
        }

        function selectActionConfirm(_ctmsConfirmTime, param) {
            //console.log('ctmsConfirmTime:',ctmsConfirmTime);
            var modalResult = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/myTrainingSelectActionConfirmModal.html',
                controller: 'myTrainingSelectActionConfirmModalController as vm',
                size: 'lg',
                backdrop: 'static',
                keyboard: false,
                taiClass: getTaiClass(),
                windowClass: getWindowClass(),
                resolve: {
                    ctmsConfirmTime: function ctmsConfirmTime() {
                        return _ctmsConfirmTime;
                    },
                    data: function data() {
                        return param;
                    }
                }
            });
            return modalResult;
        }

        function openOptionSelector(data, title, _isCycle) {
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/optionSelector.html',
                controller: 'optionSelectorController as vm',
                size: 'sm',
                backdrop: 'static',
                taiClass: getTaiClass(),
                resolve: {
                    titleTranslate: function titleTranslate() {
                        return title;
                    },
                    keyValueList: function keyValueList() {
                        return data;
                    },
                    isCycle: function isCycle() {
                        return _isCycle;
                    }
                }

            });
            return result;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('scheduleService', scheduleService);

    function scheduleService($http, apiUrl, commonService) {
        var service = {
            get: get,
            donwloadIcs: donwloadIcs,
            getCalendarArea: getCalendarArea
        };

        var url = apiUrl.tsApi + 'schedule/';

        function get(thisMonth, calendarAreaNo) {
            var param = {
                thisMonth: thisMonth.format('YYYY/MM/DD'),
                calAreaSerilNo: calendarAreaNo,
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            if (sessionStorage.getItem('token')) {
                return $http.post(url + 'get', param);
            }
            return $http.post(url + 'getByNoLogin', param);
        }

        function donwloadIcs(param, isIos) {
            var downloadUrl = format('{0}PostExportSchedule?calendarSerilNo={1}&menuSerilNo={2}&token={3}&perSerilNo={4}&isIos={5}', url, param.calendarSerilNo, getMenuQueryString(), sessionStorage.getItem('token'), sessionStorage.getItem('perSerilNo'), isIos);
            return downloadUrl;
        }

        function getCalendarArea() {
            var newApiURL = url + 'calendarArea/' + sessionStorage.getItem('perSerilNo');
            newApiURL = commonService.URLCheck(newApiURL);
            //2023-07-20 Johnson ��w2023
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}));
        }

        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('translateService', translateService);

    function translateService($rootScope, $translate, $http, $q, apiUrl, commonService) {
        var service = {
            getLanguage: getLanguage,
            getDefault: getDefault,
            change: change,
            callApi: callApi,
            getTranslates: getTranslates
        };

        function getLanguage(isWrite) {
            var param = {
                isWrite: isWrite
            };
            commonService.setParams(param);

            return $http.post(apiUrl.tsApi + 'getLanguage', param);
        }

        function getDefault(languageItems) {
            var defaultLanguage = _.find(languageItems, {
                selected: true
            });
            sessionStorage.setItem('langCode', defaultLanguage.langSerilNo);
            sessionStorage.setItem('userLang', defaultLanguage.langCode);
            callApi(sessionStorage.getItem('userLang'));
            return defaultLanguage;
        }

        function change(selectedItem) {
            sessionStorage.setItem('langCode', selectedItem.langSerilNo);
            return getLanguage(true).then(function (data) {
                sessionStorage['userLang'] = _.replace(selectedItem.langCode, '_', '-');
                var defaultLanguage = getDefault(data.data);
                return defaultLanguage;
            });
        }

        function callApi(languageCode) {
            return $translate.use(languageCode).then(function () {
                return getTranslates();
            }).then(function (data) {
                $rootScope.translate = data;
            });
        }

        function getTranslates() {
            var userLang = sessionStorage['userLang'];
            var urlTranslate = apiUrl.tsApi + 'getTranslationResource?lang=' + userLang;
            //2023-07-20 Johnson ��w2023
            //console.log("getTranslates:\service\translate.service.js");
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$.1(2).3(4(0){5 0});', 6, 6, 'response|get|urlTranslate|then|function|return'.split('|'), 0, {}));
        }
        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('visualPageService', visualPageService);

    function visualPageService($http, apiUrl, commonService) {
        var service = {
            get: get
        };

        var visualPageUrl = apiUrl.tsApi + 'visualPage';

        function get(pageSerilNo) {
            var param = {
                pageSerilNo: pageSerilNo,
                menuSerilNo: getMenuQueryString()
            };
            commonService.setParams(param);
            return $http.post(visualPageUrl, param);
        }

        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('testData', ['enumService', testData]);

    function testData(enumService) {
        var enumCourseType = enumService.courseType;
        var service = {
            MyTrainingPoint: MyTrainingPoint,
            SysTypesList: SysTypesList,
            FCLicenseList: FCLicenseList,
            CourseItem: CourseItem,
            PublishedActivity: PublishedActivity,
            CourseSession: CourseSession,
            ExamSurveyContent: ExamSurveyContent,
            InteractionData: InteractionData,
            MyUnfinishedActivities: MyUnfinishedActivities,
            MyFinishedActivities: MyFinishedActivities,
            EnrollmentAvailableAction: EnrollmentAvailableAction,
            EnrollmentAction: EnrollmentAction,
            FCCertificatedLicenseAdd: FCCertificatedLicenseAdd,
            FCCertificatedLicenseList: FCCertificatedLicenseList,
            FCAuthorizedHoursList: FCAuthorizedHoursList,
            ExternalTrainingApplication: ExternalTrainingApplication,
            FCEnrollableActivities: FCEnrollableActivities,
            LearningRecordCommit: LearningRecordCommit
        };

        return service;
        /**
         * 1.訓練存摺點數
         * @returns
         */
        function MyTrainingPoint(year) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultDefault;
            var resultYear2013;
            var resultYear2014;
            var resultYear2015;
            var resultYear2016;
            resultDefault = {
                Status: '200',
                Data: {
                    remainPoint: 0,
                    trainingPoints: []
                },
                ErrorMessage: '123'
            };
            resultYear2013 = {
                Status: '200',
                Data: {
                    remainPoint: 0,
                    trainingPoints: [{
                        courseName: "2013課程",
                        courseTime: "2013/09/21~2013/09/21",
                        courseType: "外訓課程",
                        point: 250
                    }]
                },
                ErrorMessage: ''
            };
            resultYear2014 = {
                "Status": "200",
                "Data": {
                    "remainPoint": 10000,
                    "trainingPoints": [{
                        courseName: "2014課程1",
                        courseTime: "2014/03/05~2014/03/14",
                        courseType: "外訓課程",
                        point: 250
                    }, {
                        courseName: "2014課程2",
                        courseTime: "2014/07/13~2014/07/13",
                        courseType: "線上課程",
                        point: 250
                    }]
                },
                "ErrorMessage": ""
            };
            resultYear2015 = { "Status": "200", "Data": { "remainPoint": 10000, "trainingPoints": [] }, "ErrorMessage": "" };
            resultYear2016 = { "Status": "200", "Data": { "remainPoint": 10000, "trainingPoints": [] }, "ErrorMessage": "" };
            switch (year + '') {
                case '2013':
                    result = resultYear2013;
                    break;
                case '2014':
                    result = resultYear2014;
                    break;
                case '2015':
                    result = resultYear2015;
                    break;
                case '2016':
                    result = resultYear2016;
                    break;
                default:
                    result = resultYear2016;
                    break;
            }
            return { data: result };
        }

        /**
         * 2-1.取得下拉選單資料_金融證照類別
         * @returns
         */
        function SysTypesList(type) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultType2; /**金融證照類別 */
            var resultType3; /**外訓費用貨幣種類 */
            var resultType4; /**外訓種類 */
            var resultType5; /**主辦單位 */
            resultType2 = {
                "Status": "200",
                "Data": [{
                    "id": -1,
                    "name": "All"
                }, {
                    "id": 7,
                    "name": "人力資源類"
                }, {
                    "id": 8,
                    "name": "行內自辦證照/資格類資格類資格類資格類資格類"
                }, {
                    "id": 15,
                    "name": "法金人才庫類"
                }, {
                    "id": 6,
                    "name": "金融證照類"
                }, {
                    "id": 12,
                    "name": "專案管理類"
                }, {
                    "id": 9,
                    "name": "勞工安全類"
                }],
                "ErrorMessage": ""
            };
            resultType3 = {
                "Status": "200",
                "Data": [{
                    "id": -1,
                    "name": "All"
                }, {
                    "id": 0,
                    "name": "台幣"
                }],
                "ErrorMessage": ""
            };
            resultType4 = {
                "Status": "200",
                "Data": [{
                    "id": -1,
                    "name": "All"
                }, {
                    "id": 0,
                    "name": "國外外訓"
                }, {
                    "id": 1,
                    "name": "一般外訓"
                }, {
                    "id": 2,
                    "name": "外語進修補助"
                }, {
                    "id": 3,
                    "name": "電腦進修補助"
                }, {
                    "id": 4,
                    "name": "考試補助"
                }],
                "ErrorMessage": ""
            };
            resultType5 = {
                "Status": "200",
                "Data": [{
                    "id": -1,
                    "name": "All"
                }, {
                    "id": 1,
                    "name": "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA"
                }, {
                    "id": 3,
                    "name": "路透社"
                }, {
                    "id": 4,
                    "name": "工研院台北學習中心"
                }, {
                    "id": 5,
                    "name": "中央存款保險股份有限公司"
                }, {
                    "id": 6,
                    "name": "中原大學推廣教育中心"
                }, {
                    "id": 7,
                    "name": "中國文化大學推廣教育部"
                }, {
                    "id": 8,
                    "name": "中國生產力中心"
                }, {
                    "id": 9,
                    "name": "中華人力資源管理協會"
                }, {
                    "id": 10,
                    "name": "中華人事主管協會"
                }, {
                    "id": 11,
                    "name": "中華公司治理協會"
                }, {
                    "id": 12,
                    "name": "中華民國工商協進會"
                }, {
                    "id": 13,
                    "name": "中華民國工業安全衛生協會"
                }, {
                    "id": 14,
                    "name": "中華民國內部稽核協會"
                }, {
                    "id": 15,
                    "name": "中華民國公司組織研究發展協會"
                }, {
                    "id": 16,
                    "name": "信託公會"
                }, {
                    "id": 17,
                    "name": "中華民國退休基金協會〈萬寶資產管理集團〉"
                }, {
                    "id": 18,
                    "name": "中華民國票券金融商業同業公會"
                }, {
                    "id": 19,
                    "name": "中華民國勞資關係協進會"
                }, {
                    "id": 20,
                    "name": "中華民國銀行商業同業公會全國聯合會"
                }, {
                    "id": 21,
                    "name": "中華民國職工福利發展協會"
                }, {
                    "id": 22,
                    "name": "中華民國證券投資信託暨顧問商業同業公會"
                }, {
                    "id": 23,
                    "name": "中華汽車培訓中心"
                }, {
                    "id": 24,
                    "name": "中華徵信所"
                }, {
                    "id": 25,
                    "name": "台灣金融研訓院"
                }, {
                    "id": 26,
                    "name": "台大進修推廣部"
                }, {
                    "id": 27,
                    "name": "國稅局"
                }, {
                    "id": 28,
                    "name": "台北市進出口商業同業公會"
                }, {
                    "id": 29,
                    "name": "台北金融研究發展基金會"
                }, {
                    "id": 30,
                    "name": "台北恆逸教訓訓練中心"
                }, {
                    "id": 31,
                    "name": "台北富蘭德林諮詢有限公司"
                }, {
                    "id": 32,
                    "name": "證券商業同業公會"
                }, {
                    "id": 33,
                    "name": "證券暨期貨市場發展基金會"
                }, {
                    "id": 34,
                    "name": "台北富蘭德林諮詢有限公司"
                }, {
                    "id": 35,
                    "name": "台灣金融服務業聯合總會"
                }, {
                    "id": 36,
                    "name": "台灣金融服務業聯合總會"
                }, {
                    "id": 37,
                    "name": "台灣期貨交易所股份有限公司"
                }, {
                    "id": 38,
                    "name": "巨匠電腦"
                }, {
                    "id": 39,
                    "name": "行政院金融管理委員會"
                }, {
                    "id": 40,
                    "name": "行政院勞工委員會"
                }, {
                    "id": 41,
                    "name": "何嘉仁國際教育學院"
                }, {
                    "id": 42,
                    "name": "投信投顧公會"
                }, {
                    "id": 43,
                    "name": "亞太教育訓練"
                }, {
                    "id": 44,
                    "name": "兩岸經華諮詢顧問股份有限公司"
                }, {
                    "id": 45,
                    "name": "券商同業公會"
                }, {
                    "id": 46,
                    "name": "卓越人生企管顧問公司"
                }, {
                    "id": 47,
                    "name": "和風談判學院"
                }, {
                    "id": 48,
                    "name": "旺旺中時媒體集團"
                }, {
                    "id": 49,
                    "name": "東方匯理銀行"
                }, {
                    "id": 50,
                    "name": "法國外貿銀行"
                }, {
                    "id": 51,
                    "name": "社團法人中華採購供應管理協會"
                }, {
                    "id": 52,
                    "name": "花旗銀行"
                }, {
                    "id": 53,
                    "name": "金管會"
                }, {
                    "id": 54,
                    "name": "前瞻國際顧問(股)公司"
                }, {
                    "id": 55,
                    "name": "施羅德證券投資信託股份有限公司"
                }, {
                    "id": 56,
                    "name": "美國銀行(Bank of America)"
                }, {
                    "id": 57,
                    "name": "英商渣打銀行"
                }, {
                    "id": 58,
                    "name": "財團法人會計研究發展基金會"
                }, {
                    "id": 59,
                    "name": "高雄市銀行公會"
                }, {
                    "id": 60,
                    "name": "動腦傳播股份有限公司"
                }, {
                    "id": 61,
                    "name": "國際商會中華民國總會"
                }, {
                    "id": 62,
                    "name": "富蘭德林"
                }, {
                    "id": 63,
                    "name": "彭博資訊"
                }, {
                    "id": 64,
                    "name": "渣打銀行"
                }, {
                    "id": 65,
                    "name": "勤業眾信會計師事務所\t"
                }],
                "ErrorMessage": ""
            };
            switch (type) {
                case 2:
                    result = resultType2;
                    break;
                case 3:
                    result = resultType3;
                    break;
                case 4:
                    result = resultType4;
                    break;
                case 5:
                    result = resultType5;
                    break;
                default:
                    break;
            }
            return { data: result };
        }
        /**
         * 2-3.取得下拉選單資料_取得金融證照名稱
         * @returns
         */
        function FCLicenseList() {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            result = {
                "Status": "200",
                "Data": [{
                    "attTypes": "",
                    "id": 159,
                    "name": "ARM專業能力檢定測驗(大會考)>僅透過HR上傳資格",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 177,
                    "name": "AU-910 Generic Knowledge",
                    "organization": "Australian Securities & Investments Commission"
                }, {
                    "attTypes": "",
                    "id": 190,
                    "name": "AU-927 Foreign Exchange - Knowledge & Skill",
                    "organization": "Australian Securities & Investments Commission"
                }, {
                    "attTypes": "",
                    "id": 189,
                    "name": "AU-927 Foreign Exchange - Knowledge only",
                    "organization": "Australian Securities & Investments Commission"
                }, {
                    "attTypes": "",
                    "id": 85,
                    "name": "CFA(全階)",
                    "organization": "台灣理財顧問認證協會"
                }, {
                    "attTypes": "",
                    "id": 83,
                    "name": "CFA(第一階段)",
                    "organization": "台灣理財顧問認證協會"
                }, {
                    "attTypes": "",
                    "id": 84,
                    "name": "CFA(第二階段)",
                    "organization": "台灣理財顧問認證協會"
                }, {
                    "attTypes": "",
                    "id": 86,
                    "name": "CFP",
                    "organization": "台灣理財顧問認證協會"
                }, {
                    "attTypes": "",
                    "id": 148,
                    "name": "CIA 國際內部稽核師",
                    "organization": "中華民國內部稽核協會"
                }, {
                    "attTypes": "",
                    "id": 149,
                    "name": "CISA 國際電腦稽核師",
                    "organization": "中華民國內部稽核協會"
                }, {
                    "attTypes": "",
                    "id": 87,
                    "name": "CPA(會計師)",
                    "organization": "考試院"
                }, {
                    "attTypes": "",
                    "id": 88,
                    "name": "CSIA",
                    "organization": "美國金融管理學會"
                }, {
                    "attTypes": "",
                    "id": 29,
                    "name": "e-HR管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 179,
                    "name": "Internal Audit in Financial Institution 金融機構稽核課程(HK)",
                    "organization": "香港銀行學會"
                }, {
                    "attTypes": "",
                    "id": 89,
                    "name": "MFP",
                    "organization": "美國金融管理學會"
                }, {
                    "attTypes": "",
                    "id": 90,
                    "name": "PMP國際專案經理人認証班",
                    "organization": "Project Management Institute(PMI)"
                }, {
                    "attTypes": "",
                    "id": 147,
                    "name": "PMP國際專案管理師",
                    "organization": "Project Management Institute(PMI)"
                }, {
                    "attTypes": "",
                    "id": 37,
                    "name": "一級講師",
                    "organization": "人力資源處"
                }, {
                    "attTypes": "",
                    "id": 58,
                    "name": "乙種勞工安全衛生業務主管",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 26,
                    "name": "人力資源中階主管",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 12,
                    "name": "人民幣辨識資格",
                    "organization": "分行營運事業處"
                }, {
                    "attTypes": "",
                    "id": 76,
                    "name": "人身保險代理人",
                    "organization": "中華民國考選部"
                }, {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 79,
                    "name": "人身保險業務員投資型保險商品資格測驗合格",
                    "organization": "財團法人保險事業發展中心"
                }, {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 46,
                    "name": "人身保險業務員投資型商品資格登錄(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                }, {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 45,
                    "name": "人身保險業務員登錄(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                }, {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 77,
                    "name": "人身保險業務員資格測驗合格",
                    "organization": "中華民國人壽保險商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 82,
                    "name": "人身保險業務員銷售外幣收付非投資型保險商品資格測驗合格",
                    "organization": "財團法人保險事業發展中心"
                }, {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 47,
                    "name": "人身保險業務員銷售外幣收付非投資型保險商品資格登錄(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 153,
                    "name": "人身保險經紀人",
                    "organization": "中華民國考選部"
                }, {
                    "attTypes": "",
                    "id": 24,
                    "name": "大陸人力資源管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 158,
                    "name": "大陸人力資源與勞動關係管理師",
                    "organization": "中華人事主管協會"
                }, {
                    "attTypes": "",
                    "id": 78,
                    "name": "不良債權處理實務研習班",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 124,
                    "name": "不動產鑑價測驗合格",
                    "organization": "個金授信管理處"
                }, {
                    "attTypes": "",
                    "id": 34,
                    "name": "不動產鑑價資格取得",
                    "organization": "個金授信管理處"
                }, {
                    "attTypes": "",
                    "id": 73,
                    "name": "內部稽核師",
                    "organization": "中華民國內部稽核協會"
                }, {
                    "attTypes": "",
                    "id": 131,
                    "name": "內部講師訓完訓資格",
                    "organization": "人力資源處"
                }, {
                    "attTypes": "",
                    "id": 134,
                    "name": "分行經理內部控制",
                    "organization": "通路營運事業處"
                }, {
                    "attTypes": "",
                    "id": 59,
                    "name": "丙種勞工安全衛生業務主管",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 40,
                    "name": "外匯及衍生性金融商品之風險管理研習班",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 91,
                    "name": "外匯交易專業能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 64,
                    "name": "外匯指定分行外匯人員資格",
                    "organization": "分行營運事業處"
                }, {
                    "attTypes": "",
                    "id": 8,
                    "name": "外匯經辦人員資格",
                    "organization": "分行營運事業處"
                }, {
                    "attTypes": "",
                    "id": 185,
                    "name": "外匯經辦人員資格(僅限客服部)",
                    "organization": "通路營運事業處"
                }, {
                    "attTypes": "",
                    "id": 9,
                    "name": "外匯覆核人員資格",
                    "organization": "分行營運事業處"
                }, {
                    "attTypes": "",
                    "id": 186,
                    "name": "外匯覆核人員資格(僅限客服部)",
                    "organization": "通路營運事業處"
                }, {
                    "attTypes": "",
                    "id": 22,
                    "name": "生涯發展諮商師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 57,
                    "name": "甲種勞工安全衛生業務主管",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 74,
                    "name": "企業內部控制基本能力測驗",
                    "organization": "證券暨期貨市場發展基金會"
                }, {
                    "attTypes": "",
                    "id": 157,
                    "name": "全民財經檢定(General Economic and Financial Test)",
                    "organization": "經濟日報"
                }, {
                    "attTypes": "",
                    "id": 92,
                    "name": "存款開戶課程認證",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 36,
                    "name": "年度優良講師",
                    "organization": "人力資源處"
                }, {
                    "attTypes": "",
                    "id": 156,
                    "name": "利率變動型年金資格(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 63,
                    "name": "投信投顧相關法規(含自律規範)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 120,
                    "name": "投信投顧業務員",
                    "organization": "中華民國期貨業商業同業公會"
                }, {
                    "attTypes": "身分證正反面影本, 最高學歷證書影本, 投信投顧業務員證照影本(或信託業務證照+投信投顧法規證照影本), 金融常識與職業道德測驗證書影本, 登錄聲明書 (下載路徑：台新大學>新手上路>新手教材>同仁篇>證照管理>投顧人員聲明書103年版), 請注意，此證照僅供「理財商品處」同仁申請登錄",
                    "id": 127,
                    "name": "投信投顧業務員-一般業務員(登錄投信投顧公會)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 129,
                    "name": "投信投顧業務員-基金經理人(登錄投信投顧公會)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 130,
                    "name": "投信投顧業務員-基金經理人部主管(登錄投信投顧公會)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 128,
                    "name": "投信投顧業務員-部主管(登錄投信投顧公會)",
                    "organization": "中華民國證券投資信託暨顧問商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 50,
                    "name": "防火管理人員",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 109,
                    "name": "其他類證照",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 21,
                    "name": "知識管理管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 102,
                    "name": "股務業務員資格",
                    "organization": "證券暨期貨市場發展基金會"
                }, {
                    "attTypes": "",
                    "id": 94,
                    "name": "初階外匯人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 96,
                    "name": "初階授信人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 100,
                    "name": "金融人員授信擔保品估價專業能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 99,
                    "name": "金融市場常識與職業道德",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 180,
                    "name": "金融管理師(FMA)資格認證",
                    "organization": "高級金融管理師(AFMA)委員會"
                }, {
                    "attTypes": "",
                    "id": 204,
                    "name": "金融數位力知識檢定測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 14,
                    "name": "信託業務人員信託業務專業測驗",
                    "organization": "中華民國信託業商業同業公會"
                }, {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 65,
                    "name": "信託業務人員信託業務專業測驗【信託法規乙科】",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "不需檢附任何文件",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "organization": "中華民國信託業商業同業公會"
                }, {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 30,
                    "name": "信託督導人員實務研習班",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "不需檢附任何文件",
                    "id": 5,
                    "name": "信託督導人員審定合格(登錄信託公會)",
                    "organization": "中華民國信託業商業同業公會"
                }, {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 31,
                    "name": "信託管理人員研習班",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "不需檢附任何文件",
                    "id": 6,
                    "name": "信託管理人員審定合格(登錄信託公會)",
                    "organization": "中華民國信託業商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 80,
                    "name": "保險財產規劃師",
                    "organization": "中華民國個人財產規劃人員協會"
                }, {
                    "attTypes": "",
                    "id": 51,
                    "name": "急救人員訓練",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 202,
                    "name": "衍生性金融商品及風險管理培訓班",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 41,
                    "name": "衍生性金融商品自辦課程測驗",
                    "organization": "金融市場處"
                }, {
                    "attTypes": "",
                    "id": 205,
                    "name": "衍生性金融商品銷售人員資格測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 192,
                    "name": "衍生性商品推介人員(登錄銀行公會)",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "通過證書正本",
                    "id": 193,
                    "name": "風險管理基本能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 135,
                    "name": "香港證券-卷一 基本證券及期貨規例",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 141,
                    "name": "香港證券-卷七 金融市場",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 143,
                    "name": "香港證券-卷九 衍生工具",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 136,
                    "name": "香港證券-卷二 證券規例",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 142,
                    "name": "香港證券-卷八 證券",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 144,
                    "name": "香港證券-卷十 信貸評級服務",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 145,
                    "name": "香港證券-卷十一 機構融資",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 146,
                    "name": "香港證券-卷十二 資產管理",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 137,
                    "name": "香港證券-卷三 衍生工具規例",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 139,
                    "name": "香港證券-卷五 機構融資規例",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 140,
                    "name": "香港證券-卷六 資產管理規例",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 138,
                    "name": "香港證券-卷四 信貸評級服務規例",
                    "organization": "香港證券專業協會"
                }, {
                    "attTypes": "",
                    "id": 15,
                    "name": "員工任用管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 18,
                    "name": "員工福利管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 17,
                    "name": "員工薪酬管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 19,
                    "name": "員工關係管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 161,
                    "name": "晉升10職等準RM簡報(適用產金/服金/海外/產品)>僅透過HR上傳名單",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 194,
                    "name": "晉升11職等PM/PS專業能力檢定測驗>僅透過HR上傳名單",
                    "organization": "法金產品行銷處"
                }, {
                    "attTypes": "",
                    "id": 162,
                    "name": "晉升11職等RM專業能力檢定測驗(大會考)>僅透過HR上傳名單",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 165,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處)>僅透過HR上傳資格",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 201,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/系統專案組)>僅透過HR上傳資格",
                    "organization": "法金管理處系統專案組"
                }, {
                    "attTypes": "",
                    "id": 197,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/法金作業部)>僅透過HR上傳資格",
                    "organization": "法金管理處法金作業部"
                }, {
                    "attTypes": "",
                    "id": 199,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/法金管理部)>僅透過HR上傳資格",
                    "organization": "法金管理處法金管理部"
                }, {
                    "attTypes": "",
                    "id": 200,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/金融交易作業部)>僅透過HR上傳資格",
                    "organization": "法金管理處金融交易作業部"
                }, {
                    "attTypes": "",
                    "id": 198,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/客戶服務部)>僅透過HR上傳資格",
                    "organization": "法金管理處客戶服務部"
                }, {
                    "attTypes": "",
                    "id": 196,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/建北分行)>僅透過HR上傳資格",
                    "organization": "法金管理處建北分行"
                }, {
                    "attTypes": "",
                    "id": 195,
                    "name": "晉升11職等SU專業能力檢定測驗(法金管理處/國外部)>僅透過HR上傳資格",
                    "organization": "法金管理處國外部"
                }, {
                    "attTypes": "",
                    "id": 163,
                    "name": "晉升12職等RM簡報>僅透過HR上傳資格",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 164,
                    "name": "晉升12職等專題簡報(適用PM/除國際聯貸以外之PS、TMO及SU)>僅透過HR上傳資格",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 166,
                    "name": "晉升13職等PM專題簡報>僅透過HR上傳資格",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 160,
                    "name": "晉升9職等準RM簡報(適用環貿金融處)>僅透過HR上傳資格",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 178,
                    "name": "晉升RM資格(適用產金/服金)>僅透過HR上傳名單",
                    "organization": "法金管理處"
                }, {
                    "attTypes": "",
                    "id": 182,
                    "name": "特級金融管理師(CFMA)資格認證",
                    "organization": "高級金融管理師(AFMA)委員會"
                }, {
                    "attTypes": "",
                    "id": 152,
                    "name": "租賃人才養成認證班",
                    "organization": "台北市租賃公會"
                }, {
                    "attTypes": "",
                    "id": 16,
                    "name": "訓練發展管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 103,
                    "name": "財金風險管理分析師",
                    "organization": "Global Association of Risk Professionals (GARP)，全球風險專業管理協會"
                }, {
                    "attTypes": "",
                    "id": 154,
                    "name": "財產保險代理人",
                    "organization": "中華民國考選部"
                }, {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 176,
                    "name": "財產保險業務員(限招攬傷害及健康險)(登錄產險公會)",
                    "organization": "中華民國產物保險商業同業公會"
                }, {
                    "attTypes": "請至 http://localhost/ 保險登錄專區下載登錄申請書，並備妥檢附文件，送至仁愛金控17樓。",
                    "id": 44,
                    "name": "財產保險業務員登錄(登錄產險公會)",
                    "organization": "中華民國產物保險商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 81,
                    "name": "財產保險業務員資格測驗合格",
                    "organization": "中華民國產物保險商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 155,
                    "name": "財產保險經紀人",
                    "organization": "中華民國考選部"
                }, {
                    "attTypes": "",
                    "id": 181,
                    "name": "高級金融管理師(FMA+)資格認證",
                    "organization": "高級金融管理師(AFMA)委員會"
                }, {
                    "attTypes": "",
                    "id": 188,
                    "name": "商金現勘訪廠執照資格取得",
                    "organization": "個金授信管理處"
                }, {
                    "attTypes": "",
                    "id": 126,
                    "name": "基礎人資管理師",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 98,
                    "name": "理財規劃人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 35,
                    "name": "現勘",
                    "organization": "個金授信管理處"
                }, {
                    "attTypes": "",
                    "id": 105,
                    "name": "票券商業務員",
                    "organization": "中華民國票券金融商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 60,
                    "name": "勞工安全管理甲級技術士",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 53,
                    "name": "勞工安全管理師",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 56,
                    "name": "勞工安全衛生管理乙級技術士",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 52,
                    "name": "勞工安全衛生管理員",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 61,
                    "name": "勞工衛生管理甲級技術士",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 55,
                    "name": "勞工衛生管理師",
                    "organization": ""
                }, {
                    "attTypes": "",
                    "id": 151,
                    "name": "勞健保暨勞基法管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 20,
                    "name": "勞動法令管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 117,
                    "name": "期貨分析師",
                    "organization": "中華民國期貨業商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 119,
                    "name": "期貨交易分析人員",
                    "organization": "中華民國期貨業商業同業公會"
                }, {
                    "attTypes": "不需檢附任何文件",
                    "id": 42,
                    "name": "期貨信託基金銷售機構銷售人員(登錄期貨公會)",
                    "organization": "中華民國期貨業商業同業公會"
                }, {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 43,
                    "name": "期貨信託基金銷售機構銷售人員專業科目測驗成績合格證明",
                    "organization": "中華民國期貨業商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 115,
                    "name": "期貨商業務員",
                    "organization": "中華民國期貨業商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 116,
                    "name": "期貨商業務員(登錄期貨公會)",
                    "organization": "中華民國期貨業商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 27,
                    "name": "策略性人力資源管理",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "通過證書影本, 登錄同意書 (下載路徑：台新大學>新手上路>新手教材>同仁篇>證照管理>台新銀行結構型商品推介人員資格資料變更註銷登錄申請暨同意書)",
                    "id": 150,
                    "name": "結構型商品推介人員(登錄銀行公會)",
                    "organization": "中華民國銀行商業同業公會"
                }, {
                    "attTypes": "請注意，此證照僅登錄於台新大學，若因執行業務需要登錄公會，請選擇證照名稱後方(登錄XX公會)選項。",
                    "id": 39,
                    "name": "結構型商品銷售人員資格測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "此證照目前已停用，請勿申請登錄。",
                    "id": 49,
                    "name": "結構型商品銷售自律規範測驗(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 95,
                    "name": "進階外匯人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 97,
                    "name": "進階授信人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 13,
                    "name": "開戶對保作業資格",
                    "organization": "分行營運事業處"
                }, {
                    "attTypes": "",
                    "id": 93,
                    "name": "債券人員",
                    "organization": "證券暨期貨市場發展基金會"
                }, {
                    "attTypes": "",
                    "id": 75,
                    "name": "債權委外催收人員專業能力測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 48,
                    "name": "傳統型年金資格(登錄壽險公會)",
                    "organization": "中華民國人壽保險商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 184,
                    "name": "新型分析工具認證-初階",
                    "organization": "客群經營處客戶關係管理部"
                }, {
                    "attTypes": "",
                    "id": 125,
                    "name": "資料倉儲權限認證",
                    "organization": "人力資源處"
                }, {
                    "attTypes": "",
                    "id": 66,
                    "name": "資產配置觀念與系統操作",
                    "organization": "分行營運事業處"
                }, {
                    "attTypes": "",
                    "id": 106,
                    "name": "資產證券化基本能力測驗",
                    "organization": "證券暨期貨市場發展基金會"
                }, {
                    "attTypes": "",
                    "id": 69,
                    "name": "電腦稽核研習班",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 33,
                    "name": "對保資格取得",
                    "organization": "個金授信管理處"
                }, {
                    "attTypes": "",
                    "id": 38,
                    "name": "認證講師",
                    "organization": "人力資源處"
                }, {
                    "attTypes": "",
                    "id": 67,
                    "name": "銀行內部控制與內部稽核測驗",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 122,
                    "name": "銀行辦理財富管理業務-理財業務人員及其他人員",
                    "organization": "中華民國銀行商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 121,
                    "name": "銀行辦理財富管理業務-管理人員",
                    "organization": "中華民國銀行商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 123,
                    "name": "徵信測驗合格",
                    "organization": "個金授信管理處"
                }, {
                    "attTypes": "",
                    "id": 32,
                    "name": "徵信資格取得",
                    "organization": "個金授信管理處"
                }, {
                    "attTypes": "",
                    "id": 68,
                    "name": "稽核人員研習班",
                    "organization": "台灣金融研訓院"
                }, {
                    "attTypes": "",
                    "id": 187,
                    "name": "親簽核對資格取得",
                    "organization": "個金授信管理處"
                }, {
                    "attTypes": "",
                    "id": 28,
                    "name": "績效管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 23,
                    "name": "總務行政管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 62,
                    "name": "簡易外匯人員資格",
                    "organization": "分行營運事業處"
                }, {
                    "attTypes": "",
                    "id": 25,
                    "name": "職能管理師",
                    "organization": "中華人力資源管理協會"
                }, {
                    "attTypes": "",
                    "id": 11,
                    "name": "覆核作業資格",
                    "organization": "分行營運事業處"
                }, {
                    "attTypes": "",
                    "id": 107,
                    "name": "證券交易相關法規與實務",
                    "organization": "證券暨期貨市場發展基金會"
                }, {
                    "attTypes": "",
                    "id": 118,
                    "name": "證券投資分析人員",
                    "organization": "中華民國期貨業商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 70,
                    "name": "證券商內部稽核資格",
                    "organization": "中華民國證券商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 110,
                    "name": "證券商自有資本適足比率進階計算法申報人員測驗",
                    "organization": "台灣證券交易所"
                }, {
                    "attTypes": "",
                    "id": 111,
                    "name": "證券商高級業務員",
                    "organization": "中華民國證券商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 112,
                    "name": "證券商高級業務員(登錄證券交易所)",
                    "organization": "台灣證券交易所"
                }, {
                    "attTypes": "",
                    "id": 113,
                    "name": "證券商業務員",
                    "organization": "中華民國證券商業同業公會"
                }, {
                    "attTypes": "",
                    "id": 114,
                    "name": "證券商業務員(登錄證券交易所)",
                    "organization": "台灣證券交易所"
                }, {
                    "attTypes": "",
                    "id": 10,
                    "name": "驗印資格",
                    "organization": "分行營運事業處"
                }],
                "ErrorMessage": ""
            };
            return { data: result };
        }

        /**
         * 3.取得課程教材
         * 顯示方式；下載附件
         */
        function CourseItem(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var CourseItemsDownload;
            var CourseItemsPdf;
            var CourseItemsVideo;
            CourseItemsDownload = {
                "Status": "200",
                "Data": {
                    "fileExt": "ZIP 文件",
                    "id": 1,
                    "name": "TIPS信託投資系統操作說明【91分鐘】(ZIP教材)",
                    "path": "Storage\\downloadFile.zip",
                    "type": "教材"
                },
                "ErrorMessage": ""
            };
            CourseItemsPdf = {
                "Status": "200",
                "Data": {
                    "fileExt": "PDF 文件",
                    "id": 2,
                    "name": "經濟基本指標【57分鐘】",
                    "path": "Storage\\pdfFile.pdf",
                    "type": "教材"
                },
                "ErrorMessage": ""
            };
            CourseItemsVideo = {
                "Status": "200",
                "Data": {
                    "fileExt": "MP4 文件",
                    "id": 3,
                    "name": "ETF介紹【19分鐘】",
                    // "path": "Storage\\videoFile.mp4",
                    "href": "-511951560-146372858133s7.mp4",
                    "path": "Storage\\Content\\2154\\",
                    "type": "教材"
                },
                "ErrorMessage": ""
            };
            switch (params.ItemId) {
                case 2:
                    result = CourseItemsPdf;
                    break;
                case 3:
                    result = CourseItemsVideo;
                    break;
                case 1:
                    result = CourseItemsDownload;
                    break;
                default:
                    result = CourseItemsDownload;
                    break;
            }
            return { data: result };
        }

        /**
         * 4.取得課程列表
         * @returns
         */
        function PublishedActivity(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultTW;
            var resultCN;
            var resultUS;

            resultTW = {
                Status: "200",
                Data: [{
                    "classificationId": 10,
                    "classificationName": "",
                    "courseId": 30390,
                    "courseName": "G-技能-2001簽呈寫作訓練(繁體)",
                    "courseTime": "2016/10/05~2016/10/05",
                    "courseType": 5,
                    "courseTypeName": "教室測驗(繁體)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 86917,
                    "sessionName": "20161005台新證券-法遵自評筆試(一般)【TEST】-教室測驗(繁體)"

                }, {
                    "classificationId": 1,
                    "classificationName": "",
                    "courseId": 52160,
                    "courseName": "G-技能-2001簽呈寫作訓練(繁體)",
                    "courseTime": "2016/01/01~2016/12/31",
                    "courseType": 6,
                    "courseTypeName": "問卷(繁體)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 86921,
                    "sessionName": "台新大學暨人資網站改版問卷調查(2016)(繁體)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 18,
                    "courseName": "G-技能-2001簽呈寫作訓練(繁體)",
                    "courseTime": "2016/09/07~2017/12/31",
                    "courseType": 7,
                    "courseTypeName": "學程(繁體)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 1232,
                    "sessionName": "EMBO課程(2016下半年)[無對應資料](繁體)"
                }],
                ErrorMessage: ""
            };
            resultCN = {
                "Status": "200",
                "Data": [{
                    "classificationId": 10,
                    "classificationName": "",
                    "courseId": 963,
                    "courseName": "G-技能-2001簽呈寫作訓練(簡中)",
                    "courseTime": "2016/11/09 <br>09:00-13:00 ",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 85571,
                    "sessionName": "2016-1109信託業務人員職前訓練(4小時)-台北場(外訓包班)(簡中)"
                }, {
                    "classificationId": 10,
                    "classificationName": "",
                    "courseId": 59633,
                    "courseName": "G-技能-2001簽呈寫作訓練(簡中)",
                    "courseTime": "2016/09/07~2016/12/31",
                    "courseType": 4,
                    "courseTypeName": "線上測驗(簡中)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 86920,
                    "sessionName": "105下-分行業務-法令遵循自評檢核考試班(簡中)"
                }],
                "ErrorMessage": ""
            };
            resultUS = {
                "Status": "200",
                "Data": [{
                    "classificationId": 1,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseName": "G-技能-2001簽呈寫作訓練(英文)",
                    "courseTime": "2016/01/01~2016/12/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 85908,
                    "sessionName": "信託業務人員職前訓練課程(105年)(英文)"
                }, {
                    "classificationId": 1,
                    "classificationName": "",
                    "courseId": 28322,
                    "courseName": "G-技能-2001簽呈寫作訓練(英文)",
                    "courseTime": "2016/10/01~2016/10/31(區間內的Mon,Wed,Fri)<br>09:00-17:00 <br>休息時間12:00-13:00",
                    "courseType": 2,
                    "courseTypeName": "教室課程(英文)",
                    "enrollBegin": "2016/09/09",
                    "enrollEnd": "2016/11/03",
                    "sessionId": 86925,
                    "sessionName": "20161019超強記憶創造個人競爭力(網站測試班)(英文)"
                }],
                "ErrorMessage": ""
            };

            // resultTW = { "Status": 200, "Data": [{ "classificationId": 29, "classificationName": "通識", "courseId": 2361, "courseName": "G-技能-2008初階簡報技巧", "courseTime": "2017/12/12 <br>13:30-17:30 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/07", "enrollEnd": "2017/12/12", "sessionId": 99691, "sessionName": "20171212初階簡報技巧" }, { "classificationId": 0, "classificationName": "", "courseId": 64726, "courseName": "M-領導力-2004跨世代領導：帶領貓型世代的關鍵技巧", "courseTime": "2017/11/11 <br>09:00-17:00 <br>休息時間12:00-13:00", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/03", "enrollEnd": "2017/11/11", "sessionId": 99689, "sessionName": "20171111跨世代領導：帶領貓型世代的關鍵技巧" }, { "classificationId": 0, "classificationName": "", "courseId": 5614, "courseName": "G-內講-2002內部講師培訓(一天精華版)", "courseTime": "2017/08/15 <br>09:00-17:00 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/15", "sessionId": 99685, "sessionName": "20170815內部講師訓(人資包班第一梯)test" }, { "classificationId": 0, "classificationName": "", "courseId": 24838, "courseName": "G-語言-1004 英文會話", "courseTime": "2017/08/25~2017/10/27 每1週(區間內的Fri)<br>18:00-20:00 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/21", "sessionId": 99676, "sessionName": "2017英文課金控週五人資班 " }, { "classificationId": 15, "classificationName": "專業", "courseId": 72404, "courseName": "8/1人力資源管理", "courseTime": "2017/08/25 <br>09:00-12:00 ", "courseType": 3, "courseTypeName": "外訓課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/25", "sessionId": 99680, "sessionName": "8/1人力資源管理" }, { "classificationId": 0, "classificationName": "", "courseId": 272, "courseName": "G-舒壓-1003健康養生講座", "courseTime": "2017/08/28 <br>09:00-14:00 <br>休息時間12:00-13:00", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/28", "sessionId": 99674, "sessionName": "20170828貴婦級紓壓講座" }, { "classificationId": 0, "classificationName": "", "courseId": 10451, "courseName": "P-廣告行銷-1007說故事行銷", "courseTime": "2017/08/14 <br>09:00-17:00 <br>休息時間12:00-13:00", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/08/14", "sessionId": 99677, "sessionName": "20170814說故事行銷(故事王)-test" }, { "classificationId": 25, "classificationName": "自主", "courseId": 72174, "courseName": "G-語言(自主)-100016-超簡單旅遊日語", "courseTime": "2017/12/05 <br>18:00-20:00 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/12/05", "sessionId": 99671, "sessionName": "20171205超簡單旅遊日語(自主學習課程)" }, { "classificationId": 0, "classificationName": "", "courseId": 2390, "courseName": "G-溝通-2001掌握風格，輕鬆溝通", "courseTime": "2017/10/24 <br>13:30-17:30 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/08/01", "enrollEnd": "2017/10/24", "sessionId": 99669, "sessionName": "20171024掌握風格，輕鬆溝通" }, { "classificationId": 29, "classificationName": "通識", "courseId": 61240, "courseName": "G-技能-3002商業簡報技巧", "courseTime": "2017/08/21 <br>13:30-17:30 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/07/14", "enrollEnd": "2017/08/21", "sessionId": 99667, "sessionName": "20170821商業簡報技巧(八德)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 2361, "courseName": "G-技能-2008初階簡報技巧", "courseTime": "2017/09/04 <br>09:00-12:00 ", "courseType": 2, "courseTypeName": "教室課程", "enrollBegin": "2017/07/14", "enrollEnd": "2017/09/04", "sessionId": 99666, "sessionName": "20170904初階簡報技巧" }, { "classificationId": -1, "classificationName": "", "courseId": 331, "courseName": "G-測試-1026-勞委會課程測試+Slide課程", "courseTime": "2017/03/15~", "courseType": 7, "courseTypeName": "學程", "enrollBegin": "2017/03/15", "enrollEnd": "", "sessionId": 1431, "sessionName": "20170315-勞委+3sbook+slide課程" }, { "classificationId": -1, "classificationName": "", "courseId": 330, "courseName": "G-測試-1029-3S課程與勞委課程", "courseTime": "2017/03/15~", "courseType": 7, "courseTypeName": "學程", "enrollBegin": "2017/03/15", "enrollEnd": "", "sessionId": 1430, "sessionName": "20170315-3S課程+勞委會課程" }, { "classificationId": 15, "classificationName": "專業", "courseId": 11180, "courseName": "P-證券-1008(外訓) 股務單位人員教育訓練", "courseTime": "2017/09/20 <br>14:00-17:00 ", "courseType": 3, "courseTypeName": "外訓課程", "enrollBegin": "2017/01/10", "enrollEnd": "2017/09/20", "sessionId": 99286, "sessionName": "2017-0920 股務單位人員教育訓練" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64901, "courseName": "G-成長-1005珍愛一世情─呵護親子關係【MP4-23分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98930, "sessionName": "珍愛一世情-呵護親子關係(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64895, "courseName": "G-技能-1014遠離開會地獄—「開會一把罩」【MP4-32分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98907, "sessionName": "遠離開會地獄—「開會一把罩」(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64891, "courseName": "G-執行力-1003使命必達－淺談目標管理【MP4-23分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98921, "sessionName": "使命必達－淺談目標管理(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64889, "courseName": "G-成長-1006認識太極拳【MP4-12分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98943, "sessionName": "認識太極拳(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64888, "courseName": "G-成長-1007認識國標舞【MP4-17分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98942, "sessionName": "認識國標舞(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64886, "courseName": "G-成長-1010辦公室健康操【MP4-11分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98938, "sessionName": "辦公室健康操(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64877, "courseName": "G-成長-1003吃出健康【MP4-18分鐘】(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98933, "sessionName": "吃出健康(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 64869, "courseName": "G-溝通-1010打造職場好形象【MP4-22分鐘】(v.3)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98945, "sessionName": "打造職場好形象(106年)" }, { "classificationId": 15, "classificationName": "專業", "courseId": 55764, "courseName": "P-專業知識(信用卡)-1005信用卡進件流程與徵審作業介紹(v.3)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98975, "sessionName": "信用卡進件流程與徵審作業介紹(106年)" }, { "classificationId": 15, "classificationName": "專業", "courseId": 29872, "courseName": "P-專業知識(信用卡)-1006信用卡業務管理規範(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98976, "sessionName": "信用卡業務規範(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 18025, "courseName": "G-政策-1009IDP員工職涯發展計畫(v.2)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98977, "sessionName": "IDP員工職涯發展計畫(106年)" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13951, "courseName": "G-技能-2008【OFFICE2010】ECXEL進階應用（下）", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98974, "sessionName": "Excel 2010進階應用（下）【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13950, "courseName": "G-技能-2007【OFFICE2010】ECXEL進階應用（上）", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98973, "sessionName": "Excel 2010進階應用（上）【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13949, "courseName": "G-技能-2006【OFFICE2010】Word 2010進階應用（下）", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98972, "sessionName": "Word 2010進階應用（下）【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13948, "courseName": "G-技能-2005【OFFICE2010】Word 2010進階應用（上）", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98971, "sessionName": "Word 2010進階應用（上）【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13939, "courseName": "G-技能-1021【OFFICE2010】OUTLOOK人脈管理王(下)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98970, "sessionName": "OUTLOOK人脈管理王(下)【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13903, "courseName": "G-技能-1020【OFFICE2010】OUTLOOK人脈管理王(上)", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98969, "sessionName": "OUTLOOK人脈管理王(上)【106年】" }, { "classificationId": 29, "classificationName": "通識", "courseId": 13901, "courseName": "G-技能-1019【OFFICE2010】POWERPOINT創意簡報王", "courseTime": "2017/01/04~2017/12/31", "courseType": 1, "courseTypeName": "線上課程", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98968, "sessionName": "POWERPOINT創意簡報王【106年】" }, { "classificationId": 15, "classificationName": "專業", "courseId": 34, "courseName": "P-保險-2003投資型保險證照─年金考試班", "courseTime": "2017/01/04~2017/12/31", "courseType": 4, "courseTypeName": "線上測驗", "enrollBegin": "2017/01/04", "enrollEnd": "2017/12/31", "sessionId": 98952, "sessionName": "投資型保險證照-年金考試班(106年)" }, { "classificationId": 15, "classificationName": "專業", "courseId": 20266, "courseName": "內部講師調查問券", "courseTime": "2012/08/16~2017/08/31", "courseType": 6, "courseTypeName": "問卷", "enrollBegin": "2012/08/16", "enrollEnd": "2017/08/31", "sessionId": 24543, "sessionName": "2012內部講師調查問卷" }, { "classificationId": 29, "classificationName": "通識", "courseId": 17954, "courseName": "頂峰訓練課前問卷調查", "courseTime": "2012/05/31~2017/11/01", "courseType": 6, "courseTypeName": "問卷", "enrollBegin": "2012/05/31", "enrollEnd": "2017/11/01", "sessionId": 21085, "sessionName": "2012頂峰客戶關係經營課前問卷" }], "ErrorMessage": "" }
            // resultCN = {"Status":200,"Data":[{"classificationId":29,"classificationName":"通識","courseId":13938,"courseName":"G-技能-1018【OFFICE2010】ECXEL精算大師(下)","courseTime":"2017/01/04~2017/12/31","courseType":1,"courseTypeName":"线上课程","enrollBegin":"2017/01/04","enrollEnd":"2017/12/31","sessionId":98965,"sessionName":"ECXEL精算大師(下)【106年】"},{"classificationId":29,"classificationName":"通識","courseId":13900,"courseName":"G-技能-1017【OFFICE2010】ECXEL精算大師(上)","courseTime":"2017/01/04~2017/12/31","courseType":1,"courseTypeName":"线上课程","enrollBegin":"2017/01/04","enrollEnd":"2017/12/31","sessionId":98964,"sessionName":"ECXEL精算大師(上)【106年】"},{"classificationId":29,"classificationName":"通識","courseId":68275,"courseName":"G-成長-100002-食得健康，食在安心","courseTime":"2017/03/08 <br>01:00-23:00 ","courseType":2,"courseTypeName":"教室课程","enrollBegin":"2016/10/03","enrollEnd":"2018/10/04","sessionId":99381,"sessionName":"食的健康(复制)错误测试_相同上课时间"}],"ErrorMessage":""}
            // resultUS = {"Status":200,"Data":[{"classificationId":29,"classificationName":"通識","courseId":13937,"courseName":"G-技能-1016【OFFICE2010】WORD文書排版(下)","courseTime":"2017/01/04~2017/12/31","courseType":1,"courseTypeName":"Online course","enrollBegin":"2017/01/04","enrollEnd":"2017/12/31","sessionId":98963,"sessionName":"WORD文書排版(下)【106年】"},{"classificationId":29,"classificationName":"通識","courseId":41109,"courseName":"G-新人-1033Welcome to Taishin【SG】","courseTime":"2014/08/22~2017/10/31","courseType":1,"courseTypeName":"Online course","enrollBegin":"2014/08/22","enrollEnd":"2017/10/31","sessionId":54667,"sessionName":"Welcome to Taishin【SG】(test)"}],"ErrorMessage":""}


            switch (params.LanguageCode) {
                case "en-US":
                    result = resultUS;
                    break;
                case "zh-CN":
                    result = resultCN;
                    break;
                default:
                    result = resultTW;
                    break;
            }
            result.Data = _.filter(result.Data, function (item) {
                item.classificationId = parseInt(item.classificationId);
                var compareClassficationId = parseInt(params.ClassificationId);
                // console.log('item.classificationId:',item.classificationId);
                // console.log('compareClassficationId:',compareClassficationId);
                // if (!compareClassficationId) {
                //     compareClassficationId = -1;
                // }
                if (compareClassficationId === -1) {
                    compareClassficationId = item.classificationId;
                }

                return item.classificationId === compareClassficationId;
            });
            return { data: result };
        }

        /**
         * 6.取得課程詳細內容
         * @returns
         */
        function CourseSession(type) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var CourseSessionType1; /* 線上課程 */
            var CourseSessionType2; /* 教室課程 */
            var CourseSessionType3; /* 外訓 */
            var CourseSessionType4; /* 線上測驗 */
            var CourseSessionType5; /* 教室測驗 */
            var CourseSessionType6; /* 問卷 */
            var CourseSessionType7; /* 學程 */
            CourseSessionType1 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "description": "1.最低稅負制溫故知新98進化版【29分鐘】 \r\n2.經濟基本指標【57分鐘】 \r\n3.投資境外結構型商品前的基本概念【33分鐘】 \r\n4.債券市場理論與實務【27分鐘】 \r\n5.保本及非保本型商品【41分鐘】 \r\n6.風險型態與分析【11分鐘】 \r\n7.衍生性金融商品法規介紹【29分鐘】 \r\n8.結構型商品參考法規─境外結構型商品相關【35分鐘】 \r\n9.有價證券信託【14分鐘】 \r\n10.雙雙得利投資帳戶【46分鐘】 \r\n11.SDS系統介紹【14分鐘】 \r\n12.組合式商品介紹【52分鐘】 \r\n13.組合式商品(SI/DCI/ELI)稅賦說明【30分鐘】 \r\n14.TIPS信託投資系統操作說明【102分鐘】 \r\n15.TRMS系統說明【16分鐘】 \r\n16.共同基金銷售關鍵資訊【63分鐘】 \r\n17.共同基金銷售關鍵資訊【課後測驗】 \r\n18.境內外基金相關法令【100分鐘】 \r\n19.規劃行信託相關法規簡介【21分鐘】",
                    "duration": 720,
                    "enrollCount": 11,
                    "enrollPeriod": "2017/01/04~2017/06/30",
                    "enrollRemain": 5,
                    "enrollTime": "2017/01/04~2017/06/30",
                    "outline": "1.最低稅負制溫故知新98進化版【29分鐘】 \r\n2.經濟基本指標【57分鐘】 \r\n3.投資境外結構型商品前的基本概念【33分鐘】 \r\n4.債券市場理論與實務【27分鐘】 \r\n5.保本及非保本型商品【41分鐘】 \r\n6.風險型態與分析【11分鐘】 \r\n7.衍生性金融商品法規介紹【29分鐘】 \r\n8.結構型商品參考法規─境外結構型商品相關【35分鐘】 \r\n9.有價證券信託【14分鐘】 \r\n10.雙雙得利投資帳戶【46分鐘】 \r\n11.SDS系統介紹【14分鐘】 \r\n12.組合式商品介紹【52分鐘】 \r\n13.組合式商品(SI/DCI/ELI)稅賦說明【30分鐘】 \r\n14.TIPS信託投資系統操作說明【102分鐘】 \r\n15.TRMS系統說明【16分鐘】 \r\n16.共同基金銷售關鍵資訊【63分鐘】 \r\n17.共同基金銷售關鍵資訊【課後測驗】 \r\n18.境內外基金相關法令【100分鐘】 \r\n19.規劃行信託相關法規簡介【21分鐘】",
                    "reference": [{
                        "fileExt": "PDF 文件",
                        "name": "共同基金銷售關鍵資訊-熟知KYC、KYP，與客戶共贏",
                        "path": "Storage\\Reference\\2703\\2126340124-1482803634927.pdf"
                    }],
                    "sessionName": "信託業務人員在職訓練課程(106上半年)",
                    "sessionTime": "2017/01/04 ~ 2017/06/30",
                    "target": "登錄信託公會者，每三年複訓完成本課程",
                    "waitlistCount": 5,
                    "waitlistRemain": 100
                },
                "ErrorMessage": ""
            };
            CourseSessionType2 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 500,
                    "description": "",
                    "enrollCount": 0,
                    "enrollRemain": 45,
                    "enrollTime": "2016/10/03~2018/10/04",
                    "hours": 22,
                    "intructors": "蔡毓昇 (840117)<BR>林以君 (914293)",
                    "outline": "1. 喝水喝對了嗎?\r\n2. 餐具用對了嗎?\r\n3. 容器用對了嗎?\r\n4. 增強免疫力你做對了嗎?\r\n5. Q & A",
                    "place": "內湖大樓203會議室",
                    "reference": [],
                    "sessionName": "食的健康(複製)錯誤測試_相同上課時間",
                    "sessionTime": "2017/03/08 <br>01:00-23:00 ",
                    "target": "",
                    "trainingPoint": 0,
                    "waitlistCount": 100,
                    "waitlistRemain": 100
                },
                "ErrorMessage": ""
            };
            CourseSessionType3 = {
                "Status": "200",
                "Data": {
                    "division": "信託公會(請直接至課程中報名，費用統一由HR月結支付)",
                    "enrollCount": 1,
                    "enrollPeriod": "2016/12/27~2017/04/22",
                    "externalType": "一般外訓",
                    "hours": 6,
                    "note": "來上課",
                    "outline": "1.各金融機構信託業業務人員\r\n2.財富管理相關業務人員",
                    "ownCost": 0,
                    "place": "台中市文心路二段645號11樓(新光人壽惠國大樓)   ",
                    "reference": [{
                        "fileExt": "pdf",
                        "name": "1.pdf",
                        "path": "Storage\\CTMSReference\\918\\547400339-1487310466496.pdf"
                    }],
                    "sessionTime": "2017/04/22 <br>09:00-16:00 <br>休息時間12:00-13:00",
                    "subsidyCost": 1300,
                    "totalCost": 1300
                },
                "ErrorMessage": ""
            };
            CourseSessionType4 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "description": "測試用",
                    "duration": 30,
                    "enrollCount": 2,
                    "enrollPeriod": "2017/02/22~2017/03/20",
                    "enrollRemain": 5,
                    "enrollTime": "2017/02/22~2017/03/20",
                    "outline": "",
                    "reference": [],
                    "sessionName": "20170222(測試班)",
                    "sessionTime": "2017/02/22 ~ 2017/03/20",
                    "target": "測試用",
                    "waitlistCount": 5,
                    "waitlistRemain": 5
                },
                "ErrorMessage": ""
            };
            CourseSessionType5 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "description": "",
                    "enrollCount": 5,
                    "enrollRemain": 5,
                    "enrollTime": "2017/02/18~2017/05/12",
                    "hours": 1,
                    "intructors": "內部講師",
                    "outline": "",
                    "place": "文心分行3樓",
                    "reference": [],
                    "sessionName": "20170512徵信照會證照研習班 (補考) ",
                    "sessionTime": "2017/05/12 <br>09:00-10:00 ",
                    "target": "",
                    "trainingPoint": 0,
                    "waitlistCount": 5,
                    "waitlistRemain": 5
                },
                "ErrorMessage": ""
            };
            CourseSessionType6 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "description": "TEST",
                    "duration": -1,
                    "enrollCount": 2,
                    "enrollPeriod": "2017/02/17~2017/06/30",
                    "enrollRemain": 5,
                    "enrollTime": "2017/02/17~2017/06/30",
                    "outline": "",
                    "reference": [{
                        "fileExt": "PDF 文件",
                        "name": "1",
                        "path": "Storage\\Reference\\2767\\-1480076052-1487315027958.pdf"
                    }],
                    "sessionName": "2017問卷測試",
                    "sessionTime": "2017/02/17 ~ 2017/06/30",
                    "target": "對象",
                    "waitlistCount": 5,
                    "waitlistRemain": 5
                },
                "ErrorMessage": ""
            };
            CourseSessionType7 = {
                "Status": "200",
                "Data": {
                    "costPerPerson": 0,
                    "courses": [{
                        "courseId": 45,
                        "courseName": "G-政策-100002-eMBO系統-績效目標設定(v.1)",
                        "courseTime": "2017/02/17 ~ 2017/06/30",
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "order": 1,
                        "sessionId": 99349
                    }, {
                        "courseId": 3366,
                        "courseName": "G-政策-1008eMBO系統-職場行為調整",
                        "courseTime": "2017/02/17 ~ 2017/06/30",
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "order": 2,
                        "sessionId": 99350
                    }, {
                        "courseId": 9280,
                        "courseName": "G-政策-1020IDP員工職涯發展計畫-介紹篇",
                        "courseTime": "2017/02/17 ~ 2017/06/30",
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "order": 3,
                        "sessionId": 99351
                    }],
                    "description": "本學程共有三門課程，每門課程需閱讀達90%以上，始得通過。\r\n1. eMBO系統-績效目標設定：15分鐘\r\n2. eMBO系統-職場行為調整：6分鐘\r\n3. IDP員工職涯發展計畫-介紹篇：6分鐘 ",
                    "enrollCount": 0,
                    "enrollRemain": 10,
                    "enrollTime": "2017/02/17~2017/06/30",
                    "sessionName": "學程2017年測試",
                    "sessionTime": "2017/02/17 ~ 2017/06/30",
                    "target": "MA"
                },
                "ErrorMessage": ""
            };
            switch (type) {
                case enumCourseType.webCourse:
                    result = CourseSessionType1;
                    break;
                case enumCourseType.classCourse:
                    result = CourseSessionType2;
                    break;
                case enumCourseType.externalCourse:
                    result = CourseSessionType3;
                    break;
                case enumCourseType.webTest:
                    result = CourseSessionType4;
                    break;
                case enumCourseType.classTest:
                    result = CourseSessionType5;
                    break;
                case enumCourseType.questList:
                    result = CourseSessionType6;
                    break;
                case enumCourseType.courage:
                    result = CourseSessionType7;
                    break;
                default:
                    result = { Status: 400, ErrorMessage: "未知的課程類型" };
                    break;
            }
            return { data: result };
        }

        /**
         * 7.取得課程測驗內容
         * @returns
         */
        function ExamSurveyContent(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultTestData1 = {
                "Status": "200",
                "Data": {
                    "examHistoryId": 1515029,
                    "itemId": 175226,
                    "limitMins": -1,
                    "limitTimes": 1,
                    "remainingMins": 1642,
                    "remainingTimes": 4,
                    "questions": [{
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42109,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "我明確知道我在這個課程要學習到什麼。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": "true"
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": "true"
                        }],
                        "questionId": 42110,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程內容架構清晰、具邏輯且份量適中。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": "true"
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42111,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程內容完整、具正確性並符合我的學習程度。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42112,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程的表現方式(如文字、圖片、動畫、影像、聲音…等)能有效傳達學習內容。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42113,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程學習介面(如字型、組成、配置、呈現方式…等)能有效呈現學習內容。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42120,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程提供清晰、適切的學習導引功能(如：向前、後退、回主選單、離開…)，並且容易操作與使用。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "2",
                            "value": ""
                        }],
                        "questionId": 42114,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "系統所提供的網路頻寬與連線服務是足夠的。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "這是選項5，假定有勾選",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "這是選項4，假定有勾選",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "這是選項3，假定沒勾選",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "這是選項2，假定沒勾選",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "這是選項1，假定有勾選",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 6,
                            "title": "這是選項6，假定有勾選",
                            "type": "2",
                            "value": ""
                        }],
                        "questionId": 42115,
                        "questionType": 2,
                        "required": true,
                        "scoreRate": 0,
                        "title": "這是複選題，用以測試是否運作正常。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42121,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課後測驗能幫助我學習，並能讓我知道是否有學習到應該習得的。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42116,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程有達到我的期望。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42117,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "課程內容對我的工作是有幫助的。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42118,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "我對人力資源處訓練發展組提供的 e-Learning 課程服務感到滿意。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 5,
                            "title": "非常同意",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": " ",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 1,
                            "title": "非常不同意",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 42119,
                        "questionType": 4,
                        "required": true,
                        "scoreRate": 0,
                        "title": "我會向其他同仁推薦此課程。{是必選題，題目序號後面應有標示提醒}"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": " ",
                            "type": "3",
                            "value": "AAATE"
                        }],
                        "questionId": 42122,
                        "questionType": 3,
                        "required": false,
                        "scoreRate": 0,
                        "title": "如有其他相關建議，請填寫在下面空白處，謝謝！{不是必選題}"
                    }]
                },
                "ErrorMessage": ""
            };
            var resultTestData2 = {
                "Status": "200",
                "Data": {
                    "examHistoryId": 1515312,
                    "itemId": 306761,
                    "limitMins": 30,
                    "limitTimes": 3,
                    "remainingMins": -1,
                    "remainingTimes": 6,
                    "questions": [{
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88414,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "事業銷售商品或服務附送贈品，其贈品價值上限為：商品或服務價值在新臺幣100元以上者，為商品或服務價值之二分之一；商品或服務價值在新臺幣100元以下者，為新臺幣50元。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88381,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行辦理財富管理業務或對非財富管理部門客戶銷售金融商品，不得以提供贈品方式招攬新客戶開立存款帳戶，以免違反銀行法第34條之規定，至其餘贈品活動仍須遵守銀行公會會員自律公約之相關規定。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "銷售投資型保險商品予客戶時不得任意銷售風險過高、結構過於複雜之商品。但有客觀事實證明客戶有相當專業認識及風險承擔能力者，不在此限。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "就非專業投資人之年齡、對本商品相關知識、投資經驗、財產狀況、交易目的及商品理解等要素，綜合評估其風險承受能力，無須分級，只需要保人簽名確認即可。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "應請客戶提供相關財務資訊，若客戶拒絕提供，招攬人員須於要保書予以註記，並請其於註記處親自簽名確認。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "如係連結結構型商品者，另應提供客戶投資報酬與風險告知書、結構型商品中文產品說明書及中文投資人須知。",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88387,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "下列關於投資型保險商品銷售應注意事項之敘述，何者正確?(複選題)"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88403,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行業提供投資型金融商品或服務前，應依各類金融商品或服務之特性評估金融商品或服務對金融消費者之適合度。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "該境外結構型商品因利率、匯率、有價證券市價或其他指標之變動，有直接導致本金損失或超過當初本金損失之虞者。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "該境外結構型商品因發行機構或他人之業務或財產狀況之變化，有直接導致本金損失或超過當初本金損失之虞者。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "該境外結構型商品因其他經主管機關規定足以影響投資人判斷之重要事項，有直接導致本金損失或超過當初本金損失之虞者。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "受託或銷售機構就前項境外結構型商品受託投資、受託買賣或以之為投資型保單投資標的，涉有契約權利行使期間、解除期間及效力之限制者。",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88392,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "依據境外結構型商品管理規則，下列何者為受託或銷售機構受託投資，受託買賣境外結構型商品或以之為投資型保單投資標的前，應向投資人說明之事項?(複選題)"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "金融消費者資金操作狀況及專業能力。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "金融消費者之投資屬性、對風險之瞭解及風險承受度。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "金融消費者服務之合適性，合適之投資建議範圍。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "金融消費者之所得與資金來源。",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88419,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行業提供投資型金融商品或服務，於訂立契約前，應充分瞭解金融消費者之相關資料，其內容至少應包括下列何者事項？(複選題)"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "客戶風險屬性與商品風險屬性不適配時，銀行仍宜與客戶進行交易。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "對於高齡、教育水準較低等弱勢族群客戶，基於風險承擔能力及商品適合度考量，銀行應避免與此類客戶承作結構型商品交易，以減少交易糾紛。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "客戶承作雙元貨幣等不保本之結構型商品之金額占其往來資金比率較高者，銀行宜主動提醒客戶相關商品之風險，避免客戶因投資部位過度集中而蒙受重大損失。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "得以存款名義銷售。",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88382,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "下列何者為銀行辦理結合存款與衍生性金融商品之結構型商品業務時，應留意之事項?(複選題)"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "對金融消費者所負擔義務不得低於廣告之內容。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "對金融商品或服務內容之揭露如涉及利率、費用、報酬及風險時，應以衡平及顯著之方式表達。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "應忠於原著，以英文表達，必要時得附註中文。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "應以金融服務業名義為之。",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88405,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "金融服務業從事廣告、業務招攬及營業促銷活動，應遵守哪些原則?(複選題)"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88406,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "境外結構型商品之投資人須知之重要內容，應以錄音方式保留紀錄。但對專業投資人得以交付書面或影音媒體方式取代。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88401,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行業有關外匯業務之經營，除銀行業辦理外匯業務管理辦法或央行另有規定者外，應向央行申請許可，並經發給指定證書或許可函後，始得辦理。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88388,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "最近一期經會計師查核或核閱之財務報告總資產超過新臺幣5000萬元之法人或基金，為境外結構型商品管理規則中所規定之專業投資人。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88389,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "於銷售投資型保險商品時，應審酌被保險人年齡等情況予以推介或銷售適當之商品，當被保險人投保時之保險年齡大於或等於70或本商品連結有結構型商品且被保險人於該結構型商品期滿時之保險年齡大於或等於70時，應請要保人及被保險人於要保書中之重要事項告知書或「結構型債券投資報酬與風險告知書」簽名已瞭解並願意承擔投資風險，如要保人及被保險人不願填寫則仍同意其投保。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "不得以吸收存款為目的。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "應按業務類別，分別適用各該業務法令規定及自律規範。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "贈品之單一價格以新臺幣一千元內為宜。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "銀行得為維持與客戶關係、其他業務推展或企業形象宣導等非吸收存款目的，舉辦與存款業務有關之贈品業務推廣活動。",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88418,
                        "questionType": 1,
                        "required": false,
                        "scoreRate": 5,
                        "title": "關於銀行業辦理與存款業務有關之贈品贈獎業務推廣活動時應遵循之規定，以下何者為非？"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88383,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行辦理財富管理業務，應請切實注意以誠信及充分揭露原則辦理，廣告文宣中就金融商品之可能報酬、風險及限制條件之揭露，應以衡平且顯著方式表達，不得有誇大不實陳述或誤導消費者之虞情事。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "除法令另有規定外，行銷廣告文件於對外使用前應經法令遵循主管審核。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "得使人相信能保證本金之安全或獲利。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "對於獲利與風險應作平衡報導，且得載有與向主管機關申請文件內容不符之文字或設計。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "特定投資標的之名稱應適當表達其特性及風險，不得使用可能誤導客戶之名稱。",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88397,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "信託業辦理營業促銷活動時，應遵守下列何項規定？(複選題)"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88416,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "「銀行辦理衍生性金融商品自律規範」所稱以錄音方式保留向一般客戶宣讀結構型商品交易客戶須知之重要內容，交易遇有爭議，不必保留至爭議終結為止。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "任何說明或揭露之資訊或資料均須正確。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "所有銷售文件無須編印頁碼。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 3,
                            "title": "銷售文件之用語應以中文表達，並力求淺顯易懂，必要時得附註原文。",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 4,
                            "title": "應本於誠實信用原則，並以金融消費者能充分瞭解之文字或其他方式為之。",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88409,
                        "questionType": 2,
                        "required": false,
                        "scoreRate": 5,
                        "title": "金融服務業說明金融商品或服務契約之重要內容及揭露風險，應遵守哪些基本原則?(複選題)"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88398,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行辦理外幣保證金交易及組合式產品等業務，應制定與落實瞭解客戶（KYC ）原則，並充分揭露相關風險，不得有誤導客戶情事。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [{
                            "attachment": "",
                            "order": 1,
                            "title": "是",
                            "type": "1",
                            "value": ""
                        }, {
                            "attachment": "",
                            "order": 2,
                            "title": "否",
                            "type": "1",
                            "value": ""
                        }],
                        "questionId": 88386,
                        "questionType": 6,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行依據「銀行辦理衍生性金融商品自律規範」錄音或錄影所留存之個人資料，任何人均得於保存期限內，向銀行申請調閱。除該資料之提供有妨害銀行或第三人之重大利益外，銀行應配合提供前項紀錄，並得向當事人收取必要成本費用。"
                    }, {
                        "attachment": "",
                        "groupName": "",
                        "options": [
                        // {
                        //     "attachment": "",
                        //     "order": 1,
                        //     "title": "是",
                        //     "type": "1",
                        //     "value": ""
                        // },
                        // {
                        //     "attachment": "",
                        //     "order": 2,
                        //     "title": "否",
                        //     "type": "1",
                        //     "value": ""
                        // },
                        {
                            "attachment": "",
                            "correctAnswer": false,
                            "order": 1,
                            "preTitle": false,
                            "textValue": "",
                            "title": " ",
                            "type": "3",
                            "value": "HR網站→台新大學→訓練中心"
                        }],
                        "questionId": 88400,
                        "questionType": 3,
                        "required": false,
                        "scoreRate": 5,
                        "title": "銀行業經主管機關命其於一定期間內停止申辦外匯業務，於停止期間尚未屆滿或未提報適當之具體改善措施，或提報之改善措施未獲主管機關認可前，不得以函報備查方式開辦依本辦法規定得函報備查之外匯業務。"
                    }]
                },
                "ErrorMessage": ""
            };
            // console.log(params);
            switch (params.type) {
                case '問卷':
                    result = resultTestData1;
                    break;
                case '測驗':
                    result = resultTestData2;
                    break;
                default:
                    result = { Status: 400, Data: null, ErrorMessage: "未知的課程類型" };
            }
            return { data: result };
        }
        /**
         * 8.測驗結果(P.7~8)
         * @returns
         */
        function InteractionData(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultTestData1Answer = {
                "Status": "200",
                "Data": null,
                "ErrorMessage": ""
            };
            var resultTestData2Answer = {
                "Status": "200",
                "Data": {
                    "questionResults": [{
                        "correctAnswer": "1,2,3,4",
                        "questionId": 88419,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "3",
                        "questionId": 88418,
                        "studentAnswer": "x"
                    }, {
                        "correctAnswer": "2",
                        "questionId": 88416,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "1",
                        "questionId": 88414,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "1,3,4",
                        "questionId": 88409,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "",
                        "questionId": 88406,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "1,2,4",
                        "questionId": 88405,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "1",
                        "questionId": 88403,
                        "studentAnswer": "2"
                    }, {
                        "correctAnswer": "",
                        "questionId": 88401,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "HR網站→台新大學→訓練中心",
                        "questionId": 88400,
                        "studentAnswer": "asd"
                    }, {
                        "correctAnswer": "1",
                        "questionId": 88398,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "1,4",
                        "questionId": 88397,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "1,2,3,4",
                        "questionId": 88392,
                        "studentAnswer": "x"
                    }, {
                        "correctAnswer": "2",
                        "questionId": 88389,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "",
                        "questionId": 88388,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "1,3,4",
                        "questionId": 88387,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "",
                        "questionId": 88386,
                        "studentAnswer": "2"
                    }, {
                        "correctAnswer": "1",
                        "questionId": 88383,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "2,3",
                        "questionId": 88382,
                        "studentAnswer": "1"
                    }, {
                        "correctAnswer": "1",
                        "questionId": 88381,
                        "studentAnswer": "1"
                    }],
                    "right": 0,
                    "score": 0,
                    "totalQuestions": 20,
                    "wrong": 20
                },
                "ErrorMessage": ""
            };
            // console.log("params:", params);
            switch (params.type) {
                case '問卷':
                    result = resultTestData1Answer;
                    break;
                case '測驗':
                    result = resultTestData2Answer;
                    break;
                default:
                    result = { Status: 400, Data: null, ErrorMessage: "未知的課程類型" };
            }
            return { data: result };
        }

        /**
         * 11.待修課程列表
         * @returns
         */
        function MyUnfinishedActivities(params) {
            return new Promise(function (resolve, reject) {
                var result = {
                    Status: 0,
                    Data: {},
                    ErrorMessage: ""
                };
                var resultTW;
                var resultCN;
                var resultUS;

                resultTW = {
                    "Status": "200",
                    "Data": [{
                        "courseId": 69435,
                        "courseType": 4,
                        "courseTypeName": "線上測驗",
                        "enrollmentId": 2165989,
                        "progress": "0/1",
                        "sessionId": 99354,
                        "sessionName": "20170512徵信照會證照研習班 (補考) ",
                        "sessionTime": "2017/05/12 <br>09:00-10:00 ",
                        "status": "未曾觀看"
                    }, {
                        "courseId": 67418,
                        "courseType": 3,
                        "courseTypeName": "外訓",
                        "enrollmentId": 2165984,
                        "progress": "0/1",
                        "sessionId": 99353,
                        "sessionName": "20170306北區對保實務研習班 (補考)",
                        "sessionTime": "2017/03/06 <br>09:00-10:00 ",
                        "status": "待修中"
                    }, {
                        "courseId": 10790,
                        "courseType": 5,
                        "courseTypeName": "教室測驗",
                        "enrollmentId": 2165972,
                        "progress": "0/1",
                        "sessionId": 99207,
                        "sessionName": "20170302Oracle PL/SQL認證測驗 ",
                        "sessionTime": "2017/03/02 <br>10:00-12:00 ",
                        "status": "待修中"
                    }, {
                        "courseId": 61240,
                        "courseType": 2,
                        "courseTypeName": "教室課程",
                        "enrollmentId": 2165974,
                        "progress": "1/2",
                        "sessionId": 99345,
                        "sessionName": "20170420商業簡報技巧(八德)",
                        "sessionTime": "2017/04/20 <br>09:00-12:00 ",
                        "status": "未完成"
                    }, {
                        "courseId": 9330,
                        "courseType": 2,
                        "courseTypeName": "教室課程",
                        "enrollmentId": 2165973,
                        "progress": "1/2",
                        "sessionId": 95401,
                        "sessionName": "20170417簡報製作技巧(2010版)",
                        "sessionTime": "2017/04/17 <br>13:30-17:30 ",
                        "status": "等待簽核中"
                    }, {
                        "courseId": 71771,
                        "courseType": 6,
                        "courseTypeName": "線上問卷",
                        "enrollmentId": 2165970,
                        "progress": "1/20",
                        "sessionId": 98593,
                        "sessionName": "信託業務人員在職訓練課程(106上半年)",
                        "sessionTime": "2017/01/04~2017/06/30",
                        "status": "未完成"
                    }, {
                        "courseId": 2361,
                        "courseType": 2,
                        "courseTypeName": "教室課程",
                        "enrollmentId": 2165963,
                        "progress": "1/2",
                        "sessionId": 98736,
                        "sessionName": "20170308初階簡報技巧",
                        "sessionTime": "2017/03/08 <br>13:30-17:30 ",
                        "status": "未完成"
                    }, {
                        "courseId": 71776,
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "enrollmentId": 2165962,
                        "progress": "0/3",
                        "sessionId": 98600,
                        "sessionName": "信託在職-組合式商品簡介 (106上半年)",
                        "sessionTime": "2017/01/04~2017/06/30",
                        "status": "未完成"
                    }, {
                        "courseId": 64877,
                        "courseType": 1,
                        "courseTypeName": "線上課程",
                        "enrollmentId": 2165961,
                        "progress": "0/2",
                        "sessionId": 98933,
                        "sessionName": "吃出健康(106年)",
                        "sessionTime": "2017/01/04~2017/12/31",
                        "status": "未完成"
                    }, {
                        "courseId": 0,
                        "courseType": 7,
                        "courseTypeName": "學程",
                        "enrollmentId": 2165976,
                        "progress": "",
                        "sessionId": 99286,
                        "sessionName": "2017-0920 股務單位人員教育訓練",
                        "sessionTime": "~",
                        "status": "等待簽核中"
                    }, {
                        "courseId": 0,
                        "courseType": 7,
                        "courseTypeName": "學程",
                        "enrollmentId": 2165975,
                        "progress": "",
                        "sessionId": 98652,
                        "sessionName": "2017-0422信託業務人員在職訓練-台中場",
                        "sessionTime": "~",
                        "status": "等待簽核中"
                    }],
                    "ErrorMessage": ""
                };
                resultCN = {
                    "Status": "200",
                    "Data": [{
                        "courseId": 66903,
                        "courseType": 1,
                        "courseTypeName": "線上課程(簡中)",
                        "enrollmentId": 1975394,
                        "progress": "0/3",
                        "sessionId": 91423,
                        "sessionName": "理專APP功能操作與使用(test)(簡中)",
                        "sessionTime": "2016/07/25~2016/12/31",
                        "status": "未完成(簡中)"
                    }, {
                        "courseId": 963,
                        "courseType": 3,
                        "courseTypeName": "外訓課程(簡中)",
                        "enrollmentId": 2118844,
                        "progress": "0/2",
                        "sessionId": 93496,
                        "sessionName": "20161231信託業務人員職前訓練(4小時)-台北場(簡中)",
                        "sessionTime": "2016/12/31 <br>13:00-17:00 ",
                        "status": "待修中(簡中)"
                    }],
                    "ErrorMessage": ""
                };
                resultUS = {
                    "Status": "200",
                    "Data": [{
                        "courseId": 58954,
                        "courseType": 1,
                        "courseTypeName": "線上課程(英文)",
                        "enrollmentId": 2118839,
                        "progress": "0/1",
                        "sessionId": 96530,
                        "sessionName": "「看見愛的力量」微電影(2016)(英文)",
                        "sessionTime": "2016/12/01~2016/12/31",
                        "status": "未完成(英文)"
                    }, {
                        "courseId": 305,
                        "courseType": 7,
                        "courseTypeName": "學程(英文)",
                        "enrollmentId": 0,
                        "progress": "0/12",
                        "sessionId": 1356,
                        "sessionName": "新人e起來(105-Q4)(英文)",
                        "sessionTime": "2016/10/01~2016/12/31",
                        "status": "未完成(英文)"
                    }, {
                        "courseId": 290,
                        "courseType": 7,
                        "courseTypeName": "學程(英文)",
                        "enrollmentId": 0,
                        "progress": "0/26",
                        "sessionId": 1370,
                        "sessionName": "人身保險業務員在職訓練第一年(2016-V)人身保險業務員在職訓練第一年(2016-V)【含洗錢】(英文)",
                        "sessionTime": "2016/11/01~2016/12/27",
                        "status": "未完成(英文)"
                    }],
                    "ErrorMessage": ""
                };
                switch (params.LanguageCode) {
                    case 'en-US':
                        result = resultUS;
                        break;
                    case 'zh-CN':
                        result = resultCN;
                        break;
                    default:
                        result = resultTW;
                        break;
                }

                if (params.LanguageCode === 'zh-TW') {
                    setTimeout(function () {
                        resolve({ data: result });
                    }, 1000);
                } else {
                    resolve({ data: result });
                }
            });
        }

        /**
         * 12.修課記錄列表
         * @returns
         */
        function MyFinishedActivities(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultTW;
            var resultCN;
            var resultUS;

            resultTW = {
                "Status": "200",
                "Data": [{
                    "courseId": 4,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 161360,
                    "sessionId": 2056,
                    "sessionName": "Acrobat_PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應PDF全應用(100上半年)",
                    "sessionTime": "2011/01/01~2011/06/30",
                    "status": 3
                }, {
                    "courseId": 12,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1012635,
                    "sessionId": 46737,
                    "sessionName": "Time is Money：時間管理(103上半年)",
                    "sessionTime": "2014/01/01~2014/06/30",
                    "status": 3
                }, {
                    "courseId": 12,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1854663,
                    "sessionId": 82308,
                    "sessionName": "Time is Money：時間管理(105上半年)",
                    "sessionTime": "2016/01/04~2016/06/30",
                    "status": 2
                }, {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 1765530,
                    "sessionId": 82149,
                    "sessionName": "投資型保險證照-年金考試班(105-01)",
                    "sessionTime": "2016/01/04~2016/01/31",
                    "status": 3
                }, {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 1852664,
                    "sessionId": 85907,
                    "sessionName": "投資型保險證照-年金考試班(105-04)",
                    "sessionTime": "2016/04/01~2016/04/30",
                    "status": 3
                }, {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 1955630,
                    "sessionId": 89956,
                    "sessionName": "投資型保險證照-年金考試班(105下半年)",
                    "sessionTime": "2016/07/01~2016/12/27",
                    "status": 2
                }, {
                    "courseId": 59,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 7736,
                    "sessionId": 25,
                    "sessionName": "簡易外匯機制考試班(9910-9912)",
                    "sessionTime": "2010/10/01~2010/12/31",
                    "status": 3
                }, {
                    "courseId": 59,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 2089734,
                    "sessionId": 94266,
                    "sessionName": "簡易外匯機制考試班(通路105-Q4)",
                    "sessionTime": "2016/10/01~2016/12/30",
                    "status": 3
                }, {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 14330,
                    "sessionId": 17,
                    "sessionName": "開戶對保作業實務介紹(9910-9912)",
                    "sessionTime": "2010/10/01~2010/12/31",
                    "status": 2
                }, {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1765452,
                    "sessionId": 82173,
                    "sessionName": "開戶對保作業實務介紹(105-Q1)",
                    "sessionTime": "2016/01/04~2016/03/31",
                    "status": 3
                }, {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 2131900,
                    "sessionId": 94261,
                    "sessionName": "開戶對保作業實務介紹(105-Q4)",
                    "sessionTime": "2016/10/01~2016/12/30",
                    "status": 3
                }, {
                    "courseId": 61,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 244471,
                    "sessionId": 7229,
                    "sessionName": "自行查核相關規範及注意事項(100-Q3)",
                    "sessionTime": "2011/07/01~2011/09/30",
                    "status": 2
                }, {
                    "courseId": 83,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1580993,
                    "sessionId": 74983,
                    "sessionName": "認識國標舞(104下半年)",
                    "sessionTime": "2015/08/04~2015/12/31",
                    "status": 3
                }, {
                    "courseId": 115,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 1782552,
                    "sessionId": 83589,
                    "sessionName": "20160412+0419內部講師培訓 ",
                    "sessionTime": "2016/04/12 <br>09:00-17:00 <br>休息時間12:00-13:00<br><br>2016/04/19 <br>09:00-17:00 <br>休息時間12:00-13:00",
                    "status": 2
                }, {
                    "courseId": 121,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 218800,
                    "sessionId": 7151,
                    "sessionName": "20110823簽呈寫作訓練",
                    "sessionTime": "2011/08/23 <br>13:30-18:00 ",
                    "status": 2
                }, {
                    "courseId": 219,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 264566,
                    "sessionId": 8329,
                    "sessionName": "20111011-Fun輕鬆~~創造快樂的生活",
                    "sessionTime": "2011/10/11 <br>14:00-17:00 ",
                    "status": 2
                }, {
                    "courseId": 417,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 20519,
                    "sessionId": 639,
                    "sessionName": "防制洗錢，大家一起來！(2010)",
                    "sessionTime": "2010/11/15~2010/11/26",
                    "status": 2
                }, {
                    "courseId": 440,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 16220,
                    "sessionId": 656,
                    "sessionName": "理專銷售一致化法規檢測(9911)",
                    "sessionTime": "2010/11/11~2010/11/12",
                    "status": 3
                }, {
                    "courseId": 555,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 16934,
                    "sessionId": 770,
                    "sessionName": "理專銷售一致化法規檢測(題型測試)",
                    "sessionTime": "2010/11/12~2010/11/12",
                    "status": 3
                }, {
                    "courseId": 1150,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 43260,
                    "sessionId": 1544,
                    "sessionName": "1214講師座談會",
                    "sessionTime": "2010/12/14 <br>14:00-17:30 ",
                    "status": 2
                }, {
                    "courseId": 1427,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 53226,
                    "sessionId": 1848,
                    "sessionName": "資訊安全教育",
                    "sessionTime": "2011/01/03~2011/01/21",
                    "status": 2
                }, {
                    "courseId": 1511,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1767571,
                    "sessionId": 82177,
                    "sessionName": "覆核實務作業介紹(通路105-Q1)",
                    "sessionTime": "2016/01/04~2016/03/31",
                    "status": 3
                }, {
                    "courseId": 1684,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 97963,
                    "sessionId": 2348,
                    "sessionName": "員工保密規約測驗 (100-Q1)",
                    "sessionTime": "2011/01/10~2011/03/31",
                    "status": 2
                }, {
                    "courseId": 1926,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 98474,
                    "sessionId": 2658,
                    "sessionName": "資訊安全教育(問卷補考班)",
                    "sessionTime": "2011/01/31~2011/02/25",
                    "status": 2
                }, {
                    "courseId": 2353,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 115681,
                    "sessionId": 3672,
                    "sessionName": "20110401改變的力量(下午場)",
                    "sessionTime": "2011/04/01 <br>14:00-17:00 ",
                    "status": 2
                }, {
                    "courseId": 2759,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 111186,
                    "sessionId": 3622,
                    "sessionName": "當幸福來敲門【此為第一季台新大學宣傳活動，不認列訓練時數】",
                    "sessionTime": "2011/04/14~2011/04/20 每1週(區間內的Mon,Tue,Wed,Thu,Fri)<br>16:00-17:00 ",
                    "status": 2
                }, {
                    "courseId": 3062,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 121338,
                    "sessionId": 4155,
                    "sessionName": "1000329測試",
                    "sessionTime": "2011/03/29~2011/03/29",
                    "status": 3
                }, {
                    "courseId": 3366,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 137379,
                    "sessionId": 4842,
                    "sessionName": "eMBO系統-職場行為調整 (一般同仁)-功能單位、法金",
                    "sessionTime": "2011/04/18~2011/04/29",
                    "status": 2
                }, {
                    "courseId": 3620,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 147507,
                    "sessionId": 4928,
                    "sessionName": "100年理專專業檢測測驗班(補考班) ",
                    "sessionTime": "2011/04/22~2011/04/22",
                    "status": 3
                }, {
                    "courseId": 3921,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 157915,
                    "sessionId": 5504,
                    "sessionName": "覆核實務-小百科(5)",
                    "sessionTime": "2011/05/04~2011/06/17",
                    "status": 3
                }, {
                    "courseId": 4033,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 166491,
                    "sessionId": 5669,
                    "sessionName": "無三不成禮",
                    "sessionTime": "2011/05/13~2011/06/17",
                    "status": 2
                }, {
                    "courseId": 4102,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 172835,
                    "sessionId": 5598,
                    "sessionName": "201110525體驗學習教學技巧分享",
                    "sessionTime": "2011/05/25 <br>13:30-17:30 ",
                    "status": 2
                }, {
                    "courseId": 4102,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 1165246,
                    "sessionId": 57327,
                    "sessionName": "20140903破冰手法大解析(優秀內部講師免費活動)",
                    "sessionTime": "2014/09/03 <br>13:30-17:30 ",
                    "status": 2
                }, {
                    "courseId": 4102,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 1576652,
                    "sessionId": 74912,
                    "sessionName": "20150922我的熱情來自於成就他人",
                    "sessionTime": "2015/09/22 <br>15:00-18:00 ",
                    "status": 2
                }, {
                    "courseId": 4102,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 2050891,
                    "sessionId": 93035,
                    "sessionName": "20160930國際大師的創意教學技法與學習新趨勢",
                    "sessionTime": "2016/09/30 <br>14:00-17:00 ",
                    "status": 2
                }, {
                    "courseId": 4259,
                    "courseType": 3,
                    "courseTypeName": "外訓課程",
                    "enrollmentId": 610169,
                    "sessionId": 26912,
                    "sessionName": "2012-0921金融市場常識與職業道德",
                    "sessionTime": "2012/09/21 <br>18:00-20:00 ",
                    "status": 2
                }, {
                    "courseId": 4365,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 165743,
                    "sessionId": 5911,
                    "sessionName": "OJT-3S把服務做到最好",
                    "sessionTime": "2011/05/17 <br>10:00-10:30 ",
                    "status": 2
                }, {
                    "courseId": 4366,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 165771,
                    "sessionId": 5912,
                    "sessionName": "OJT-法令遵循及資訊安全宣導",
                    "sessionTime": "2011/05/17 <br>10:30-11:00 ",
                    "status": 2
                }, {
                    "courseId": 4684,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 191644,
                    "sessionId": 6213,
                    "sessionName": "100上-信用卡-法令遵循自評檢核考試班",
                    "sessionTime": "2011/06/01~2011/06/16",
                    "status": 3
                }, {
                    "courseId": 5283,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 185889,
                    "sessionId": 6758,
                    "sessionName": "個人資料保護法因應與衝擊認知教育訓練(功能、法金)",
                    "sessionTime": "2011/06/20~2011/07/01",
                    "status": 2
                }, {
                    "courseId": 8995,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 225227,
                    "sessionId": 8668,
                    "sessionName": "3Sbook，隨時分享簡單、真心、極優的每一刻！(功能、法金)",
                    "sessionTime": "2011/07/29~2011/08/12",
                    "status": 2
                }, {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 243312,
                    "sessionId": 9185,
                    "sessionName": "20110905-1 派外主管管理須知",
                    "sessionTime": "2011/09/05 <br>14:00-16:00 ",
                    "status": 2
                }, {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 245342,
                    "sessionId": 9420,
                    "sessionName": "20110905-2 薪資制度與稅務處理",
                    "sessionTime": "2011/09/05 <br>16:30-20:30 ",
                    "status": 2
                }, {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 245343,
                    "sessionId": 9422,
                    "sessionName": "20111003 員工招聘任用",
                    "sessionTime": "2011/10/03 <br>17:00-20:00 ",
                    "status": 2
                }, {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 245346,
                    "sessionId": 9426,
                    "sessionName": "20111013 社會保險與員工福利",
                    "sessionTime": "2011/10/13 <br>17:00-20:00 ",
                    "status": 2
                }, {
                    "courseId": 9477,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 464127,
                    "sessionId": 23026,
                    "sessionName": "20121003 與工會共舞",
                    "sessionTime": "2012/10/03 <br>15:00-18:00 ",
                    "status": 2
                }, {
                    "courseId": 9680,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 554420,
                    "sessionId": 22225,
                    "sessionName": "產險考照模擬測驗(101下半年)",
                    "sessionTime": "2012/07/01~2012/12/31",
                    "status": 3
                }, {
                    "courseId": 10817,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 291201,
                    "sessionId": 11764,
                    "sessionName": "20111107內控內稽案例暨法令宣導(人力資源處)",
                    "sessionTime": "2011/11/07 <br>15:30-17:30 ",
                    "status": 2
                }, {
                    "courseId": 11371,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 288776,
                    "sessionId": 11704,
                    "sessionName": "防制洗錢，大家一起來！(2011-法金、功能)",
                    "sessionTime": "2011/10/31~2011/11/11",
                    "status": 2
                }, {
                    "courseId": 11371,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 554046,
                    "sessionId": 26829,
                    "sessionName": "防制洗錢，大家一起來！(2012-功能其他單位)",
                    "sessionTime": "2012/10/08~2012/10/25",
                    "status": 2
                }, {
                    "courseId": 11920,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 306566,
                    "sessionId": 12473,
                    "sessionName": "100-11-分行作業規範測驗",
                    "sessionTime": "2011/11/16~2011/11/29",
                    "status": 2
                }, {
                    "courseId": 13899,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1963434,
                    "sessionId": 90435,
                    "sessionName": "WORD文書排版(上)【105下半年】",
                    "sessionTime": "2016/07/01~2016/12/30",
                    "status": 3
                }, {
                    "courseId": 13901,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1575469,
                    "sessionId": 74131,
                    "sessionName": "POWERPOINT創意簡報王【104下半年】",
                    "sessionTime": "2015/07/20~2015/12/31",
                    "status": 3
                }, {
                    "courseId": 14828,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 399071,
                    "sessionId": 17536,
                    "sessionName": "20120413 HR也要懂的行銷之道",
                    "sessionTime": "2012/04/13 <br>15:00-17:00 ",
                    "status": 2
                }, {
                    "courseId": 16816,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1677300,
                    "sessionId": 79221,
                    "sessionName": "信託在職─信託業務綜覽【II】(104-11)",
                    "sessionTime": "2015/11/01~2015/11/30",
                    "status": 3
                }, {
                    "courseId": 16827,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 411826,
                    "sessionId": 18708,
                    "sessionName": "eTag自動儲值專案(功能)",
                    "sessionTime": "2012/05/14~2012/05/25",
                    "status": 2
                }, {
                    "courseId": 17577,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 435905,
                    "sessionId": 21188,
                    "sessionName": "101上-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2012/06/01~2012/06/15",
                    "status": 2
                }, {
                    "courseId": 18025,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1971636,
                    "sessionId": 82375,
                    "sessionName": "IDP員工職涯發展計畫(105年)",
                    "sessionTime": "2016/01/04~2016/12/30",
                    "status": 3
                }, {
                    "courseId": 18339,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 617003,
                    "sessionId": 30447,
                    "sessionName": "自行查核相關規範及注意事項(102-Q1)",
                    "sessionTime": "2013/01/01~2013/03/26",
                    "status": 2
                }, {
                    "courseId": 18536,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 460069,
                    "sessionId": 22961,
                    "sessionName": "個資管理控管機制宣導教育訓練(功能)",
                    "sessionTime": "2012/07/09~2012/07/26",
                    "status": 2
                }, {
                    "courseId": 20268,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 534576,
                    "sessionId": 24547,
                    "sessionName": "20120918 EQ無礙，未來更high",
                    "sessionTime": "2012/09/18 <br>14:00-17:00 ",
                    "status": 2
                }, {
                    "courseId": 20628,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 505062,
                    "sessionId": 25030,
                    "sessionName": "20120830輔銷人員晨會及產品專業度檢測",
                    "sessionTime": "2012/08/30~2012/08/31",
                    "status": 3
                }, {
                    "courseId": 23101,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 583844,
                    "sessionId": 28326,
                    "sessionName": "Q3晨會TEST",
                    "sessionTime": "2012/11/20~2012/12/31",
                    "status": 3
                }, {
                    "courseId": 25204,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 623890,
                    "sessionId": 31329,
                    "sessionName": "台新銀行新光三越聯名卡競品權益比較(test)",
                    "sessionTime": "2013/02/01~2013/02/01",
                    "status": 3
                }, {
                    "courseId": 28808,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 701659,
                    "sessionId": 36017,
                    "sessionName": "防制洗錢，大家一起來！(2013功能、子公司II)",
                    "sessionTime": "2013/05/06~2013/05/21",
                    "status": 2
                }, {
                    "courseId": 29109,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 744824,
                    "sessionId": 37101,
                    "sessionName": "102上-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2013/06/01~2013/06/15",
                    "status": 2
                }, {
                    "courseId": 29128,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 710389,
                    "sessionId": 36373,
                    "sessionName": "【空中英語教室】Beating Stress (戰勝壓力)",
                    "sessionTime": "2013/05/16~2013/12/31",
                    "status": 3
                }, {
                    "courseId": 29355,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 757635,
                    "sessionId": 37097,
                    "sessionName": "台新證券-法遵自評筆試(一般)【102上】",
                    "sessionTime": "2013/06/03~2013/06/26",
                    "status": 2
                }, {
                    "courseId": 31029,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 771493,
                    "sessionId": 38973,
                    "sessionName": "OJT-法規-第二季法令遵循暨資安宣導",
                    "sessionTime": "2013/06/26 <br>14:00-14:30 ",
                    "status": 2
                }, {
                    "courseId": 31158,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 781710,
                    "sessionId": 39303,
                    "sessionName": "個人資料保護宣導課程(HR)",
                    "sessionTime": "2013/07/15~2013/07/31",
                    "status": 2
                }, {
                    "courseId": 32901,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 845845,
                    "sessionId": 42432,
                    "sessionName": "「金融消費者保護法」及其相關子法之重點說明(第一梯次)",
                    "sessionTime": "2013/09/23~2013/10/23",
                    "status": 2
                }, {
                    "courseId": 33111,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1809577,
                    "sessionId": 84810,
                    "sessionName": "2014人身保險在職訓練-零散",
                    "sessionTime": "~",
                    "status": 3
                }, {
                    "courseId": 33112,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1809679,
                    "sessionId": 84817,
                    "sessionName": "2014財產保險在職訓練-零散",
                    "sessionTime": "~",
                    "status": 3
                }, {
                    "courseId": 33529,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 855031,
                    "sessionId": 42842,
                    "sessionName": "OJT-法規-第二季法令遵循暨資安宣導",
                    "sessionTime": "2013/09/25 <br>14:00-14:30 ",
                    "status": 2
                }, {
                    "courseId": 34014,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1808070,
                    "sessionId": 84282,
                    "sessionName": "信託業務人員職前訓練課程(105-03)",
                    "sessionTime": "2016/03/01~2016/03/31",
                    "status": 3
                }, {
                    "courseId": 34014,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 2041573,
                    "sessionId": 91701,
                    "sessionName": "信託業務人員職前訓練課程(105下半年)",
                    "sessionTime": "2016/08/01~2016/12/30",
                    "status": 3
                }, {
                    "courseId": 34181,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 872125,
                    "sessionId": 43743,
                    "sessionName": "20131009 尋找羅浮宮暗畫",
                    "sessionTime": "2013/10/09 <br>15:30-18:30 ",
                    "status": 2
                }, {
                    "courseId": 35308,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 909145,
                    "sessionId": 45732,
                    "sessionName": "102下-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2013/12/02~2013/12/19",
                    "status": 2
                }, {
                    "courseId": 36343,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1282161,
                    "sessionId": 61835,
                    "sessionName": "信託業務人員在職訓練課程(103-12)",
                    "sessionTime": "2014/12/01~2014/12/31",
                    "status": 3
                }, {
                    "courseId": 40306,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 994258,
                    "sessionId": 51698,
                    "sessionName": "OJT-2014第一季資安暨法遵宣導課程名單",
                    "sessionTime": "2014/03/25 <br>14:00-14:30 ",
                    "status": 2
                }, {
                    "courseId": 40351,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 996178,
                    "sessionId": 51788,
                    "sessionName": "防制洗錢，大家一起來(2014功能、子公司、通路)",
                    "sessionTime": "2014/04/02~2014/04/30",
                    "status": 2
                }, {
                    "courseId": 40643,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 1070380,
                    "sessionId": 52424,
                    "sessionName": "20140618 複訓_勞工安全衛生 (北區_內湖_下午)",
                    "sessionTime": "2014/06/18 <br>14:00-17:00 ",
                    "status": 2
                }, {
                    "courseId": 41344,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1048766,
                    "sessionId": 53283,
                    "sessionName": "金融專業培訓課程--外匯業務分行篇(國外部TEST)",
                    "sessionTime": "2014/05/16~2014/06/30",
                    "status": 3
                }, {
                    "courseId": 41558,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1056214,
                    "sessionId": 54076,
                    "sessionName": "美國海外帳戶稅收遵循法(FATCA)介紹【2014】",
                    "sessionTime": "2014/06/03~2014/06/30",
                    "status": 2
                }, {
                    "courseId": 41933,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1576041,
                    "sessionId": 73482,
                    "sessionName": "台新金控的核心价值(104下半年)",
                    "sessionTime": "2015/07/01~2015/12/31",
                    "status": 2
                }, {
                    "courseId": 43620,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1131157,
                    "sessionId": 56980,
                    "sessionName": "個資侵害事件之應變程序",
                    "sessionTime": "2014/08/11~2014/08/29",
                    "status": 2
                }, {
                    "courseId": 45594,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1204691,
                    "sessionId": 60298,
                    "sessionName": "2014 資訊安全教育",
                    "sessionTime": "2014/10/13~2014/10/31",
                    "status": 2
                }, {
                    "courseId": 45594,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1411546,
                    "sessionId": 69411,
                    "sessionName": "2015 資訊安全教育",
                    "sessionTime": "2015/05/04~2015/05/29",
                    "status": 2
                }, {
                    "courseId": 47260,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1272749,
                    "sessionId": 62654,
                    "sessionName": "企業倫理",
                    "sessionTime": "2014/12/16~2014/12/31",
                    "status": 2
                }, {
                    "courseId": 50199,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1387594,
                    "sessionId": 68451,
                    "sessionName": "銀行業防制洗錢及打擊資助恐怖主義注意事項(2015)",
                    "sessionTime": "2015/04/07~2015/04/30",
                    "status": 2
                }, {
                    "courseId": 52160,
                    "courseType": 6,
                    "courseTypeName": "問卷",
                    "enrollmentId": 1425084,
                    "sessionId": 69695,
                    "sessionName": "台新大學暨人資網站改版問卷調查(test)",
                    "sessionTime": "2015/05/12~2015/05/18",
                    "status": 0
                }, {
                    "courseId": 52160,
                    "courseType": 6,
                    "courseTypeName": "問卷",
                    "enrollmentId": 1437104,
                    "sessionId": 69903,
                    "sessionName": "台新大學暨人資網站改版問卷調查(2015)",
                    "sessionTime": "2015/05/18~2015/05/29",
                    "status": 2
                }, {
                    "courseId": 55764,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1765451,
                    "sessionId": 82343,
                    "sessionName": "信用卡進件流程與徵審作業介紹(105上半年)",
                    "sessionTime": "2016/01/04~2016/06/30",
                    "status": 1
                }, {
                    "courseId": 55820,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1547020,
                    "sessionId": 75145,
                    "sessionName": "個資侵害事件之應變程序(2015)",
                    "sessionTime": "2015/08/10~2015/09/07",
                    "status": 2
                }, {
                    "courseId": 58214,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1641409,
                    "sessionId": 78458,
                    "sessionName": "「金融消費者保護法」及其相關子法之重點說明(2015)",
                    "sessionTime": "2015/10/19~2015/11/13",
                    "status": 2
                }, {
                    "courseId": 58954,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1672067,
                    "sessionId": 79652,
                    "sessionName": "「看見愛的力量」微電影(2015)",
                    "sessionTime": "2015/11/05~2015/12/31",
                    "status": 2
                }, {
                    "courseId": 59632,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 1700490,
                    "sessionId": 80745,
                    "sessionName": "104下-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2015/12/01~2015/12/16",
                    "status": 2
                }, {
                    "courseId": 63973,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1861689,
                    "sessionId": 87641,
                    "sessionName": "資訊安全教育(2016)",
                    "sessionTime": "2016/05/03~2016/05/31",
                    "status": 2
                }, {
                    "courseId": 65645,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1923693,
                    "sessionId": 89470,
                    "sessionName": "「票據招商 吸收存款」專案",
                    "sessionTime": "2016/06/20~2016/07/15",
                    "status": 2
                }, {
                    "courseId": 65916,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1945653,
                    "sessionId": 90607,
                    "sessionName": "金融消費者保護法及公平待客原則(含誠信經營守則、企業倫理)",
                    "sessionTime": "2016/07/04~2016/07/29",
                    "status": 2
                }, {
                    "courseId": 66903,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1975394,
                    "sessionId": 91423,
                    "sessionName": "理專APP功能操作與使用(test)",
                    "sessionTime": "2016/07/25~2016/07/25",
                    "status": 3
                }, {
                    "courseId": 66903,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1982705,
                    "sessionId": 91521,
                    "sessionName": "理專APP功能操作與使用",
                    "sessionTime": "2016/07/26~2016/08/26",
                    "status": 3
                }, {
                    "courseId": 67327,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 1984657,
                    "sessionId": 92043,
                    "sessionName": "Hahow好學校 廣告影片測試",
                    "sessionTime": "2016/07/31~2016/08/05",
                    "status": 3
                }, {
                    "courseId": 67836,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 2042239,
                    "sessionId": 93734,
                    "sessionName": "防制洗錢及打擊資助恐怖主義風險評估與管理(2016)",
                    "sessionTime": "2016/09/12~2016/10/07",
                    "status": 2
                }, {
                    "courseId": 68146,
                    "courseType": 1,
                    "courseTypeName": "線上課程",
                    "enrollmentId": 2033954,
                    "sessionId": 93489,
                    "sessionName": "洗錢防制法解析與案例說明 (2016-test)",
                    "sessionTime": "2016/09/02~2016/09/09",
                    "status": 3
                }, {
                    "courseId": 70025,
                    "courseType": 2,
                    "courseTypeName": "教室課程",
                    "enrollmentId": 2118774,
                    "sessionId": 96118,
                    "sessionName": "20161128樂活人生健康講座",
                    "sessionTime": "2016/11/28 <br>18:00-19:00 ",
                    "status": 2
                }, {
                    "courseId": 70253,
                    "courseType": 4,
                    "courseTypeName": "線上測驗",
                    "enrollmentId": 2136532,
                    "sessionId": 96745,
                    "sessionName": "105下-一般版-法令遵循自評檢核考試班",
                    "sessionTime": "2016/12/01~2016/12/16",
                    "status": 2
                }, {
                    "courseId": 137,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 71853,
                    "sessionId": 1223,
                    "sessionName": "分行新人e課程-專業理專(105-Q2)",
                    "sessionTime": "2016/04/01~2016/06/30",
                    "status": 3
                }, {
                    "courseId": 282,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 69170,
                    "sessionId": 1166,
                    "sessionName": "新人e起來(105-01~105-04)",
                    "sessionTime": "2016/01/01~2016/04/30",
                    "status": 3
                }, {
                    "courseId": 291,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 77491,
                    "sessionId": 1275,
                    "sessionName": "新人e起來(105-Q3)",
                    "sessionTime": "2016/07/01~2016/09/30",
                    "status": 3
                }, {
                    "courseId": 305,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81076,
                    "sessionId": 1356,
                    "sessionName": "新人e起來(105-Q4)",
                    "sessionTime": "2016/10/01~2016/12/30",
                    "status": 3
                }, {
                    "courseId": 312,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81331,
                    "sessionId": 1406,
                    "sessionName": "財產保險業務員在職訓練(MP4測試)",
                    "sessionTime": "2016/12/20~2017/01/26",
                    "status": 0
                }, {
                    "courseId": 314,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81327,
                    "sessionId": 1405,
                    "sessionName": "人身保險業務員在職訓練(MP4測試)",
                    "sessionTime": "2016/12/20~2017/01/26",
                    "status": 0
                }, {
                    "courseId": 315,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81323,
                    "sessionId": 1404,
                    "sessionName": "財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練財產保險業務員在職訓練第一年(MP4測試)",
                    "sessionTime": "2016/12/20~2017/01/26",
                    "status": 0
                }, {
                    "courseId": 316,
                    "courseType": 7,
                    "courseTypeName": "學程",
                    "enrollmentId": 81319,
                    "sessionId": 1403,
                    "sessionName": "人身保險業務員在職訓練第一年(MP4測試)",
                    "sessionTime": "2016/12/20~2017/01/26",
                    "status": 0
                }],
                "ErrorMessage": ""
            };
            resultCN = {
                "Status": "200",
                "Data": [{
                    "courseId": 4,
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollmentId": 161360,
                    "sessionId": 2056,
                    "sessionName": "Acrobat_PDF全應用(100上半年)(簡中)",
                    "sessionTime": "2011/01/01~2011/06/30",
                    "status": 3
                }, {
                    "courseId": 12,
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollmentId": 1012635,
                    "sessionId": 46737,
                    "sessionName": "Time is Money：時間管理(103上半年)(簡中)",
                    "sessionTime": "2014/01/01~2014/06/30",
                    "status": 3
                }, {
                    "courseId": 12,
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollmentId": 1854663,
                    "sessionId": 82308,
                    "sessionName": "Time is Money：時間管理(105上半年)(簡中)",
                    "sessionTime": "2016/01/04~2016/06/30",
                    "status": 2
                }, {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗(簡中)",
                    "enrollmentId": 1765530,
                    "sessionId": 82149,
                    "sessionName": "投資型保險證照-年金考試班(105-01)(簡中)",
                    "sessionTime": "2016/01/04~2016/01/31",
                    "status": 3
                }, {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗(簡中)",
                    "enrollmentId": 1852664,
                    "sessionId": 85907,
                    "sessionName": "投資型保險證照-年金考試班(105-04)(簡中)",
                    "sessionTime": "2016/04/01~2016/04/30",
                    "status": 3
                }, {
                    "courseId": 34,
                    "courseType": 4,
                    "courseTypeName": "線上測驗(簡中)",
                    "enrollmentId": 1955630,
                    "sessionId": 89956,
                    "sessionName": "投資型保險證照-年金考試班(105下半年)(簡中)",
                    "sessionTime": "2016/07/01~2016/12/31",
                    "status": 2
                }],
                "ErrorMessage": ""
            };
            resultUS = {
                "Status": "200",
                "Data": [{
                    "courseId": 59,
                    "courseType": 4,
                    "courseTypeName": "線上測驗(英文)",
                    "enrollmentId": 7736,
                    "sessionId": 25,
                    "sessionName": "簡易外匯機制考試班(9910-9912)(英文)",
                    "sessionTime": "2010/10/01~2010/12/31",
                    "status": 3
                }, {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollmentId": 14330,
                    "sessionId": 17,
                    "sessionName": "開戶對保作業實務介紹(9910-9912)(英文)",
                    "sessionTime": "2010/10/01~2010/12/31",
                    "status": 2
                }, {
                    "courseId": 60,
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollmentId": 1765452,
                    "sessionId": 82173,
                    "sessionName": "開戶對保作業實務介紹(105-Q1)(英文)",
                    "sessionTime": "2016/01/04~2016/03/31",
                    "status": 3
                }, {
                    "courseId": 61,
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollmentId": 244471,
                    "sessionId": 7229,
                    "sessionName": "自行查核相關規範及注意事項(100-Q3)(英文)",
                    "sessionTime": "2011/07/01~2011/09/30",
                    "status": 2
                }, {
                    "courseId": 83,
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollmentId": 1580993,
                    "sessionId": 74983,
                    "sessionName": "認識國標舞(104下半年)(英文)",
                    "sessionTime": "2015/08/04~2015/12/31",
                    "status": 3
                }],
                "ErrorMessage": ""
            };
            switch (params.LanguageCode) {
                case 'en-US':
                    result = resultUS;
                    break;
                case 'zn-CN':
                    result = resultCN;
                    break;
                default:
                    result = resultTW;
                    break;
            }
            return { data: result };
        }
        /**
         * 14.取得修課動作&內容
         * @returns
         */
        function EnrollmentAvailableAction(courseItem) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultType1; /** 一般 */
            var resultType2; /** 測驗 */
            var resultType3; /** 問卷 */
            resultType1 = {
                Status: '200',
                Data: {
                    "lmsItems": [{
                        "action": "Play",
                        "completedTime": "2016/10/27 11:53",
                        "itemId": 3,
                        "itemName": "共同基金銷售關鍵資訊【63分鐘】(影片)",
                        "score": "",
                        "status": "未完成",
                        "type": "課程內容",
                        "viewedTime": "00:00:01"
                    }, {
                        "action": "Test",
                        "completedTime": "2016/10/18 10:43",
                        "itemId": 4,
                        "itemName": "共同基金銷售關鍵資訊【測驗】",
                        "score": "",
                        "status": "完成",
                        "type": "測驗",
                        "viewedTime": "00:00:31"
                    }, {
                        "action": "???",
                        "completedTime": "",
                        "itemId": 1,
                        "itemName": "這是ZIP教材下載",
                        "score": "不公佈",
                        "status": "",
                        "type": "課程內容",
                        "viewedTime": ""
                    }, {
                        "action": "???",
                        "completedTime": "",
                        "itemId": 2,
                        "itemName": "這是PDF教材",
                        "score": "不公佈",
                        "status": "",
                        "type": "課程內容",
                        "viewedTime": ""
                    }, {
                        "action": "???",
                        "completedTime": "2016/10/17 21:35",
                        "itemId": 4,
                        "itemName": "信託業務人員職前教育訓練課程【課後問卷】",
                        "score": "",
                        "status": "未曾觀看",
                        "type": "問卷",
                        "viewedTime": "00:00:00"
                    }],
                    "attendanceRate": 0,
                    "attendances": [],
                    "availableActions": [],
                    "courseSessions": [],
                    "preSurveyItemId": 0,
                    "progress": "1/5",
                    "reportDeadline": "",
                    "reportSubmitted": 0,
                    "reportTotal": 0,
                    "reports": [],
                    "status": -1
                },
                'ErrorMessage': ''
            };
            resultType2 = {
                "Status": "200",
                "Data": {
                    "attendanceRate": 0,
                    "attendances": [],
                    "availableActions": ["Cancel", "Leave", "Exemption"],
                    "courseSessions": [],
                    "lmsItems": [{
                        "action": "Test",
                        "completedTime": "2016/12/16 17:17",
                        "itemId": 336655,
                        "itemName": "G-法規-1089金控一般版-法令遵循自評檢核考試班(105上)",
                        "score": "28.0",
                        "status": "未通過",
                        "type": "測驗",
                        "viewedTime": "00:31:06"
                    }],
                    "preSurveyItemId": 5,
                    "progress": "",
                    "reportDeadline": "",
                    "reportSubmitted": 0,
                    "reportTotal": 0,
                    "reports": [],
                    "status": -1
                },
                "ErrorMessage": ""
            };
            resultType3 = {
                Status: '200',
                Data: {
                    "attendanceRate": 0,
                    "attendances": [],
                    "availableActions": [],
                    "courseSessions": [],
                    "lmsItems": [{
                        "action": "",
                        "completedTime": "2016/09/09 09:18",
                        "itemId": 268699,
                        "itemName": "台新大學暨人資網站改版問卷調查",
                        "score": "",
                        "status": "完成",
                        "type": "問卷",
                        "viewedTime": "00:01:46"
                    }],
                    "preSurveyItemId": 0,
                    "reportDeadline": "",
                    "reportSubmitted": 0,
                    "progress": "0/1",
                    "status": "未完成",
                    "reportTotal": 0,
                    "reports": []
                },
                'ErrorMessage': ''
            };

            switch (courseItem.courseType) {
                case enumCourseType.classTest:
                    result = resultType2;
                    break;
                case enumCourseType.webTest:
                    result = resultType2;
                    break;
                case enumCourseType.questList:
                    result = resultType3;
                    break;
                default:
                    result = resultType1;
                    break;
            }
            return { data: result };
        }
        /**
         * 15.課程動作(P.18)
         * @returns
         */
        function EnrollmentAction(param) {

            return new Promise(function (resolve, reject) {

                var result = {
                    Status: 0,
                    Data: {},
                    ErrorMessage: ""
                };

                var resultFail = {
                    Status: '200',
                    Data: {
                        failCode: -2,
                        failMessage: '',
                        success: 0
                    },
                    ErrorMessage: ''
                };
                var resultSucess = {
                    Status: '200',
                    Data: {
                        failCode: -1,
                        failMessage: '',
                        success: 1
                    },
                    ErrorMessage: ''
                };
                switch (param.IsProgram) {
                    case 1:
                        result = resultFail;
                        break;
                    default:
                        result = resultSucess;
                        break;
                }

                setTimeout(function () {
                    resolve({ data: result });
                }, 2000);
            });
        }

        /**
         * 16.金融證照紀錄申請(P.18)
         * @returns
         */
        function FCCertificatedLicenseAdd() {
            var result = {
                Status: '200',
                Data: null,
                ErrorMessage: ''
            };
            return { data: result };
        }
        /**
         * 17.金融證照查詢
         * @returns
         */
        function FCCertificatedLicenseList() {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            result = {
                "Status": "200",
                "Data": [{
                    "acquireDate": "2016/01/04",
                    "applyDate": "2016/01/05",
                    "id": 5,
                    "name": "信託督導人員審定合格(登錄信託公會)",
                    "status": "申請取消",
                    "validDate": "2019/01/03",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "2016/01/05 14:01",
                    "workflowItem": "學員",
                    "workflowName": "李佳憓 (990028)",
                    "workflowReason": "",
                    "workflowResult": "取消"
                }, {
                    "acquireDate": "2016/12/13",
                    "applyDate": "2016/12/15",
                    "id": 6,
                    "name": "信託管理人員審定合格(登錄信託公會)",
                    "status": "已成功完成",
                    "validDate": "2019/12/13",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "2016/12/15 17:36",
                    "workflowItem": "人資經辦",
                    "workflowName": "李佳憓 (990028)",
                    "workflowReason": "由人資處登錄",
                    "workflowResult": "核准"
                }, {
                    "acquireDate": "2016/12/13",
                    "applyDate": "2016/12/15",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "status": "已成功完成",
                    "validDate": "2019/12/13",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "2016/12/15 17:36",
                    "workflowItem": "人資經辦",
                    "workflowName": "李佳憓 (990028)",
                    "workflowReason": "由人資處登錄",
                    "workflowResult": "核准"
                }, {
                    "acquireDate": "2010/11/10",
                    "applyDate": "2010/11/10",
                    "id": 13,
                    "name": "開戶對保作業資格",
                    "status": "已成功完成",
                    "validDate": "永遠有效",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "",
                    "workflowItem": "",
                    "workflowName": "",
                    "workflowReason": "",
                    "workflowResult": ""
                }, {
                    "acquireDate": "2016/11/02",
                    "applyDate": "2016/12/15",
                    "id": 46,
                    "name": "人身保險業務員投資型商品資格登錄(登錄壽險公會)",
                    "status": "簽核中",
                    "validDate": "永遠有效",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "",
                    "workflowItem": "人資經辦",
                    "workflowName": "周孟蕎 (1000323),黃昱珩 (1020258),張瑋晏 (1040831)",
                    "workflowReason": "",
                    "workflowResult": ""
                }, {
                    "acquireDate": "2016/06/29",
                    "applyDate": "2016/07/07",
                    "id": 112,
                    "name": "證券商高級業務員(登錄證券交易所)",
                    "status": "簽核中",
                    "validDate": "永遠有效",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "",
                    "workflowItem": "人資經辦",
                    "workflowName": "周孟蕎 (1000323),黃昱珩 (1020258),張瑋晏 (1040831)",
                    "workflowReason": "",
                    "workflowResult": ""
                }, {
                    "acquireDate": "2016/04/19",
                    "applyDate": "2016/04/27",
                    "id": 131,
                    "name": "內部講師訓完訓資格",
                    "status": "已成功完成",
                    "validDate": "永遠有效",
                    "validStatus": "有效",
                    "validStatusKey": 1,
                    "workflowDateTime": "2016/04/27 16:06",
                    "workflowItem": "人資經辦",
                    "workflowName": "張瑋晏 (1040831)",
                    "workflowReason": "由人資處登錄",
                    "workflowResult": "核准"
                }, {
                    "acquireDate": "2013/01/27",
                    "applyDate": "2013/02/19",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "status": "已成功完成",
                    "validDate": "2016/01/27",
                    "validStatus": "註銷",
                    "validStatusKey": 2,
                    "workflowDateTime": "2013/02/19 12:00",
                    "workflowItem": "部門管理員代為申請",
                    "workflowName": "李佳憓 (990028)",
                    "workflowReason": "",
                    "workflowResult": "直接核准"
                }, {
                    "acquireDate": "2013/09/03",
                    "applyDate": "2013/02/19",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "status": "已拒絕",
                    "validDate": "2016/09/02",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2013/10/01 16:56",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "TEST(無受訓紀錄)",
                    "workflowResult": "拒絕"
                }, {
                    "acquireDate": "2016/03/01",
                    "applyDate": "2016/03/09",
                    "id": 7,
                    "name": "信託業務人員審定合格(登錄信託公會)",
                    "status": "已拒絕",
                    "validDate": "2019/03/01",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2016/03/15 16:18",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "(無測驗合格紀錄)",
                    "workflowResult": "拒絕"
                }, {
                    "acquireDate": "2016/06/29",
                    "applyDate": "2016/07/07",
                    "id": 5,
                    "name": "信託督導人員審定合格(登錄信託公會)",
                    "status": "已拒絕",
                    "validDate": "2019/06/29",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2016/07/07 17:57",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "(不屬於目前職務所需證照)",
                    "workflowResult": "拒絕"
                }, {
                    "acquireDate": "2013/12/01",
                    "applyDate": "2013/12/30",
                    "id": 44,
                    "name": "財產保險業務員登錄(登錄產險公會)",
                    "status": "已拒絕",
                    "validDate": "永遠有效",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2013/12/30 15:43",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "請書面送保經申請(http://localhost)，通過後由保險系統直接轉入，請勿線上申請。(請書面送保經申請(http://localhost)，通過後由保險系統直接轉入，請勿線上申請。)",
                    "workflowResult": "拒絕"
                }, {
                    "acquireDate": "2016/06/28",
                    "applyDate": "2016/07/07",
                    "id": 44,
                    "name": "財產保險業務員登錄(登錄產險公會)",
                    "status": "已拒絕",
                    "validDate": "永遠有效",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2016/07/07 18:01",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "",
                    "workflowResult": "拒絕"
                }, {
                    "acquireDate": "2016/07/07",
                    "applyDate": "2016/07/07",
                    "id": 127,
                    "name": "投信投顧業務員-一般業務員(登錄投信投顧公會)",
                    "status": "已拒絕",
                    "validDate": "永遠有效",
                    "validStatus": "無效",
                    "validStatusKey": 0,
                    "workflowDateTime": "2016/07/07 17:54",
                    "workflowItem": "人資經辦",
                    "workflowName": "黃昱珩 (1020258)",
                    "workflowReason": "",
                    "workflowResult": "拒絕"
                }],
                "ErrorMessage": ""
            };
            return { data: result };
        }

        /**
         * 18.金融證照認列時數(QQ)
         * @returns
         */
        function FCAuthorizedHoursList() {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            result = {
                "Status": "200",
                "Data": [{
                    "licenseId": 6,
                    "licenseName": "信託管理人員審定合格(登錄信託公會)",
                    "trainingCategory": "在職訓練",
                    "trainingEndDate": "2019/12/13",
                    "unfinishHours": "尚缺外訓:0.0,尚缺內訓:0.0",
                    "validStatus": 1
                }, {
                    "licenseId": 7,
                    "licenseName": "信託業務人員審定合格(登錄信託公會)",
                    "trainingCategory": "在職訓練",
                    "trainingEndDate": "2019/12/13",
                    "unfinishHours": "尚缺外訓:6.0,尚缺內訓:12.0",
                    "validStatus": 1
                }, {
                    "licenseId": 13,
                    "licenseName": "開戶對保作業資格",
                    "trainingCategory": "受訓後取得",
                    "trainingEndDate": "",
                    "unfinishHours": "尚缺外訓:0.0,尚缺內訓:0.0",
                    "validStatus": 1
                }, {
                    "licenseId": 131,
                    "licenseName": "內部講師訓完訓資格",
                    "trainingCategory": "受訓後取得",
                    "trainingEndDate": "",
                    "unfinishHours": "尚缺外訓:0.0,尚缺內訓:0.0",
                    "validStatus": 1
                }],
                "ErrorMessage": ""
            };
            return { data: result };
        }
        /**
         * 19.金融證照紀錄申請
         * @returns
         */
        function ExternalTrainingApplication() {
            var result = {
                Status: '200',
                Data: {
                    failCode: -1,
                    failMessage: '',
                    success: 0
                },
                ErrorMessage: ''
            };
            return { data: result };
        }
        /**
         * 20.金融證照可報名課程(QQ)
         * @returns
         */
        function FCEnrollableActivities(params) {
            var result = {
                Status: 0,
                Data: {},
                ErrorMessage: ""
            };
            var resultEmpty;
            var resultTW;
            var resultCN;
            var resultUS;

            resultEmpty = {
                "Status": "200",
                "Data": [],
                "ErrorMessage": ""
            };
            resultTW = {
                "Status": "200",
                "Data": [{
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 13372,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 84290,
                    "sessionName": "信託在職-組合式商品簡介 (105-03)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 13372,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 85914,
                    "sessionName": "信託在職-組合式商品簡介 (105-04)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1871,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 1.5,
                    "hours": 1.5,
                    "sessionId": 82154,
                    "sessionName": "信託在職-信託業務綜覽【I】(105-01)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1871,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 1.5,
                    "hours": 1.5,
                    "sessionId": 83629,
                    "sessionName": "信託在職-信託業務綜覽【I】(105-02)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1871,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 1.5,
                    "hours": 1.5,
                    "sessionId": 84289,
                    "sessionName": "信託在職-信託業務綜覽【I】(105-03)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1871,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 1.5,
                    "hours": 1.5,
                    "sessionId": 85913,
                    "sessionName": "信託在職-信託業務綜覽【I】(105-04)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16788,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 2,
                    "hours": 2,
                    "sessionId": 82162,
                    "sessionName": "信託在職─「TIPS信託投資系統操作說明」+ 「TRMS系統說明」(105-01)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16788,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 2,
                    "hours": 2,
                    "sessionId": 83638,
                    "sessionName": "信託在職─「TIPS信託投資系統操作說明」+ 「TRMS系統說明」(105-02)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16788,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 2,
                    "hours": 2,
                    "sessionId": 84297,
                    "sessionName": "信託在職─「TIPS信託投資系統操作說明」+ 「TRMS系統說明」(105-03)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16788,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 2,
                    "hours": 2,
                    "sessionId": 85921,
                    "sessionName": "信託在職─「TIPS信託投資系統操作說明」+ 「TRMS系統說明」(105-04)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1866,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 0.5,
                    "hours": 0.5,
                    "sessionId": 82153,
                    "sessionName": "信託在職-「有價證券信託」暨「規劃型金錢信託」(105-01)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1866,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 0.5,
                    "hours": 0.5,
                    "sessionId": 83628,
                    "sessionName": "信託在職-「有價證券信託」暨「規劃型金錢信託」(105-02)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1866,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 0.5,
                    "hours": 0.5,
                    "sessionId": 84286,
                    "sessionName": "信託在職-「有價證券信託」暨「規劃型金錢信託」(105-03)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1866,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 0.5,
                    "hours": 0.5,
                    "sessionId": 85911,
                    "sessionName": "信託在職-「有價證券信託」暨「規劃型金錢信託」(105-04)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16816,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 82163,
                    "sessionName": "信託在職─信託業務綜覽【II】(105-01)(繁中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 16816,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(繁中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 83639,
                    "sessionName": "信託在職─信託業務綜覽【II】(105-02)(繁中)"
                }],
                "ErrorMessage": ""
            };
            resultCN = {
                "Status": "200",
                "Data": [{
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 82150,
                    "sessionName": "信託業務人員職前訓練課程(105-01)(簡中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 83621,
                    "sessionName": "信託業務人員職前訓練課程(105-02)(簡中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 84282,
                    "sessionName": "信託業務人員職前訓練課程(105-03)(簡中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": "2016/01/01 ~ 2016/12/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "2016/01/01",
                    "enrollEnd": "2016/12/31",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 85908,
                    "sessionName": "信託業務人員職前訓練課程(105年)(簡中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 34014,
                    "courseTime": " ~ ",
                    "courseType": 1,
                    "courseTypeName": "線上課程(簡中)",
                    "enrollBegin": "",
                    "enrollEnd": "",
                    "fcAuthHours": 8,
                    "hours": 8,
                    "sessionId": 86934,
                    "sessionName": "信託業務人員職前訓練課程(105年)(複製)(簡中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 963,
                    "courseTime": "2016/02/20 ~ 2016/02/20",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/01",
                    "fcAuthHours": 4,
                    "hours": 4,
                    "sessionId": 83791,
                    "sessionName": "2016-0220信託業務人員職前訓練(4小時)-台北場(簡中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 963,
                    "courseTime": "2016/03/12 ~ 2016/03/12",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/01",
                    "fcAuthHours": 4,
                    "hours": 4,
                    "sessionId": 83792,
                    "sessionName": "2016-0312信託業務人員職前訓練(4小時)-高雄場(簡中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 963,
                    "courseTime": "2016/03/26 ~ 2016/03/26",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/01",
                    "fcAuthHours": 4,
                    "hours": 4,
                    "sessionId": 85389,
                    "sessionName": "2016-0326信託業務人員職前訓練(4小時)-台北場(簡中)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 963,
                    "courseTime": "2016/04/09 ~ 2016/04/09",
                    "courseType": 3,
                    "courseTypeName": "外訓課程(簡中)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/01",
                    "fcAuthHours": 4,
                    "hours": 4,
                    "sessionId": 85570,
                    "sessionName": "2016-0409信託業務人員職前訓練(4小時)-台中場(簡中)"
                }],
                "ErrorMessage": ""
            };
            resultUS = {
                "Status": "200",
                "Data": [{
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1861,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 3,
                    "hours": 3,
                    "sessionId": 82152,
                    "sessionName": "信託在職-結構型商品理論與實務(105-01)(英文)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1861,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 3,
                    "hours": 3,
                    "sessionId": 83627,
                    "sessionName": "信託在職-結構型商品理論與實務(105-02)(英文)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1861,
                    "courseTime": "2016/03/01 ~ 2016/03/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/03/01",
                    "enrollEnd": "2016/03/31",
                    "fcAuthHours": 3,
                    "hours": 3,
                    "sessionId": 84284,
                    "sessionName": "信託在職-結構型商品理論與實務(105-03)(英文)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 1861,
                    "courseTime": "2016/04/01 ~ 2016/04/30",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/04/01",
                    "enrollEnd": "2016/04/30",
                    "fcAuthHours": 3,
                    "hours": 3,
                    "sessionId": 85910,
                    "sessionName": "信託在職-結構型商品理論與實務(105-04)(英文)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 13372,
                    "courseTime": "2016/01/04 ~ 2016/01/31",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/01/04",
                    "enrollEnd": "2016/01/31",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 82155,
                    "sessionName": "信託在職-組合式商品簡介 (105-01)(英文)"
                }, {
                    "classificationId": 0,
                    "classificationName": "",
                    "courseId": 13372,
                    "courseTime": "2016/02/01 ~ 2016/02/29",
                    "courseType": 1,
                    "courseTypeName": "線上課程(英文)",
                    "enrollBegin": "2016/02/01",
                    "enrollEnd": "2016/02/29",
                    "fcAuthHours": 1,
                    "hours": 1,
                    "sessionId": 83630,
                    "sessionName": "信託在職-組合式商品簡介 (105-02)(英文)"
                }],
                "ErrorMessage": ""
            };
            switch (params.LanguageCode) {
                case "en-US":
                    result = resultUS;
                    break;
                case "zh-CN":
                    result = resultCN;
                    break;
                default:
                    result = resultTW;
                    break;
            }
            //result = resultEmpty; //QQ
            return { data: result };
        }
        /**
         * 21.金融證照紀錄申請
         * @returns
         */
        function LearningRecordCommit() {
            var result = {
                Status: '200',
                Data: null,
                ErrorMessage: ''
            };
            return { data: result };
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('bulletinDetailController', bulletinDetailController);

    function bulletinDetailController(viewModel) {
        var vm = this;
        vm.data = viewModel.data;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('bulletinMoreController', bulletinMoreController);

    function bulletinMoreController(viewModel) {
        var vm = this;

        onInit();

        function onInit() {
            vm.data = viewModel.data;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('commonController', commonController);

    function commonController($sce) {
        var vm = this;
        onInit();

        function onInit() {
            menuService.getInformationBySerilNo(getMenuQueryString()).then(function (data) {
                menuService.generateUrl(data.data, sessionStorage.getItem('token'));
                vm.url = $sce.trustAsResourceUrl(data.data.url);
            });
            vm.url = $sce.trustAsResourceUrl(sessionStorage.getItem('iframeUrl'));
        }
    }
})();
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
    'use strict';

    angular.module('app').controller('headerSearchResultController', headerSearchResultController);

    function headerSearchResultController(modalService, headerService, $rootScope, viewModel, menuService, enumService, siteCode, $window) {
        var vm = this;
        vm.isMobile = modalService.isMobile();
        vm.data = viewModel.data;
        vm.redirectMenuSearchResult = redirectMenuSearchResult;
        vm.redirectContentSearchResult = redirectContentSearchResult;
        vm.pageChange = pageChange;
        vm.tabChange = tabChange;
        vm.search = search;
        vm.checkLastMenu = checkLastMenu;
        vm.getMoreList = getMoreList;
        vm.needKeywordLog = false;

        vm.view = {
            initTotal: 0
        };

        init();

        function init() {
            vm.searchedKeyword = vm.data.keyword;
            vm.keyword = vm.data.keyword;
            vm.siteCode = siteCode;
        }

        function redirectMenuSearchResult(item) {
            //console.log("item.menuSerilNo:"+item.menuSerilNo);
            if (!_.isEmpty(sessionStorage.getItem('menuAllList'))) {

                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');

                //如果Menu=37(上課與證照)，就設定Menu=-9901(待修課程)
                if (parseInt(item.menuSerilNo) === 37) {
                    sessionStorage.setItem('menuSerilNo', -9901);
                } else {
                    sessionStorage.setItem('menuSerilNo', item.menuSerilNo);
                }

                //點選任一動態磚即撈取是選單功能Menu資料
                var menuAllList = JSON.parse(sessionStorage.getItem('menuAllList'));
                var menuItems = menuAllList.filter(function (menuLists) {
                    return parseInt(menuLists.menuSerilNo) === parseInt(sessionStorage.getItem('menuSerilNo')) && menuLists.hasChild === false;
                });
                //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                if (menuItems !== null && menuItems.length !== 0) {
                    sessionStorage.setItem('menuSerilNo', menuItems[0].menuSerilNo);
                    sessionStorage.setItem('menuItemPath', menuItems[0].menuItemPath);
                } else {
                    //如是選單節點即撈取第二或第三階層是否為父階層 
                    menuItems = menuAllList.filter(function (menuLists) {
                        return parseInt(menuLists.parentId) === parseInt(sessionStorage.getItem('menuSerilNo'));
                    });

                    //撈取選單節點下排序第一個功能Menu
                    if (menuItems != null && menuItems.length !== 0) {
                        var sort = Math.min.apply(Math, _toConsumableArray(menuItems.map(function (p) {
                            return p.sort;
                        })));
                        var menuItem = menuItems.filter(function (menuLists) {
                            return parseInt(menuLists.sort) === parseInt(sort);
                        });

                        //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                        //console.log(menuItem);
                        if (menuItem !== null && menuItem.length !== 0) {
                            if (!menuItem[0].hasChild) {
                                sessionStorage.setItem('menuSerilNo', menuItem[0].menuSerilNo);
                            }
                            sessionStorage.setItem('menuItemPath', menuItem[0].menuItemPath);
                        }
                    }
                }

                console.log('headerSearchResult_redirectMenuSearchResult-menuSerilNo:' + sessionStorage.getItem('menuSerilNo'));
                console.log('headerSearchResult_redirectMenuSearchResult-menuItemPath:' + sessionStorage.getItem('menuItemPath'));
            }

            // 目前外網只有一種轉頁方式: 本頁直接跳轉
            menuService.redirectUrl(item);

            // if (item.target === enumService.target.wrap) {
            //     window.open('//' + location.host + '/#/external?menu=' + item.menuSerilNo, 'searchResult');
            // } else {
            //     item.isWindowOpen = true;
            //     menuService.redirectUrl(item);
            // }
        }

        function redirectContentSearchResult(item) {

            // 目前外網只有一種轉頁方式: 本頁直接跳轉
            $window.location.href = '//' + location.host + '/#/bulletin/detail/' + item.serilNo, 'searchResult';

            //window.open('//' + location.host + '/#/bulletin/detail/' + item.serilNo, 'searchResult');
        }

        function pageChange() {
            var newPage = vm.data.currentPage;
            var keyword = vm.searchedKeyword;
            var newType = vm.data.currentSearchResultType;
            vm.keyword = keyword;
            headerService.getSearchResult(keyword, newPage, newType, vm.siteCode, vm.needKeywordLog).then(function (data) {
                vm.data = data.data;
            });
        }

        function getMoreList() {
            var newPage = vm.data.currentPage + 1;
            var keyword = vm.searchedKeyword;
            var newType = vm.data.currentSearchResultType;
            vm.keyword = keyword;
            headerService.getSearchResult(keyword, newPage, newType, vm.siteCode, vm.needKeywordLog).then(function (data) {

                // 加載資料至原本的資料清單上

                var result = data.data;
                result.menuMetroResults = _.concat(vm.data.menuMetroResults, result.menuMetroResults);
                result.contentResults = _.concat(vm.data.contentResults, result.contentResults);
                result.bulletinContentResults = _.concat(vm.data.bulletinContentResults, result.bulletinContentResults);
                result.formContentResults = _.concat(vm.data.formContentResults, result.formContentResults);
                vm.data = result;
            });
        }

        function tabChange(currentSearchResultType) {
            vm.view.initTotal++;
            if (vm.view.initTotal > 1) {
                var keyword = vm.searchedKeyword;
                vm.data.currentPage = 1;
                vm.keyword = keyword;
                headerService.getSearchResult(keyword, vm.data.currentPage, currentSearchResultType, vm.siteCode, vm.needKeywordLog).then(function (data) {
                    vm.data = data.data;
                });
            }
        }
        function specialKeywordVerification(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }
        function search() {

            var keyword = vm.keyword;
            if (keyword) {

                var SKV = specialKeywordVerification(keyword);

                if (!SKV) {
                    vm.data.currentPage = 1;
                    vm.searchedKeyword = keyword;
                    vm.needKeywordLog = true;
                    //$location.path('/header/searchResult/' + keyword);
                    headerService.getSearchResult(keyword, vm.data.currentPage, vm.data.currentSearchResultType, vm.siteCode, vm.needKeywordLog).then(function (data) {
                        vm.data = data.data;
                    });
                } else {
                    console.log('specialKeywords:' + $rootScope.translate.specialKeywords);
                    toastr.warning($rootScope.translate.specialKeywords);
                }
            }
        }

        function checkLastMenu(index, menu) {
            var menuSize = Object.keys(menu).length - 1;
            return Number(index) === menuSize;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('externalController', externalController);

    function externalController($sce, menuService) {
        var vm = this;

        init();

        function init() {

            // 紀錄這次進入的 menu No 到 session storage 中
            // 如果需要登入就會被導到登入頁
            // 登入後就會依照這個參數導到該頁面中
            //sessionStorage.setItem('menuNo', getMenuQueryString());

            var langSerilNo = 1;
            if (sessionStorage.getItem('langCode')) {
                langSerilNo = sessionStorage.getItem('langCode');
            }

            menuService.getInformationBySerilNo(getMenuQueryString(), langSerilNo).then(function (data) {

                var isEmbed = data.data.target === 2 /*崁入式窗*/;
                if (isEmbed) {
                    menuService.generateUrl(data.data, sessionStorage.getItem('token'));

                    vm.url = $sce.trustAsResourceUrl(data.data.url);
                } else {
                    // includ token transfer flow
                    menuService.redirectUrl(data.data);
                }
            });
        }

        // function getCurrentLangSerilNo(){
        //       if (sessionStorage.getItem('langCode')) {
        //         langSerilNo = sessionStorage.getItem('langCode');
        //     }
        // }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('externalSchemaTransferController', externalSchemaTransferController);

    function externalSchemaTransferController() {

        init();

        function init() {
            // 提供 APP 開啟其他 APP 的跳轉頁面
            var schema = getSchemaQueryString();
            window.location = schema + '://';
        }

        function getSchemaQueryString() {

            if (location.href.split('schema=').length > 1) {
                //2023-07-10 Johnson 資安2023
                return eval(function (p, a, c, k, e, r) {
                    e = function e(c) {
                        return c.toString(a);
                    };if (!''.replace(/^/, String)) {
                        while (c--) {
                            r[e(c)] = k[c] || e(c);
                        }k = [function (e) {
                            return r[e];
                        }];e = function e() {
                            return '\\w+';
                        };c = 1;
                    };while (c--) {
                        if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                    }return p;
                }('3.4.5(\'6=\')[1].0(/</2,\'&7\').0(/>/2,\'&8\').0(/"/2,\'&9\').0(/\'/2,\'&#a\').0(/[<>!]|(\\(\\))|((b|c|d)\\e*\\(.*\\))/2,\'\')', 15, 15, 'replace||g|location|href|split|schema|lt|gt|quot|x27|for|while|if|s'.split('|'), 0, {}));
            }
            return undefined;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('homeController', homeController);

    function homeController(viewModel) {
        var vm = this;

        init();

        function init() {
            vm.data = viewModel.data;
            var menuSerilNo = getMenuQueryString();
            if (parseInt(menuSerilNo) === 31 || menuSerilNo === undefined) {
                $(".ui-blackCover").css("display", "none");
                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('mobileTriggerController', mobileTriggerController);

    function mobileTriggerController($location, modalService) {
        init();

        function init() {
            modalService.login();
            $location.path('/login');
        }
    }
})();
'use strict';

(function () {
  'use strict';

  angular.module('app').controller('nextMenuDetailController', nextMenuDetailController);

  function nextMenuDetailController(viewModel) {
    var vm = this;
    vm.data = viewModel.data;
  }
})();
'use strict';

(function () {
	'use strict';

	angular.module('app').controller('nextMenuController', nextMenuController);

	function nextMenuController(viewModel, homeService) {
		var vm = this;
		vm.getMoreList = getMoreList;
		var currentPage = 1;
		init();

		function init() {
			vm.menuSerilNo = getMenuQueryString();
			vm.data = viewModel.data;
			vm.currentPage = 1;
		}

		function getMoreList() {
			currentPage++;
			homeService.getNextMore(currentPage).then(function (data) {
				vm.data.hasMore = data.data.hasMore;
				vm.data.bulletins.bulletins = _.concat(vm.data.bulletins.bulletins, data.data.bulletins.bulletins);
			});
		}
	}
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('scheduleController', scheduleController);

    function scheduleController($scope, scheduleService, $timeout, $rootScope, viewModel) {
        var vm = this;
        vm.changeDate = changeDate;
        vm.outputFile = outputFile;
        vm.changeArea = changeArea;
        vm.getStartForList = getStartForList;
        vm.getEndForList = getEndForList;
        vm.getAllDay = getAllDay;
        vm.showButton = showButton;
        vm.trigger = 1;

        vm.view = {
            isLogin: sessionStorage.getItem('token')
        };

        init();

        function init() {
            vm.calendarAreas = viewModel.data;
            vm.schedule = moment().add(8, 'hour');
            getSchedule();
        }

        function changeDate() {
            $timeout(function () {
                getSchedule();
            }, 10);
        }

        function getSchedule() {
            vm.clickDay = vm.schedule.format('YYYY/MM/DD');
            var calendarSerilNo = vm.calendarArea ? vm.calendarArea.calendarAreaSerilNo : 0;
            vm.promise = scheduleService.get(vm.schedule, calendarSerilNo).then(function (data) {
                vm.dateItem = data.data.scheduleTodays;
                vm.trigger++;
                return data;
            });
        }

        function outputFile(item) {
            if (DEVICE_TYPE !== null && DEVICE_TYPE.toLowerCase() === 'android') {
                var param = {
                    title: item.title,
                    description: item.txtContent,
                    isAllDay: item.isAllDay,
                    begin: (Date.parse(item.startDate) - 8 * 60 * 60 * 1000) / 1000,
                    end: (Date.parse(item.endDate) - 8 * 60 * 60 * 1000) / 1000,
                    reminder: 0,
                    isEveryDay: item.isEveryDay
                };
                var method = "appendEvent";
                appCallback(method, param);
            } else {
                // 瀏覽器或其他
                var isIos = true;
                if (DEVICE_TYPE !== null && DEVICE_TYPE.toLowerCase() === 'ios') {
                    isIos = true;
                }
                location.href = scheduleService.donwloadIcs(item, isIos);
                toastr.success($rootScope.translate.tshrExportScheduleMessage);
            }
        }

        function changeArea() {
            getSchedule();
        }

        function getStartForList(item) {
            if (item.isAllDay) {
                return moment(item.startDate).format('YYYY/MM/DD');
            }
            return moment(item.startDate).format('YYYY/MM/DD HH:mm');
        }

        function getEndForList(item) {
            if (item.isEveryDay) {
                return $rootScope.translate.any;
            }

            if (item.isAllDay) {
                return moment(item.endDate).subtract(1, 'd').format('YYYY/MM/DD');
            }
            return moment(item.endDate).format('YYYY/MM/DD HH:mm');
        }

        function getAllDay(item) {
            if (item.isAllDay) {
                return $rootScope.translate.allDay;
            }
        }

        function showButton(item) {
            var show = true;
            var now = moment();
            var eventDte = moment(item.endDate); //以事件結束日期比較，事件已結束的就不顯示提醒我

            if (now > eventDte) {
                show = false;
            }
            //console.log('show:',show);
            return show;
        }
    }
})();
"use strict";

(function () {
  "use strict";

  angular.module("app").controller("loginDirectEditPwdController", loginDirectEditPwdController);

  function loginDirectEditPwdController(sysCode, loginService, $location, e2eService, $rootScope, $routeParams, commonService, iAmNotRobot, $http, apiUrl, $scope) {
    var vm = this;
    vm.submit = submit;
    vm.autoFill = autoFill;
    vm.sendVerifyCodeFromSignUp = sendVerifyCodeFromSignUp;
    vm.checkVerify = checkVerify;
    vm.iAmNotRobot = iAmNotRobot;
    vm.isShowConfirmUpdate = false;

    vm.view = {
      type: "editPwd"
    };

    // virtual keyboard start
    vm.showVirKey = showVirKey;
    vm.isShowVirKey = false;
    vm.textChanged = textChanged;
    vm.focusObj = null;
    vm.virData = null;
    vm.canSend = false;
    // 針對哪個 input 使用動態鍵盤輸入
    vm.getFocusNewPwd = function () {
      vm.focusObj = "newPwd";
      vm.virData = vm.data.newPwd;
    };
    vm.getFocusConfirmPwd = function () {
      vm.focusObj = "confirmPwd";
      vm.virData = vm.data.confirmPwd;
    };
    vm.checkPassword = function () {
      if (vm.data.confirmPwd !== undefined && vm.data.newPwd !== undefined && vm.data.confirmPwd.length >= 6 && vm.data.newPwd.length >= 6) {
        if (vm.data.confirmPwd === vm.data.newPwd) {
          vm.canSend = true;
        } else {
          vm.canSend = false;
        }
      } else {
        vm.canSend = false;
      }
    };

    function textChanged(newPwd) {
      var e = document.getElementById(vm.focusObj);
      e.value = newPwd;
      var $e = angular.element(e);
      $e.triggerHandler("input");
    }

    function showVirKey() {
      if (vm.isShowVirKey) vm.isShowVirKey = false;else vm.isShowVirKey = true;
    }

    onInit();

    function onInit() {
      // debugger;
      commonService.fetchDecyrptForDirectModifyDto({
        phoneNumber: $routeParams.mobilTel,
        userAccount: $routeParams.userAccount,
        verifyCode: $routeParams.verifyCode
      }).then(function (data) {
        vm.data = {
          userAccount: data.data.userAccount,
          verifyCode: data.data.verifyCode,
          sysCode: sysCode
        };

        vm.form2 = {
          mobilTel: data.data.phoneNumber,
          email: data.data.userAccount
        };

        vm.form1 = {
          sysCode: sysCode,
          userAccount: data.data.userAccount,
          tel: data.data.phoneNumber,
          validCode: data.data.validCode,
          issend: false
        };
      });
    }

    function submit() {
      vm.confirmPwd = vm.data.newPwd !== vm.data.confirmPwd;
      if (!vm.confirmPwd) {
        loginService.directModifyUserPassword(vm.data).then(function (data) {
          if (data) {
            toastr.success($rootScope.translate.commonEditPwdSuccess);
            if ($routeParams.mobilTel) {
              vm.view.type = "phone";
              $("#divPhone").show();
            } else {
              $location.path("/login");
            }
          }
        });
      }
    }

    function autoFill() {
      e2eService.directEditPwd(vm.data);
    }

    function sendVerifyCodeFromSignUp() {
      //20180314 Anthony
      //1. Verify reCaptcha with MHRAPI and Google API
      //2-1. Succcess : Go Back to Login step
      //2-2. Fail : throw Error Messege

      //test error situation
      //recaptcha.response = recaptcha.response+'ee';
      if ($("#inputVerify").val().length == 4) {
        vm.form1.issend = true;
        loginService.produceVerifyCodeFromSignUp(vm.form1).then(function () {
          toastr.success($rootScope.translate.commonAlreadySendSMS);
        });
      } else {
        toastr.warning($rootScope.translate.commonReCaptchaFail);
        return false;
      }
    }

    function checkVerify() {
      var param = {
        verifyCode: vm.form1.validCode,
        userAccount: vm.form1.userAccount,
        PhoneNumber: vm.form1.tel
      };
      loginService.verifyCodeCheckFromSignUp(param).then(function () {
        removeSsoInfo();
        toastr.success($rootScope.translate.alreadyVerifyPhoneNumber);
        $location.path("/login");
      });
    }
  }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('loginForceEditPwdController', loginForceEditPwdController);

    function loginForceEditPwdController(sysCode, loginService, $location, e2eService, $rootScope) {
        var vm = this;
        vm.submit = submit;
        vm.autoFill = autoFill;

        onInit();

        function onInit() {
            vm.data = {};
        }

        function submit() {
            vm.confirmPwd = vm.data.newPwd !== vm.data.confirmPwd;
            if (!vm.confirmPwd) {
                vm.data.sysCode = sysCode;
                vm.data.token = sessionStorage.getItem('token');
                loginService.modifyUserPassword(vm.data).then(function (data) {
                    if (data) {
                        removeSsoInfo();
                        toastr.success($rootScope.translate.commonEditPwdSuccess);
                        $location.path('/login');
                    }
                });
            }
        }

        function autoFill() {
            e2eService.forceEditPwd(vm.data);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('loginForgetPwdDirectEditPwdController', loginForgetPwdDirectEditPwdController);

    function loginForgetPwdDirectEditPwdController(sysCode, loginService, $location, $rootScope, $routeParams, $scope) {

        var vm = this;
        vm.submit = submit;
        vm.isValidLink = false;

        // virtual keyboard start
        vm.showVirKey = showVirKey;
        vm.isShowVirKey = false;
        vm.isShowConfirmPwdVirKey = false;
        vm.textChanged = textChanged;
        vm.focusObj = null;
        vm.virData = null;

        vm.getFocusNewPwd = function () {
            vm.focusObj = "newPwd";
            vm.virData = vm.data.newPwd;
        };
        vm.getFocusConfirmPwd = function () {
            vm.focusObj = "confirmPwd";
            vm.virData = vm.data.confirmPwd;
        };

        function textChanged(newPwd) {
            var e = document.getElementById(vm.focusObj);
            e.value = newPwd;
            var $e = angular.element(e);
            $e.triggerHandler('input');
        }

        function showVirKey() {
            if (vm.isShowVirKey) vm.isShowVirKey = false;else vm.isShowVirKey = true;
        }

        onInit();

        function onInit() {

            var param = {
                userAccount: $routeParams.userAccount /*crypted*/
                , verifyCode: $routeParams.verifyCode /*crypted*/
            };

            // check verify code 
            loginService.checkVerifyCode(param).then(function (data) {

                // console.log(data);
                if (data.data.Result === "100") {

                    vm.data = {
                        userAccount: data.data.userAccount,
                        verifyCode: data.data.verifyCode,
                        sysCode: sysCode
                    };

                    // show input box 
                    vm.isValidLink = true;
                } else {

                    // show error message
                    toastr.error(data.data.ResultMsg);
                }
            });
        }

        function submit() {
            //console.log(vm.data);
            vm.confirmPwd = vm.data.newPwd !== vm.data.confirmPwd;
            if (!vm.confirmPwd) {
                loginService.directModifyUserPassword(vm.data).then(function (data) {
                    if (data) {
                        toastr.success($rootScope.translate.commonEditPwdSuccess);
                        removeSsoInfo();
                        $location.path('/login');
                    }
                });
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('loginController', loginController);

    function loginController(viewModel) {
        var vm = this;

        init();

        function init() {
            vm.data = viewModel.data;

            var menuSerilNo = getMenuQueryString();
            if (parseInt(menuSerilNo) === 31 || menuSerilNo === undefined) {
                $(".ui-blackCover").css("display", "none");
                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');
            }
        }
    }
})();
'use strict';

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

(function () {
    'use strict';

    angular.module('app').controller('showRelatedFunctionsModalController', showRelatedFunctionsModalController);

    function showRelatedFunctionsModalController(modalService, $uibModalInstance, headerService, relatedInfo, menuId, $location, menuService) {
        var vm = this;
        vm.isMobile = modalService.isMobile();
        vm.cancel = cancel;
        vm.redirectMenuSearchResult = redirectMenuSearchResult;
        vm.redirectContentSearchResult = redirectContentSearchResult;

        onInit();

        function onInit() {
            vm.data = {};
            vm.data.relatedInfo = relatedInfo;
            vm.data.menuId = menuId;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function redirectMenuSearchResult(item) {
            //console.log("item.menuSerilNo:"+item.menuSerilNo);
            if (!_.isEmpty(sessionStorage.getItem('menuAllList'))) {

                sessionStorage.setItem('menuSerilNo', '');
                sessionStorage.setItem('menuItemPath', '');

                //如果Menu=37(上課與證照)，就設定Menu=-9901(待修課程)
                if (parseInt(item.menuSerilNo) === 37) {
                    sessionStorage.setItem('menuSerilNo', -9901);
                } else {
                    sessionStorage.setItem('menuSerilNo', item.menuSerilNo);
                }

                //點選任一動態磚即撈取是選單功能Menu資料
                var menuAllList = JSON.parse(sessionStorage.getItem('menuAllList'));
                var menuItems = menuAllList.filter(function (menuLists) {
                    return parseInt(menuLists.menuSerilNo) === parseInt(sessionStorage.getItem('menuSerilNo')) && menuLists.hasChild === false;
                });
                //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                if (menuItems !== null && menuItems.length !== 0) {
                    sessionStorage.setItem('menuSerilNo', menuItems[0].menuSerilNo);
                    sessionStorage.setItem('menuItemPath', menuItems[0].menuItemPath);
                } else {
                    //如是選單節點即撈取第二或第三階層是否為父階層 
                    menuItems = menuAllList.filter(function (menuLists) {
                        return parseInt(menuLists.parentId) === parseInt(sessionStorage.getItem('menuSerilNo'));
                    });

                    //撈取選單節點下排序第一個功能Menu
                    if (menuItems != null && menuItems.length !== 0) {
                        var sort = Math.min.apply(Math, _toConsumableArray(menuItems.map(function (p) {
                            return p.sort;
                        })));
                        var menuItem = menuItems.filter(function (menuLists) {
                            return parseInt(menuLists.sort) === parseInt(sort);
                        });

                        //設定MenuSerilNo / MenuItemPath，以便點選三明治時會自動帶停駐在目前選單位置
                        //console.log(menuItem);
                        if (menuItem !== null && menuItem.length !== 0) {
                            if (!menuItem[0].hasChild) {
                                sessionStorage.setItem('menuSerilNo', menuItem[0].menuSerilNo);
                            }
                            sessionStorage.setItem('menuItemPath', menuItem[0].menuItemPath);
                        }
                    }
                }

                console.log('showRelatedFunctions_redirectMenuSearchResult-menuSerilNo:' + sessionStorage.getItem('menuSerilNo'));
                console.log('showRelatedFunctions_redirectMenuSearchResult-menuItemPath:' + sessionStorage.getItem('menuItemPath'));
            }

            menuService.redirectUrl(item);
            $uibModalInstance.close();
        }

        function redirectContentSearchResult(item) {
            $location.path("bulletin/detail/" + item.serilNo).search("menu", 2);
            $uibModalInstance.close();
        }
    }
})();
'use strict';

var Module = angular.module('datePicker', []);

Module.constant('datePickerConfig', {
    //template: 'directive/datePicker/datePicker.html',
    view: 'month',
    views: ['year', 'month', 'date', 'hours', 'minutes'],
    momentNames: {
        year: 'year',
        month: 'month',
        date: 'day',
        hours: 'hours',
        minutes: 'minutes'
    },
    viewConfig: {
        year: ['years', 'isSameYear'],
        month: ['months', 'isSameMonth'],
        hours: ['hours', 'isSameHour'],
        minutes: ['minutes', 'isSameMinutes']
    },
    step: 5
});
//Moment format filter.
Module.filter('mFormat', function () {
    return function (m, format, tz) {
        var result = '';
        if (!moment.isMoment(m)) {
            result = moment(m).format(format);
        } else {
            result = tz ? moment.tz(m, tz).format(format) : m.format(format);
        }
        return result;
    };
});

Module.directive('datePicker', ['datePickerConfig', 'datePickerUtils', '$timeout', '$rootScope', function datePickerDirective(datePickerConfig, datePickerUtils, $timeout, $rootScope) {
    //noinspection JSUnusedLocalSymbols
    return {
        // this is a bug ?
        require: '?ngModel',
        templateUrl: 'directive/datePicker/datePicker.html',
        scope: {
            model: '=datePicker',
            after: '=?',
            before: '=?',
            choiceDate: '=?',
            trigger: '=?'
        },
        link: function link(scope, element, attrs, ngModel) {
            scope.translateWeek = translateWeek;
            var methodList = {
                //有空維護這支程式請方法(無論公有或私有)移到此區塊
                setDate: setDate
            };
            var arrowClick = false,
                tz = scope.tz = attrs.timezone,
                createMoment = datePickerUtils.createMoment,
                eventIsForPicker = datePickerUtils.eventIsForPicker,
                step = parseInt(attrs.step || datePickerConfig.step, 10),
                partial = !!attrs.partial,
                minDate = getDate('minDate'),
                maxDate = getDate('maxDate'),
                pickerID = element[0].id,
                now = scope.now = createMoment(),
                selected = scope.date = createMoment(scope.model || now),
                autoclose = attrs.autoClose === 'true',

            // Either gets the 1st day from the attributes, or asks moment.js to give it to us as it is localized.
            firstDay = attrs.firstDay && attrs.firstDay >= 0 && attrs.firstDay <= 6 ? parseInt(attrs.firstDay, 10) : moment().weekday(0).day(),
                prepareViewData,
                isSame,
                clipDate,
                isNow,
                inValidRange;

            //==Main==
            init();
            //========
            function init() {
                //有空維護請將屬於初始設定放於此區塊
                datePickerUtils.setParams(tz, firstDay);
            }

            function prepareViews() {
                scope.views = datePickerConfig.views.concat();
                scope.view = attrs.view || datePickerConfig.view;
                scope.views = scope.views.slice(scope.views.indexOf(attrs.maxView || 'year'), scope.views.indexOf(attrs.minView || 'minutes') + 1);
                if (scope.views.length === 1 || scope.views.indexOf(scope.view) === -1) {
                    scope.view = scope.views[0];
                }
            }

            function getDate(name) {
                return datePickerUtils.getDate(scope, attrs, name);
            }
            if (!scope.model) {
                selected.minute(Math.ceil(selected.minute() / step) * step).second(0);
            }

            scope.template = attrs.template || datePickerConfig.template;

            scope.watchDirectChanges = attrs.watchDirectChanges !== undefined;
            scope.callbackOnSetDate = attrs.dateChange ? datePickerUtils.findFunction(scope, attrs.dateChange) : undefined;

            prepareViews();

            scope.setView = function (nextView) {
                if (scope.views.indexOf(nextView) !== -1) {
                    scope.view = nextView;
                }
            };
            //todo anson修改為了要關閉日期的地方
            scope.selectDate = function (date) {
                if (attrs.disabled) {
                    return false;
                }
                if (isSame(scope.date, date)) {
                    date = scope.date;
                }
                date = clipDate(date);
                if (!date) {
                    return false;
                }
                scope.date = date;

                var nextView = scope.views[scope.views.indexOf(scope.view) + 1];
                if (!nextView || partial || scope.model) {
                    setDate(date);
                }

                if (nextView) {
                    scope.setView(nextView);
                } else if (autoclose) {
                    element.addClass('hidden');
                    scope.$emit('hidePicker');
                } else {
                    prepareViewData();
                }
                // anson:為了不關閉，所以判斷autoClose
                if (attrs.minView === scope.views[0] && attrs.autoClose !== 'false') {
                    element.addClass('hidden');
                    scope.$emit('hidePicker');
                }
            };

            function setDate(date, notEmit) {
                //資料實際設定移到 setDate 後續監聽事件處理
                if (date) {
                    scope.model = date;
                    // if (ngModel) {
                    //  ngModel.$setViewValue(date);
                    // }
                }
                if (!notEmit) {
                    scope.$emit('setDate', date, scope.view);
                }

                //This is duplicated in the new functionality.
                if (scope.callbackOnSetDate) {
                    scope.callbackOnSetDate(attrs.datePicker, scope.date);
                }
            };

            function update() {
                var view = scope.view;
                datePickerUtils.setParams(tz, firstDay);

                if (scope.model && !arrowClick) {
                    scope.date = createMoment(scope.model);
                    arrowClick = false;
                }

                var date = scope.date;
                switch (view) {
                    case 'year':
                        scope.years = datePickerUtils.getVisibleYears(date);
                        break;
                    case 'month':
                        scope.months = datePickerUtils.getVisibleMonths(date);
                        break;
                    case 'date':
                        scope.weekdays = scope.weekdays || datePickerUtils.getDaysOfWeek();
                        // scope.weekdays = scope.weekdays || datePickerUtils.getWeekDays();
                        scope.weeks = datePickerUtils.getVisibleWeeks(date);
                        break;
                    case 'hours':
                        scope.hours = datePickerUtils.getVisibleHours(date);
                        break;
                    case 'minutes':
                        scope.minutes = datePickerUtils.getVisibleMinutes(date, step);
                        break;
                }
                if (scope.choiceDate) {
                    initChoiceDate();
                }
            }

            // 透過外部變更 trigger 值來觸發更新行事曆資料
            scope.$watch('trigger', function (data) {
                if (data > 1) {
                    initChoiceDate();
                }
            });

            function translateWeek(weekday) {
                weekday = weekday + '';
                var weekdayName = {
                    '0': $rootScope.translate.tsunWeekSunday || 'Sunday',
                    '1': $rootScope.translate.tsunWeekMonday || 'Monday',
                    '2': $rootScope.translate.tsunWeekTuesday || 'Tuesday',
                    '3': $rootScope.translate.tsunWeekWednesday || 'Wednesday',
                    '4': $rootScope.translate.tsunWeekThusday || 'Thusday',
                    '5': $rootScope.translate.tsunWeekFriday || 'Friday',
                    '6': $rootScope.translate.tsunWeekSaturday || 'Saturday'
                };
                return weekdayName[weekday] || 'unknownday';
            }

            function initChoiceDate() {
                var classes = [],
                    classList = '',
                    i,
                    j,
                    week,
                    weeks = scope.weeks;
                var choiceDateArr = [];

                scope.choiceDate.then(function (data) {

                    // 目前選擇的日期
                    // console.log('scope.date:', scope.date.toDate());

                    // 所有行事曆資料
                    // console.log('data.data.schedules:', jQuery.extend(true, {}, data.data.schedules));

                    var prev2Month = moment(scope.date).subtract(2, 'M');
                    var next1Month = moment(scope.date).add(1, 'M');
                    var next2Month = moment(scope.date).add(2, 'M');
                    var limitDate = moment.range(prev2Month, next2Month);

                    _.each(data.data.schedules, function (x) {

                        // 針對沒有 end 的事件，給予固定值填滿整個當月行事曆
                        if (moment(x.end).isAfter(next1Month)) {
                            x.end = next1Month.format('YYYY-MM-DDTHH:mm:ss');
                        }

                        // 過濾在被選擇日期的上下2月份的所有行事曆資料
                        if (limitDate.contains(moment(x.end))) {
                            choiceDateArr.push(x);
                        }
                    });

                    // 被選擇日期的上下2月份的所有行事曆資料
                    // console.log('choiceDateArr:', jQuery.extend(true, {}, choiceDateArr));

                    var dateRange = _.chain(choiceDateArr).forEach(function (x) {
                        var end = moment(x.end);
                        // 沒有加這行在下個階段會產生區間日期計算錯誤
                        x.end = end.hour() < 9 ? end.subtract(1, 'day').format('YYYY-MM-DDTHH:mm:ss') : end.format('YYYY-MM-DDTHH:mm:ss');
                    }).map(function (x) {
                        // 計算區間中的每個日期
                        var result = moment.range(moment(x.start).toDate(), moment(x.end).toDate()).toArray('days');
                        return result;
                    }).flatten().map(function (x) {
                        return x.format('YYYYMMDD');
                    }).uniq().sortBy().value();

                    // 需要顯示圈圈的日期
                    // console.log('dateRange:', dateRange);

                    for (i = 0; i < weeks.length; i++) {
                        week = weeks[i];
                        classes.push([]);
                        for (j = 0; j < week.length; j++) {
                            classList = '';
                            _.each(dateRange, function (x) {
                                if (x === moment(week[j]).format('YYYYMMDD')) {
                                    classList += 'choice';
                                }
                            });

                            classes[i].push(classList);
                        }
                    }
                    scope.classes = classes;
                });
            }

            function watch() {
                var result;
                if (scope.view !== 'date') {
                    result = scope.view;
                } else {
                    result = scope.date ? scope.date.month() : null;
                }
                return result;
            }

            scope.$watch(watch, function () {
                update();
            });

            if (scope.watchDirectChanges) {
                scope.$watch('model', function () {
                    arrowClick = false;
                    update();
                });
            }

            prepareViewData = function prepareViewData() {
                var view = scope.view,
                    date = scope.date,
                    classes = [],
                    classList = '',
                    i,
                    j,
                    choiceDay;

                datePickerUtils.setParams(tz, firstDay);
                if (view === 'date') {
                    var weeks = scope.weeks,
                        week;

                    for (i = 0; i < weeks.length; i++) {
                        week = weeks[i];
                        classes.push([]);
                        for (j = 0; j < week.length; j++) {
                            classList = '';
                            // if (datePickerUtils.isSameDay(date, week[j])) {
                            //     classList += 'active';
                            // }
                            // if (isNow(week[j], view)) {
                            //     classList += ' now';
                            // }
                            //if (week[j].month() !== date.month()) classList += ' disabled';
                            // if (week[j].month() !== date.month() || !inValidRange(week[j])) {
                            //     classList += ' disabled';
                            // }


                            classes[i].push(classList);
                        }
                    }
                } else {
                    var params = datePickerConfig.viewConfig[view],
                        dates = scope[params[0]],
                        compareFunc = params[1];

                    for (i = 0; i < dates.length; i++) {
                        classList = '';
                        if (datePickerUtils[compareFunc](date, dates[i])) {
                            classList += 'active';
                        }
                        if (isNow(dates[i], view)) {
                            classList += ' now';
                        }
                        if (!inValidRange(dates[i])) {
                            classList += ' disabled';
                        }
                        classes.push(classList);
                    }
                }
                // scope.classes = classes;
            };

            scope.next = function (delta) {
                var date = moment(scope.date);
                delta = delta || 1;
                switch (scope.view) {
                    case 'year':
                    /*falls through*/
                    case 'month':
                        date.year(date.year() + delta);
                        break;
                    case 'date':
                        date.month(date.month() + delta);
                        break;
                    case 'hours':
                    /*falls through*/
                    case 'minutes':
                        date.hours(date.hours() + delta);
                        break;
                }
                date = clipDate(date);

                if (date) {
                    scope.date = date;
                    setDate(date, true);
                    arrowClick = true;
                }
            };

            inValidRange = function inValidRange(date) {
                var valid = true;
                if (minDate && minDate.isAfter(date)) {
                    valid = isSame(minDate, date);
                }
                if (maxDate && maxDate.isBefore(date)) {
                    valid &= isSame(maxDate, date);
                }
                return valid;
            };

            isSame = function isSame(date1, date2) {
                return date1.isSame(date2, datePickerConfig.momentNames[scope.view]) ? true : false;
            };

            clipDate = function clipDate(date) {
                if (minDate && minDate.isAfter(date)) {
                    return minDate;
                } else if (maxDate && maxDate.isBefore(date)) {
                    return maxDate;
                } else {
                    return date;
                }
            };

            isNow = function isNow(date, view) {
                var is = true;

                switch (view) {
                    case 'minutes':
                        is &= ~~(now.minutes() / step) === ~~(date.minutes() / step);
                    /* falls through */
                    case 'hours':
                        is &= now.hours() === date.hours();
                    /* falls through */
                    case 'date':
                        is &= now.date() === date.date();
                    /* falls through */
                    case 'month':
                        is &= now.month() === date.month();
                    /* falls through */
                    case 'year':
                        is &= now.year() === date.year();
                }
                return is;
            };

            scope.prev = function (delta) {
                return scope.next(-delta || -1);
            };

            if (pickerID) {
                scope.$on('pickerUpdate', function (event, pickerIDs, data) {
                    if (eventIsForPicker(pickerIDs, pickerID)) {
                        var updateViews = false,
                            updateViewData = false;

                        if (angular.isDefined(data.minDate)) {
                            minDate = data.minDate ? data.minDate : false;
                            updateViewData = true;
                        }
                        if (angular.isDefined(data.maxDate)) {
                            maxDate = data.maxDate ? data.maxDate : false;
                            updateViewData = true;
                        }

                        if (angular.isDefined(data.minView)) {
                            attrs.minView = data.minView;
                            updateViews = true;
                        }
                        if (angular.isDefined(data.maxView)) {
                            attrs.maxView = data.maxView;
                            updateViews = true;
                        }
                        attrs.view = data.view || attrs.view;

                        if (updateViews) {
                            prepareViews();
                        }

                        if (updateViewData) {
                            update();
                        }
                    }
                });
            }
        }
    };
}]);
'use strict';

var PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty';

var Module = angular.module('datePicker');

Module.constant('dateTimeConfig', {
    template: function template(attrs, id) {
        return '' + '<div ' + (id ? 'id="' + id + '" ' : '') + 'date-picker="' + attrs.ngModel + '" ' + (attrs.view ? 'view="' + attrs.view + '" ' : '') + (attrs.maxView ? 'max-view="' + attrs.maxView + '" ' : '') + (attrs.maxDate ? 'max-date="' + attrs.maxDate + '" ' : '') + (attrs.autoClose ? 'auto-close="' + attrs.autoClose + '" ' : '') + (attrs.template ? 'template="' + attrs.template + '" ' : '') + (attrs.minView ? 'min-view="' + attrs.minView + '" ' : '') + (attrs.minDate ? 'min-date="' + attrs.minDate + '" ' : '') + (attrs.partial ? 'partial="' + attrs.partial + '" ' : '') + (attrs.step ? 'step="' + attrs.step + '" ' : '') + (attrs.onSetDate ? 'date-change="' + attrs.onSetDate + '" ' : '') + (attrs.ngModel ? 'ng-model="' + attrs.ngModel + '" ' : '') + (attrs.firstDay ? 'first-day="' + attrs.firstDay + '" ' : '') + (attrs.timezone ? 'timezone="' + attrs.timezone + '" ' : '') + 'class="date-picker-date-time"></div>';
    },
    format: 'YYYY-MM-DD HH:mm',
    views: ['date', 'year', 'month', 'hours', 'minutes'],
    autoClose: true,
    position: 'relative'
});

Module.directive('dateTimeAppend', function () {
    return {
        link: function link(scope, element) {
            element.bind('click', function () {
                element.find('input')[0].focus();
            });
        }
    };
});

Module.filter('resultFormat', function () {
    //處理結果的格式化.
    return function (newValue, oldValue, formatConfig) {
        // console.log("enter resultFormat");
        // console.log("newValue:",newValue);
        // console.log("oldValue:",oldValue);
        var result = '';
        var newValueDate = Date.parse(newValue);
        var oldValueDate = Date.parse(oldValue);
        if (!newValueDate) {
            if (oldValueDate && newValue) {
                // console.log("resultValue set as oldValue");
                result = oldValue;
            } else if (formatConfig.getDefault) {
                // console.log("checking default");
                result = formatConfig.defaultValue ? formatConfig.defaultValue : moment(new Date()).format(formatConfig.format);
            } else {
                result = '';
            }
        } else if (!moment.isMoment(newValue)) {
            // console.log("normale Setting,newValue is not moment");
            result = moment(newValue, formatConfig.format).format(formatConfig.format);
        } else {
            // console.log("normale Setting,newValue is moment");
            result = formatConfig.timezone ? moment.tz(newValueDate, formatConfig.timezone).format(formatConfig.format) : moment(newValue).format(formatConfig.format);
        }
        // console.log("end resultFormat...result", result);
        return result;
    };
});
Module.directive('dateTime', ['$compile', '$timeout', '$document', '$filter', 'dateTimeConfig', '$parse', 'datePickerUtils', function ($compile, $timeout, $document, $filter, dateTimeConfig, $parse, datePickerUtils) {
    var body = $document.find('body');
    // var dateFilter = $filter('mFormat');
    var dateFilter = $filter('resultFormat');

    return {
        require: 'ngModel',
        scope: {
            model: '=ngModel',
            appendAlign: '@',
            onEvent: '&'
        },
        link: function link(scope, element, attrs, ngModel, $scope) {
            var configs = {
                //有空維護這隻程式請將所屬控制類別參數改放此區塊
                formatConfig: {
                    // 日期格式化校正設定
                    format: attrs.format || dateTimeConfig.format,
                    timezone: attrs.timezone || false,
                    getDefault: attrs.getDefault ? attrs.getDefault === 'true' : true,
                    defaultValue: attrs.defaultValue || null
                }
            };
            var data = {
                oldValue: '',
                template: dateTimeConfig.template(attrs)
                //有空維護這隻程式請將所屬資料類別參數改放此區塊
            };
            var format = attrs.format || dateTimeConfig.format,
                parentForm = element.inheritedData('$formController'),
                views = $parse(attrs.views)(scope) || dateTimeConfig.views.concat(),
                view = attrs.view || views[0],
                index = views.indexOf(view),
                dismiss = attrs.autoClose ? $parse(attrs.autoClose)(scope) : dateTimeConfig.autoClose,
                picker = null,
                pickerID = element[0].id,
                position = attrs.position || dateTimeConfig.position,
                container = null,
                minDate = null,
                minValid = null,
                maxDate = null,
                maxValid = null,
                timezone = attrs.timezone || false,
                eventIsForPicker = datePickerUtils.eventIsForPicker,
                dateChange = null,
                shownOnce = false,
                dateRequired;
            //===Main==
            init();
            //=========
            function logicInit() {
                if (!scope.appendAlign) {
                    scope.appendAlign = 'down';
                }
                if (index === -1) {
                    views.splice(index, 1);
                }
                views.unshift(view);

                if (angular.isDefined(attrs.minDate)) {
                    setMin(datePickerUtils.findParam(scope, attrs.minDate));

                    ngModel.$validators.min = function (value) {
                        //If we don't have a min / max value, then any value is valid.
                        return minValid ? moment.isMoment(value) && (minDate.isSame(value) || minDate.isBefore(value)) : true;
                    };
                }

                if (angular.isDefined(attrs.maxDate)) {
                    setMax(datePickerUtils.findParam(scope, attrs.maxDate));

                    ngModel.$validators.max = function (value) {
                        return maxValid ? moment.isMoment(value) && (maxDate.isSame(value) || maxDate.isAfter(value)) : true;
                    };
                }

                if (angular.isDefined(attrs.dateChange)) {
                    dateChange = datePickerUtils.findFunction(scope, attrs.dateChange);
                }

                if (pickerID) {
                    scope.$on('pickerUpdate', function (event, pickerIDs, data) {
                        if (eventIsForPicker(pickerIDs, pickerID)) {
                            if (picker) {
                                //Need to handle situation where the data changed but the picker is currently open.
                                //To handle this, we can create the inner picker with a random ID, then forward
                                //any events received to it.
                            } else {
                                var validateRequired = false;
                                if (angular.isDefined(data.minDate)) {
                                    setMin(data.minDate);
                                    validateRequired = true;
                                }
                                if (angular.isDefined(data.maxDate)) {
                                    setMax(data.maxDate);
                                    validateRequired = true;
                                }

                                if (angular.isDefined(data.minView)) {
                                    attrs.minView = data.minView;
                                }
                                if (angular.isDefined(data.maxView)) {
                                    attrs.maxView = data.maxView;
                                }

                                attrs.view = data.view || attrs.view;

                                if (validateRequired) {
                                    ngModel.$validate();
                                }
                                if (angular.isDefined(data.format)) {
                                    format = attrs.format = data.format || dateTimeConfig.format;
                                    ngModel.$modelValue = -1; //Triggers formatters. This value will be discarded.
                                }
                                // getTemplate();
                            }
                        }
                    });
                }

                // getTemplate();
                element.change();
            }
            function init() {
                //console.log("dateTime...ngModel:", ngModel);
                //todo anson為了自訂datePicker需要新增一筆以上才能通過驗証
                scope.$watch(attrs.dateRequired, function (value) {
                    if (!value) {
                        ngModel.$invalid = true;
                    }
                });
                scope.$on('setDate', function (event, date, view) {
                    setDateProcess(event, date, view);
                });
                scope.$on('hidePicker', function () {
                    element.triggerHandler('blur');
                });
                scope.$on('$destroy', clear);
                element.bind('focus', showPicker);
                element.bind('blur', clear);
                element.change(function () {
                    // console.log("enter change event");
                    // console.log("scope.model:",scope.model);
                    // console.log(" data.oldValue:", data.oldValue);
                    var resultDate = dateFilter(scope.model, data.oldValue, configs.formatConfig);
                    element.val(resultDate);
                    scope.model = resultDate;
                    data.oldValue = resultDate;
                    if (dateChange) {
                        dateChange(attrs.ngModel, scope.model);
                    }
                    // console.log("scope.model:", resultDate);
                    // console.log("scope:", scope);
                    // console.log("end change event");
                });
                logicInit();
            }

            function setDateProcess(event, date, view) {
                //console.log("detect setDate on");
                //console.log("viewValue set:", date);
                scope.model = date;
                element.change();
                event.stopPropagation();
                if (attrs.minView === view) {
                    if (dismiss && views[views.length - 1] === view) {
                        clear();
                    }
                    element.blur();
                }
            }
            function parser(viewValue) {
                //console.log("parser viewValue:", viewValue);
                var parsed = moment(viewValue, format);
                var result = undefined;
                if (parsed.isValid()) {
                    result = parsed;
                }
                //console.log("parser result:", result);
                return result;
            }

            function setMin(date) {
                minDate = date;
                attrs.minDate = date ? date.format() : date;
                minValid = moment.isMoment(date);
            }

            function setMax(date) {
                maxDate = date;
                attrs.maxDate = date ? date.format() : date;
                maxValid = moment.isMoment(date);
            }

            function clear() {
                // return;
                // console.log("enter clear...picker:", picker, "container:", container);
                if (picker) {
                    picker.remove();
                    picker = null;
                }
                if (container) {
                    container.remove();
                    container = null;
                }
                // console.log("end clear...picker:", picker, "container:", container);
            }

            // function getTemplate() {
            //     template = dateTimeConfig.template(attrs);
            // }

            function showPicker() {
                if (picker) {
                    return;
                }
                var bodyHeight = document.body.scrollHeight;
                // create picker element
                picker = $compile(data.template)(scope);
                picker.css({
                    display: 'block',
                    position: position
                });
                picker.bind('mousedown', function (evt) {
                    evt.preventDefault();
                });
                scope.$digest();

                // move picker below input element
                if (position === 'absolute') {
                    body.append(picker);
                    $timeout(function () {
                        //這段可能會有BUG
                        //BUG原因是scope.$digest()其實還沒跑完(這方法好像是非同步)
                        //因此要徹底解決需要找到後置的處理方案
                        var width = 400;
                        if (body.width() < width) {
                            width = body.width() - 10;
                        }
                        var pos = element[0].getBoundingClientRect();
                        var pickerHeight = picker.height();
                        var height = pos.height || element[0].offsetHeight; // Support IE8
                        var scrollHeight = body.scrollTop();
                        var showTop = pos.top + height + scrollHeight;
                        if (showTop + pickerHeight > bodyHeight) {
                            showTop = bodyHeight - pickerHeight;
                        }

                        picker.css({
                            top: showTop + 'px',
                            left: pos.left + 'px',
                            position: position,
                            width: width + 'px'
                        });
                    }, 50);
                } else {
                    // relative
                    container = angular.element('<div style="min-width:0px;" date-picker-wrapper></div>');
                    element[0].parentElement.insertBefore(container[0], element[0]);
                    container.append(picker);
                    picker.css({ top: element[0].offsetHeight + 'px', display: 'block' });
                }
                // console.log("scope.appendAlign:", scope.appendAlign);
                // console.log("top:", element[0].offsetHeight);
                // console.log("picker",picker);
                // console.log("picker.height:", picker.height());
                // console.log("container",container);
                // console.log("container.height:", container.height());
            }
        }
    };
}]);
'use strict';

angular.module('datePicker').factory('datePickerUtils', function () {
  var tz, firstDay;
  var createNewDate = function createNewDate(year, month, day, hour, minute) {
    var utc = Date.UTC(year | 0, month | 0, day | 0, hour | 0, minute | 0);
    return tz ? moment.tz(utc, tz) : moment(utc);
  };

  return {
    getVisibleMinutes: function getVisibleMinutes(m, step) {
      var year = m.year(),
          month = m.month(),
          day = m.date(),
          hour = m.hours(),
          pushedDate,
          offset = m.utcOffset() / 60,
          minutes = [],
          minute;

      for (minute = 0; minute < 60; minute += step) {
        pushedDate = createNewDate(year, month, day, hour - offset, minute);
        minutes.push(pushedDate);
      }
      return minutes;
    },
    getVisibleWeeks: function getVisibleWeeks(m) {
      m = moment(m);
      var startYear = m.year(),
          startMonth = m.month();

      //Set date to the first day of the month
      m.date(1);

      //Grab day of the week
      var day = m.day();
      //Go back the required number of days to arrive at the previous week start
      m.date(firstDay - (day + (firstDay >= day ? 6 : -1)));

      var weeks = [];
      while (weeks.length < 6) {
        if (m.year() === startYear && m.month() > startMonth) {
          break;
        }
        weeks.push(this.getDaysOfWeek(m));
        m.add(7, 'd');
      }
      return weeks;
    },
    getVisibleYears: function getVisibleYears(d) {
      var m = moment(d),
          year = m.year();

      m.year(year - year % 10);
      year = m.year();

      var offset = m.utcOffset() / 60,
          years = [],
          pushedDate,
          actualOffset;

      for (var i = 0; i < 12; i++) {
        pushedDate = createNewDate(year, 0, 1, 0 - offset);
        actualOffset = pushedDate.utcOffset() / 60;
        if (actualOffset !== offset) {
          pushedDate = createNewDate(year, 0, 1, 0 - actualOffset);
          offset = actualOffset;
        }
        years.push(pushedDate);
        year++;
      }
      return years;
    },
    getWeekDays: function getWeekDays() {
      return [0, 1, 2, 3, 4, 5, 6];
    },
    getDaysOfWeek: function getDaysOfWeek(m) {
      m = m ? m : tz ? moment.tz(tz).day(firstDay) : moment().day(firstDay);

      var year = m.year(),
          month = m.month(),
          day = m.date(),
          days = [],
          pushedDate,
          offset = m.utcOffset() / 60,
          actualOffset;

      for (var i = 0; i < 7; i++) {
        pushedDate = createNewDate(year, month, day, 0 - offset, 0, false);
        actualOffset = pushedDate.utcOffset() / 60;
        if (actualOffset !== offset) {
          pushedDate = createNewDate(year, month, day, 0 - actualOffset, 0, false);
        }
        days.push(pushedDate);
        day++;
      }
      return days;
    },
    getVisibleMonths: function getVisibleMonths(m) {
      var year = m.year(),
          offset = m.utcOffset() / 60,
          months = [],
          pushedDate,
          actualOffset;

      for (var month = 0; month < 12; month++) {
        pushedDate = createNewDate(year, month, 1, 0 - offset, 0, false);
        actualOffset = pushedDate.utcOffset() / 60;
        if (actualOffset !== offset) {
          pushedDate = createNewDate(year, month, 1, 0 - actualOffset, 0, false);
        }
        months.push(pushedDate);
      }
      return months;
    },
    getVisibleHours: function getVisibleHours(m) {
      var year = m.year(),
          month = m.month(),
          day = m.date(),
          hours = [],
          hour,
          pushedDate,
          actualOffset,
          offset = m.utcOffset() / 60;

      for (hour = 0; hour < 24; hour++) {
        pushedDate = createNewDate(year, month, day, hour - offset, 0, false);
        actualOffset = pushedDate.utcOffset() / 60;
        if (actualOffset !== offset) {
          pushedDate = createNewDate(year, month, day, hour - actualOffset, 0, false);
        }
        hours.push(pushedDate);
      }

      return hours;
    },
    isAfter: function isAfter(model, date) {
      return model && model.unix() >= date.unix();
    },
    isBefore: function isBefore(model, date) {
      return model.unix() <= date.unix();
    },
    isSameYear: function isSameYear(model, date) {
      return model && model.year() == date.year();
    },
    isSameMonth: function isSameMonth(model, date) {
      return this.isSameYear(model, date) && model.month() === date.month();
    },
    isSameDay: function isSameDay(model, date) {
      return this.isSameMonth(model, date) && model.date() === date.date();
    },
    isSameHour: function isSameHour(model, date) {
      return this.isSameDay(model, date) && model.hours() === date.hours();
    },
    isSameMinutes: function isSameMinutes(model, date) {
      return this.isSameHour(model, date) && model.minutes() === date.minutes();
    },
    setParams: function setParams(zone, fd) {
      tz = zone;
      firstDay = fd;
    },
    scopeSearch: function scopeSearch(scope, name, comparisonFn) {
      var parentScope = scope,
          nameArray = name.split('.'),
          target,
          i,
          j = nameArray.length;

      do {
        target = parentScope = parentScope.$parent;

        //Loop through provided names.
        for (i = 0; i < j; i++) {
          target = target[nameArray[i]];
          if (!target) {
            continue;
          }
        }

        //If we reached the end of the list for this scope,
        //and something was found, trigger the comparison
        //function. If the comparison function is happy, return
        //found result. Otherwise, continue to the next parent scope
        if (target && comparisonFn(target)) {
          return target;
        }
      } while (parentScope.$parent);

      return false;
    },
    findFunction: function findFunction(scope, name) {
      //Search scope ancestors for a matching function.
      return this.scopeSearch(scope, name, function (target) {
        //Property must also be a function
        return angular.isFunction(target);
      });
    },
    findParam: function findParam(scope, name) {
      //Search scope ancestors for a matching parameter.
      return this.scopeSearch(scope, name, function () {
        //As long as the property exists, we're good
        return true;
      });
    },
    createMoment: function createMoment(m) {
      if (tz) {
        return moment.tz(m, tz);
      } else {
        //If input is a moment, and we have no TZ info, we need to remove TZ
        //info from the moment, otherwise the newly created moment will take
        //the timezone of the input moment. The easiest way to do that is to
        //take the unix timestamp, and use that to create a new moment.
        //The new moment will use the local timezone of the user machine.
        return moment.isMoment(m) ? moment.unix(m.unix()) : moment(m);
      }
    },
    getDate: function getDate(scope, attrs, name) {
      var result = false;
      if (attrs[name]) {
        result = this.createMoment(attrs[name]);
        if (!result.isValid()) {
          result = this.findParam(scope, attrs[name]);
          if (result) {
            result = this.createMoment(result);
          }
        }
      }

      return result;
    },
    //Checks if an event targeted at a specific picker, via either a string name, or an array of strings.
    eventIsForPicker: function eventIsForPicker(targetIDs, pickerID) {
      function matches(id) {
        if (id instanceof RegExp) {
          return id.test(pickerID);
        }
        return id === pickerID;
      }

      if (angular.isArray(targetIDs)) {
        return targetIDs.some(matches);
      }
      return matches(targetIDs);
    }
  };
});
'use strict';

var Module = angular.module('datePicker');

Module.directive('dateRange', ['$compile', 'datePickerUtils', 'dateTimeConfig', function ($compile, datePickerUtils, dateTimeConfig) {
  function getTemplate(attrs, id, model, min, max) {
    return dateTimeConfig.template(angular.extend(attrs, {
      ngModel: model,
      minDate: min && moment.isMoment(min) ? min.format() : false,
      maxDate: max && moment.isMoment(max) ? max.format() : false
    }), id);
  }

  function randomName() {
    return 'picker' + new Date().getTime().toString().substr(2);
  }

  return {
    scope: {
      start: '=',
      end: '='
    },
    link: function link(scope, element, attrs) {
      var dateChange = null,
          pickerRangeID = element[0].id,
          pickerIDs = [randomName(), randomName()],
          createMoment = datePickerUtils.createMoment,
          eventIsForPicker = datePickerUtils.eventIsForPicker;

      scope.dateChange = function (modelName, newDate) {
        //Notify user if callback exists.
        if (dateChange) {
          dateChange(modelName, newDate);
        }
      };

      function setMax(date) {
        scope.$broadcast('pickerUpdate', pickerIDs[0], {
          maxDate: date
        });
      }

      function setMin(date) {
        scope.$broadcast('pickerUpdate', pickerIDs[1], {
          minDate: date
        });
      }

      if (pickerRangeID) {
        scope.$on('pickerUpdate', function (event, targetIDs, data) {
          if (eventIsForPicker(targetIDs, pickerRangeID)) {
            //If we received an update event, dispatch it to the inner pickers using their IDs.
            scope.$broadcast('pickerUpdate', pickerIDs, data);
          }
        });
      }

      datePickerUtils.setParams(attrs.timezone);

      scope.start = createMoment(scope.start);
      scope.end = createMoment(scope.end);

      scope.$watchGroup(['start', 'end'], function (dates) {
        //Scope data changed, update picker min/max
        setMin(dates[0]);
        setMax(dates[1]);
      });

      if (angular.isDefined(attrs.dateChange)) {
        dateChange = datePickerUtils.findFunction(scope, attrs.dateChange);
      }

      attrs.onSetDate = 'dateChange';

      var template = '<div><table class="date-range"><tr><td valign="top">' + getTemplate(attrs, pickerIDs[0], 'start', false, scope.end) + '</td><td valign="top">' + getTemplate(attrs, pickerIDs[1], 'end', scope.start, false) + '</td></tr></table></div>';

      var picker = $compile(template)(scope);
      element.append(picker);
    }
  };
}]);
'use strict';

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position']).constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
}).service('uibDropdownService', ['$document', '$rootScope', function ($document, $rootScope) {
  var openScope = null;

  this.open = function (dropdownScope) {
    if (!openScope) {
      $document.on('click', closeDropdown);
      $document.on('keydown', keybindFilter);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;
  };

  this.close = function (dropdownScope) {
    if (openScope === dropdownScope) {
      openScope = null;
      $document.off('click', closeDropdown);
      $document.off('keydown', keybindFilter);
    }
  };

  var closeDropdown = function closeDropdown(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope) {
      return;
    }

    if (evt && openScope.getAutoClose() === 'disabled') {
      return;
    }

    if (evt && evt.which === 3) {
      return;
    }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  var keybindFilter = function keybindFilter(evt) {
    if (evt.which === 27) {
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}]).controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
      scope = $scope.$new(),
      // create a child scope so we are not polluting original one
  templateScope,
      appendToOpenClass = dropdownConfig.appendToOpenClass,
      openClass = dropdownConfig.openClass,
      getIsOpen,
      setIsOpen = angular.noop,
      toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
      appendToBody = false,
      appendTo = null,
      keynavEnabled = false,
      selectedOption = null,
      body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function () {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function (value) {
        scope.isOpen = !!value;
      });
    }

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
    keynavEnabled = angular.isDefined($attrs.keyboardNav);

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      appendTo.append(self.dropdownMenu);
      $element.on('$destroy', function handleDestroyEvent() {
        self.dropdownMenu.remove();
      });
    }
  };

  this.toggle = function (open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function () {
    return scope.isOpen;
  };

  scope.getToggleElement = function () {
    return self.toggleElement;
  };

  scope.getAutoClose = function () {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function () {
    return $element;
  };

  scope.isKeynavEnabled = function () {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function (keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
    angular.element(self.dropdownMenu).find('a') : $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40:
        {
          if (!angular.isNumber(self.selectedOption)) {
            self.selectedOption = 0;
          } else {
            self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
          }
          break;
        }
      case 38:
        {
          if (!angular.isNumber(self.selectedOption)) {
            self.selectedOption = elems.length - 1;
          } else {
            self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
          }
          break;
        }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function () {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function () {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  scope.$watch('isOpen', function (isOpen, wasOpen) {
    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
          css,
          rightalign;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        css.right = window.innerWidth - (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth - (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var hasOpenClass = openContainer.hasClass(appendTo ? appendToOpenClass : openClass);

    if (hasOpenClass === !isOpen) {
      $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, appendTo ? appendToOpenClass : openClass).then(function () {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function (dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
          });
        });
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope);
    } else {
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      uibDropdownService.close(scope);
      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}]).directive('uibDropdown', function () {
  return {
    controller: 'UibDropdownController',
    link: function link(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
}).directive('uibDropdownMenu', function () {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function link(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
}).directive('uibDropdownToggle', function () {
  return {
    require: '?^uibDropdown',
    link: function link(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function toggleDropdown(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function () {
            dropdownCtrl.toggle();
          });
        }
      };

      element.bind('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function () {
        element.unbind('click', toggleDropdown);
      });
    }
  };
});
'use strict';

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
.factory('$uibPosition', ['$document', '$window', function ($document, $window) {
  /**
   * Used by scrollbarWidth() function to cache scrollbar's width.
   * Do not access this variable directly, use scrollbarWidth() instead.
   */
  var SCROLLBAR_WIDTH;
  /**
   * scrollbar on body and html element in IE and Edge overlay
   * content and should be considered 0 width.
   */
  var BODY_SCROLLBAR_WIDTH;
  var OVERFLOW_REGEX = {
    normal: /(auto|scroll)/,
    hidden: /(auto|scroll|hidden)/
  };
  var PLACEMENT_REGEX = {
    auto: /\s?auto?\s?/i,
    primary: /^(top|bottom|left|right)$/,
    secondary: /^(top|bottom|left|right|center)$/,
    vertical: /^(top|bottom)$/
  };
  var BODY_REGEX = /(HTML|BODY)/;

  return {

    /**
     * Provides a raw DOM element from a jQuery/jQLite element.
     *
     * @param {element} elem - The element to convert.
     *
     * @returns {element} A HTML element.
     */
    getRawNode: function getRawNode(elem) {
      return elem.nodeName ? elem : elem[0] || elem;
    },

    /**
     * Provides a parsed number for a style property.  Strips
     * units and casts invalid numbers to 0.
     *
     * @param {string} value - The style value to parse.
     *
     * @returns {number} A valid number.
     */
    parseStyle: function parseStyle(value) {
      value = parseFloat(value);
      return isFinite(value) ? value : 0;
    },

    /**
     * Provides the closest positioned ancestor.
     *
     * @param {element} element - The element to get the offest parent for.
     *
     * @returns {element} The closest positioned ancestor.
     */
    offsetParent: function offsetParent(elem) {
      elem = this.getRawNode(elem);

      var offsetParent = elem.offsetParent || $document[0].documentElement;

      function isStaticPositioned(el) {
        return ($window.getComputedStyle(el).position || 'static') === 'static';
      }

      while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
        offsetParent = offsetParent.offsetParent;
      }

      return offsetParent || $document[0].documentElement;
    },

    /**
     * Provides the scrollbar width, concept from TWBS measureScrollbar()
     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
     * In IE and Edge, scollbar on body and html element overlay and should
     * return a width of 0.
     *
     * @returns {number} The width of the browser scollbar.
     */
    scrollbarWidth: function scrollbarWidth(isBody) {
      if (isBody) {
        if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
          var bodyElem = $document.find('body');
          bodyElem.addClass('uib-position-body-scrollbar-measure');
          BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
          BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
          bodyElem.removeClass('uib-position-body-scrollbar-measure');
        }
        return BODY_SCROLLBAR_WIDTH;
      }

      if (angular.isUndefined(SCROLLBAR_WIDTH)) {
        var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
        $document.find('body').append(scrollElem);
        SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
        SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
        scrollElem.remove();
      }

      return SCROLLBAR_WIDTH;
    },

    /**
     * Provides the padding required on an element to replace the scrollbar.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**scrollbarWidth**: the width of the scrollbar</li>
     *     <li>**widthOverflow**: whether the the width is overflowing</li>
     *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
     *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
     *     <li>**heightOverflow**: whether the the height is overflowing</li>
     *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
     *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
     *   </ul>
     */
    scrollbarPadding: function scrollbarPadding(elem) {
      elem = this.getRawNode(elem);

      var elemStyle = $window.getComputedStyle(elem);
      var paddingRight = this.parseStyle(elemStyle.paddingRight);
      var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
      var scrollParent = this.scrollParent(elem, false, true);
      var scrollbarWidth = this.scrollbarWidth(scrollParent, BODY_REGEX.test(scrollParent.tagName));

      return {
        scrollbarWidth: scrollbarWidth,
        widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
        right: paddingRight + scrollbarWidth,
        originalRight: paddingRight,
        heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
        bottom: paddingBottom + scrollbarWidth,
        originalBottom: paddingBottom
      };
    },

    /**
     * Checks to see if the element is scrollable.
     *
     * @param {element} elem - The element to check.
     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
     *   default is false.
     *
     * @returns {boolean} Whether the element is scrollable.
     */
    isScrollable: function isScrollable(elem, includeHidden) {
      elem = this.getRawNode(elem);

      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
      var elemStyle = $window.getComputedStyle(elem);
      return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
    },

    /**
     * Provides the closest scrollable ancestor.
     * A port of the jQuery UI scrollParent method:
     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
     *
     * @param {element} elem - The element to find the scroll parent of.
     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
     *   default is false.
     * @param {boolean=} [includeSelf=false] - Should the element being passed be
     * included in the scrollable llokup.
     *
     * @returns {element} A HTML element.
     */
    scrollParent: function scrollParent(elem, includeHidden, includeSelf) {
      elem = this.getRawNode(elem);

      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
      var documentEl = $document[0].documentElement;
      var elemStyle = $window.getComputedStyle(elem);
      if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
        return elem;
      }
      var excludeStatic = elemStyle.position === 'absolute';
      var scrollParent = elem.parentElement || documentEl;

      if (scrollParent === documentEl || elemStyle.position === 'fixed') {
        return documentEl;
      }

      while (scrollParent.parentElement && scrollParent !== documentEl) {
        var spStyle = $window.getComputedStyle(scrollParent);
        if (excludeStatic && spStyle.position !== 'static') {
          excludeStatic = false;
        }

        if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
          break;
        }
        scrollParent = scrollParent.parentElement;
      }

      return scrollParent;
    },

    /**
     * Provides read-only equivalent of jQuery's position function:
     * http://api.jquery.com/position/ - distance to closest positioned
     * ancestor.  Does not account for margins by default like jQuery position.
     *
     * @param {element} elem - The element to caclulate the position on.
     * @param {boolean=} [includeMargins=false] - Should margins be accounted
     * for, default is false.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**width**: the width of the element</li>
     *     <li>**height**: the height of the element</li>
     *     <li>**top**: distance to top edge of offset parent</li>
     *     <li>**left**: distance to left edge of offset parent</li>
     *   </ul>
     */
    position: function position(elem, includeMagins) {
      elem = this.getRawNode(elem);

      var elemOffset = this.offset(elem);
      if (includeMagins) {
        var elemStyle = $window.getComputedStyle(elem);
        elemOffset.top -= this.parseStyle(elemStyle.marginTop);
        elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
      }
      var parent = this.offsetParent(elem);
      var parentOffset = { top: 0, left: 0 };

      if (parent !== $document[0].documentElement) {
        parentOffset = this.offset(parent);
        parentOffset.top += parent.clientTop - parent.scrollTop;
        parentOffset.left += parent.clientLeft - parent.scrollLeft;
      }

      return {
        width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
        height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
        top: Math.round(elemOffset.top - parentOffset.top),
        left: Math.round(elemOffset.left - parentOffset.left)
      };
    },

    /**
     * Provides read-only equivalent of jQuery's offset function:
     * http://api.jquery.com/offset/ - distance to viewport.  Does
     * not account for borders, margins, or padding on the body
     * element.
     *
     * @param {element} elem - The element to calculate the offset on.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**width**: the width of the element</li>
     *     <li>**height**: the height of the element</li>
     *     <li>**top**: distance to top edge of viewport</li>
     *     <li>**right**: distance to bottom edge of viewport</li>
     *   </ul>
     */
    offset: function offset(elem) {
      elem = this.getRawNode(elem);

      var elemBCR = elem.getBoundingClientRect();
      return {
        width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
        height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
        top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
        left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
      };
    },

    /**
     * Provides offset distance to the closest scrollable ancestor
     * or viewport.  Accounts for border and scrollbar width.
     *
     * Right and bottom dimensions represent the distance to the
     * respective edge of the viewport element.  If the element
     * edge extends beyond the viewport, a negative value will be
     * reported.
     *
     * @param {element} elem - The element to get the viewport offset for.
     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
     * of the first scrollable element, default is false.
     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
     * be accounted for, default is true.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**top**: distance to the top content edge of viewport element</li>
     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
     *     <li>**left**: distance to the left content edge of viewport element</li>
     *     <li>**right**: distance to the right content edge of viewport element</li>
     *   </ul>
     */
    viewportOffset: function viewportOffset(elem, useDocument, includePadding) {
      elem = this.getRawNode(elem);
      includePadding = includePadding !== false ? true : false;

      var elemBCR = elem.getBoundingClientRect();
      var offsetBCR = { top: 0, left: 0, bottom: 0, right: 0 };

      var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
      var offsetParentBCR = offsetParent.getBoundingClientRect();

      offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
      offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
      if (offsetParent === $document[0].documentElement) {
        offsetBCR.top += $window.pageYOffset;
        offsetBCR.left += $window.pageXOffset;
      }
      offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
      offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

      if (includePadding) {
        var offsetParentStyle = $window.getComputedStyle(offsetParent);
        offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
        offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
        offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
        offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
      }

      return {
        top: Math.round(elemBCR.top - offsetBCR.top),
        bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
        left: Math.round(elemBCR.left - offsetBCR.left),
        right: Math.round(offsetBCR.right - elemBCR.right)
      };
    },

    /**
     * Provides an array of placement values parsed from a placement string.
     * Along with the 'auto' indicator, supported placement strings are:
     *   <ul>
     *     <li>top: element on top, horizontally centered on host element.</li>
     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
     *     <li>bottom: element on bottom, horizontally centered on host element.</li>
     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
     *     <li>left: element on left, vertically centered on host element.</li>
     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
     *     <li>right: element on right, vertically centered on host element.</li>
     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
     *   </ul>
     * A placement string with an 'auto' indicator is expected to be
     * space separated from the placement, i.e: 'auto bottom-left'  If
     * the primary and secondary placement values do not match 'top,
     * bottom, left, right' then 'top' will be the primary placement and
     * 'center' will be the secondary placement.  If 'auto' is passed, true
     * will be returned as the 3rd value of the array.
     *
     * @param {string} placement - The placement string to parse.
     *
     * @returns {array} An array with the following values
     * <ul>
     *   <li>**[0]**: The primary placement.</li>
     *   <li>**[1]**: The secondary placement.</li>
     *   <li>**[2]**: If auto is passed: true, else undefined.</li>
     * </ul>
     */
    parsePlacement: function parsePlacement(placement) {
      var autoPlace = PLACEMENT_REGEX.auto.test(placement);
      if (autoPlace) {
        placement = placement.replace(PLACEMENT_REGEX.auto, '');
      }

      placement = placement.split('-');

      placement[0] = placement[0] || 'top';
      if (!PLACEMENT_REGEX.primary.test(placement[0])) {
        placement[0] = 'top';
      }

      placement[1] = placement[1] || 'center';
      if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
        placement[1] = 'center';
      }

      if (autoPlace) {
        placement[2] = true;
      } else {
        placement[2] = false;
      }

      return placement;
    },

    /**
     * Provides coordinates for an element to be positioned relative to
     * another element.  Passing 'auto' as part of the placement parameter
     * will enable smart placement - where the element fits. i.e:
     * 'auto left-top' will check to see if there is enough space to the left
     * of the hostElem to fit the targetElem, if not place right (same for secondary
     * top placement).  Available space is calculated using the viewportOffset
     * function.
     *
     * @param {element} hostElem - The element to position against.
     * @param {element} targetElem - The element to position.
     * @param {string=} [placement=top] - The placement for the targetElem,
     *   default is 'top'. 'center' is assumed as secondary placement for
     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
     *   <ul>
     *     <li>top</li>
     *     <li>top-right</li>
     *     <li>top-left</li>
     *     <li>bottom</li>
     *     <li>bottom-left</li>
     *     <li>bottom-right</li>
     *     <li>left</li>
     *     <li>left-top</li>
     *     <li>left-bottom</li>
     *     <li>right</li>
     *     <li>right-top</li>
     *     <li>right-bottom</li>
     *   </ul>
     * @param {boolean=} [appendToBody=false] - Should the top and left values returned
     *   be calculated from the body element, default is false.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**top**: Value for targetElem top.</li>
     *     <li>**left**: Value for targetElem left.</li>
     *     <li>**placement**: The resolved placement.</li>
     *   </ul>
     */
    positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {
      hostElem = this.getRawNode(hostElem);
      targetElem = this.getRawNode(targetElem);

      // need to read from prop to support tests.
      var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
      var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

      placement = this.parsePlacement(placement);

      var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
      var targetElemPos = { top: 0, left: 0, placement: '' };

      if (placement[2]) {
        var viewportOffset = this.viewportOffset(hostElem, appendToBody);

        var targetElemStyle = $window.getComputedStyle(targetElem);
        var adjustedSize = {
          width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
          height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
        };

        placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' : placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' : placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' : placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' : placement[0];

        placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' : placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' : placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' : placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' : placement[1];

        if (placement[1] === 'center') {
          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
              placement[1] = 'left';
            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
              placement[1] = 'right';
            }
          } else {
            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
              placement[1] = 'top';
            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
              placement[1] = 'bottom';
            }
          }
        }
      }

      switch (placement[0]) {
        case 'top':
          targetElemPos.top = hostElemPos.top - targetHeight;
          break;
        case 'bottom':
          targetElemPos.top = hostElemPos.top + hostElemPos.height;
          break;
        case 'left':
          targetElemPos.left = hostElemPos.left - targetWidth;
          break;
        case 'right':
          targetElemPos.left = hostElemPos.left + hostElemPos.width;
          break;
      }

      switch (placement[1]) {
        case 'top':
          targetElemPos.top = hostElemPos.top;
          break;
        case 'bottom':
          targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
          break;
        case 'left':
          targetElemPos.left = hostElemPos.left;
          break;
        case 'right':
          targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
          break;
        case 'center':
          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
          } else {
            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
          }
          break;
      }

      targetElemPos.top = Math.round(targetElemPos.top);
      targetElemPos.left = Math.round(targetElemPos.left);
      targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

      return targetElemPos;
    },

    /**
    * Provides a way for positioning tooltip & dropdown
    * arrows when using placement options beyond the standard
    * left, right, top, or bottom.
    *
    * @param {element} elem - The tooltip/dropdown element.
    * @param {string} placement - The placement for the elem.
    */
    positionArrow: function positionArrow(elem, placement) {
      elem = this.getRawNode(elem);

      var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
      if (!innerElem) {
        return;
      }

      var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

      var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
      if (!arrowElem) {
        return;
      }

      var arrowCss = {
        top: '',
        bottom: '',
        left: '',
        right: ''
      };

      placement = this.parsePlacement(placement);
      if (placement[1] === 'center') {
        // no adjustment necessary - just reset styles
        angular.element(arrowElem).css(arrowCss);
        return;
      }

      var borderProp = 'border-' + placement[0] + '-width';
      var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

      var borderRadiusProp = 'border-';
      if (PLACEMENT_REGEX.vertical.test(placement[0])) {
        borderRadiusProp += placement[0] + '-' + placement[1];
      } else {
        borderRadiusProp += placement[1] + '-' + placement[0];
      }
      borderRadiusProp += '-radius';
      var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

      switch (placement[0]) {
        case 'top':
          arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'bottom':
          arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'left':
          arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'right':
          arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
          break;
      }

      arrowCss[placement[1]] = borderRadius;

      angular.element(arrowElem).css(arrowCss);
    }
  };
}]);
'use strict';

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
.factory('$$stackedMap', function () {
  return {
    createNew: function createNew() {
      var stack = [];

      return {
        add: function add(key, value) {
          stack.push({
            key: key,
            value: value
          });
        },
        get: function get(key) {
          for (var i = 0; i < stack.length; i++) {
            if (key === stack[i].key) {
              return stack[i];
            }
          }
        },
        keys: function keys() {
          var keys = [];
          for (var i = 0; i < stack.length; i++) {
            keys.push(stack[i].key);
          }
          return keys;
        },
        top: function top() {
          return stack[stack.length - 1];
        },
        remove: function remove(key) {
          var idx = -1;
          for (var i = 0; i < stack.length; i++) {
            if (key === stack[i].key) {
              idx = i;
              break;
            }
          }
          return stack.splice(idx, 1)[0];
        },
        removeTop: function removeTop() {
          return stack.splice(stack.length - 1, 1)[0];
        },
        length: function length() {
          return stack.length;
        }
      };
    }
  };
});
'use strict';

angular.module('ui.bootstrap', ['ui.bootstrap.modal', 'ui.bootstrap.tabs', 'ui.bootstrap.carousel', 'ui.bootstrap.dropdown', 'ui.bootstrap.typeahead', 'ui.bootstrap.pagination']);
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('httpInterceptor', httpInterceptor);

    function httpInterceptor($httpParamSerializer, $location, $q, $rootScope, apiUrl, blockUI) {
        var service = {
            response: response,
            request: request,
            responseError: responseError
        };

        function response(data) {
            return data;
        }

        function responseError(error) {

            blockUI.stop();

            switch (error.status) {
                case 406:
                    toastr.warning($rootScope.translate.pleaseSetNo);
                    $location.path('/').search('menu', 31);
                    break;
                case 404:
                    toastr.warning(error.data);
                    break;
                case 403:
                    toastr.warning($rootScope.translate.canNotAccess);
                    $location.path('/').search('menu', 31);
                    break;
                case 401:
                    if (sessionStorage.getItem('token')) {
                        if ($rootScope.translate) {
                            toastr.warning($rootScope.translate.tokenIsTimeout);
                        }
                    }
                    removeSsoInfo();
                    $location.path('/login').search({});
                    break;
                case 400:
                    toastr.warning(error.data.message);
                    break;
                case 303:
                    var isConfirm = confirm(error.data);
                    if (isConfirm) {
                        if (sessionStorage.getItem('token')) {
                            $location.path('/').search('menu', 1);
                        } else {
                            $location.path('/login').search({});
                        }
                    } else {
                        return $q.resolve(error);
                    }
                    break;

                case -1:

                    // 在 IOS APP 中停留一段時間
                    // 在按上一頁面就會產生 -1 的錯誤訊息
                    // 但此 error 不包含任何 data / message 資訊
                    // 所以就先這樣 避免進入 default 跳出錯誤訊息

                    break;

                default:

                    // post error message to server
                    var status = '',
                        data = '',
                        message = '';
                    if (error) {
                        if (error.statu) {
                            status = error.status;
                        }
                        if (error.data) {
                            data = error.data;
                            if (error.data.message) {
                                message = error.data.message;
                            }
                        }
                    }

                    var errorLog = '[httpInterceptor] status: ' + error.status + ', data: ' + error.data + ', message: ' + message;
                    postException(errorLog, apiUrl);

                    showSystemError();
                    break;
            }
            return $q.reject(error);
        }

        function request(config) {
            var contentType = _.get(config.headers, 'Content-Type');
            if (!_.startsWith(contentType, 'application/json')) {
                config.headers = {
                    'Content-Type': 'application/x-www-form-urlencoded'
                };
                config.transformRequest = function (data) {
                    return $httpParamSerializer(data);
                };
            }

            // config.headers["Accept-Language"] = sessionStorage.getItem("userLang");

            // if (sessionStorage.getItem('langCode')) {
            //     config.headers.LangCode = sessionStorage.getItem('langCode');
            // } else {
            //     config.headers.LangCode = getDefaultLangCode();
            //     sessionStorage.setItem('langCode', getDefaultLangCode());
            // }

            if (sessionStorage.getItem('langCode')) {
                config.headers.LangCode = sessionStorage.getItem('langCode');
                config.headers["Accept-Language"] = sessionStorage.getItem('userLang');
            } else {

                getDefaultUserLang(apiUrl.tsApi, navigator.systemLanguage).done(function (data) {

                    var userLang = data;
                    var langCode = getLangCode(userLang);
                    config.headers.LangCode = langCode;
                    sessionStorage.setItem('langCode', langCode);
                });
            }

            return config;
        }

        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('choicePerSerilNoModalController', choicePerSerilNoModalController);

    function choicePerSerilNoModalController($uibModal, data, $uibModalInstance) {
        var vm = this;
        vm.choiceSeirlNo = choiceSeirlNo;
        vm.data = data;

        function choiceSeirlNo(item) {
            return $uibModalInstance.close(item);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('contectModalController', contectModalController);

    function contectModalController($uibModalInstance, modalService, e2eService, headerService, $rootScope, loginService, iAmNotRobot, userData, $http, apiUrl) {
        var vm = this;
        vm.cancel = cancel;
        vm.autoFill = autoFill;
        vm.submit = submit;
        vm.iAmNotRobot = iAmNotRobot;

        init();

        function init() {
            vm.view = {
                show: false
            };
            vm.data = {};
            vm.isLogin = userData.isLogin;
            vm.data.name = userData.cName;
            vm.data.email = userData.email;

            if (!sessionStorage.getItem('token')) {
                //     loginService.getSsoInfo().then(function(data) {
                //         vm.data.name = sessionStorage.getItem('cName');
                //         vm.data.email = data.data.email;
                //         vm.isLogin = true;
                //     });
                vm.view.show = true;
            }
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function autoFill() {
            e2eService.contactMe(vm.data);
        }

        function specialKeywordVerification(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }

        function submit() {
            if (specialKeywordVerification(vm.data.name)) {
                toastr.warning($rootScope.translate.commonName + $rootScope.translate.specialKeywords);
                return false;
            } else if (specialKeywordVerification(vm.data.content)) {
                toastr.warning($rootScope.translate.commonContent + $rootScope.translate.specialKeywords);
                return false;
            }

            if (vm.isLogin) {
                //已登入狀態下，略過圖形驗證
                headerService.contactMe(vm.data).then(function () {
                    toastr.success($rootScope.translate.sendMailSuccess);
                    $uibModalInstance.dismiss('cancel');
                });
            } else {
                if (specialKeywordVerification(vm.login.inputVerify)) {
                    toastr.warning($rootScope.translate.validateCode + $rootScope.translate.specialKeywords);
                    return false;
                }

                if ($('#inputVerify').val().length == 4) {
                    var paramsData = {
                        name: vm.data.name,
                        email: vm.data.email,
                        content: vm.data.content,
                        inputVerify: $('#inputVerify').val().toUpperCase(),
                        isPass: $('#isPass').val(),
                        SecretKey: "1"
                    };

                    headerService.contactMe(paramsData).then(function (data) {

                        if (data) {
                            toastr.success($rootScope.translate.sendMailSuccess);
                            $uibModalInstance.dismiss('cancel');
                        } else {
                            toastr.warning($rootScope.translate.commonReCaptchaFail);
                        }
                    });
                } else {
                    toastr.warning($rootScope.translate.commonIncorrectFormat);
                }
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('courseDetailModalController', courseDetailModalController);

    function courseDetailModalController(modalService, $uibModalInstance, $q, $scope, enumService, trainingInnerService, courseItem, settingModel, $location, $anchorScroll, commonService, defaultTabIndex) {

        var vm = this;
        vm.isMobile = modalService.isMobile();
        vm.setPathUrl = setPathUrl;
        vm.goTop = goTop;
        vm.cancel = cancel;
        vm.enroll = enroll;
        vm.tabChange = tabChange;
        vm.sessionChoice = sessionChoice;
        vm.enum = {
            courseType: enumService.courseType
        };
        //===Main==
        init();
        //=========
        function init() {
            dataInit();
            logicInit();
            $scope.$on('emitExamSubmit', function () {
                enroll();
            });
        }

        function dataInit() {
            settingModel = settingModel || {};
            vm.data = {
                importCourse: courseItem || null, //.....理論上是清單列傳入的班次課程
                importCourseActivities: null, //..........傳入的班次課程包含學習動作(WS14)
                sessionItem: null, //.....................班次資料
                sessionDetail: null, //...................班次詳細資料
                courageItem: null, //.....................學程資料
                courageDetail: null, //...................學程詳細資料
                enrollQuestionItem: null, //..............報名前問卷
                enrollActivity: null, //..................報名問卷
                tabIndex: 0 //...........................畫面頁籤
            };
            vm.view = {
                enrollQuestionMode: settingModel.isEnroll || false,
                hasEnrollQuestion: false, //..............有報名前問卷
                contentCourage: false,
                contentCourse: false,
                pageLoad: false,
                couragePage: false, //.............學程頁面
                sessionPage: false //.............班次頁面
            };
        }
        function logicInit() {
            return sessionInit(vm.data.importCourse).then(function () {
                var selectActive = trainingInnerService.getSelectActive(vm.data.importCourse);
                return selectActive.then(function (data) {
                    //console.log("selectActiveResult:", data);
                    vm.data.importCourseActivities = data;
                });
            }).then(function () {
                vm.view.hasEnrollQuestion = vm.data.importCourseActivities.preSurveyItemId > 0;
                //console.log('hasQues:',vm.view.hasEnrollQuestion );
                if (vm.view.hasEnrollQuestion) {
                    vm.data.enrollActivity = {
                        type: '問卷',
                        itemId: vm.data.importCourseActivities.preSurveyItemId
                    };
                }
                vm.data.tabIndex = vm.view.enrollQuestionMode ? 2 : vm.data.tabIndex;
                Accordion();
            });
        }

        function sessionInit(importItem) {
            if (!importItem) {
                return;
            }
            var courseDetail = trainingInnerService.getCourseDetail(importItem);
            return courseDetail.then(function (data) {
                var courseDetailResult = detailFormat(data);
                switch (parseInt(importItem.courseType)) {
                    case vm.enum.courseType.courage:
                        //學程
                        vm.data.courageItem = angular.copy(importItem);
                        vm.data.courageDetail = courseDetailResult;
                        vm.view.couragePage = true;
                        vm.data.tabIndex = defaultTabIndex ? defaultTabIndex : 0; // 第一頁籤是 0，但客戶要求預設顯示第2頁籤
                        break;
                    default:
                        //非學程
                        vm.data.sessionItem = angular.copy(importItem);
                        vm.data.sessionDetail = courseDetailResult;
                        vm.view.sessionPage = true;
                        vm.data.tabIndex = defaultTabIndex ? defaultTabIndex : 1; // 第一頁籤是 1，但客戶要求預設顯示第2頁籤
                        break;
                }
            });
        }

        function detailFormat(sourceData) {
            var detailData = angular.copy(sourceData);
            if (!detailData) {
                return detailData;
            }
            //===========
            var brCheck = /(\r?\n)/g;
            _.forEach(detailData, function (value, key) {
                var isInt = value === parseInt(value, 10);
                var isString = typeof value === "string";
                if (isInt) {
                    var isAsNull = value < 0;

                    if (isAsNull) {
                        detailData[key] = null;
                    } else {
                        detailData[key] = value + '';
                    }
                } else if (isString) {
                    detailData[key] = value.replace(brCheck, "<br/>");
                }
            });
            //===========
            if (detailData.reference) {
                //檢查參考文件格式
                if (!angular.isArray(detailData.reference)) {
                    //參考文件必須是陣列
                    detailData.reference = null;
                }
                if (detailData.reference.length <= 0) {
                    //參考文件必須有內容
                    detailData.reference = null;
                }
            }
            return detailData;
        }
        function goTop() {
            $location.hash('PageTop');
            $anchorScroll();
            $location.hash('');
        }
        function enroll() {
            trainingInnerService.postSessionAction(vm.data.importCourse, 'Enroll').then(function (result) {
                if (!result) {
                    $uibModalInstance.dismiss('cancel');
                    return;
                }
                $uibModalInstance.close(result);
            });
        }
        function tabChange(index) {
            vm.view.couragePage = false;
            vm.view.sessionPage = false;
            switch (index) {
                case 0:
                    vm.view.couragePage = true;
                    vm.data.sessionItem = null;
                    vm.data.sessionDetail = null;
                    vm.data.tabIndex = 0;
                    break;
                case 1:
                    vm.view.sessionPage = true;
                    vm.data.tabIndex = 1;
                    break;
                case 2:
                    vm.data.tabIndex = 2;
                    break;
                default:
                    break;
            }
            // console.log("enter tabChange , index:", vm.data.tabIndex);
        }

        function sessionChoice(sessionItem) {
            // console.log("enter sessionChoice,sessionItem:", sessionItem);
            if (!sessionItem.courseType) {
                sessionItem.courseType = 1;
            }
            return sessionInit(sessionItem).then(function () {
                tabChange(1);
            });
        }
        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function setPathUrl(filePath) {
            var pathUrl = commonService.ctmsFilePath(filePath);
            return pathUrl;
        }
        //======Jquery====
        function Accordion() {
            $(document).off("click", ".accordion .title");

            $(document).on("click", ".accordion .title", function (j) {
                var dropDown = $(this).closest('.col-sm-12').find('p.acc-info');
                $(this).closest('.accordion').find('p.acc-info').not(dropDown).slideUp();

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).closest('.accordion').find('a.active').removeClass('active');
                    $(this).addClass('active');
                }

                dropDown.stop(false, true).slideToggle();

                j.preventDefault();
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('editPwdModalController', editPwdModalController);

    function editPwdModalController(loginService, sysCode, e2eService, $rootScope, $uibModalInstance, $route, $scope) {
        var vm = this;
        vm.submit = submit;
        vm.autoFill = autoFill;
        vm.cancel = cancel;

        // virtual keyboard start
        vm.showVirKey = showVirKey;
        vm.isShowVirKey = false;
        vm.textChanged = textChanged;
        vm.focusObj = null;
        vm.virData = null;

        // 針對哪個 input 使用動態鍵盤輸入
        vm.getFocusOldPwd = function () {
            vm.focusObj = "oldPwd";
            vm.virData = vm.data.oldPwd;
        };
        vm.getFocusNewPwd = function () {
            vm.focusObj = "newPwd";
            vm.virData = vm.data.newPwd;
        };
        vm.getFocusConfirmPwd = function () {
            vm.focusObj = "confirmPwd";
            vm.virData = vm.data.confirmPwd;
        };

        function textChanged(newPwd) {
            console.log("vm.focusObj:", vm.focusObj);
            var e = document.getElementById(vm.focusObj);
            e.value = newPwd;
            console.log("newPwd:", newPwd);
            var $e = angular.element(e);
            $e.triggerHandler('input');
        }

        function showVirKey() {
            if (vm.isShowVirKey) vm.isShowVirKey = false;else vm.isShowVirKey = true;
        }

        init();

        function init() {
            vm.data = {};
            loginService.getSsoInfo().then(function (data) {
                vm.data.userAccount = data.data.userAccount;
            });
        }

        function submit() {
            vm.confirmPwd = vm.data.newPwd == vm.data.oldPwd;
            if (!vm.confirmPwd) {
                vm.confirmPwd = vm.data.newPwd !== vm.data.confirmPwd;
            }

            if (!vm.confirmPwd) {
                loginService.setSsoParams(vm.data);
                loginService.modifyUserPassword(vm.data).then(function (data) {
                    if (data !== undefined) {
                        removeSsoInfo();
                        $route.reload();
                        toastr.success($rootScope.translate.commonEditPwdSuccess);
                        $uibModalInstance.close();
                    }
                });
            }
        }

        function autoFill() {
            e2eService.editPwdModal(vm.data);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('explanationModalController', explanationModalController);

    function explanationModalController($uibModalInstance, loginService) {
        var vm = this;
        vm.cancel = cancel;

        loginService.getPwdConstrain().then(function (data) {
            vm.data = data.data;
        });

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('forgetPwdModalController', forgetPwdModalController);

    function forgetPwdModalController($uibModalInstance, $uibModal, sysCode, loginService, $rootScope, e2eService, enumService, iAmNotRobot) {
        var vm = this;
        vm.sendMail = sendMail;
        vm.submit = submit;
        vm.cancel = cancel;
        vm.forgetAutoFill = forgetAutoFill;
        vm.iAmNotRobot = iAmNotRobot;

        onInit();

        function onInit() {
            vm.data = {};
            vm.state = 'typeAccount';
            vm.data.target = 1;
        }

        function specialKeywordVerificationUserAccount(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }

        function specialKeywordVerification(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }

        function sendMail() {

            if (specialKeywordVerificationUserAccount($('#inputUserAccount').val())) {
                toastr.warning($rootScope.translate.tsdgLoginAccount + $rootScope.translate.specialKeywords);
                return false;
            } else if (specialKeywordVerification($('#inputVerify').val())) {
                toastr.warning($rootScope.translate.validateCode + $rootScope.translate.specialKeywords);
                return false;
            }

            //console.log('sendMail recaptcha:',vm.reCaptcha);
            if ($('#inputVerify').val().length == 4) {
                //將登入帳號轉成小寫
                if (vm.data.userAccount.indexOf('@') >= 0) {
                    vm.data.userAccount = vm.data.userAccount.toLowerCase();
                }

                var params = {
                    userAccount: vm.data.userAccount,
                    sysCode: sysCode,
                    target: vm.data.target,
                    inputVerify: $('#inputVerify').val().toUpperCase(),
                    isPass: $('#isPass').val(),
                    SecretKey: "1"
                };

                loginService.forgetPWD(params).then(function (data) {

                    if (data) {
                        switch (parseInt(params.target)) {
                            case enumService.sendTarget.email:
                                // console.log(data);
                                toastr.success($rootScope.translate.commonAlreadySendMail);
                                break;
                            case enumService.sendTarget.sms:
                                toastr.success($rootScope.translate.commonAlreadySendSMS);
                                break;
                        }

                        return data;
                    }
                }).then(function (data) {
                    if (data && params.target !== enumService.sendTarget.email) {
                        vm.state = 'directEditPwd';
                    } else {
                        $uibModalInstance.dismiss('cancel');
                    }
                });
            } else {
                toastr.warning($rootScope.translate.commonReCaptchaFail);
            }
        }

        function submit() {

            vm.data.sysCode = sysCode;
            loginService.directModifyUserPassword(vm.data).then(function (data) {
                if (data) {
                    toastr.success($rootScope.translate.commonEditPwdSuccess);
                    $uibModalInstance.close('ok');
                }
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function forgetAutoFill() {
            e2eService.forgetPwd(vm.data);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('loginModalController', loginModalController);

    function loginModalController($rootScope, $scope, $uibModalInstance, loginService, $location, modalService, enumService, e2eService, mobileService, translateService, iAmNotRobot) {
        // console.log("iAmNotRobot:",iAmNotRobot);
        var vm = this;
        vm.isMobile = modalService.isMobile();
        vm.iAmNotRobot = iAmNotRobot;
        vm.cancel = cancel;
        vm.submit = submit;
        vm.autoFill = autoFill;
        vm.autoFill2 = autoFill2;
        vm.openForgetPwd = openForgetPwd;
        vm.openRegister = openRegister;
        vm.openExplanation = openExplanation;
        //vm.enableLogin = enableLogin;
        vm.deviceToken = deviceToken;

        // virtual kb need
        vm.isInitKeyboard = false;
        vm.showVirKey = showVirKey;
        vm.isShowVirKey = false;
        vm.pwdChanged = pwdChanged;
        vm.focusObj = null;
        vm.virData = null;

        // ------------------------
        // 針對哪個 input 使用動態鍵盤輸入
        vm.getFocusUserAccount = function () {
            vm.focusObj = "userAccount";
            //vm.virData = vm.login.userAccount;    //2019-09-23 修正focus：TypeError: 無法取得未定義或 Null 參考的屬性 'userAccount'
        };
        vm.getFocusUserPwd = function () {
            vm.focusObj = "userPwd";
            //vm.virData = vm.login.pwd;    //2019-09-23 修正focus：TypeError: 無法取得未定義或 Null 參考的屬性 'pwd'
        };
        vm.enableLogin = function () {
            enableLogin;
        };

        function pwdChanged(newPwd) {
            if (vm.focusObj == null) //2019-09-23 修正未指定focus造成錯誤：修正為NULL帶預設欄位為帳號
                vm.focusObj = "userAccount";

            var e = document.getElementById(vm.focusObj);
            e.value = newPwd;
            var $e = angular.element(e);
            $e.triggerHandler('input');
        }

        function showVirKey() {
            if (vm.isShowVirKey) vm.isShowVirKey = false;else vm.isShowVirKey = true;
        }

        // -----------------------

        // 測試是否有抓到 Device Token
        function deviceToken() {
            var myDeviceToken = "device token is empty";
            if (DEVICE_TOKEN) {
                myDeviceToken = DEVICE_TOKEN;
            }
            return myDeviceToken;
        }

        vm.view = {
            loginBefore: false
        };
        //讀入Google reCaptcha需要的key


        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function specialKeywordVerificationUserAccount(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }

        function specialKeywordVerification(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }

        function submit() {

            if (specialKeywordVerificationUserAccount(vm.login.userAccount)) {
                toastr.warning($rootScope.translate.tsdgLoginAccount + $rootScope.translate.specialKeywords);
                return false;
            } else if (specialKeywordVerification(vm.login.inputVerify)) {
                toastr.warning($rootScope.translate.validateCode + $rootScope.translate.specialKeywords);
                return false;
            }

            if ($('#inputVerify').val().length == 4) {

                var paramsLogin = {
                    userAccount: btoa(vm.login.userAccount),
                    pwd: btoa(vm.login.pwd),
                    inputVerify: $('#inputVerify').val().toUpperCase(),
                    isPass: $('#isPass').val(),
                    SecretKey: "1"
                };

                //console.log("submit pass");
                //已在SP中統一做大小寫比較
                // if (vm.login.userAccount.indexOf('@') >= 0){
                //    vm.login.userAccount = vm.login.userAccount.toLowerCase();
                // }
                // console.log('vm:', vm);
                // console.log('vm.login:', vm.login);
                // console.log(' vm.login.isPass:',  vm.login.isPass);

                loginService.login(paramsLogin).then(function (data) {
                    if (data) {
                        if (data.length > 1) {
                            var result = modalService.getChoicePerSerilNo(data);
                            result.result.then(function (item) {
                                var params = {
                                    pwd: vm.login.pwd,
                                    perSerilNo: item.PerserilNo,
                                    userAccount: item.UserAccount
                                };
                                loginService.loginByPerSerilNo(params).then(function (data) {
                                    if (data) {
                                        loginToEditOrHome(data);
                                        mobileService.postMobileInfo(data);
                                    }
                                });
                            });
                        } else {
                            //console.log('sso item:',data);
                            loginToEditOrHome(data);
                            mobileService.postMobileInfo(data);
                        }
                        vm.view.loginBefore = false;
                        return data;
                    } else if (!data === undefined) {
                        toastr.warning($rootScope.translate.commonReCaptchaFail);
                        //2023-07-13 Johnson 資安2023
                        vm.login.pwd = eval(function (p, a, c, k, e, r) {
                            e = String;if (!''.replace(/^/, String)) {
                                while (c--) {
                                    r[c] = k[c] || c;
                                }k = [function (e) {
                                    return r[e];
                                }];e = function e() {
                                    return '\\w+';
                                };c = 1;
                            };while (c--) {
                                if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                            }return p;
                        }('0;', 2, 1, 'null'.split('|'), 0, {}));
                    }
                }).catch(function () {
                    vm.view.loginBefore = false;
                });
            } else {
                toastr.warning($rootScope.translate.commonReCaptchaFail);
            }
        }

        /**
         * 判斷要登入到首頁或強制修改密碼頁
         * 
         * @param data (description)
         */
        function loginToEditOrHome(data) {
            setSsoInfo(data);
            $uibModalInstance.close('ok');
            $('#captcha iframe').empty().remove();
            translateService.getLanguage().then(function (languageItems) {
                var defaultLangItem = _.find(languageItems.data, {
                    selected: true
                });
                translateService.change(defaultLangItem);
                if (data.IsForce) {
                    sessionStorage.setItem('isForce', true);
                    $location.path('/login/forceEditPwd');
                } else if (data.isFirstLogin) {
                    modalService.phoneNumber();
                } else {
                    $location.path('/').search('menu', 31);
                }
            });
        }

        function autoFill() {
            vm.login = {};
            e2eService.login(vm.login);
            //debugger;
            //var result = loginService.QueryCaptcha();
        }
        function autoFill2() {
            vm.login = {};
            e2eService.login(vm.login);
            //debugger;
            //var result = loginService.chkCaptcha();
        }
        function openForgetPwd() {
            modalService.forgetPwd();
        }

        function openRegister() {
            modalService.register();
        }

        function openExplanation() {
            modalService.explanation();
        }

        function enableLogin() {
            vm.view.loginBefore = false;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('phoneNumberModalController', phoneNumberModalController);

    function phoneNumberModalController($uibModalInstance, loginService, $rootScope, $uibModalStack) {
        var vm = this;
        vm.cancel = cancel;
        vm.sendVerifyCodeFromPhone = sendVerifyCodeFromPhone;
        vm.checkVerify = checkVerify;
        vm.isSended = false;

        init();

        function init() {
            loginService.getSsoInfo().then(function (data) {
                vm.form1 = {
                    userAccount: data.data.userAccount,
                    tel: data.data.tel
                };
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function sendVerifyCodeFromPhone() {
            loginService.sendVerifyCodeFromPhone(vm.form1.userAccount).then(function () {
                toastr.success($rootScope.translate.commonAlreadySendSMS);
            });
            vm.isSended = true;
        }

        function checkVerify() {
            var param = {
                verifyCode: vm.form1.validCode,
                userAccount: vm.form1.userAccount,
                PhoneNumber: vm.form1.tel
            };
            loginService.verifyCodeCheckFromPhone(param).then(function (data) {
                if (data) {
                    toastr.success($rootScope.translate.alreadyVerifyPhoneNumber);
                    $uibModalStack.dismissAll();
                }
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('registerModalController', registerModalController);

    function registerModalController($uibModalInstance, loginService, $rootScope, sysCode, e2eService, blockUI, iAmNotRobot) {
        var vm = this;
        vm.cancel = cancel;
        vm.submit = submit;
        vm.autoFill = autoFill;
        vm.iAmNotRobot = iAmNotRobot;

        onInit();

        function onInit() {
            vm.data = {};
            vm.sendType = [{ id: 1, name: 'Email' }, { id: 2, name: $rootScope.translate.commonSMS }];
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function specialKeywordVerificationUserAccount(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }

        function specialKeywordVerification(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【\】【/】【<】【>】【'】【"】【(】【)】【%】【.】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            keyWord = keyWord.replace(/\\/g, "/");
            var pattern = new RegExp("[/\\/<>'\"()%.]");
            var result = false;
            for (var i = 0; i < keyWord.length; i++) {
                console.log('for keyWord:' + keyWord.substr(i, 1) + ' pattern:' + keyWord.substr(i, 1).replace(pattern, 'false'));
                if (keyWord.substr(i, 1).replace(pattern, 'false') == "false") {
                    result = true;
                }
            }
            return result;
        }

        function phoneKeywordVerification(keyWord) {
            /*2020-06-11 Johnson
            特殊字元 【0-9】
            問題單：2020/05/13  2020 APP滲透測試報告
            https://app.asana.com/0/742244134012369/1175524709436847
            */
            var result = false;
            var str = keyWord.replace(/[^0-9]/g, 'false');
            if (str.indexOf('false') != -1) result = true;

            return result;
        }

        function submit() {

            if (specialKeywordVerificationUserAccount(vm.data.email)) {
                toastr.warning($rootScope.translate.tsdgLoginAccount + $rootScope.translate.specialKeywords);
                return false;
            } else if (specialKeywordVerificationUserAccount(vm.data.cName)) {
                toastr.warning($rootScope.translate.tsdgName + $rootScope.translate.specialKeywords);
                return false;
            } else if (phoneKeywordVerification(vm.data.perTel)) {
                toastr.warning($rootScope.translate.commonMobile + $rootScope.translate.commonIncorrectFormat);
                return false;
            } else if (specialKeywordVerification(vm.login.inputVerify)) {
                toastr.warning($rootScope.translate.validateCode + $rootScope.translate.specialKeywords);
                return false;
            }

            // Block the user interface
            if ($('#inputVerify').val().length == 4) {
                blockUI.start();

                vm.data.target = 1;
                vm.data.sysCode = sysCode;

                var params = {
                    cName: vm.data.cName,
                    email: vm.data.email,
                    target: vm.data.target,
                    sysCode: vm.data.sysCode,
                    pwd: vm.data.pwd,
                    perTel: vm.data.perTel,
                    confirmPwd: vm.data.confirmPwd,
                    inputVerify: $('#inputVerify').val().toUpperCase(),
                    isPass: $('#isPass').val(),
                    SecretKey: "1"
                };

                loginService.registerOutsideUser(params).then(function (data) {
                    // Unblock the user interface
                    blockUI.stop();
                    if (data) {
                        toastr.success($rootScope.translate.commonAlreadySendMail);
                        $uibModalInstance.close('ok');
                    }
                });
            } else {
                toastr.warning($rootScope.translate.commonReCaptchaFail);
            }
        }

        function autoFill() {
            e2eService.register(vm.data);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('settingModalController', settingModalController);

    function settingModalController($uibModalInstance, loginService, $rootScope, modalService, viewModel, $q, headerService) {
        var vm = this;
        vm.cancel = cancel;
        vm.submit = submit;
        vm.openEditPwd = openEditPwd;
        vm.openPhoneNumber = openPhoneNumber;
        vm.setFontSize = setFontSize;
        vm.enableperTel = enableperTel;

        vm.view = {
            isEmployee: false,
            isperTel: true
        };

        init();

        function init() {
            vm.settings = viewModel;
            loginService.getSsoInfo().then(function (data) {
                vm.data = {
                    cName: data.data.cName,
                    perTel: data.data.tel
                };
                vm.view.isEmployee = data.data.isEmployee;
                vm.view.perTelcheck = data.data.tel;
                //判斷=1，顯示手機驗證碼按鈕  
                vm.view.moblieIsVerify = data.data.moblieIsVerify;

                enableperTel(data.data.tel);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function submit() {
            loginService.editUserProfile(vm.data);
            $uibModalInstance.dismiss('cancel');
        }

        function openEditPwd() {
            modalService.editPwd().result.then(function () {
                $uibModalInstance.dismiss('cancel');
            });
        }

        function openPhoneNumber() {
            modalService.phoneNumber();
        }

        function setFontSize(item) {
            headerService.setFontSize(item.sizeCode).then(function () {
                _.each(vm.settings.fontSizes, function (x) {
                    x.isSelected = false;
                });
                $rootScope.fontSize = item.sizeCode;
                item.isSelected = true;
            });
        }

        function enableperTel(tel) {
            if (tel === null) {
                vm.view.isperTel = false;
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('tsunBulletinMoreController', tsunBulletinMoreController);

    function tsunBulletinMoreController(viewModel, $location, bulletinService) {
        var vm = this;
        vm.redirect = redirect;
        vm.getNoticeMoreList = getNoticeMoreList;

        var bulletinGetByPaggerDto = {
            menuSerilNo: '',
            bulletinTypeSerilNo: '',
            PaggerChoice: 1,
            noticePage: 1
        };

        onInit();

        function onInit() {
            vm.data = viewModel.data;
        }

        function redirect(bulletinSerilNo) {
            $location.path('/tsu/bulletin/noticeDetail/' + bulletinSerilNo).search('menu', getMenuQueryString());
        }

        function getNoticeMoreList() {
            bulletinGetByPaggerDto.noticePage++;
            //2為通知中心的意思
            bulletinGetByPaggerDto.dataType = 2;
            setSiteCode(bulletinGetByPaggerDto);
            bulletinService.getTsunMoreList(bulletinGetByPaggerDto).then(function (data) {
                vm.data.notices.bulletins = _.concat(vm.data.notices.bulletins, data.data.notices.bulletins);
                vm.data.hasNoticeMore = data.data.hasNoticeMore;
            });
        }

        function setSiteCode(bulletinParam) {
            switch (vm.type) {
                case 'bulletin':
                    bulletinParam.siteCode = enumService.siteCode.hrOutside;
                    break;
                case 'notice':
                    bulletinParam.siteCode = enumService.siteCode.tsunOut;
                    break;
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('tsunBulletinNoticeDetailController', tsunBulletinNoticeDetailController);

    function tsunBulletinNoticeDetailController(viewModel) {
        var vm = this;
        vm.data = viewModel.data;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('trainingInnerService', trainingInnerService);

    function trainingInnerService(headerService, sysCode, enumService, $http, apiUrl, isTestMode, testData, $q, $rootScope, ctmsService, commonService, translateService) {
        var enumCourseType = enumService.courseType;
        var service = {
            getCourseLog: getCourseLog,
            getFinancial: getFinancial,
            getBankBook: getBankBook,
            getExterior: getExterior,
            getYears: getYears,
            getEffectives: getEffectives,
            postExterior: postExterior,
            getConfigSetting: getConfigSetting,
            getCourseItems: getCourseItems,
            getSelectActive: getSelectActive,
            getExternaltype: getExternaltype,
            getCurrency: getCurrency,
            getUnfinishedActivities: getUnfinishedActivities,
            getCertificateType: getCertificateType,
            getLicensesNames: getLicensesNames,
            postFinancial: postFinancial,
            getAuthorizedHours: getAuthorizedHours,
            postLearningRecord: postLearningRecord,
            postExamSurveyContent: postExamSurveyContent,
            getExamSurveyContent: getExamSurveyContent,
            getCourseDetail: getCourseDetail,
            getAuthorizedHoursCourse: getAuthorizedHoursCourse,
            postSessionAction: postSessionAction,
            getCourseListAll: getCourseListAll,
            getCourseList: getCourseList,
            getMenu: getMenu,
            getCollectionList: getCollectionList,
            addCollection: addCollection,
            delCollection: delCollection,
            hasEnrollQuestion: hasEnrollQuestion,
            loadLangs: loadLangs,
            getCarousel: getCarousel,
            checkCourseWithMenu: checkCourseWithMenu,
            checkItem: checkItem
        };
        return service;

        function getConfigSetting() {
            var newApiURL = apiUrl.tsApi + 'checkConfig';
            newApiURL = commonService.URLCheck(newApiURL);

            //2023-07-18 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}));
        }

        function getCourseLog(lang) {
            var params = {
                LanguageCode: lang,
                UserId: $rootScope.userInfo.userAccount,
                StartIndex: 1,
                EndIndex: 99999,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call MyFinishedActivities,params:", params);
            return ctmsService.MyFinishedActivities(params).then(function (data) {
                if (!data) {
                    return null;
                }
                _.forEach(data, function (item) {
                    item.LanguageCode = params.LanguageCode;
                });
                return data;
            });
        }

        // 取得待修項目資料
        function getUnfinishedActivities(lang) {
            var params = {
                LanguageCode: lang,
                UserId: $rootScope.userInfo.userAccount,
                tkn: sessionStorage.getItem('token')
            };
            //console.log("call MyUnfinishedActivities,params:", params);
            return ctmsService.MyUnfinishedActivities(params).then(function (data) {
                if (!data) {
                    return null;
                }
                _.forEach(data, function (item) {
                    item.LanguageCode = params.LanguageCode;
                });
                //console.log("MyUnfinishedActivities,data:", data);
                return data;
            });
        }

        // 取得課程詳細資訊
        function getCourseDetail(item) {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                CourseType: item.courseType,
                SessionId: item.sessionId,
                IsProgram: item.courseType === enumCourseType.courage ? 1 : 0,
                tkn: sessionStorage.getItem('token')
            };
            //console.log("call CourseSession,params:", params);
            return ctmsService.CourseSession(params).then(function (data) {
                if (!data) {
                    return null;
                }
                data.LanguageCode = params.LanguageCode;
                if (data.courses) {
                    _.forEach(data.courses, function (item) {
                        item.LanguageCode = params.LanguageCode;
                    });
                }
                return data;
            });
        }

        //取得課程行為清單
        function getSelectActive(item) {
            //console.log('active item:',item);
            var params = {
                LanguageCode: item.LanguageCode,
                UserId: $rootScope.userInfo.userAccount,
                SessionId: item.sessionId,
                IsProgram: item.courseType === enumCourseType.courage ? 1 : 0,
                tkn: sessionStorage.getItem('token')
            };
            if (isTestMode) {
                //為了要實踐簡單互動
                params.courseType = item.courseType;
            }
            // console.log("call EnrollmentAvailableAction,params:", params);
            return ctmsService.EnrollmentAvailableAction(params).then(function (data) {
                // console.log("EnrollmentAvailableAction result:", data);
                if (!data) {
                    return null;
                }
                data.LanguageCode = params.LanguageCode;
                _.forEach(data.lmsItems, function (item) {
                    item.LanguageCode = params.LanguageCode;
                });
                console.log('WS14 : EnrollmentAvailableAction result: ', data);
                return data;
            });
        }

        // 取得金融證照記錄
        function getFinancial(status) {
            var params = {
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: sessionStorage.getItem('userLang'),
                Status: status,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call FCCertificatedLicenseList,params:", params);
            // console.log("result :",ctmsService.FCCertificatedLicenseList(params));
            return ctmsService.FCCertificatedLicenseList(params);
        }

        // 取得證書認列時數
        function getAuthorizedHours() {
            var params = {
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: sessionStorage.getItem('userLang'),
                LicenseId: '-1',
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call FCAuthorizedHoursList,params:", params);
            return ctmsService.FCAuthorizedHoursList(params);
        }

        function getCourseItems(activityItem) {
            //取得課程教材
            var params = {
                ItemId: activityItem.itemId,
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: activityItem.LanguageCode,
                tkn: sessionStorage.getItem('token')
            };
            console.log("call CourseItem,params:", params);
            return ctmsService.CourseItem(params).then(function (data) {
                if (!data) {
                    return null;
                }
                data.LanguageCode = params.LanguageCode;
                data.AttachmentSerilNo = params.ItemId;
                console.log("getCourseItems :", data);
                return data;
            });
        }

        function getBankBook(year, lang) {
            var params = {
                UserId: $rootScope.userInfo.userAccount,
                Annual: year,
                LanguageCode: lang,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call MyTrainingPoint,params:", params);
            return ctmsService.MyTrainingPoint(params).then(function (data) {
                if (!data) {
                    return null;
                }
                var returnResult = {
                    bankBook: data.trainingPoints,
                    remainPoint: data.remainPoint,
                    LanguageCode: params.LanguageCode
                };
                if (new Date().getFullYear() + '' !== year + '') {
                    // 選擇的年份如果不是當前年份，則剩餘點數為0
                    returnResult.remainPoint = '0';
                }
                return returnResult;
            });
        }

        // 取得主辦單位
        function getExterior() {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                Type: 5, // 主辦單位
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call SysTypesList,params:", params);
            return ctmsService.SysTypesList(params);
        }

        // 取得證照有效狀態
        function getEffectives() {
            /*--(2016-09-29)
            如今日電話說明因 有效證照 為固定值
            由旭聯提供定義值即可 (無須透過API取得)
            已更新規格請見附件，謝謝！
            若有問題再麻煩與我聯繫喔，謝謝~
            Raina
            */
            var stateList = [{
                id: -1, // 數值無法為空，所以使用 -1
                name: $rootScope.translate.tsunFinacialCertificationStatusAll
            }, {
                id: 0,
                name: $rootScope.translate.tsunFinacialCertificationStatusInactive
            }, {
                id: 1,
                name: $rootScope.translate.tsunFinacialCertificationStatusActive
            }, {
                id: 2,
                name: $rootScope.translate.tsunFinacialCertificationStatusCancel
            }, {
                id: 3,
                name: $rootScope.translate.tsunFinacialCertificationStatusRemove
            }];
            return $q.when(stateList);
        }

        // 取得證照類別
        function getCertificateType() {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                Type: 2, // 證照類別
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call SysTypesList,params:", params);
            return ctmsService.SysTypesList(params);
        }

        // 依證照類別取得所有證照名稱
        function getLicensesNames(licenseCategoryId) {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                LicenseCategoryId: licenseCategoryId,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call FCLicenseList,params:", params);
            return ctmsService.FCLicenseList(params);
        }

        // 取得外訓種類
        function getExternaltype() {
            // var params = {
            //     LanguageCode: sessionStorage.getItem('userLang'),
            //     Type: 4, // 外訓種類
            //     tkn: sessionStorage.getItem('token')
            // };
            // // console.log("call SysTypesList,params:", params);
            // return ctmsService.SysTypesList(params);
            var result = [{
                //請選擇
                id: -1,
                name: $rootScope.translate.commonPleaseSelect,
                allowanceRate: 0,
                sortIndex: 0
            }, {
                //一般外訓
                id: 1,
                name: $rootScope.translate.tsunExternalType1,
                allowanceRate: 0,
                sortIndex: 1
            }, {
                //外語進修補助
                id: 2,
                name: $rootScope.translate.tsunExternalType2,
                allowanceRate: 50,
                sortIndex: 2
            }, {
                //電腦進修補助
                id: 3,
                name: $rootScope.translate.tsunExternalType3,
                allowanceRate: 50,
                sortIndex: 3
            }, {
                //考試補助
                id: 4,
                name: $rootScope.translate.tsunExternalType4,
                allowanceRate: 100,
                sortIndex: 4
            }, {
                //國外外訓
                id: 0,
                name: $rootScope.translate.tsunExternalType0,
                allowanceRate: 0,
                sortIndex: 5
            }];
            return result;
        }

        // 取得繳費幣別
        function getCurrency() {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                Type: 3, // 幣別
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call SysTypesList,params:", params);
            return ctmsService.SysTypesList(params);
        }

        // 取得問卷或測驗題目
        function getExamSurveyContent(sessionId, activityItem) {
            var params = {
                LanguageCode: activityItem.LanguageCode,
                SessionId: sessionId,
                ItemId: activityItem.itemId,
                UserId: $rootScope.userInfo.userAccount,
                tkn: sessionStorage.getItem('token')
            };
            if (isTestMode) {
                //為了要實踐簡單互動
                params.type = activityItem.type;
            }
            // console.log("call ExamSurveyContent,params:", params);
            return ctmsService.ExamSurveyContent(params).then(function (result) {
                // console.log("get ExamSurveyContent");
                result.LanguageCode = params.LanguageCode;
                return result;
            });
        }
        //回傳問卷或測驗填答
        function postExamSurveyContent(sessionId, examContent) {
            var params = {
                LanguageCode: examContent.LanguageCode,
                UserId: $rootScope.userInfo.userAccount,
                SessionId: sessionId,
                ExamHistoryId: examContent.examHistoryId,
                UserResponse: examContent.answers,
                ItemId: examContent.itemId,
                Finish: examContent.finish,
                tkn: sessionStorage.getItem('token')
            };
            if (isTestMode) {
                //為了要實踐簡單互動
                // console.log("postExamSurveyContent:", params);
                params.type = examContent.activeItemtype;
            }
            // console.log("call InteractionData,params:", params);
            return ctmsService.InteractionData(params).then(function (result) {
                // console.log("send InteractionData");
                return result;
            });
        }

        // 外訓申請 (POST
        function postExterior(item) {
            //console.log('postExterior item:',item);
            // var dateTimeString = getCourseDatesString(item);
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                UserId: $rootScope.userInfo.userAccount,
                CourseName: item.Name,
                OrganizationId: '',
                Type: item.type.id,
                Outline: item.Outline,
                CourseDate: '',
                CourseTime: '',
                Location: item.Place,
                Course_Cost_Currency_1: item.currency,
                Course_Cost_Amount_1: item.coursePrice,
                Transportation_Cost_Amount_1: item.travelPrice,
                Course_Converting_Amount_1: item.totalPrice,
                CourseRemark: item.Remark || '　',
                tkn: sessionStorage.getItem('token')
            };
            // 把上課日期串成字串
            // ex "2016/01/02,2016/01/04"
            _.forEach(item.dateSettingList, function (perDateStr) {
                _.forEach(perDateStr.innerDataDate, function (dateValue) {
                    if (params.CourseDate.length > 0) {
                        params.CourseDate += ',';
                    }
                    params.CourseDate += dateValue;
                });
                _.forEach(perDateStr.innerDataTime, function (timeValue) {
                    if (params.CourseTime.length > 0) {
                        params.CourseTime += ',';
                    }
                    params.CourseTime += timeValue;
                });
            });

            // 把主辦單位的 id 串起來 
            // ex "3,4,7,8"
            _.forEach(item.organizer, function (perOrg) {
                params.OrganizationId += perOrg.id + ',';
            });
            if (params.OrganizationId.length > 0) {
                // 去掉最後一個逗號
                params.OrganizationId = params.OrganizationId.substring(0, params.OrganizationId.length - 1);
            }
            //console.log("call ExternalTrainingApplication,params:", params);
            return ctmsService.ExternalTrainingApplication(params).then(function (result) {
                if (!result) {
                    return null;
                }
                toastr.success($rootScope.translate.tsunSuccessExternalApplication);
                return result;
            });
        }

        // 證照申請 (POST
        function postFinancial(item) {
            var params = {
                LanguageCode: sessionStorage.getItem('userLang'),
                UserId: $rootScope.userInfo.userAccount,
                LicenseId: item.licenses.id,
                AcquireDate: item.getDay,
                LicenseCode: item.licensesNO || '　',
                Comment: item.otherMark || '　',
                tkn: sessionStorage.getItem('token')
            };
            console.log("call FCCertificatedLicenseAdd,params:", params);
            return ctmsService.FCCertificatedLicenseAdd(params);
        }

        // 學習記錄回傳 (POST
        function postLearningRecord(item, isAlert) {
            //console.log('WS 21 Learning Record item :', item);
            if (!item) {
                return;
            }
            var params = {
                ItemId: item.ItemId,
                SessionId: item.SessionId,
                Duration: item.Duration,
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: item.LanguageCode,
                tkn: sessionStorage.getItem('token')
            };
            //console.log('item is not null');
            //測試關閉瀏覽器有無傳送資料
            // var str = 'return OK';
            // headerService.saveLearnLog(str);

            commonService.setCtmsParams(params);
            //console.log("call LearningRecordCommit,params:", params);
            return ctmsService.LearningRecordCommit(params).then(function (data) {
                // console.log("send LearningRecordCommit");
                if (!data) {
                    return null;
                }
                if (isAlert) {
                    toastr.success($rootScope.translate.tsunSendSuccess);
                }
                return true;
            }).catch(function (reason) {
                // chris: log for mobile
                //console.log('ctms-learning-record-error:',reason);
                postException('ctms-learning-record-error: ' + JSON.stringify(reason), apiUrl);
                throw reason;
            });
        }

        function getYears(minYear) {
            var thisYear = new Date().getFullYear();
            minYear = minYear || thisYear - 10;
            // console.log("getYears , minYear:", minYear);
            var years = [];
            for (var i = thisYear; i > thisYear - 10; i--) {
                if (i >= minYear) {
                    years.push(i);
                }
            }
            return years;
        }

        function getAuthorizedHoursCourse(item, lang) {
            var params = {
                LanguageCode: lang,
                UserId: $rootScope.userInfo.userAccount,
                LicenseId: item.licenseId,
                tkn: sessionStorage.getItem('token')
            };
            // console.log("call FCEnrollableActivities,params:", params);
            return ctmsService.FCEnrollableActivities(params).then(function (data) {
                if (!data) {
                    return null;
                }
                _.forEach(data, function (item) {
                    item.LanguageCode = params.LanguageCode;
                });
                return data;
            });
        }

        function postSessionAction(sessionItem, Action) {
            var params = {
                tkn: sessionStorage.getItem('token'),
                LanguageCode: sessionItem.LanguageCode,
                UserId: $rootScope.userInfo.userAccount,
                SessionId: sessionItem.sessionId,
                IsProgram: sessionItem.courseType === enumCourseType.courage ? 1 : 0,
                ActionType: Action
            };
            // console.log("call EnrollmentAction,params:", params);
            return ctmsService.EnrollmentAction(params).then(function (result) {
                if (!result) {
                    return null;
                }
                toastr.success($rootScope.translate.tsunSendSuccess);
                return result;
            });
        }

        function getMenu(langCode) {
            langCode = langCode || sessionStorage.getItem('langCode');
            //console.log("send tsapi.CourseList   langCode:", langCode);
            var newApiURL = apiUrl.tsApi + 'ctms/CourseCategory?langSerilNo=' + langCode;
            newApiURL = commonService.URLCheck(newApiURL);

            //2023-07-18 Johnson 資安2023
            return eval(function (p, a, c, k, e, r) {
                e = String;if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[c] = k[c] || c;
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('$0.1(2);', 3, 3, 'http|get|newApiURL'.split('|'), 0, {}));

            //2023-07-17 Johnson 資安2023
            //var csrfToken = sessionStorage.getItem('token');
            //return $http.get(newApiURL, csrfToken).then(function (result) {
            //    return result.data;
            //});
        }

        // 取得課程列表
        function getCourseList(classificationId, langCode) {
            //console.log("classificationId:", classificationId);
            var params = {
                UserId: $rootScope.userInfo.userAccount,
                LanguageCode: langCode,
                ClassificationId: parseInt(classificationId) || -1,
                CourseType: -1,
                tkn: sessionStorage.getItem('token')
            };
            //三個= 不會有作用，請保留2個就好
            if (classificationId == 0) {
                params.ClassificationId = 0;
            }
            //console.log(" params.ClassificationId:",  params.ClassificationId);

            //console.log("call PublishedActivity,params:", params);
            return ctmsService.PublishedActivity(params).then(function (data) {
                _.forEach(data, function (item) {
                    item.LanguageCode = params.LanguageCode;
                });
                return data;
            });
        }

        function getCourseListAll(catagoryId) {
            //取得不分語系的課程清單
            return loadLangs().then(function (langs) {
                //console.log('langs:',langs);
                var coursePromist = [];
                _.forEach(langs, function (lang) {
                    // console.log('lang:', lang.langCode)
                    // console.log( getCourseList(catagoryId, lang.langCode))
                    coursePromist.push(getCourseList(catagoryId, lang.langCode));
                });
                return $q.all(coursePromist).then(function (data) {
                    var resultCourseList = []; //全部課程清單
                    if (data) {
                        _.forEach(data, function (courseList) {
                            //console.log('courseList:', courseList)
                            courseList = _.orderBy(courseList, ['courseTime'], ['desc']);
                            Array.prototype.push.apply(resultCourseList, courseList);
                        });
                        resultCourseList = _.uniqBy(resultCourseList, function (courseItem) {
                            return courseItem.sessionId;
                        });
                    }
                    return resultCourseList;
                });
            }).then(function (resultCourseList) {
                //final
                //console.log('resultCourseList:', resultCourseList);
                return resultCourseList;
            });
        }

        function checkCourseWithMenu(courseList /*, catagoryList*/) {
            var resultCourseList = courseList;

            //filter將排序打亂了，先將filter拿掉
            // console.log("courseList:", courseList);
            // console.log("catagoryList:", catagoryList);

            // _.forEach(catagoryList, function(catagoryItem) {

            //     var courseIsValid = _.filter(courseList, function(courseItem) {
            //         var checkResult;
            //         //console.log("catagoryItem:", catagoryItem);
            //         //console.log("courseItem:", courseItem);
            //         checkResult = parseInt(courseItem.classificationId) === parseInt(catagoryItem.categoryId);
            //         return checkResult;
            //     });

            //     //console.log("courseIsValid:", courseIsValid);
            //     Array.prototype.push.apply(resultCourseList, courseIsValid);
            // });

            //console.log("resultCourseList:", resultCourseList);
            resultCourseList = _.uniqBy(resultCourseList, function (courseItem) {
                return courseItem.sessionId;
            });
            return $q.when(resultCourseList);
        }

        function getCollectionList(langCode) {
            var params = {
                sysCode: sysCode,
                tkn: sessionStorage.getItem('token'),
                sysLang: langCode || null
            };
            return $http.post(apiUrl.tsApi + 'Collection/GetList', params).then(function (data) {
                //console.log('user course data:',data.data.collectionList);
                if (!data) {
                    return null;
                }
                return data.data.collectionList;
            });
        }

        function addCollection(sessionItem) {
            var params = {
                sysCode: sysCode,
                tkn: sessionStorage.getItem('token'),
                collectionSessionId: sessionItem.sessionId,
                langSerilNo: sessionStorage.getItem('langCode'),
                sysLang: sessionStorage.getItem('langCode')
            };
            return $http.post(apiUrl.tsApi + 'Collection/Save', params).then(function (result) {
                toastr.success(result.data);
            });
        }

        function delCollection(sessionItem, isAlert) {
            var params = {
                sysCode: sysCode,
                tkn: sessionStorage.getItem('token'),
                collectionSessionId: sessionItem.sessionId,
                sysLang: sessionStorage.getItem('langCode')
            };
            return $http.post(apiUrl.tsApi + 'Collection/Del', params).then(function (result) {
                if (isAlert) {
                    toastr.success(result.data);
                }
            });
        }

        function hasEnrollQuestion(item) {
            return getSelectActive(item).then(function (data) {
                if (!data) {
                    return null;
                }
                return data.preSurveyItemId > 0;
            });
        }

        function loadLangs() {
            return translateService.getLanguage().then(function (data) {
                if (!data) {
                    return null;
                }
                return _.orderBy(data.data, ['selected', 'langSerilNo'], ['desc', 'asc']);
            });
        }

        function getCarousel(activeType) {
            var param = {};
            var postUrl = '';
            commonService.setParams(param);
            switch (activeType) {
                case 3:
                    postUrl = apiUrl.tsApi + 'ActiveHotRecommend/PostSmallCourse';
                    break;
                default:
                    postUrl = apiUrl.tsApi + 'ActiveHotRecommend/postHotRecommend';
                    break;
            }
            return $http.post(postUrl, param).then(function (data) {
                if (!data) {
                    return null;
                }
                return data.data;
            });
        }

        function checkItem(item) {
            var params = {
                attachmentSerilNo: item.AttachmentSerilNo,
                fileUrl: item.fileUrl,
                tkn: sessionStorage.getItem('token')
            };

            return $http.post(apiUrl.tsApi + 'ctms/ItemCheck', params);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('visualpageController', visualpageController);

    function visualpageController(viewModel, menuService, commonService, apiUrl, sysCode, bulletinService, headerService) {
        var vm = this;
        vm.showSelected = showSelected;
        vm.download = download;
        vm.menuAlterClick = menuAlterClick;
        init();

        function init() {
            vm.data = viewModel.data;
            vm.view = viewInit();
            vm.localValue = localValueInit();
            treeInit();
            menuAlterInit();
            $(document).trigger('visualPageInited', {});
        }

        function viewInit() {
            var result = {};

            return result;
        }

        function localValueInit() {
            var result = {
                menuAlterNodes: [],
                selectedMenuText: '',
                selectedMenuIndex: 0
            };
            return result;
        }

        function showSelected(node) {
            if (node.url) {
                menuService.redirectUrl(node);
            }
        }

        function treeInit() {
            vm.treeOptions = {
                nodeChildren: "children",
                dirSelectable: false
            };
        }

        function menuAlterInit() {
            vm.localValue.menuAlterNodes = [];
            _.forEach(vm.data.treeView, function (treeNode) {
                treeNodeView(treeNode, '');
            });

            //以visualPage的ID來判斷選擇到的MenuLangName
            var menuNo = getMenuQueryString();
            //console.log("menuNo:", menuNo);
            var menuSelectedIndex = 0;
            for (var i = 0; i <= vm.localValue.menuAlterNodes.length - 1; i++) {
                if (vm.localValue.menuAlterNodes[i].menuSerilNo === menuNo) {
                    menuSelectedIndex = i;
                }
            }
            menuAlterClick(menuSelectedIndex, true);
            return;
            //======
            function treeNodeView(treeNode, preSymbol) {
                var _preSymbol = '　' + (preSymbol || '');
                treeNode.isEmptyUrl = false;
                treeNode.url = treeNode.url || '';
                if (treeNode.url.length < 1) {
                    treeNode.isEmptyUrl = true;
                }
                treeNode.menuAlterText = _preSymbol + treeNode.menuLangName;
                //======
                vm.localValue.menuAlterNodes.push(treeNode);
                if (!treeNode.children) {
                    treeNode.children = [];
                }
                _.forEach(treeNode.children, function (treeNodeChild) {
                    treeNodeView(treeNodeChild, _preSymbol);
                });
            }
        }

        function menuAlterClick(index, isInit) {
            var targetNode = vm.localValue.menuAlterNodes[index];
            //====
            var isError = !targetNode;
            //====
            if (isError) {
                vm.localValue.selectedMenuText = "";
                vm.localValue.selectedMenuIndex = 0;
            } else if (targetNode.isEmptyUrl) {
                return;
            } else {
                vm.localValue.selectedMenuText = targetNode.menuLangName;
                vm.localValue.selectedMenuIndex = index;
            }
            if (!isInit) {
                menuService.redirectUrl(targetNode);
            }
            return;
        }

        function download(url, fileName) {
            console.log('url:', url);
            console.log('fileName:', fileName);
            if (url && fileName) {
                var params = {
                    menuSerilNo: getMenuQueryString(),
                    MenuClickAttachmentId: url
                };
                commonService.setParams(params);
                headerService.saveMenuClickingAttachment(params);
                //先確認是否是把浮水印拿掉就不能下載(在PC上)
                // if (commonService.getFileType(url) !== 'pdf') {

                // } else {
                //     var param = {
                //         wholeUrl: url,
                //         fileName: fileName,
                //     };
                //     bulletinService.donwloadStampForUrl(param);
                // }

                //因應ios無法打開可視化中的PDF，ios另行處理
                window.open(url, '_self');
                // if (DEVICE_TYPE !== null && DEVICE_TYPE.toLowerCase() === 'ios') {
                //     window.open(url,'_self');
                // } else {
                //     window.open(url);
                // }
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('tsunHomeController', tsunHomeController);

    function tsunHomeController(viewModel) {
        var vm = this;

        init();

        function init() {
            vm.data = viewModel.data;
        }
    }
})();
'use strict';

angular.module('ui.bootstrap.carousel', []).controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
  var self = this,
      slides = self.slides = $scope.slides = [],
      SLIDE_DIRECTION = 'uib-slideDirection',
      currentIndex = -1,
      currentInterval,
      isPlaying,
      bufferedTransitions = [];
  self.currentSlide = null;
  var destroyed = false;
  self.addSlide = function (slide, element) {
    slide.$element = element;
    slides.push(slide);
    //if this is the first slide or the slide is set to active, select it
    if (slides.length === 1 || slide.active) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      self.select(slides[slides.length - 1]);
      if (slides.length === 1) {
        $scope.play();
      }
    } else {
      slide.active = false;
    }
  };

  self.getCurrentIndex = function () {
    if (self.currentSlide && angular.isDefined(self.currentSlide.index)) {
      return +self.currentSlide.index;
    }
    return currentIndex;
  };

  self.next = $scope.next = function () {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(getSlideByIndex(newIndex), 'next');
  };

  self.prev = $scope.prev = function () {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(getSlideByIndex(newIndex), 'prev');
  };

  self.removeSlide = function (slide) {
    if (angular.isDefined(slide.index)) {
      slides.sort(function (a, b) {
        return +a.index > +b.index;
      });
    }

    var bufferedIndex = bufferedTransitions.indexOf(slide);
    if (bufferedIndex !== -1) {
      bufferedTransitions.splice(bufferedIndex, 1);
    }
    //get the index of the slide inside the carousel
    var index = slides.indexOf(slide);
    slides.splice(index, 1);
    $timeout(function () {
      if (slides.length > 0 && slide.active) {
        if (index >= slides.length) {
          self.select(slides[index - 1]);
        } else {
          self.select(slides[index]);
        }
      } else if (currentIndex > index) {
        currentIndex--;
      }
    });

    //clean the currentSlide when no more slide
    if (slides.length === 0) {
      self.currentSlide = null;
      clearBufferedTransitions();
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function (nextSlide, direction) {
    var nextIndex = $scope.indexOfSlide(nextSlide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide && nextSlide !== self.currentSlide && !$scope.$currentTransition) {
      goNext(nextSlide, nextIndex, direction);
    } else if (nextSlide && nextSlide !== self.currentSlide && $scope.$currentTransition) {
      bufferedTransitions.push(nextSlide);
      nextSlide.active = false;
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function (slide) {
    return angular.isDefined(slide.index) ? +slide.index : slides.indexOf(slide);
  };

  $scope.isActive = function (slide) {
    return self.currentSlide === slide;
  };

  $scope.pause = function () {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function () {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $scope.$on('$destroy', function () {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function (noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  function clearBufferedTransitions() {
    while (bufferedTransitions.length) {
      bufferedTransitions.shift();
    }
  }

  function getSlideByIndex(index) {
    if (angular.isUndefined(slides[index].index)) {
      return slides[index];
    }
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, { direction: direction, active: true });
    angular.extend(self.currentSlide || {}, { direction: direction, active: false });
    if ($animate.enabled($element) && !$scope.$currentTransition && slide.$element && self.slides.length > 1) {
      slide.$element.data(SLIDE_DIRECTION, slide.direction);
      if (self.currentSlide && self.currentSlide.$element) {
        self.currentSlide.$element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slide.$element, function (element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
          if (bufferedTransitions.length) {
            var nextSlide = bufferedTransitions.pop();
            var nextIndex = $scope.indexOfSlide(nextSlide);
            var nextDirection = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
            clearBufferedTransitions();

            goNext(nextSlide, nextIndex, nextDirection);
          }
        }
      });
    }

    self.currentSlide = slide;
    currentIndex = index;

    //every time you change slides, reset the timer
    restartTimer();
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
      clearBufferedTransitions();
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}]).directive('uibCarousel', function () {
  return {
    transclude: true,
    replace: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'directive/ui-bootstrap/carousel/carousel.html';
    },
    scope: {
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&',
      showBar: '=',
      showArrow: '='
    }
  };
}).directive('uibSlide', function () {
  return {
    require: '^uibCarousel',
    transclude: true,
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'directive/ui-bootstrap/carousel/slide.html';
    },
    scope: {
      active: '=?',
      actual: '=?',
      index: '=?'
    },
    link: function link(scope, element, attrs, carouselCtrl) {
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function () {
        carouselCtrl.removeSlide(scope);
      });

      scope.$watch('active', function (active) {
        if (active) {
          carouselCtrl.select(scope);
        }
      });
    }
  };
}).animation('.item', ['$animateCss', function ($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function beforeAddClass(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, { addClass: directionClass }).start().done(removeClassFn);

        return function () {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function beforeRemoveClass(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, { addClass: directionClass }).start().done(removeClassFn);

        return function () {
          stopped = true;
        };
      }
      done();
    }
  };
}]);
'use strict';

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
.factory('$$debounce', ['$timeout', function ($timeout) {
  return function (callback, debounceTime) {
    var timeoutPromise;

    return function () {
      var self = this;
      var args = Array.prototype.slice.call(arguments);
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }

      timeoutPromise = $timeout(function () {
        callback.apply(self, args);
      }, debounceTime);
    };
  };
}]);
'use strict';

angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap', 'ui.bootstrap.position'])

/**
 * A helper, internal data structure that stores all references attached to key
 */
.factory('$$multiMap', function () {
    return {
        createNew: function createNew() {
            var map = {};

            return {
                entries: function entries() {
                    return Object.keys(map).map(function (key) {
                        return {
                            key: key,
                            value: map[key]
                        };
                    });
                },
                get: function get(key) {
                    return map[key];
                },
                hasKey: function hasKey(key) {
                    return !!map[key];
                },
                keys: function keys() {
                    return Object.keys(map);
                },
                put: function put(key, value) {
                    if (!map[key]) {
                        map[key] = [];
                    }

                    map[key].push(value);
                },
                remove: function remove(key, value) {
                    var values = map[key];

                    if (!values) {
                        return;
                    }

                    var idx = values.indexOf(value);

                    if (idx !== -1) {
                        values.splice(idx, 1);
                    }

                    if (!values.length) {
                        delete map[key];
                    }
                }
            };
        }
    };
})

/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
.provider('$uibResolve', function () {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function (resolver) {
        this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function ($injector, $q) {
        var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
        return {
            resolve: function resolve(invocables, locals, parent, self) {
                if (resolver) {
                    return resolver.resolve(invocables, locals, parent, self);
                }

                var promises = [];

                angular.forEach(invocables, function (value) {
                    if (angular.isFunction(value) || angular.isArray(value)) {
                        promises.push($q.resolve($injector.invoke(value)));
                    } else if (angular.isString(value)) {
                        promises.push($q.resolve($injector.get(value)));
                    } else {
                        promises.push($q.resolve(value));
                    }
                });

                return $q.all(promises).then(function (resolves) {
                    var resolveObj = {};
                    var resolveIter = 0;
                    angular.forEach(invocables, function (value, key) {
                        resolveObj[key] = resolves[resolveIter++];
                    });

                    return resolveObj;
                });
            }
        };
    }];
})

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
.directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack', function ($animate, $injector, $modalStack) {
    return {
        replace: true,
        templateUrl: 'directive/ui-bootstrap/modal/backdrop.html',
        compile: function compile(tElement, tAttrs) {
            tElement.addClass(tAttrs.backdropClass);
            return linkFn;
        }
    };

    function linkFn(scope, element, attrs) {
        if (attrs.modalInClass) {
            $animate.addClass(element, attrs.modalInClass);

            scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                var done = setIsAsync();
                if (scope.modalOptions.animation) {
                    $animate.removeClass(element, attrs.modalInClass).then(done);
                } else {
                    done();
                }
            });
        }
    }
}]).directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document', function ($modalStack, $q, $animateCss, $document) {
    return {
        scope: {
            index: '@'
        },
        replace: true,
        transclude: true,
        templateUrl: function templateUrl(tElement, tAttrs) {
            return tAttrs.templateUrl || 'directive/ui-bootstrap/modal/window.html';
        },
        link: function link(scope, element, attrs) {
            element.addClass(attrs.windowClass || '');
            element.addClass(attrs.windowTopClass || '');
            scope.size = attrs.size;
            scope.taiClass = [];
            if (attrs.taiClass) {
                angular.forEach(attrs.taiClass.split(','), function (item) {
                    scope.taiClass.push(item);
                });
            }

            scope.close = function (evt) {

                var modal = $modalStack.getTop();

                // 如果是手機且關閉最後一個 Modal 時候執行
                if (!modal && DEVICE_TYPE) {
                    var param = {};
                    var method = "closepopup";
                    appCallback(method, param);
                }

                if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && evt.target === evt.currentTarget) {
                    evt.preventDefault();
                    evt.stopPropagation();
                    $modalStack.dismiss(modal.key, 'backdrop click');
                }
            };

            // moved from template to fix issue #2280
            element.on('click', scope.close);

            // This property is only added to the scope for the purpose of detecting when this directive is rendered.
            // We can detect that by using this property in the template associated with this directive and then use
            // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
            scope.$isRendered = true;

            // Deferred object that will be resolved when this modal is render.
            var modalRenderDeferObj = $q.defer();
            // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
            // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
            attrs.$observe('modalRender', function (value) {
                if (value === 'true') {

                    // 如果是手機且彈跳 Modal 時候執行
                    if (DEVICE_TYPE) {
                        var param = {};
                        var method = "popup";
                        appCallback(method, param);
                    }

                    modalRenderDeferObj.resolve();
                }
            });

            modalRenderDeferObj.promise.then(function () {
                var animationPromise = null;

                if (attrs.modalInClass) {
                    animationPromise = $animateCss(element, {
                        addClass: attrs.modalInClass
                    }).start();

                    scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
                        var done = setIsAsync();
                        $animateCss(element, {
                            removeClass: attrs.modalInClass
                        }).start().then(done);
                    });
                }

                $q.when(animationPromise).then(function () {
                    // Notify {@link $modalStack} that modal is rendered.
                    var modal = $modalStack.getTop();
                    if (modal) {
                        $modalStack.modalRendered(modal.key);
                    }

                    /**
                     * If something within the freshly-opened modal already has focus (perhaps via a
                     * directive that causes focus). then no need to try and focus anything.
                     */
                    if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
                        var inputWithAutofocus = element[0].querySelector('[autofocus]');
                        /**
                         * Auto-focusing of a freshly-opened modal element causes any child elements
                         * with the autofocus attribute to lose focus. This is an issue on touch
                         * based devices which will show and then hide the onscreen keyboard.
                         * Attempts to refocus the autofocus element via JavaScript will not reopen
                         * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
                         * the modal element if the modal does not contain an autofocus element.
                         */
                        if (inputWithAutofocus) {
                            inputWithAutofocus.focus();
                        } else {
                            element[0].focus();
                        }
                    }
                });
            });
        }
    };
}]).directive('uibModalAnimationClass', function () {
    return {
        compile: function compile(tElement, tAttrs) {
            if (tAttrs.modalAnimation) {
                tElement.addClass(tAttrs.uibModalAnimationClass);
            }
        }
    };
}).directive('uibModalTransclude', function () {
    return {
        link: function link(scope, element, attrs, controller, transclude) {
            transclude(scope.$parent, function (clone) {
                element.empty();
                element.append(clone);
            });
        }
    };
}).factory('$uibModalStack', ['$animate', '$animateCss', '$document', '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition', function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
    var OPENED_MODAL_CLASS = 'modal-open';
    var backdropDomEl, backdropScope;
    var openedWindows = $$stackedMap.createNew();
    var openedClasses = $$multiMap.createNew();
    var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
    };
    var topModalIndex = 0;
    var previousTopOpenedModal = null;

    //Modal focus behavior
    var tabableSelector = 'a[href], area[href], input:not([disabled]), ' + 'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' + 'iframe, object, embed, *[tabindex], *[contenteditable=true]';
    var scrollbarPadding;

    function isVisible(element) {
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }

    function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
            if (openedWindows.get(opened[i]).value.backdrop) {
                topBackdropIndex = i;
            }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
            topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
    }

    $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
        if (backdropScope) {
            backdropScope.index = newBackdropIndex;
        }
    });

    function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
            topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
            var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
            openedClasses.remove(modalBodyClass, modalInstance);
            appendToElement.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
            if (scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
                if (scrollbarPadding.originalRight) {
                    appendToElement.css({ paddingRight: scrollbarPadding.originalRight + 'px' });
                } else {
                    appendToElement.css({ paddingRight: '' });
                }
                scrollbarPadding = null;
            }
            toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
            elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
            appendToElement.focus();
        }
    }

    // Add or remove "windowTopClass" from the top window in the stack
    function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
            modalWindow = openedWindows.top().value;
            modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
    }

    function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
            var backdropScopeRef = backdropScope;
            removeAfterAnimate(backdropDomEl, backdropScope, function () {
                backdropScopeRef = null;
            });
            backdropDomEl = undefined;
            backdropScope = undefined;
        }
    }

    function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function setIsAsync() {
            if (!asyncDeferred) {
                asyncDeferred = $q.defer();
                asyncPromise = asyncDeferred.promise;
            }

            return function asyncDone() {
                asyncDeferred.resolve();
            };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
            if (afterAnimating.done) {
                return;
            }
            afterAnimating.done = true;

            $animate.leave(domEl).then(function () {
                domEl.remove();
                if (closedDeferred) {
                    closedDeferred.resolve();
                }
            });

            scope.$destroy();
            if (done) {
                done();
            }
        }
    }

    $document.on('keydown', keydownListener);

    $rootScope.$on('$destroy', function () {
        $document.off('keydown', keydownListener);
    });

    function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
            return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
            switch (evt.which) {
                case 27:
                    {
                        if (modal.value.keyboard) {
                            evt.preventDefault();
                            $rootScope.$apply(function () {
                                $modalStack.dismiss(modal.key, 'escape key press');
                            });
                        }
                        break;
                    }
                case 9:
                    {
                        var list = $modalStack.loadFocusElementList(modal);
                        var focusChanged = false;
                        if (evt.shiftKey) {
                            if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                                focusChanged = $modalStack.focusLastFocusableElement(list);
                            }
                        } else {
                            if ($modalStack.isFocusInLastItem(evt, list)) {
                                focusChanged = $modalStack.focusFirstFocusableElement(list);
                            }
                        }

                        if (focusChanged) {
                            evt.preventDefault();
                            evt.stopPropagation();
                        }

                        break;
                    }
            }
        }
    }

    $modalStack.open = function (modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
            modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();
        openedWindows.add(modalInstance, {
            deferred: modal.deferred,
            renderDeferred: modal.renderDeferred,
            closedDeferred: modal.closedDeferred,
            modalScope: modal.scope,
            backdrop: modal.backdrop,
            keyboard: modal.keyboard,
            openedClass: modal.openedClass,
            windowTopClass: modal.windowTopClass,
            animation: modal.animation,
            appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (!appendToElement.length) {
            throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
        }

        if (currBackdropIndex >= 0 && !backdropDomEl) {
            backdropScope = $rootScope.$new(true);
            backdropScope.modalOptions = modal;
            backdropScope.index = currBackdropIndex;
            backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
            backdropDomEl.attr('backdrop-class', modal.backdropClass);
            if (modal.animation) {
                backdropDomEl.attr('modal-animation', 'true');
            }
            $compile(backdropDomEl)(backdropScope);
            $animate.enter(backdropDomEl, appendToElement);
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
            'template-url': modal.windowTemplateUrl,
            'window-class': modal.windowClass,
            'window-top-class': modal.windowTopClass,
            'size': modal.size,
            'index': topModalIndex,
            'animate': 'animate',
            'tai-class': modal.taiClass
        }).html(modal.content);
        if (modal.animation) {
            angularDomEl.attr('modal-animation', 'true');
        }

        scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
        if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            appendToElement.css({ paddingRight: scrollbarPadding.right + 'px' });
        }
        appendToElement.addClass(modalBodyClass);
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;

        // 解決表單有時在IE無法輸入問題
        fixIeNotAbleToInput('.modal');
    };

    function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
    }

    $modalStack.close = function (modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
            modalWindow.value.modalScope.$$uibDestructionScheduled = true;
            modalWindow.value.deferred.resolve(result);
            removeModalWindow(modalInstance, modalWindow.value.modalOpener);
            return true;
        }
        return !modalWindow;
    };

    $modalStack.dismiss = function (modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
            modalWindow.value.modalScope.$$uibDestructionScheduled = true;
            modalWindow.value.deferred.reject(reason);
            removeModalWindow(modalInstance, modalWindow.value.modalOpener);
            return true;
        }
        return !modalWindow;
    };

    $modalStack.dismissAll = function (reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
            topModal = this.getTop();
        }
    };

    $modalStack.getTop = function () {
        return openedWindows.top();
    };

    $modalStack.modalRendered = function (modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
            modalWindow.value.renderDeferred.resolve();
        }
    };

    $modalStack.focusFirstFocusableElement = function (list) {
        if (list.length > 0) {
            list[0].focus();
            return true;
        }
        return false;
    };

    $modalStack.focusLastFocusableElement = function (list) {
        if (list.length > 0) {
            list[list.length - 1].focus();
            return true;
        }
        return false;
    };

    $modalStack.isModalFocused = function (evt, modalWindow) {
        if (evt && modalWindow) {
            var modalDomEl = modalWindow.value.modalDomEl;
            if (modalDomEl && modalDomEl.length) {
                return (evt.target || evt.srcElement) === modalDomEl[0];
            }
        }
        return false;
    };

    $modalStack.isFocusInFirstItem = function (evt, list) {
        if (list.length > 0) {
            return (evt.target || evt.srcElement) === list[0];
        }
        return false;
    };

    $modalStack.isFocusInLastItem = function (evt, list) {
        if (list.length > 0) {
            return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
    };

    $modalStack.loadFocusElementList = function (modalWindow) {
        if (modalWindow) {
            var modalDomE1 = modalWindow.value.modalDomEl;
            if (modalDomE1 && modalDomE1.length) {
                var elements = modalDomE1[0].querySelectorAll(tabableSelector);
                return elements ? Array.prototype.filter.call(elements, function (element) {
                    return isVisible(element);
                }) : elements;
            }
        }
    };

    return $modalStack;
}]).provider('$uibModal', function () {
    var $modalProvider = {
        options: {
            animation: true,
            backdrop: true, //can also be false or 'static'
            keyboard: true
        },
        $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack', function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
            var $modal = {};

            function getTemplatePromise(options) {
                return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);
            }

            var promiseChain = null;
            $modal.getPromiseChain = function () {
                return promiseChain;
            };

            $modal.open = function (modalOptions) {
                var modalResultDeferred = $q.defer();
                var modalOpenedDeferred = $q.defer();
                var modalClosedDeferred = $q.defer();
                var modalRenderDeferred = $q.defer();
                //prepare an instance of a modal to be injected into controllers and returned to a caller
                var modalInstance = {
                    result: modalResultDeferred.promise,
                    opened: modalOpenedDeferred.promise,
                    closed: modalClosedDeferred.promise,
                    rendered: modalRenderDeferred.promise,
                    close: function close(result) {
                        return $modalStack.close(modalInstance, result);
                    },
                    dismiss: function dismiss(reason) {
                        return $modalStack.dismiss(modalInstance, reason);
                    }
                };

                //merge and clean up options
                modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
                modalOptions.resolve = modalOptions.resolve || {};
                modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

                //verify options
                if (!modalOptions.template && !modalOptions.templateUrl) {
                    throw new Error('One of template or templateUrl options is required.');
                }

                var templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);

                function resolveWithTemplate() {
                    return templateAndResolvePromise;
                }

                // Wait for the resolution of the existing promise chain.
                // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
                // Then add to $modalStack and resolve opened.
                // Finally clean up the chain variable if no subsequent modal has overwritten it.
                var samePromise;
                samePromise = promiseChain = $q.all([promiseChain]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {
                    var providedScope = modalOptions.scope || $rootScope;

                    var modalScope = providedScope.$new();
                    modalScope.$close = modalInstance.close;
                    modalScope.$dismiss = modalInstance.dismiss;

                    modalScope.$on('$destroy', function () {
                        if (!modalScope.$$uibDestructionScheduled) {
                            modalScope.$dismiss('$uibUnscheduledDestruction');
                        }
                    });

                    var ctrlInstance,
                        ctrlInstantiate,
                        ctrlLocals = {};

                    //controllers
                    if (modalOptions.controller) {
                        ctrlLocals.$scope = modalScope;
                        ctrlLocals.$uibModalInstance = modalInstance;
                        angular.forEach(tplAndVars[1], function (value, key) {
                            ctrlLocals[key] = value;
                        });

                        // the third param will make the controller instantiate later,private api
                        // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                        ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true);
                        if (modalOptions.controllerAs) {
                            ctrlInstance = ctrlInstantiate.instance;

                            if (modalOptions.bindToController) {
                                ctrlInstance.$close = modalScope.$close;
                                ctrlInstance.$dismiss = modalScope.$dismiss;
                                angular.extend(ctrlInstance, providedScope);
                            }

                            ctrlInstance = ctrlInstantiate();

                            modalScope[modalOptions.controllerAs] = ctrlInstance;
                        } else {
                            ctrlInstance = ctrlInstantiate();
                        }

                        if (angular.isFunction(ctrlInstance.$onInit)) {
                            ctrlInstance.$onInit();
                        }
                    }

                    $modalStack.open(modalInstance, {
                        scope: modalScope,
                        deferred: modalResultDeferred,
                        renderDeferred: modalRenderDeferred,
                        closedDeferred: modalClosedDeferred,
                        content: tplAndVars[0],
                        animation: modalOptions.animation,
                        backdrop: modalOptions.backdrop,
                        keyboard: modalOptions.keyboard,
                        backdropClass: modalOptions.backdropClass,
                        windowTopClass: modalOptions.windowTopClass,
                        windowClass: modalOptions.windowClass,
                        windowTemplateUrl: modalOptions.windowTemplateUrl,
                        size: modalOptions.size,
                        openedClass: modalOptions.openedClass,
                        appendTo: modalOptions.appendTo,
                        taiClass: modalOptions.taiClass
                    });
                    modalOpenedDeferred.resolve(true);
                }, function resolveError(reason) {
                    modalOpenedDeferred.reject(reason);
                    modalResultDeferred.reject(reason);
                })['finally'](function () {
                    if (promiseChain === samePromise) {
                        promiseChain = null;
                    }
                });

                return modalInstance;
            };

            return $modal;
        }]
    };

    return $modalProvider;
});
'use strict';

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging']).controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
      rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
      forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
      boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
      pageLabel = angular.isDefined($attrs.pageLabel) ? function (idx) {
    return $scope.$parent.$eval($attrs.pageLabel, { $page: idx });
  } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1,
        endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) {
          //need ellipsis for all options unless range is too close to beginning
          var previousPageSet = makePage(startPage - 1, '...', false);
          pages.unshift(previousPageSet);
        }
        if (boundaryLinkNumbers) {
          if (startPage === 3) {
            //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) {
          //need ellipsis for all options unless range is too close to end
          var nextPageSet = makePage(endPage + 1, '...', false);
          pages.push(nextPageSet);
        }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) {
            //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function () {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}]).constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: '<<',
  previousText: '<',
  nextText: '>',
  lastText: '>>',
  rotate: true,
  forceEllipses: false
}).directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled: '='
    },
    require: ['uibPagination', '?ngModel'],
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'directive/ui-bootstrap/pagination/pagination.html';
    },
    replace: true,
    link: function link(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0],
          ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);
'use strict';

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function ($parse) {
  return {
    create: function create(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function (ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function () {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function (value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function (newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function () {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function () {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function (page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function (key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function () {
        return $scope.page === 1;
      };

      $scope.noNext = function () {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function () {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function () {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);
'use strict';

angular.module('ui.bootstrap.tabs', []).controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
      oldIndex;
  ctrl.tabs = [];
  ctrl.select = function (index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isNumber(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function (t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isNumber(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ? index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function (val) {
    if (angular.isNumber(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function () {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}]).directive('uibTabset', function () {
  return {
    transclude: true,
    replace: true,
    scope: {
      isNohover: '@'
    },
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'directive/ui-bootstrap/tabs/tabset.html';
    },
    link: function link(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
      if (angular.isUndefined(attrs.active)) {
        scope.active = 0;
      }
    }
  };
}).directive('uibTab', ['$parse', function ($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'directive/ui-bootstrap/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
      //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function controller() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function link(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function (value) {
          scope.disabled = !!value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function (t) {
            return t.index;
          })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function (evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function () {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}]).directive('uibTabHeadingTransclude', function () {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function link(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
}).directive('uibTabContentTransclude', function () {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function link(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function (contents) {
        angular.forEach(contents, function (node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (node.hasAttribute('uib-tab-heading') || node.hasAttribute('data-uib-tab-heading') || node.hasAttribute('x-uib-tab-heading') || node.tagName.toLowerCase() === 'uib-tab-heading' || node.tagName.toLowerCase() === 'data-uib-tab-heading' || node.tagName.toLowerCase() === 'x-uib-tab-heading' || node.tagName.toLowerCase() === 'uib:tab-heading');
  }
});
'use strict';

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
.factory('uibTypeaheadParser', ['$parse', function ($parse) {
  //                      00000111000000000000022200000000000000003333333333333330000000000044000
  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
  return {
    parse: function parse(input) {
      var match = input.match(TYPEAHEAD_REGEXP);
      if (!match) {
        throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' + ' but got "' + input + '".');
      }

      return {
        itemName: match[3],
        source: $parse(match[4]),
        viewMapper: $parse(match[2] || match[1]),
        modelMapper: $parse(match[1])
      };
    }
  };
}]).controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser', function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
  var HOT_KEYS = [9, 13, 27, 38, 40];
  var eventDebounceTime = 200;
  var modelCtrl, ngModelOptions;
  //SUPPORTED ATTRIBUTES (OPTIONS)

  //minimal no of characters that needs to be entered before typeahead kicks-in
  var minLength = originalScope.$eval(attrs.typeaheadMinLength);
  if (!minLength && minLength !== 0) {
    minLength = 1;
  }

  originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
    minLength = !newVal && newVal !== 0 ? 1 : newVal;
  });

  //minimal wait time after last character typed before typeahead kicks-in
  var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

  //should it restrict model values to the ones selected from the popup only?
  var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
  originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
    isEditable = newVal !== false;
  });

  //binding to a variable that indicates if matches are being retrieved asynchronously
  var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

  //a callback executed when a match is selected
  var onSelectCallback = $parse(attrs.typeaheadOnSelect);

  //should it select highlighted popup value when losing focus?
  var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

  //binding to a variable that indicates if there were no results after the query is completed
  var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

  var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

  var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

  var appendTo = attrs.typeaheadAppendTo ? originalScope.$eval(attrs.typeaheadAppendTo) : null;

  var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

  //If input matches an item of the list exactly, select it automatically
  var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

  //binding to a variable that indicates if dropdown is open
  var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

  var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

  //INTERNAL VARIABLES

  //model setter executed upon match selection
  var parsedModel = $parse(attrs.ngModel);
  var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
  var $setModelValue = function $setModelValue(scope, newValue) {
    if (angular.isFunction(parsedModel(originalScope)) && ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
      return invokeModelSetter(scope, { $$$p: newValue });
    }

    return parsedModel.assign(scope, newValue);
  };

  //expressions used by typeahead
  var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

  var hasFocus;

  //Used to avoid bug in iOS webview where iOS keyboard does not fire
  //mousedown & mouseup events
  //Issue #3699
  var selected;

  //create a child scope for the typeahead directive so we are not polluting original scope
  //with typeahead-specific data (matches, query etc.)
  var scope = originalScope.$new();
  var offDestroy = originalScope.$on('$destroy', function () {
    scope.$destroy();
  });
  scope.$on('$destroy', offDestroy);

  // WAI-ARIA
  var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(new Date().getTime() * 10000);
  element.attr({
    'aria-autocomplete': 'list',
    'aria-expanded': false,
    'aria-owns': popupId
  });

  var inputsContainer, hintInputElem;
  //add read-only input to show hint
  if (showHint) {
    inputsContainer = angular.element('<div></div>');
    inputsContainer.css('position', 'relative');
    element.after(inputsContainer);
    hintInputElem = element.clone();
    hintInputElem.attr('placeholder', '');
    hintInputElem.attr('tabindex', '-1');
    hintInputElem.val('');
    hintInputElem.css({
      'position': 'absolute',
      'top': '0px',
      'left': '0px',
      'border-color': 'transparent',
      'box-shadow': 'none',
      'opacity': 1,
      'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
      'color': '#999'
    });
    element.css({
      'position': 'relative',
      'vertical-align': 'top',
      'background-color': 'transparent'
    });
    inputsContainer.append(hintInputElem);
    hintInputElem.after(element);
  }

  //pop-up element used to display matches
  var popUpEl = angular.element('<div uib-typeahead-popup></div>');
  popUpEl.attr({
    id: popupId,
    matches: 'matches',
    active: 'activeIdx',
    select: 'select(activeIdx, evt)',
    'move-in-progress': 'moveInProgress',
    query: 'query',
    position: 'position',
    'assign-is-open': 'assignIsOpen(isOpen)',
    debounce: 'debounceUpdate'
  });
  //custom item template
  if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
    popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
  }

  if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
    popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
  }

  var resetHint = function resetHint() {
    if (showHint) {
      hintInputElem.val('');
    }
  };

  var resetMatches = function resetMatches() {
    scope.matches = [];
    scope.activeIdx = -1;
    element.attr('aria-expanded', false);
    resetHint();
  };

  var getMatchId = function getMatchId(index) {
    return popupId + '-option-' + index;
  };

  // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
  // This attribute is added or removed automatically when the `activeIdx` changes.
  scope.$watch('activeIdx', function (index) {
    if (index < 0) {
      element.removeAttr('aria-activedescendant');
    } else {
      element.attr('aria-activedescendant', getMatchId(index));
    }
  });

  var inputIsExactMatch = function inputIsExactMatch(inputValue, index) {
    if (scope.matches.length > index && inputValue) {
      return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
    }

    return false;
  };

  var getMatchesAsync = function getMatchesAsync(inputValue, evt) {
    var locals = { $viewValue: inputValue };
    isLoadingSetter(originalScope, true);
    isNoResultsSetter(originalScope, false);
    $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
      //it might happen that several async queries were in progress if a user were typing fast
      //but we are interested only in responses that correspond to the current view value
      var onCurrentRequest = inputValue === modelCtrl.$viewValue;
      if (onCurrentRequest && hasFocus) {
        if (matches && matches.length > 0) {
          scope.activeIdx = focusFirst ? 0 : -1;
          isNoResultsSetter(originalScope, false);
          scope.matches.length = 0;

          //transform labels
          for (var i = 0; i < matches.length; i++) {
            locals[parserResult.itemName] = matches[i];
            scope.matches.push({
              id: getMatchId(i),
              label: parserResult.viewMapper(scope, locals),
              model: matches[i]
            });
          }

          scope.query = inputValue;
          //position pop-up with matches - we need to re-calculate its position each time we are opening a window
          //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
          //due to other elements being rendered
          recalculatePosition();

          element.attr('aria-expanded', true);

          //Select the single remaining option if user input matches
          if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
              $$debounce(function () {
                scope.select(0, evt);
              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
            } else {
              scope.select(0, evt);
            }
          }

          if (showHint) {
            var firstLabel = scope.matches[0].label;
            if (angular.isString(inputValue) && inputValue.length > 0 && firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
              hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
            } else {
              hintInputElem.val('');
            }
          }
        } else {
          resetMatches();
          isNoResultsSetter(originalScope, true);
        }
      }
      if (onCurrentRequest) {
        isLoadingSetter(originalScope, false);
      }
    }, function () {
      resetMatches();
      isLoadingSetter(originalScope, false);
      isNoResultsSetter(originalScope, true);
    });
  };

  // bind events only if appendToBody params exist - performance feature
  if (appendToBody) {
    angular.element($window).on('resize', fireRecalculating);
    $document.find('body').on('scroll', fireRecalculating);
  }

  // Declare the debounced function outside recalculating for
  // proper debouncing
  var debouncedRecalculate = $$debounce(function () {
    // if popup is visible
    if (scope.matches.length) {
      recalculatePosition();
    }

    scope.moveInProgress = false;
  }, eventDebounceTime);

  // Default progress type
  scope.moveInProgress = false;

  function fireRecalculating() {
    if (!scope.moveInProgress) {
      scope.moveInProgress = true;
      scope.$digest();
    }

    debouncedRecalculate();
  }

  // recalculate actual position and set new values to scope
  // after digest loop is popup in right position
  function recalculatePosition() {
    scope.position = appendToBody ? $position.offset(element) : $position.position(element);
    scope.position.top += element.prop('offsetHeight');
  }

  //we need to propagate user's query so we can higlight matches
  scope.query = undefined;

  //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
  var timeoutPromise;

  var scheduleSearchWithTimeout = function scheduleSearchWithTimeout(inputValue) {
    timeoutPromise = $timeout(function () {
      getMatchesAsync(inputValue);
    }, waitTime);
  };

  var cancelPreviousTimeout = function cancelPreviousTimeout() {
    if (timeoutPromise) {
      $timeout.cancel(timeoutPromise);
    }
  };

  resetMatches();

  scope.assignIsOpen = function (isOpen) {
    isOpenSetter(originalScope, isOpen);
  };

  scope.select = function (activeIdx, evt) {
    //called from within the $digest() cycle
    var locals = {};
    var model, item;

    selected = true;
    locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
    model = parserResult.modelMapper(originalScope, locals);
    $setModelValue(originalScope, model);
    modelCtrl.$setValidity('editable', true);
    modelCtrl.$setValidity('parse', true);

    onSelectCallback(originalScope, {
      $item: item,
      $model: model,
      $label: parserResult.viewMapper(originalScope, locals),
      $event: evt
    });

    resetMatches();

    //return focus to the input element if a match was selected via a mouse click event
    // use timeout to avoid $rootScope:inprog error
    if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
      $timeout(function () {
        element[0].focus();
      }, 0, false);
    }
  };

  //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
  element.on('keydown', function (evt) {
    //typeahead is open and an "interesting" key was pressed
    if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
      return;
    }

    /**
     * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
     * or
     * shift + tab is pressed to bring focus to the previous element
     * then clear the results
     */
    if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13) || evt.which === 9 && !!evt.shiftKey) {
      resetMatches();
      scope.$digest();
      return;
    }

    evt.preventDefault();
    var target;
    switch (evt.which) {
      case 9:
      case 13:
        scope.$apply(function () {
          if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
            $$debounce(function () {
              scope.select(scope.activeIdx, evt);
            }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
        break;
      case 27:
        evt.stopPropagation();

        resetMatches();
        originalScope.$digest();
        break;
      case 38:
        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
        scope.$digest();
        target = popUpEl.find('li')[scope.activeIdx];
        target.parentNode.scrollTop = target.offsetTop;
        break;
      case 40:
        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
        scope.$digest();
        target = popUpEl.find('li')[scope.activeIdx];
        target.parentNode.scrollTop = target.offsetTop;
        break;
    }
  });

  element.bind('focus', function (evt) {
    hasFocus = true;
    if (minLength === 0 && !modelCtrl.$viewValue) {
      $timeout(function () {
        getMatchesAsync(modelCtrl.$viewValue, evt);
      }, 0);
    }
  });

  element.bind('blur', function (evt) {
    if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
      selected = true;
      scope.$apply(function () {
        if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
          $$debounce(function () {
            scope.select(scope.activeIdx, evt);
          }, scope.debounceUpdate.blur);
        } else {
          scope.select(scope.activeIdx, evt);
        }
      });
    }
    if (!isEditable && modelCtrl.$error.editable) {
      modelCtrl.$setViewValue();
      // Reset validity as we are clearing
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);
      element.val('');
    }
    hasFocus = false;
    selected = false;
  });

  // Keep reference to click handler to unbind it.
  var dismissClickHandler = function dismissClickHandler(evt) {
    // Issue #3973
    // Firefox treats right click as a click on document
    if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
      resetMatches();
      if (!$rootScope.$$phase) {
        originalScope.$digest();
      }
    }
  };

  $document.on('click', dismissClickHandler);

  originalScope.$on('$destroy', function () {
    $document.off('click', dismissClickHandler);
    if (appendToBody || appendTo) {
      $popup.remove();
    }

    if (appendToBody) {
      angular.element($window).off('resize', fireRecalculating);
      $document.find('body').off('scroll', fireRecalculating);
    }
    // Prevent jQuery cache memory leak
    popUpEl.remove();

    if (showHint) {
      inputsContainer.remove();
    }
  });

  var $popup = $compile(popUpEl)(scope);

  if (appendToBody) {
    $document.find('body').append($popup);
  } else if (appendTo) {
    angular.element(appendTo).eq(0).append($popup);
  } else {
    element.after($popup);
  }

  this.init = function (_modelCtrl, _ngModelOptions) {
    modelCtrl = _modelCtrl;
    ngModelOptions = _ngModelOptions;

    scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);

    //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
    //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
    modelCtrl.$parsers.unshift(function (inputValue) {
      hasFocus = true;

      if (minLength === 0 || inputValue && inputValue.length >= minLength) {
        if (waitTime > 0) {
          cancelPreviousTimeout();
          scheduleSearchWithTimeout(inputValue);
        } else {
          getMatchesAsync(inputValue);
        }
      } else {
        isLoadingSetter(originalScope, false);
        cancelPreviousTimeout();
        resetMatches();
      }

      if (isEditable) {
        return inputValue;
      }

      if (!inputValue) {
        // Reset in case user had typed something previously.
        modelCtrl.$setValidity('editable', true);
        return null;
      }

      modelCtrl.$setValidity('editable', false);
      return undefined;
    });

    modelCtrl.$formatters.push(function (modelValue) {
      var candidateViewValue, emptyViewValue;
      var locals = {};

      // The validity may be set to false via $parsers (see above) if
      // the model is restricted to selected values. If the model
      // is set manually it is considered to be valid.
      if (!isEditable) {
        modelCtrl.$setValidity('editable', true);
      }

      if (inputFormatter) {
        locals.$model = modelValue;
        return inputFormatter(originalScope, locals);
      }

      //it might happen that we don't have enough info to properly render input value
      //we need to check for this situation and simply return model value if we can't apply custom formatting
      locals[parserResult.itemName] = modelValue;
      candidateViewValue = parserResult.viewMapper(originalScope, locals);
      locals[parserResult.itemName] = undefined;
      emptyViewValue = parserResult.viewMapper(originalScope, locals);

      return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
    });
  };
}]).directive('uibTypeahead', function () {
  return {
    controller: 'UibTypeaheadController',
    require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
    link: function link(originalScope, element, attrs, ctrls) {
      ctrls[2].init(ctrls[0], ctrls[1]);
    }
  };
}).directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
  return {
    scope: {
      matches: '=',
      query: '=',
      active: '=',
      position: '&',
      moveInProgress: '=',
      select: '&',
      assignIsOpen: '&',
      debounce: '&'
    },
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.popupTemplateUrl || 'directive/ui-bootstrap/typeahead/typeahead-popup.html';
    },
    link: function link(scope, element, attrs) {
      scope.templateUrl = attrs.templateUrl;

      scope.isOpen = function () {
        var isDropdownOpen = scope.matches.length > 0;
        scope.assignIsOpen({ isOpen: isDropdownOpen });
        return isDropdownOpen;
      };

      scope.isActive = function (matchIdx) {
        return scope.active === matchIdx;
      };

      scope.selectActive = function (matchIdx) {
        scope.active = matchIdx;
      };

      scope.selectMatch = function (activeIdx, evt) {
        var debounce = scope.debounce();
        if (angular.isNumber(debounce) || angular.isObject(debounce)) {
          $$debounce(function () {
            scope.select({ activeIdx: activeIdx, evt: evt });
          }, angular.isNumber(debounce) ? debounce : debounce['default']);
        } else {
          scope.select({ activeIdx: activeIdx, evt: evt });
        }
      };
    }
  };
}]).directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
  return {
    scope: {
      index: '=',
      match: '=',
      query: '='
    },
    link: function link(scope, element, attrs) {
      var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'directive/ui-bootstrap/typeahead/typeahead-match.html';
      $templateRequest(tplUrl).then(function (tplContent) {
        var tplEl = angular.element(tplContent.trim());
        element.replaceWith(tplEl);
        $compile(tplEl)(scope);
      });
    }
  };
}]).filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
  var isSanitizePresent;
  isSanitizePresent = $injector.has('$sanitize');

  function escapeRegexp(queryToEscape) {
    // Regex: capture the whole query string and replace it with the string that will be used to match
    // the results, for example if the capture is "a" the result will be \a
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }

  function containsHtml(matchItem) {
    return (/<.*>/g.test(matchItem)
    );
  }

  return function (matchItem, query) {
    if (!isSanitizePresent && containsHtml(matchItem)) {
      $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
    }
    matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
    if (!isSanitizePresent) {
      matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
    }
    return matchItem;
  };
}]);
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('confirmDialogController', confirmDialogController);

    function confirmDialogController($uibModal, $uibModalInstance, config, $rootScope, blockUI) {
        var vm = this;
        //==Main==
        onInit();
        //========

        function onInit() {
            vm.data = dataInit();
            vm.view = viewInit();
            vm.event = eventInit();
            vm.style = styleInit();
            //=========
            vm.view.hasTitle = !!vm.data.confirmTitle;
            vm.view.hasContent = !!vm.data.confirmContent;
            vm.style.titleStyle = { padding: '10px', 'word-break': 'break-word' };
            vm.style.contentStyle = { padding: '10px', 'word-break': 'break-word' };
            vm.style.footerStyle = { padding: '10px', 'word-break': 'break-word' };
            vm.isBusy = false;
        }
        function dataInit() {
            config = config || {};
            //=====
            var result = {
                confirmTitle: config.confirmTitle || '', //..........................................詢問標題
                confirmContent: config.confirmContent || '', //......................................詢問內容
                textButtonOk: config.textButtonOk || $rootScope.translate.tsunButtonConfirmOk, //....確認按鈕文字
                textButtonCancel: config.textButtonCancel || $rootScope.translate.commonCancel, //...取消按鈕文字
                promiseAction: config.promiseAction //...動作
            };
            return result;
        }
        function viewInit() {
            var result = {
                hasTitle: false, //......是否有標題
                hasContent: false //....是否有內容
            };
            return result;
        }
        function eventInit() {
            var result = {
                ok: ok, //.........確認詢問事件，回傳true
                cancel: cancel //.拒絕詢問事件，回傳false
            };
            return result;
        }
        function styleInit() {
            var result = {
                bodyStyle: {}, //.........整個畫面的風格
                titleStyle: {}, //........標題的風格
                contentStyle: {}, //......內容的風格
                footerStyle: {} //.......尾段的風格
            };
            return result;
        }
        //=========
        function ok() {

            if (vm.data.promiseAction) {
                vm.isBusy = true;
                vm.data.promiseAction().then(function () {
                    $uibModalInstance.close(true);
                });
            } else {
                $uibModalInstance.close(true);
            }
        }
        function cancel() {
            $uibModalInstance.close(false);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('tsunCourseController', tsunCourseController);

    function tsunCourseController(modalService, trainingInnerService, userInfo, urlParam, $q, $rootScope, $scope, $uibModal) {
        var vm = this;
        //vm.selectedMenu = selectedMenu;
        vm.openCourseDetail = openCourseDetail;
        vm.addToShoppingCar = addToShoppingCar;
        vm.enroll = enroll;
        vm.openCourseCategorySelector = openCourseCategorySelector;
        vm.isMobile = modalService.isMobile();
        //==Main==
        onInit();
        //========
        function onInit() {
            menuInit();
            dataInit();
            logicInit();

            $scope.$watch('isSmallView', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                menuSlide();
            });
            $scope.$watch('vm.data.courseListFilter.length', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (!newValue) {
                    newValue = 0;
                }
                vm.view.courseEmpty = newValue < 1;
            });
        }

        function menuInit() {
            if (location.href.indexOf('sessionId') > 0 || location.href.indexOf('courseId') > 0) {
                console.log('sessionId:', queryString('sessionId'));
                console.log('courseId:', queryString('courseId'));
                var sessionId = queryString('sessionId');
                var courseId = queryString('courseId');

                if (!sessionId || !courseId) {
                    sessionStorage.setItem('menuSerilNo', '');
                    sessionStorage.setItem('menuSerilNo', -9903);
                }
            }
        }

        function dataInit() {
            vm.data = {
                urlParam: urlParamFormat(urlParam) || {}, //.........網頁傳入的參數
                collectionList: null,
                courseList: [], //...................................課程資料清單
                courseListFilter: [], //.............................課程資料清單於Filter處理後結果
                courseCatagories: [],
                courseCatagoriesSelectedItemName: $rootScope.translate.commonAll
            };
            vm.viewShow = {
                slides: []
            };
            vm.view = {
                isMobile: modalService.isMobile(),
                courseEmpty: false, //.........查無資料判定
                pageLoading: false, //.........頁面讀取中
                pageLoaded: false //..........頁面讀取完畢
            };
            vm.menuIndex = -1;
            vm.menuChildIndex = -1;
        }

        function logicInit() {
            vm.view.pageLoading = true;
            loadMenu().then(function (catagoryId) {
                menuSlide();
                if (!catagoryId) {
                    return;
                }
                return loadCourseList(-1, true);
            }).then(function () {
                vm.data.courseList = _.filter(vm.data.courseList, function (courseItem) {
                    var checkCourseID = vm.data.urlParam.courseid || courseItem.courseId;
                    var checkSessionID = vm.data.urlParam.sessionid || courseItem.sessionId;
                    // console.log("courseItem", courseItem);
                    // console.log("checkCourseID", checkCourseID);
                    // console.log("checkSessionID", checkSessionID);
                    return courseItem.courseId === checkCourseID && courseItem.sessionId === checkSessionID;
                });
            }).then(function () {
                vm.view.courseEmpty = vm.data.courseList.length < 1;
                vm.view.pageLoading = false;
                vm.view.pageLoaded = true;
            });
        }

        function urlParamFormat(sourceData) {
            if (!sourceData) {
                return null;
            }
            var params = {};
            _.forEach(sourceData, function (value, key) {
                var keyString = (key + '').toLowerCase();
                switch (keyString) {
                    case 'courseid':
                        params[keyString] = parseInt(value);
                        break;
                    case 'sessionid':
                        params[keyString] = parseInt(value);
                        break;
                    default:
                        break;
                }
            });
            return params;
        }

        function menuSlide() {
            var slideNum = 4;
            if ($rootScope.isSmallView) {
                slideNum = 4;
            }
            vm.viewShow.slides = _.chunk(vm.data.courseCatagories, slideNum);
            _.forEach(vm.viewShow.slides, function (slideItem) {
                for (var index = slideItem.length; index < slideNum; index++) {
                    slideItem.push({
                        categoryId: null
                    });
                }
            });
            //console.logconsole.log('menuSlide:', vm.viewShow.slides);
        }

        function loadMenu(langItem) {
            //console.log('langItem:',langItem);
            return trainingInnerService.getMenu(langItem).then(function (data) {
                // console.log("loadMenu data:", data);
                // data.unshift({ categoryId: "-1", categoryName: $rootScope.translate.commonAll });
                // console.log("loadMenu data:", data);
                vm.data.courseCatagories = data;
                if (data.length < 1) {
                    return null;
                }
                vm.menuIndex = -1;
                vm.menuChildIndex = -1;
                return -1;
                //return data.data[0].categoryId;
            });
        }

        function loadCourseList(courseCategory, loadCollection) {
            // var courseList = trainingInnerService.getCourseList(courseCategory);
            //console.log('courseCategory:',courseCategory);
            return trainingInnerService.getCourseListAll(courseCategory).then(function (courseList) {
                console.log("getCourseListAll:", courseList);
                var promisList = [trainingInnerService.checkCourseWithMenu(courseList, vm.data.courseCatagories)];

                if (loadCollection) {
                    promisList.push(loadUserCollection());
                }
                return $q.all(promisList).then(function (data) {
                    //console.log("getCourseListAll:", data[0]);
                    return data[0]; //courseList
                });
            }).then(function (courseListChecked) {
                //console.log('vm.data.courseList:',courseListChecked);
                _.forEach(courseListChecked, function (data) {
                    //console.log('sTime:',data.courseTime);
                    data.courseTime = data.courseTime.replace(/\<br\>/ig, ' ');
                    //console.log('data:',data.courseTime);
                });
                vm.data.courseList = courseListChecked;
                collectionCheck();
                return courseListChecked;
            });
        }

        function loadUserCollection() {
            var collectionList = trainingInnerService.getCollectionList();
            return collectionList.then(function (data) {
                vm.data.collectionList = data;
                return data;
            });
        }
        // select menu
        // function selectedMenu(categoryId) {
        //     // var isSameCourse =
        //     //     (vm.menuIndex === index) &&
        //     //     (vm.menuChildIndex = menuChildIndex);
        //     // if (isSameCourse) {
        //     //     //如果再度點選篩選中的類別，就取消選取，呈現所有資料。
        //     //     vm.menuIndex = -1;
        //     //     vm.menuChildIndex = -1;
        //     //     loadCourseList(-1);
        //     //     return;
        //     // }
        //     // vm.menuIndex = index;
        //     // vm.menuChildIndex = menuChildIndex;
        //     //loadCourseList(categoryId);
        // }

        // select enroll
        function enroll(item) {
            console.log('enroll');
            var confirmDialog = modalService.confrimDialog({
                confirmContent: $rootScope.translate.tsunEnrollInfoNoQuestion,
                promiseAction: function promiseAction() {
                    return trainingInnerService.hasEnrollQuestion(item).then(function (result) {
                        if (!result) {
                            return trainingInnerService.postSessionAction(item, 'Enroll').then(function (result) {
                                if (!result) {
                                    return;
                                }
                                enrollSuccess(item);
                            }).then(function () {
                                //clear url param
                                console.log('enrollSuccess');
                                if (location.href.toLowerCase().indexOf('sessionid') > 0 || location.href.toLowerCase().indexOf('courseid') > 0) {
                                    console.log("current url:", location.href);
                                    //2023-07-24 Johnson 資安2023
                                    location.href = eval(function (p, a, c, k, e, r) {
                                        e = function e(c) {
                                            return c.toString(a);
                                        };if (!''.replace(/^/, String)) {
                                            while (c--) {
                                                r[e(c)] = k[c] || e(c);
                                            }k = [function (e) {
                                                return r[e];
                                            }];e = function e() {
                                                return '\\w+';
                                            };c = 1;
                                        };while (c--) {
                                            if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                                        }return p;
                                    }('`${2.3.4(\'/#\')[0]+\'/#/5/6?7=\'+8.9(\'a\')}`.1(/</g,\'&b\').1(/>/g,\'&c\').1(/"/g,\'&d\').1(/\'/g,\'&#e\').1(/[<>!]|(\\(\\))|((f|h|i)\\j*\\(.*\\))/g,\'\');', 20, 20, '|replace|location|href|split|tsu|course|menu|sessionStorage|getItem|menuSerilNo|lt|gt|quot|x27|for||while|if|s'.split('|'), 0, {}));
                                }
                            });
                        } else {
                            var settingModel = {
                                isEnroll: true
                            };
                            var modal = modalService.courseDetail(item, settingModel);
                            modal.result.then(function (result) {
                                if (!result) {
                                    return;
                                }
                                enrollSuccess(item);
                            }).then(function () {
                                //clear url param
                                console.log('enrollSuccess');
                                if (location.href.toLowerCase().indexOf('sessionid') > 0 || location.href.toLowerCase().indexOf('courseid') > 0) {
                                    console.log("current url:", location.href);
                                    //2023-07-24 Johnson 資安2023
                                    location.href = eval(function (p, a, c, k, e, r) {
                                        e = function e(c) {
                                            return c.toString(a);
                                        };if (!''.replace(/^/, String)) {
                                            while (c--) {
                                                r[e(c)] = k[c] || e(c);
                                            }k = [function (e) {
                                                return r[e];
                                            }];e = function e() {
                                                return '\\w+';
                                            };c = 1;
                                        };while (c--) {
                                            if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                                        }return p;
                                    }('`${2.3.4(\'/#\')[0]+\'/#/5/6?7=\'+8.9(\'a\')}`.1(/</g,\'&b\').1(/>/g,\'&c\').1(/"/g,\'&d\').1(/\'/g,\'&#e\').1(/[<>!]|(\\(\\))|((f|h|i)\\j*\\(.*\\))/g,\'\');', 20, 20, '|replace|location|href|split|tsu|course|menu|sessionStorage|getItem|menuSerilNo|lt|gt|quot|x27|for||while|if|s'.split('|'), 0, {}));
                                }
                            });
                        }
                    });
                }
            });

            // confirmDialog.result.then(function(result) {
            //     result = !!result;
            //     if (result !== true) {
            //         return;
            //     }
            //     trainingInnerService.hasEnrollQuestion(item).then(function(result) {
            //         if (!result) {
            //             trainingInnerService.postSessionAction(item, 'Enroll')
            //                 .then(function(result) {
            //                     if (!result) { return; }
            //                     enrollSuccess(item);
            //                 });
            //         } else {
            //             var settingModel = {
            //                 isEnroll: true
            //             };
            //             var modal = modalService.courseDetail(item, settingModel);
            //             modal.result.then(function(result) {
            //                 if (!result) { return; }
            //                 enrollSuccess(item);
            //             });
            //         }
            //     });
            // });
        }

        function openCourseDetail(item) {
            var modal = modalService.courseDetail(item);
            modal.result.then(function (data) {
                if (data) {
                    enrollSuccess(item);
                }
            });
        }

        function enrollSuccess(item) {
            trainingInnerService.delCollection(item, false).then(function () {
                var itemIndex = _.findIndex(vm.data.courseList, { sessionId: item.sessionId });
                if (itemIndex > -1) {
                    vm.data.courseList.splice(itemIndex, 1);
                }
            });
        }

        function addToShoppingCar(item) {
            trainingInnerService.addCollection(item).then(function () {
                // console.log("vm.data.collectionList",vm.data.collectionList);
                if (!vm.data.collectionList) {
                    vm.data.collectionList = [];
                }
                vm.data.collectionList.push({ collectionSessionId: item.sessionId });
                item.isAdd = true;
            });
            //trainingInnerService.addToShoppingCar(item);
        }

        function collectionCheck() {
            //console.log("vm.data.collectionList", vm.data.collectionList);
            _.forEach(vm.data.courseList, function (courseItem) {
                var indexFind = _.findIndex(vm.data.collectionList, {
                    collectionSessionId: courseItem.sessionId
                });
                courseItem.isAdd = indexFind >= 0;
            });
            return vm.data.courseList;
        }

        function openCourseCategorySelector() {
            var item = vm.data.courseCatagories;
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/courseCategorySelector.html',
                controller: 'courseCategorySelectorController as vm',
                size: 'sm',
                backdrop: 'static',
                taiClass: modalService.getTaiClass(),
                resolve: {
                    categoryItem: function categoryItem() {
                        return item;
                    }
                }
            });
            //這個則是接收傳回來的值
            result.result.then(function (result) {
                vm.data.courseCatagoriesSelectedItemName = result[0].categoryName;
                loadCourseList(result[0].categoryId);
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('courseService', courseService);

    function courseService() {
        var service = {};
        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('tsunShoppingCartController', tsunShoppingCartController);

    function tsunShoppingCartController($q, trainingInnerService, $uibModal, modalService, $rootScope) {
        var vm = this;
        vm.setTypeClass = setTypeClass;
        vm.openCourseModal = openCourseModal;
        vm.delCollection = delCollection;
        vm.enroll = enroll;
        //===Main===
        onInit();
        //==========
        function dataInit() {
            vm.data = {
                items: []
            };
            vm.view = {
                isMobile: modalService.isMobile(), //.是否為行動裝置
                collectionEmpty: false, //............查無資料判定
                pageLoading: false, //................頁面讀取中
                pageLoaded: false //.................頁面讀取完畢
            };
        }

        function logicInit() {
            //邏輯初始化。
            vm.view.pageLoading = true;
            return loadCollections().then(function (collectionList) {
                vm.data.items = collectionList || [];
            }).then(function () {
                //finally
                checkIsEmpty();
                vm.view.pageLoading = false;
                vm.view.pageLoaded = true;
            });
        }

        function onInit() {
            dataInit();
            logicInit();
        }

        function loadCollections() {
            //驗證課程收藏資料
            var courseCollection = trainingInnerService.getCollectionList();
            //取得所有課程資料
            var courseList = trainingInnerService.getCourseListAll();
            var resultSessionItems = [];
            return $q.all([courseCollection, courseList]).then(function (data) {
                //驗證課程收藏
                var dataCourseCollection = data[0];
                var dataCourseList = data[1];
                console.log("dataCourseList:", dataCourseList);
                _.forEach(dataCourseList, function (data) {
                    data.courseTime = data.courseTime.replace(/\<br\>/ig, ' ');
                });

                //console.log("courseColletion Raw:",dataCourseCollection);
                console.log("dataCourseList:", dataCourseList);
                _.forEach(dataCourseCollection, function (collectionItem) {
                    console.log("collectionItem:", collectionItem);
                    var findIndex = _.findIndex(dataCourseList, { sessionId: collectionItem.collectionSessionId });
                    if (findIndex >= 0) {
                        resultSessionItems.push(dataCourseList[findIndex]);
                    }
                    // return (findIndex >= 0);
                });
                // console.log("courseColletion result:",resultSessionItems);
                return resultSessionItems;
            });
        }

        function setTypeClass(type) {
            if (type === 'inClass') {
                return 'fa-book';
            }
            return 'fa-desktop';
        }

        function openCourseModal(item) {
            var modal = modalService.courseDetail(item);
            modal.result.then(function (data) {
                if (data) {
                    enrollSuccess(item);
                }
            });
        }

        function delCollection(item) {
            var confirmDialog = modalService.confrimDialog({
                confirmContent: format("{0}\r\n{1}", $rootScope.translate.tsunConfirmRemove, item.sessionName)
            });
            confirmDialog.result.then(function (result) {
                result = !!result;
                if (result !== true) {
                    return;
                }
                trainingInnerService.delCollection(item, true).then(function () {
                    remove(item);
                });
            });
        }

        function checkIsEmpty() {
            if (vm.data.items.length < 1) {
                vm.view.collectionEmpty = true;
            } else {
                vm.view.collectionEmpty = false;
            }
        }

        function remove(item) {
            var itemIndex = _.findIndex(vm.data.items, { sessionId: item.sessionId });
            if (itemIndex > -1) {
                vm.data.items.splice(itemIndex, 1);
            }
            checkIsEmpty();
        }

        function enrollSuccess(item) {
            trainingInnerService.delCollection(item, false).then(function () {
                remove(item);
            });
        }

        function enroll(item) {
            var confirmDialog = modalService.confrimDialog({
                confirmContent: $rootScope.translate.tsunEnrollInfoNoQuestion
            });
            confirmDialog.result.then(function (result) {
                result = !!result;
                if (result !== true) {
                    return;
                }
                trainingInnerService.hasEnrollQuestion(item).then(function (result) {
                    if (!result) {
                        trainingInnerService.postSessionAction(item, 'Enroll').then(function (result) {
                            if (!result) {
                                return;
                            }
                            enrollSuccess(item);
                        });
                    } else {
                        var settingModel = {
                            isEnroll: true
                        };
                        var modal = modalService.courseDetail(item, settingModel);
                        modal.result.then(function (data) {
                            if (data) {
                                enrollSuccess(item);
                            }
                        });
                    }
                });
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('shoppingCartService', shoppingCartService);

    function shoppingCartService() {
        var service = {};
        //==Main==
        return service;
        //========
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('tsunMyTrainingController', tsunMyTrainingController);

    function tsunMyTrainingController($q, ssoInfo, $rootScope, $timeout, $scope, modalService) {
        var vm = this;
        //==Main==
        onInit();
        //========
        function onInit() {
            vm.method = methodList();
            vm.view = viewInit();
            vm.data = dataInit();
            logicInit();
        }

        function dataInit() {
            var result = {
                ssoInfo: null,
                translate: $rootScope.translate
            };
            return result;
        }

        function viewInit() {
            var result = {
                pageLoading: false, //.........頁面讀取中
                pageLoaded: false, //..........頁面讀取完畢
                menuType: 1, //................選單顯示樣式(磚塊[1]或是下拉[2])
                isMobile: modalService.isMobile()
            };
            return result;
        }

        function methodList() {
            var result = {
                menuClick: menuClick
            };
            return result;
        }

        function logicInit() {
            // console.log("ssoInfo:", ssoInfo);
            vm.menuIndex = 0;
            vm.menuList = [];
            vm.view.pageLoading = true;
            return $q.when(menuLoad()).then(function () {
                vm.view.pageLoading = false;
                vm.view.pageLoaded = true;
                vm.menuSeletedText = vm.menuList[0].name;
                if (ssoInfo) {
                    vm.data.ssoInfo = ssoInfo;
                } else {
                    //另外取得使用者資訊。
                }
                $scope.$watch('isSmallView', function (newValue, oldValue) {
                    if (newValue === oldValue) {
                        return;
                    }
                    menuNameEdit();
                });
            });
        }

        function menuLoad() {
            vm.menuList = [{ id: 1, name: '', nameValue: $rootScope.translate.tsunRepairProject }, { id: 2, name: '', nameValue: $rootScope.translate.tsunCourseLog }, { id: 3, name: '', nameValue: $rootScope.translate.tsunFinancial }, { id: 4, name: '', nameValue: $rootScope.translate.tsunExterior }, { id: 5, name: '', nameValue: $rootScope.translate.tsunBankBook }];
            menuStyleChange();
            menuNameEdit();
        }

        function menuStyleChange() {
            var langSelected = sessionStorage.getItem('langCode');
            switch (langSelected) {
                case '1':
                case '2':
                    vm.view.menuType = 1;
                    break;
                default:
                    vm.view.menuType = 2;
                    break;
            }
        }

        function menuClick(index) {
            vm.menuIndex = index;
            //console.log('menuIndex:', vm.menuIndex);
        }

        function menuNameEdit() {
            if (vm.menuList.length < 1) {
                return;
            }
            var langSelected = sessionStorage.getItem('langCode');
            _.forEach(vm.menuList, function (menuItem) {
                var nameLength = menuItem.nameValue.length;
                var position = 0;
                if (!$rootScope.isSmallView) {
                    menuItem.name = menuItem.nameValue;
                    return;
                }
                switch (langSelected) {
                    case '1':
                    case '2':
                        //中文處理
                        var numLineChange = 2;
                        menuItem.name = '';
                        do {
                            if (nameLength - position > numLineChange) {
                                menuItem.name += menuItem.nameValue.substr(position, numLineChange);
                                menuItem.name += '<br/>';
                            } else {
                                menuItem.name += menuItem.nameValue.substr(position, nameLength - position);
                            }
                            position += numLineChange;
                        } while (nameLength - position > 0);
                        break;
                    default:
                        menuItem.name = menuItem.nameValue;
                        //外語處理
                        break;
                }
            });
        }

        /* 漢堡選單click事件 */
        var menuSerilNo = parseInt(getMenuQueryString());
        //console.log('train index menu:', menuSerilNo);
        //待修
        if (menuSerilNo === -9901) {
            menuClick(0);
        }
        //修課紀錄
        if (menuSerilNo === -9906) {
            menuClick(1);
        }
        //金融 先跳過
        if (menuSerilNo === -9991 || menuSerilNo === -9992 || menuSerilNo === -9993) {
            menuClick(2);
        }
        //外訓
        if (menuSerilNo === -9904) {
            menuClick(3);
        }
        //存摺
        if (menuSerilNo === -9907) {
            menuClick(4);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiMyTrainingBankBook', taiMyTrainingBankBook);

    function taiMyTrainingBankBook() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingBankBookController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.bankBook.html',
            scope: {
                isFocus: '='
            }
        };
        return directive;
    }
    /* @ngInject */
    function taiMyTrainingBankBookController($q, trainingInnerService, $scope, $uibModal, modalService) {
        var vm = this;
        vm.yearChanged = yearChanged;
        vm.openYearSelector = openYearSelector;
        vm.isMobile = modalService.isMobile();
        onInit();

        function onInit() {
            vm.data = dataInit();
            vm.view = viewInit();
            $scope.$watch('vm.isFocus', function (newValue) {
                if (newValue === true) {
                    logicInit();
                }
            });
        }

        function dataInit() {
            var result = {
                years: [], //........年度下拉清單的矩陣
                year: 1970, //.......選取的年度
                remainPoint: 0, //...剩餘存摺點數
                bankBook: [] //.....當年度花費點數的課程
            };
            return result;
        }

        function viewInit() {
            var result = {
                bankBookEmpty: false, //.......訓練存摺點數為空
                isInited: false, //............是否被初始化過
                pageLoaded: false, //..........頁面讀取完畢
                pageLoading: false //.........頁面讀取中
            };
            return result;
        }

        function logicInit() {
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //=====
            var promiseEvt = function () {
                vm.view.isInited = true;
                vm.data.years = trainingInnerService.getYears(2011);
                vm.data.year = vm.data.years[0];
            }();
            $q.when(promiseEvt).then(function () {
                return yearChanged();
            }).then(function () {
                vm.view.pageLoaded = true;
                vm.view.pageLoading = false;
            });
        }

        function loadBankBook(year) {
            // return trainingInnerService.loadLangs()
            //     .then(function (langs) {
            //         var bankBookItem = {
            //             remainPoint: null,
            //             bankBook: []
            //         };
            //         var promiseList = [];
            //         _.forEach(langs, function (lang) {
            //             promiseList.push(trainingInnerService.getBankBook(year, lang.langCode));
            //         });
            //         return $q.all(promiseList).then(function (data) {
            //             _.forEach(data, function (perReceiveData) {
            //                 if (!bankBookItem.remainPoint) {
            //                     bankBookItem.remainPoint = perReceiveData.remainPoint;
            //                 }
            //                 Array.prototype.push.apply(bankBookItem.bankBook, perReceiveData.bankBook);
            //             });
            //             return bankBookItem;
            //         });
            //     });
            return trainingInnerService.getBankBook(year, sessionStorage.getItem("userLang"));
        }

        function yearChanged() {
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //======
            var result = loadBankBook(vm.data.year).then(function (bankBookItem) {
                if (!bankBookItem) {
                    vm.data.remainPoint = 0;
                    vm.data.bankBook = {};
                    vm.view.bankBookEmpty = true;
                    return;
                }
                //取代sessionTime中的<br>
                // _.forEach(bankBookItem, function(data) {
                //     console.log('sTime:',data);
                //     // data.courseTime = data.courseTime.replace(/\<br\>/ig, ' ');
                //     // console.log('data:',data.courseTime);
                // });
                vm.data.remainPoint = bankBookItem.remainPoint;
                vm.data.bankBook = bankBookItem.bankBook;
                vm.view.bankBookEmpty = bankBookItem.bankBook.length < 1;
                return true;
            }).then(function () {
                vm.view.pageLoaded = true;
                vm.view.pageLoading = false;
            });
            return result;
        }

        function openYearSelector() {
            vm.view.pageLoaded = true;
            vm.view.pageLoading = false;

            var result = modalService.openOptionSelector(vm.data.years, 'yrSelect', false);

            //這個則是接收傳回來的值
            result.result.then(function (data) {
                vm.data.year = data;
                loadBankBook(vm.data.year).then(function (bankBookItem) {
                    if (!bankBookItem) {
                        vm.data.remainPoint = 0;
                        vm.data.bankBook = {};
                        vm.view.bankBookEmpty = true;
                        return;
                    }
                    vm.data.remainPoint = bankBookItem.remainPoint;
                    vm.data.bankBook = bankBookItem.bankBook;
                    vm.view.bankBookEmpty = bankBookItem.bankBook.length < 1;
                    return true;
                }).then(function () {
                    vm.view.pageLoaded = true;
                    vm.view.pageLoading = false;
                });
            });
            return result;
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiMyTrainingCourseLog', taiMyTrainingCourseLog);

    function taiMyTrainingCourseLog() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingCourseLogController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.courseLog.html',
            scope: {
                isFocus: '=',
                translatePool: '='
            }
        };
        return directive;
    }
    /* @ngInject */
    function taiMyTrainingCourseLogController(trainingInnerService, $q, $scope, modalService) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.translatePool = $scope.$parent.vm.data.translatePool;
        onInit();
        function onInit() {
            vm.isMobile = modalService.isMobile();
            vm.openYearSelector = openYearSelector;
            //vm.openTime = openTime;
            vm.yearChange = yearChange;
            vm.statusConvert = statusConvert;
            vm.method = methodList(); //找機會要把上面的設定移到這裡
            //======
            vm.data = dataInit();
            vm.view = viewInit();
            //======
            $scope.$watch('vm.data.courseLogFilter.length', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (!newValue) {
                    newValue = 0;
                }
                vm.view.courseLogEmpty = newValue < 1;
            });
            $scope.$watch('vm.isFocus', function (newValue) {
                if (newValue === true) {
                    logicInit();
                }
            });
        }

        function dataInit() {
            var result = {
                courseLogSource: [],
                courseLog: [],
                courseLogFilter: []
            };

            return result;
        }

        function viewInit() {
            var result = {
                courseLogEmpty: false, //.........查無資料判定
                isInited: false, //............是否被初始化過
                pageLoaded: false, //..........頁面讀取完畢
                pageLoading: false //.........頁面讀取中
            };
            return result;
        }

        function methodList() {
            var result = {
                filterSessionTimeByYear: filterSessionTimeByYear
            };
            return result;
        }

        function logicInit() {
            vm.view.isInited = true;
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //======
            return trainingInnerService.getCourseLog(sessionStorage.getItem("userLang")).then(function (courseLog) {
                //取代<br>
                _.forEach(courseLog, function (data) {
                    //console.log('sTime:',data.sessionTime);
                    data.sessionTime = data.sessionTime.replace(/\<br\>/ig, ' ');
                    //console.log('data:',data.sessionTime);
                });
                //console.log('courseLog:', courseLog);
                vm.data.courseLogSource = courseLog;
                vm.years = trainingInnerService.getYears(2011);
                vm.year = vm.years[0];
                getCourseLog();
                return true;
            }).then(function () {
                vm.view.pageLoaded = true;
                vm.view.pageLoading = false;
            });
        }

        function filterSessionTimeByYear(year) {
            return _.filter(vm.data.courseLogSource, function (o) {
                return o.sessionTime.indexOf(year) !== -1;
            });
        }

        function getCourseLog() {
            vm.data.courseLog = vm.method.filterSessionTimeByYear(vm.year);
            vm.view.courseLogEmpty = vm.data.courseLog.length < 1;
        }

        function yearChange(year) {
            vm.year = year;
            getCourseLog();
        }

        function statusConvert(statusCode) {
            if (!statusCode && statusCode !== 0) {
                return '';
            }
            switch (statusCode + '') {
                case '-1':
                    return vm.translatePool.tsunPassStatusValueNotCourage;
                case '0':
                    return vm.translatePool.tsunPassStatusValueNA;
                case '1':
                    return vm.translatePool.tsunPassStatusValueExemption;
                case '2':
                    return vm.translatePool.tsunPassStatusValueOK;
                case '3':
                    return vm.translatePool.tsunPassStatusValueNotOK;
                default:
                    return '';
            }
        }

        function openYearSelector() {
            var result = modalService.openOptionSelector(vm.years, 'yrSelect', false);
            //這個則是接收傳回來的值
            result.result.then(function (data) {
                vm.year = data;
                getCourseLog();
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiMyTrainingExterior', taiMyTrainingExterior);

    function taiMyTrainingExterior() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingExteriorController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.exterior.html',
            scope: {
                isFocus: '=',
                translatePool: '='
            }
        };
        return directive;
    }
    /* @ngInject */
    function taiMyTrainingExteriorController(trainingInnerService, $uibModal, $q, modalService, $rootScope, $scope) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.translatePool = $scope.$parent.vm.data.translatePool;
        //===Main===
        onInit();
        //==========
        function onInit() {
            //===
            vm.mustRemark = false;
            vm.submit = submit;
            vm.openOrganizer = openOrganizer;
            vm.removeOrganizer = removeOrganizer;
            vm.removeTime = removeTime;
            vm.openTime = openTime;
            vm.plusTotalPricer = plusTotalPricer;
            vm.openApplicationFormTypeSelector = openApplicationFormTypeSelector;
            vm.method = methodList(); //有一天要把上面這些設定移到這裡
            vm.isMobile = modalService.isMobile();
            //===
            vm.applicationForm = applicationFormInit();
            vm.data = dataInit();
            vm.view = viewInit();
            vm.UserAccount = $rootScope.userInfo.userAccount;
            //===
            $scope.$watch('vm.isFocus', function (newValue) {
                if (newValue === true && vm.view.isInited === false) {
                    logicInit();
                }
            });
        }

        function logicInit() {
            vm.view.isInited = true;
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //=====
            var exteriorData = trainingInnerService.getExterior();
            var Externaltype = trainingInnerService.getExternaltype();
            //console.log('Externaltype:',Externaltype);
            var currency = trainingInnerService.getCurrency();
            $q.all([exteriorData, Externaltype, currency]).then(function (data) {
                // 皆需排除掉第一筆資料: ALL - 1

                vm.data.exteriorData = _.filter(data[0], function (o) {
                    return o.id !== -1;
                });
                // vm.data.type = _.filter(data[1], function(o) {
                //     return o.id !== -1;
                // });
                vm.data.type = data[1][0];
                vm.data.currency = _.filter(data[2], function (o) {
                    return o.id !== -1;
                });

                // 設置預設選取第一個 radio btn
                vm.applicationForm.currency = _.head(vm.data.currency).id;
            }).then(function () {
                vm.view.pageLoaded = true;
                vm.view.pageLoading = false;
            });
        }

        function methodList() {
            var result = {};
            return result;
        }

        function viewInit() {
            var result = {
                isInited: false, //............是否被初始化過
                pageLoaded: false, //..........頁面讀取完畢
                pageLoading: false //.........頁面讀取中
            };
            return result;
        }

        function dataInit() {
            var result = {
                organizer: [],
                exteriorData: null,
                type: null,
                currency: null,
                dateSettingList: [],
                organizerOther: 413
            };
            return result;
        }

        function applicationFormInit() {
            var result = {
                Name: null,
                type: null,
                Outline: null,
                Place: null,
                currency: null,
                organizer: [],
                times: null,
                dateSettingList: [],
                Remark: '',
                coursePrice: 0,
                travelPrice: 0,
                totalPrice: 0,
                allowance: 0
            };
            return result;
        }

        function submit() {
            if (vm.mustRemark && !vm.applicationForm.Remark) {
                vm.form1.$valid = false;
            }
            if (vm.form1.$valid === false) {
                toastr.warning(vm.translatePool.tsunFormMsgRequiredEmpty);
                return;
            }

            if (vm.data.organizer !== null) {
                vm.applicationForm.organizer = vm.data.organizer;
            }
            vm.applicationForm.dateSettingList = angular.copy(vm.data.dateSettingList);
            //======
            var exteriorType = angular.copy(vm.applicationForm.type) || {};
            var isAllowance = exteriorType.allowanceRate > 0;
            var isFeeEmpty = vm.applicationForm.totalPrice < 1;
            //=====
            if (isAllowance && isFeeEmpty) {
                //TODO:多國語系(英文)
                var errorMsgEmptyFee = format(vm.translatePool.tsunErrorExternalApplicateEmptyFee);
                toastr.warning(errorMsgEmptyFee);
                return;
            }
            var thisYear = new Date().getFullYear();
            trainingInnerService.getBankBook(thisYear, sessionStorage.getItem("userLang")).then(function (bankBookData) {
                if (bankBookData) {
                    var recentPoint = parseInt(bankBookData.remainPoint) || 0;
                    var allowance = vm.applicationForm.allowance || 0;
                    //=====
                    var isPointEmpty = recentPoint < 1;
                    if (isAllowance && isPointEmpty) {
                        //TODO:多國語系(英文)
                        var errorMsgEmptyPoint = format(vm.translatePool.tsunErrorExternalApplicateAllowance, allowance + '');
                        toastr.warning(errorMsgEmptyPoint);
                        return;
                    }
                    //=====
                    if (isAllowance) {
                        var confirmText = format(vm.translatePool.tsunConfirmExternalApplicate, recentPoint + '', allowance + '');
                        var confirmDialog = modalService.confrimDialog({
                            confirmContent: confirmText.replace(/，/g, "<br/>")
                        });
                        confirmDialog.result.then(function (result) {
                            result = !!result;
                            if (result !== true) {
                                return;
                            }
                            postFormData();
                        });
                    } else {
                        postFormData();
                    }
                }
            });
        }

        function postFormData() {
            var data = angular.copy(vm.applicationForm.dateSettingList);
            console.log('vm.applicationForm:', data);
            trainingInnerService.postExterior(vm.applicationForm).then(function (result) {
                if (result) {
                    postExteriorSuccess();
                }
            });
        }

        function postExteriorSuccess() {
            var Externaltype = trainingInnerService.getExternaltype();
            vm.form1.$submitted = false;
            vm.data.organizer = [];
            vm.data.dateSettingList = [];
            vm.applicationForm.Name = '';

            //修正送出第二張申請單時，type選擇錯誤
            vm.data.type = Externaltype[0];
            vm.applicationForm.type = Externaltype[0];

            vm.applicationForm.Outline = '';
            vm.applicationForm.Place = '';
            vm.applicationForm.coursePrice = 0;
            vm.applicationForm.travelPrice = 0;
            vm.applicationForm.totalPrice = 0;
            vm.applicationForm.allowance = 0;
            vm.applicationForm.Remark = '';
            //vm.applicationForm.currency = vm.data.currency[0];
            vm.applicationForm.organizer = [];
            vm.applicationForm.times = null;
            vm.applicationForm.dateSettingList = [];
        }

        function openOrganizer() {
            var organizerResult = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/myTrainingOrganizerModal.html',
                controller: 'myTrainingOrganizerModalController as vm',
                size: 'lg',
                taiClass: modalService.getTaiClass(),
                resolve: {
                    params: function params() {
                        return vm.data.exteriorData;
                    },
                    choiceList: function choiceList() {
                        return vm.data.organizer;
                    }
                }
            });
            organizerResult.rendered.then(function () {
                var modalBootstrap = $(".modal-open > .modal");
                var modalBootstrapContent = modalBootstrap.find("> .modal-dialog > .modal-content ");
                if (!modalBootstrap) {
                    return;
                }
                var footerDiv = modalBootstrap.find(".footer");
                var showDiv = modalBootstrap.find("#content");
                var buttonShowTrigger = false;
                //====
                renderInit();
                //====
                function renderInit() {
                    buttonHide();
                    adjustOrgNameWidth();
                    $(document).off('submitSearchEnd').on('submitSearchEnd', function () {
                        adjustOrgNameWidth();
                    });
                    $(document).off('submitSearchStart').on('submitSearchStart', function () {
                        buttonShowTrigger = false;
                        buttonHide();
                    });
                    $(document).off('checkboxClick').on('checkboxClick', function (event, triggerResult) {
                        // console.log("listen checkboxClick ,trigger:", triggerResult);
                        buttonShowTrigger = !!triggerResult;
                        checkboxEvent();
                    });
                    modalBootstrap.scroll(function () {
                        scrollEvent();
                    });
                }

                function adjustOrgNameWidth() {
                    var allShowArea = modalBootstrapContent.find('.organizerNameShowArea');
                    allShowArea.css("max-width", modalBootstrapContent.width() - 70 + "px");
                }

                function scrollEvent() {
                    checkButtonCanShow();
                }

                function checkboxEvent() {
                    checkButtonCanShow();
                }

                function buttonHide() {
                    if (!footerDiv) {
                        return;
                    }
                    footerDiv.css({ "display": "none" });
                    footerDiv.find('a,button').css({ "display": "none" });
                    $(document).trigger('floatButtonDisplay', [false]);
                }

                function checkButtonCanShow() {
                    // 改變Footer樣式，使其保持在最下面。
                    var paddingHeight = 30;
                    var checkHeight = showDiv.height() - modalBootstrap.height() - paddingHeight;
                    var buttonInContent = checkHeight > modalBootstrap.scrollTop();
                    // console.log("showDiv:",showDiv);
                    // console.log("modalBootstrap.scrollTop()", modalBootstrap.scrollTop());
                    // console.log("checkHeight", checkHeight);
                    // console.log("buttonShowTrigger", buttonShowTrigger);
                    // console.log("buttonShowTrigger", buttonInContent);
                    if (buttonInContent && buttonShowTrigger) {
                        buttonShow();
                    } else {
                        buttonHide();
                    }
                }

                function buttonShow() {
                    if (!footerDiv) {
                        return;
                    }
                    footerDiv.find('a,button').css({
                        "position": "relative",
                        "display": "inline-block",
                        "left": "-50%"
                    });
                    var topLocation = modalBootstrap.height() + modalBootstrap.scrollTop() - footerDiv.outerHeight() * 2;
                    footerDiv.css({
                        "display": "inline-block",
                        "position": "absolute",
                        "top": topLocation,
                        "left": "50%",
                        // "right": "0px",
                        "margin-left": "auto",
                        "margin-right": "auto"
                    });
                    $(document).trigger('floatButtonDisplay', [true]);
                }
            });
            //這個則是接收傳回來的值
            organizerResult.result.then(function (data) {
                _.forEach(data, function (item) {
                    if (_.findIndex(vm.data.organizer, { "id": item.id }) < 0) {
                        vm.data.organizer.push(angular.copy(item));
                    }
                });
                vm.mustRemark = _.findIndex(vm.data.organizer, { "id": vm.data.organizerOther }) > -1;
            });
        }

        function removeOrganizer(item) {
            var index = _.findIndex(vm.data.organizer, { "id": item.id });
            if (index < 0) {
                return;
            }

            var confirmDialog = modalService.confrimDialog({
                confirmContent: format("{0}\r\n{1}", vm.translatePool.tsunConfirmRemove, item.name)
            });
            confirmDialog.result.then(function (result) {
                result = !!result;
                if (result !== true) {
                    return;
                }
                vm.data.organizer.splice(index, 1);
            });
        }

        function openTime() {
            console.log("beforeSelect vm.data.dateSettingList", vm.data.dateSettingList);
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/myTrainingExteriorTimeModal.html',
                controller: 'myTrainingExteriorTimeModalController as vm',
                size: 'lg',
                backdrop: 'static',
                taiClass: modalService.getTaiClass(),
                resolve: {
                    saveList: function saveList() {
                        return vm.data.dateSettingList;
                    }
                }
            });

            //這個則是接收傳回來的值
            result.result.then(function (data) {
                vm.data.dateSettingList = data;
                console.log("vm.data.dateSettingList", vm.data.dateSettingList);
            });
        }

        // function caculateDuringTime(lisTime) {
        //     var duringTimes = 0;
        //     if (lisTime) {
        //         _.forEach(lisTime, function (item) {
        //             duringTimes += item.duringTimes;
        //         });
        //     }
        //     if (!duringTimes) {
        //         duringTimes = 0;
        //     }
        //     // 將時間格式化產出
        //     return parseInt(duringTimes / 1000 / 60 / 60) + '.' + parseInt((duringTimes / 1000 / 60 % 60) * 100 / 60);
        // }

        function removeTime() {
            // var removeConfirm = confirm('確定要刪除?');
            // if (removeConfirm) {
            //     _.forEach(vm.times.selected, function (item) {
            //         var index = _.findIndex(vm.times, function (x) {
            //             return x === item;
            //         });
            //         vm.times.splice(index, 1);
            //     });
            // }
            // vm.timesCountString = caculateDuringTime(data);
        }

        function plusTotalPricer() {
            vm.applicationForm.totalPrice = vm.applicationForm.coursePrice + vm.applicationForm.travelPrice;
            if (vm.applicationForm.type) {
                var allowanceRate = vm.applicationForm.type.allowanceRate || 0;
                allowanceRate = allowanceRate;
                vm.applicationForm.allowance = Math.round(vm.applicationForm.totalPrice * allowanceRate / 100);
            }
        }

        function openApplicationFormTypeSelector() {
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/applicationFormTypeSelector.html',
                controller: 'applicationFormTypeSelectorController as vm',
                size: 'sm',
                backdrop: 'static',
                taiClass: modalService.getTaiClass()
            });
            //這個則是接收傳回來的值
            result.result.then(function (result) {
                vm.data.type = result;
                vm.applicationForm.type = result;
                plusTotalPricer();
            });
        }
    }
})();
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

(function () {
    'use strict';

    angular.module('app.directive').directive('taiMyTrainingFinancial', taiMyTrainingFinancial);

    Module.filter('licensesFlter', function () {
        //處理結果的格式化.
        return function (dataList, keyValue) {
            //==
            keyValue = keyValue || '';
            keyValue = (keyValue + '').toLowerCase();
            //==
            var result = [];
            var regExpCompare = new RegExp(keyValue, "g");
            _.forEach(dataList, function (perItem) {
                var compareString = perItem.name || '';
                if (compareString.toLowerCase().match(regExpCompare)) {
                    result.push(angular.copy(perItem));
                }
            });
            if (result.length < 1) {
                result.push({
                    name: '查無此證照名稱',
                    id: -1
                });
            }
            return result;
        };
    });

    function taiMyTrainingFinancial() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingFinancialController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.financial.html',
            scope: {
                translatePool: '=',
                isFocus: '=',
                ssoInfo: '='
            }
        };
        return directive;
    }
    /* @ngInject */
    function taiMyTrainingFinancialController($uibModal, $scope, modalService, trainingInnerService, $rootScope, $q, finacialLicicense, $timeout) {
        var vm = this;
        // 1.8.2 父層參數 data  無法直接從 scope 引入
        vm.translatePool = $scope.$parent.vm.data.translatePool;
        vm.ssoInfo = $scope.$parent.vm.data.ssoInfo;
        //===Main===
        onInit();
        //==========
        function onInit() {
            //console.log('onInit');
            vm.finacialLicicense = finacialLicicense;
            vm.submit = submit;
            vm.effectiveChange = effectiveChange;
            vm.openCertificateStatusSelector = openCertificateStatusSelector;
            vm.openCertificateTypeSelector = openCertificateTypeSelector;
            vm.openCourseListSelector = openCourseListSelector;
            vm.licenseKeyUp = licenseKeyUp;
            vm.certificateChange = certificateChange;
            vm.courseListSelectChange = courseListSelectChange;
            vm.getcourseList = getcourseList;
            vm.licenseBlur = licenseBlur;
            //vm.method = methodList(); //找機會要把上面的設定移到這裡
            //=======
            vm.financial = {};
            // console.log("taiMyTrainingFinancial onInit()");
            vm.isMobile = modalService.isMobile();
            //vm.isMobile=true;
            vm.menuNo = parseInt(getMenuQueryString());
            vm.data = dataInit();
            vm.view = viewInit();

            vm.UserInfo = vm.ssoInfo.cName + "(" + vm.ssoInfo.empId + ")";
            vm.UserDept = vm.ssoInfo.depName;
            vm.tabChange = tabChange;
            //console.log("82===>");


            $scope.$watch('vm.data.financialFilter.length', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (!newValue) {
                    newValue = 0;
                }
                vm.view.recordEmpty = newValue < 1;
                //console.log("89===>");
            });
            $scope.$watch('vm.data.authorizedHoursFilter.length', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (!newValue) {
                    newValue = 0;
                }
                vm.view.licienceEmpty = newValue < 1;
                //console.log("95===>");
            });
            $scope.$watch('vm.isFocus', function (newValue) {
                //console.log("98===>" + newValue);
                if (newValue === true) {
                    logicInit();
                }
            });
        }

        function dataInit() {
            //console.log('dataInit');
            var result = {
                //tabIndex: 0, //................選單序號
                financial: [], //..............證照紀錄API回傳清單
                financialFilter: [], //........證照紀錄於Filter處理後結果
                authorizedHours: [], //........證照認列時數API回傳清單
                authorizedHoursFilter: [] //..證照認列時數於Filter處理後結果
            };
            return result;
        }

        function viewInit() {
            //console.log('viewInit');
            var result = {
                recordEmpty: false, //..............證照紀錄資料為空
                licienceEmpty: false, //.............證照認列時數為空
                isInited_Page1: false, //............是否被初始化過(Page1)
                pageLoaded_Page1: false, //..........頁面讀取完畢(Page1)
                pageLoading_Page1: false, //.........頁面讀取中(Page1)
                isInited_Page2: false, //............是否被初始化過(Page2)
                pageLoaded_Page2: false, //..........頁面讀取完畢(Page2)
                pageLoading_Page2: false, //.........頁面讀取中(Page2)
                isInited_Page3: false, //............是否被初始化過(Page3)
                pageLoaded_Page3: false, //..........頁面讀取完畢(Page3)
                pageLoading_Page3: false //.........頁面讀取中(Page3)
            };
            return result;
        }

        function logicInit() {
            // /* 漢堡選單click事件 */
            //console.log('logicInit ', vm.menuNo);

            if (vm.menuNo === -9991) {
                vm.data.tabIndex = 0;
            }
            if (vm.menuNo === -9992) {
                vm.data.tabIndex = 1;
            }
            if (vm.menuNo === -9993) {
                vm.data.tabIndex = 2;
            }

            switch (vm.data.tabIndex) {
                case 0:
                    return logicInit_Page1();
                case 1:
                    return logicInit_Page2();
                case 2:
                    return logicInit_Page3();
                default:
                    break;
            }
        }

        function logicInit_Page1() {
            //console.log('logicInit_Page1');
            // if (vm.view.isInited_Page1 === true) {
            //     return;
            // }
            vm.view.isInited_Page1 = true;
            vm.view.pageLoaded_Page1 = false;
            vm.view.pageLoading_Page1 = true;
            //========
            var promiseList = [trainingInnerService.getFinancial(-1), // 證書記錄(資料)
            trainingInnerService.getEffectives()];
            return $q.all(promiseList).then(function (receiveData) {
                vm.data.financial = receiveData[0];
                vm.data.effectives = receiveData[1];
            }).then(function () {
                _.forEach(vm.data.financial, function (item) {
                    item.workflow = workflowFormat(item);
                });

                vm.view.recordEmpty = vm.data.financial.length < 1;
                vm.effective = vm.data.effectives[0]; // 預設為全部
            }).then(function () {
                //===
                vm.view.pageLoaded_Page1 = true;
                vm.view.pageLoading_Page1 = false;
                //以menu來選定tab
                $timeout(function () {
                    $scope.activeTabIndex = 0;
                });
            });
        }

        function logicInit_Page2() {
            //console.log('logicInit_Page2');
            if (vm.view.isInited_Page2 === true) {
                return;
            }
            vm.view.isInited_Page2 = true;
            vm.view.pageLoaded_Page2 = false;
            vm.view.pageLoading_Page2 = true;
            //========
            var promiseList = [trainingInnerService.getCertificateType()];
            //console.log('promiseList :', promiseList);
            return $q.all(promiseList).then(function (receiveData) {
                vm.data.certificateType = receiveData[0];
            }).then(function () {
                vm.certificate = vm.data.certificateType[0];
                //console.log('init vm.certificate :', vm.certificate);
                certificateChange();
                //以menu來選定tab
                $timeout(function () {
                    $scope.activeTabIndex = 1;
                });
                vm.view.pageLoaded_Page2 = true;
                vm.view.pageLoading_Page2 = false;
            });
        }

        function logicInit_Page3() {
            //console.log('logicInit_Page3');
            // if (vm.view.isInited_Page3 === true) {
            //     return;
            // }
            vm.view.isInited_Page3 = true;
            vm.view.pageLoaded_Page3 = false;
            vm.view.pageLoading_Page3 = true;
            //========
            var promiseList = [trainingInnerService.getAuthorizedHours()];
            return $q.all(promiseList).then(function (receiveData) {
                vm.data.authorizedHours = receiveData[0];
                //console.log(receiveData);
            }).then(function () {
                //內訓課程類別名稱
                var courseTypeInternal = vm.translatePool.tsunInternalCourse;
                //外訓課程類別名稱
                var courseTypeExternal = vm.translatePool.tsunExternalCourse;
                _.forEach(vm.data.authorizedHours, function (item) {
                    //console.log(item);
                    //證照時數可修課程清單
                    // var regExFormat1 = /(\([^\(^\)]*\))/g;//.....去除括弧內資料
                    // var regExFormat2 = /([\d]*-?[\d]*)/g;//......去除開始時間設定
                    getcourseList(item).then(function (data) {
                        item.courseList = _.filter(data, function (courseItem) {
                            //外訓資料要回公司找經辦人員申請
                            return courseItem.courseType !== 3;
                        });
                        //console.log('Init courseItem:', item.courseList);
                        item.courseListGroup = _.chain(item.courseList).groupBy("courseId").map(function (courseList) {
                            _.forEach(courseList, function (courseItem, index) {
                                courseItem.groupByIndex = index + 1;
                                courseItem.showName = courseItem.sessionName || '';
                            });
                        }).value();
                        if (item.courseList.length < 1) {
                            item.courseList.unshift({
                                //空的內訓資料，查無資料時補上
                                courseId: -1,
                                courseType: 1,
                                showName: vm.translatePool.tsunEmptyCourse
                            });
                        }
                        item.courseList.unshift({
                            //空的外訓資料，用來顯示台新罐頭文字
                            courseId: -3,
                            courseType: 3,
                            showName: vm.translatePool.tsunExternalCourseNotAllowForWeb
                        });
                        // tsunEmptyCourse
                        _.forEach(item.courseList, function (courseItem) {
                            if (courseItem.courseType !== 3) {
                                courseItem.groupName = courseTypeInternal;
                                if (courseItem.fcAuthHours) {
                                    courseItem.showName = courseItem.showName || '';
                                    courseItem.showName = courseItem.showName + "(" + courseItem.fcAuthHours + "小時)";
                                }
                            } else {
                                courseItem.groupName = courseTypeExternal;
                            }
                        });
                    });
                });
            }).then(function () {
                //取代時數為空的資料
                _.forEach(vm.data.authorizedHours, function (data) {
                    if (data.trainingEndDate.length < 1) {
                        data.trainingEndDate = data.trainingEndDate.replace('', '~');
                    }
                });
                //以menu來選定tab
                $timeout(function () {
                    $scope.activeTabIndex = 2;
                });
                vm.view.licienceEmpty = vm.data.authorizedHours.length < 1;
                vm.view.pageLoaded_Page3 = true;
                vm.view.pageLoading_Page3 = false;
            });
        }

        function workflowFormat(financialItem) {
            //console.log('workflowFormat');
            // workflow 整理
            var result = '';
            var checkList = ['workflowItem', 'workflowReason'];
            if (!financialItem) {
                return '';
            }
            _.forEach(checkList, function (propName) {
                if (!financialItem[propName]) {
                    financialItem[propName] = '';
                }
            });

            if (financialItem.workflowItem !== '') {
                result += format("<li><span>{0}</span></li>", financialItem.workflowItem);
            }
            if (financialItem.workflowReason !== '') {
                result += format("<li><span>{0}</span></li>", financialItem.workflowReason);
            }
            if (result.length > 0) {
                result = format("<ul>{0}</ul>", result);
            }
            return result;
        }

        function getcourseList(licensesItem) {
            console.log('getcourseList');
            return trainingInnerService.getAuthorizedHoursCourse(licensesItem, sessionStorage.getItem("userLang"));
        }

        function submit() {
            // console.log("vm.financial.getDay", vm.financial.getDay);
            // console.log('vm.form1.$valid:',vm.form1.$valid);
            if (vm.form1.$valid) {
                trainingInnerService.postFinancial(vm.financial).then(function (result) {
                    if (!result) {
                        return;
                    }
                    postFinancialSucess();
                    toastr.success(vm.translatePool.tsunSendSuccess);
                });
            } else {
                toastr.warning(vm.translatePool.tsunFormMsgRequiredEmpty);
            }
        }

        function postFinancialSucess() {
            //console.log('postFinancialSucess');
            vm.form1.$submitted = false;
            vm.financial.licenses = null;
            vm.financial.licensesNO = null;
            vm.financial.getDay = '';
            vm.financial.otherMark = null;
        }
        // 證照狀態 change 事件
        function effectiveChange(result) {
            //console.log('effectiveChange');
            var status = result.id;
            //var status = vm.effective.id;
            trainingInnerService.getFinancial(status).then(function (data) {
                vm.data.financial = data;
                _.forEach(vm.data.financial, function (item) {
                    item.workflow = workflowFormat(item);
                });
            });
        }

        // 證照名稱欄位 key up 事件
        function licenseKeyUp() {
            // 因為找不到popup的display來源，所以手動show
            //console.log('licenseKeyUp');
            $('[uib-typeahead-popup].dropdown-menu').show();
        }

        // 證照類別 change 事件
        function certificateChange() {
            // console.log('certificateChange');
            // console.log("vm.certificate", vm.certificate);
            trainingInnerService.getLicensesNames(vm.certificate.id).then(function (data) {
                //console.log('certificateChange',data);
                vm.data.licensesNames = data;
            });
            vm.financial.licenses = [];
        }

        // 認列時數，可參與之課程清單 change 事件
        function courseListSelectChange(List, item) {
            //console.log('courseListSelectChange');
            // console.log('before change List:', List);
            // console.log('before change item:', item);
            if (!item) {
                return;
            }
            if (!item.sessionId) {
                return;
            }
            var modal = modalService.courseDetail(item, null, 2);
            modal.result.then(function (data) {
                if (data) {
                    enrollSuccess(List, item);
                }
            });
            //console.log('after change:', item);
        }

        function enrollSuccess(List, item) {
            //console.log('enrollSuccess');
            var itemIndex = _.findIndex(List, { sessionId: item.sessionId });
            if (itemIndex > -1) {
                List.splice(itemIndex, 1);
            }
        }

        function tabChange(index) {
            //console.log('tabChange');
            if (vm.menuNo === -9991 || vm.menuNo === -9992 || vm.menuNo === -9993) return;
            vm.data.tabIndex = index;
            switch (vm.data.tabIndex) {
                case 0:
                    logicInit_Page1();
                    break;
                case 1:
                    logicInit_Page2();
                    break;
                case 2:
                    logicInit_Page3();
                    break;
                default:
                    break;
            }
        }

        function licenseBlur() {
            //console.log('licenseBlur');
            if (_typeof(vm.financial.licenses).toLowerCase() !== 'object') {
                vm.financial.licenses = "";
            }
            if (!vm.financial.licenses.id) {
                return;
            }
            if (vm.financial.licenses.id < 1) {
                vm.financial.licenses = null;
            }
        }

        function openCertificateStatusSelector() {
            //console.log('openCertificateStatusSelector');
            var result = modalService.openOptionSelector(trainingInnerService.getEffectives(), 'tsunCertificateStatus', false);
            //這個則是接收傳回來的值
            result.result.then(function (result) {
                vm.effective = result;
                //console.log('result :', result);
                effectiveChange(result);
            });
        }

        function openCertificateTypeSelector() {
            //console.log('openCertificateTypeSelector');
            var result = modalService.openOptionSelector(trainingInnerService.getCertificateType(), 'tsunCretificateClass', false);
            //這個則是接收傳回來的值
            result.result.then(function (result) {
                vm.certificate = result;
                //console.log('result :', vm.certificate);
                certificateChange();
            });
        }

        function openCourseListSelector(item) {
            //console.log('openCourseListSelector',item);
            var result = $uibModal.open({
                templateUrl: 'controller/tsun/training/myTraining/modal/courseListSelector.html',
                controller: 'courseListSelectorController as vm',
                size: 'sm',
                backdrop: 'static',
                taiClass: modalService.getTaiClass(),
                resolve: {
                    courseItem: function courseItem() {
                        return item;
                    }
                }
            });
            //這個則是接收傳回來的值
            result.result.then(function (result) {
                courseListSelectChange(result[0], result[1]);
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiMyTrainingRepairProject', taiMyTrainingRepairProject);

    function taiMyTrainingRepairProject() {
        var directive = {
            bindToController: true,
            controller: taiMyTrainingRepairProjectController,
            controllerAs: 'vm',
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/taiMyTraining.repairProject.html',
            scope: {
                isFocus: '='
            }
        };
        return directive;
    }

    /* @ngInject */
    function taiMyTrainingRepairProjectController(trainingInnerService, modalService, $q, $scope) {
        var vm = this;
        vm.directToCourse = directToCourse;
        //==Main==
        init();
        //========
        function init() {
            vm.isMobile = modalService.isMobile();
            vm.openDetail = openDetail;
            vm.setPercentStyle = setPercentStyle;
            vm.method = methodList(); //找機會要把上面的設定移到這裡
            //
            //=====
            vm.data = dataInit();
            vm.view = viewInit();
            //======
            $scope.$watch('vm.isFocus', function (newValue) {
                if (newValue === true) {
                    logicInit();
                }
            });
            $scope.$watch('vm.data.repairProjectInFilter.length', function (newValue, oldValue) {
                if (newValue === oldValue) {
                    return;
                }
                if (!newValue) {
                    newValue = 0;
                }
                vm.view.courseEmpty = newValue < 1;
            });
        }

        function methodList() {
            var result = {};
            return result;
        }

        function dataInit() {
            var result = {
                timeConfig: {},
                sessionSelected: null,
                repairProject: [], //..........待修項目資料
                repairProjectInFilter: [] //..待修項目資料(查詢結果)
            };
            return result;
        }

        function viewInit() {
            var result = {
                courseEmpty: false, //.........查無資料判定
                isInited: false, //............是否被初始化過
                pageLoaded: false, //..........頁面讀取完畢
                pageLoading: false //.........頁面讀取中
            };
            return result;
        }

        function logicInit() {
            vm.view.isInited = true;
            vm.view.pageLoaded = false;
            vm.view.pageLoading = true;
            //=====
            var promiseList = [loadConfig(), loadItemList()];
            $q.all(promiseList).then(function () {
                vm.view.pageLoaded = true;
                vm.view.pageLoading = false;
            });
        }

        function loadConfig() {
            return trainingInnerService.getConfigSetting().then(function (configData) {
                vm.data.timeConfig = configData.data;
            });
        }

        function loadItemList() {
            // console.log("repairProjec loadItemList");
            return trainingInnerService.loadLangs().then(function (langs) {
                var repairProject = [];
                var promiseList = [];
                //console.log('langs:', langs);
                _.forEach(langs, function (lang) {
                    // console.log('lang:', lang.langCode)
                    // console.log( trainingInnerService.getUnfinishedActivities(lang.langCode))
                    promiseList.push(trainingInnerService.getUnfinishedActivities(lang.langCode));
                });
                return $q.all(promiseList).then(function (data) {
                    _.forEach(data, function (perReceiveData) {
                        // console.log('perReceiveData:',perReceiveData);
                        perReceiveData = _.orderBy(perReceiveData, ['sessionTime'], ['desc']);
                        Array.prototype.push.apply(repairProject, perReceiveData);
                    });
                    repairProject = _.uniqBy(repairProject, function (courseItem) {
                        //設定唯一鍵
                        return courseItem.sessionId;
                    });
                    //console.log('repairProject:',repairProject);
                    return repairProject;
                });
            }).then(function (repairProject) {
                //取代sessionTime中的<br>
                _.forEach(repairProject, function (data) {
                    //console.log('sTime:',data.sessionTime);
                    data.sessionTime = data.sessionTime.replace(/\<br\>/ig, ' ');
                    //console.log('data:',data.sessionTime);
                });
                vm.data.repairProject = repairProject;
                vm.view.courseEmpty = repairProject.length < 1;
                return true;
            });
        }

        function openDetail(item) {
            vm.data.sessionSelected = item.sessionId;
            //==========
            var param = {
                item: item,
                timeConfig: vm.data.timeConfig
            };
            var openModal = modalService.trainingSelectAction(param);

            openModal.result.then(function () {
                //關閉視窗時要重整頁面
                loadItemList();
            });
        }

        function setPercentStyle(item) {
            var progress;
            var percentage;
            var style = {};
            if (item.progress && item.progress.length > 0) {
                progress = item.progress.split('/');
                if (progress.length < 2) {
                    item.progress = null;
                    progress = ['0', '1'];
                }
            } else {
                item.progress = null;
                progress = ['0', '1'];
            }
            percentage = 100 * (parseFloat(progress[0]) / parseFloat(progress[1]));
            percentage = parseInt(percentage) + '';
            if (percentage === '0') {
                style = { 'display': 'none' };
            } else {
                style = { 'width': percentage + '%' };
            }
            return style;
        }

        function directToCourse() {
            //console.log("current url:", location.href);
            var menuNo = location.href.split('menu=')[1];
            //2023-07-10 Johnson 資安2023
            location.href = eval(function (p, a, c, k, e, r) {
                e = function e(c) {
                    return c.toString(a);
                };if (!''.replace(/^/, String)) {
                    while (c--) {
                        r[e(c)] = k[c] || e(c);
                    }k = [function (e) {
                        return r[e];
                    }];e = function e() {
                        return '\\w+';
                    };c = 1;
                };while (c--) {
                    if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]);
                }return p;
            }('2.3.4(\'/#\')[0]+\'/#/5/6?7=\'+8.1(/</g,\'&9\').1(/>/g,\'&a\').1(/"/g,\'&b\').1(/\'/g,\'&#c\').1(/[<>!]|(\\(\\))|((d|e|f)\\h*\\(.*\\))/g,\'\')', 18, 18, '|replace|location|href|split|tsu|course|menu|menuNo|lt|gt|quot|x27|for|while|if||s'.split('|'), 0, {}));
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('tsunRecommendDocController', tsunRecommendDocController);

    function tsunRecommendDocController(trainingInnerService, $location, $q) {
        var vm = this;
        //==Main==
        init();
        //========
        function init() {
            dataInit();
            logicInit();
        }
        function dataInit() {
            vm.data = {
                innerHtml: '' //........內容顯示的HTML
            };
            vm.view = {};
        }
        function logicInit() {
            return loadData().then(function () {});
        }

        function loadData() {
            var recommendHtml = sessionStorage.getItem("recommendHTML");
            return $q.when(recommendHtml).then(function (data) {
                vm.data.innerHtml = data;
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('tsunRecommendController', tsunRecommendController);

    function tsunRecommendController(trainingInnerService, $location, modalService, commonService, activeType) {
        var vm = this;
        vm.carouselClick = carouselClick;
        vm.showImg = showImg;
        vm.showVedio = showVedio;
        vm.backList = backList;
        //==Main==
        init();
        //========
        function init() {
            dataInit();
            logicInit();
        }

        function dataInit() {
            vm.data = {
                carousel: [], //.......................熱門推薦取得原始資料
                carouselSelected: {} //...............點選的熱門推薦
            };
            vm.view = {
                isMobile: modalService.isMobile(), //..是否為行動裝置
                pageLoading: false, //.................頁面讀取中
                pageLoaded: false, //..................頁面讀取完畢
                showCarousel: true, //.................顯示熱門推薦清單
                showEmbed: false, //...................顯示嵌入式內容
                recommendEmpty: false, //..............內容是否為空
                recommendEmptyType2: false, //.........內容為空時顯示熱門推薦訊息
                recommendEmptyType3: false, //.........內容為空時顯示微課程訊息
                isMulitiData: true //.................是否有多筆資料(使用輪播樣式)
            };
        }

        function logicInit() {
            vm.view.pageLoading = true;
            return loadData().then(function () {
                if (vm.data.carousel.length < 1) {
                    vm.view.recommendEmpty = true;
                    vm.view.recommendEmptyType2 = activeType === 2;
                    vm.view.recommendEmptyType3 = activeType === 3;
                    if (!vm.view.recommendEmptyType2) {
                        //預設錯誤訊息為"熱門推薦類型"
                        vm.view.recommendEmptyType2 = !vm.view.recommendEmptyType2 && !vm.view.recommendEmptyType3;
                    }
                }

                vm.view.pageLoading = false;
                vm.view.pageLoaded = true;

                // 不知道為什麼不會自動跑動，所以在觸發一次囉
                $('#myCarousel').carousel({
                    interval: 5000
                });
            });
        }

        function loadData() {
            return trainingInnerService.getCarousel(activeType).then(function (result) {
                vm.data.carousel = result;
                //console.log("vm.data.carousel:", vm.data.carousel);
                //console.log("carousel $index",$index);
                vm.view.isMulitiData = result.length > 1;
            });
        }

        function viewChange(showArea) {
            vm.view.showCarousel = false;
            vm.view.showEmbed = false;

            switch (showArea) {
                case 'carousel':
                    vm.view.showCarousel = true;
                    break;
                case 'embed':
                    vm.view.showEmbed = true;
                    break;
                default:
                    break;
            }
        }

        function showImg(attachmentType) {
            return commonService.showImg(attachmentType);
        }

        function showVedio(attachmentType) {
            return commonService.showVedio(attachmentType);
        }

        function backList() {
            viewChange('carousel');
        }

        function carouselClick(carouselItem) {
            var newWindow;
            vm.data.carouselSelected = angular.copy(carouselItem);
            vm.data.carouselSelected.isUrl = false;
            vm.data.carouselSelected.url = vm.data.carouselSelected.url || "";
            if (vm.data.carouselSelected.url.length > 0) {
                vm.data.carouselSelected.isUrl = true;
            }
            switch (carouselItem.target) {
                case 2:
                    viewChange('embed');
                    break;
                case 3:
                    if (vm.data.carouselSelected.isUrl) {
                        window.location = vm.data.carouselSelected.url;
                        return;
                    } else {
                        sessionStorage.setItem('recommendHTML', vm.data.carouselSelected.activityContent);
                        $location.path('/tsu/recommendHTML');
                    }
                    break;
                case 1:
                    //開新視窗
                    newWindow = window.open('', '_blank');

                    if (vm.data.carouselSelected.isUrl) {
                        newWindow.location = vm.data.carouselSelected.url;
                    } else {
                        newWindow.document.write(vm.data.carouselSelected.activityContent);
                    }
                    newWindow.document.title = vm.data.carouselSelected.activityTitle;
                    commonService.setOneWindow(newWindow);
                    break;
                default:
                    newWindow = window.open('', '_blank');
                    if (vm.data.carouselSelected.isUrl) {
                        newWindow.location = vm.data.carouselSelected.url;
                    } else {
                        newWindow.document.write(vm.data.carouselSelected.activityContent);
                    }
                    newWindow.document.title = vm.data.carouselSelected.activityTitle;
                    commonService.setOneWindow(newWindow);
                    break;
            }
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.service').factory('recommendInnerService', recommendInnerService);

    function recommendInnerService() {
        var service = {};
        return service;
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('applicationFormTypeSelectorController', applicationFormTypeSelectorController);

    function applicationFormTypeSelectorController($q, $rootScope, $scope, $uibModalInstance, trainingInnerService) {
        var vm = this;
        vm.cancel = cancel;
        vm.TypeSelected = TypeSelected;

        onInit();

        function onInit() {
            var promiseList = [trainingInnerService.getExternaltype()];
            return $q.all(promiseList).then(function (receiveData) {
                //console.log(receiveData);
                //vm.type = receiveData[0];
                vm.type = _.filter(receiveData[0], function (o) {
                    return o.id !== -1;
                });
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function TypeSelected(data) {
            //console.log('TypeSelected:',data);
            $uibModalInstance.close(data);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('courseCategorySelectorController', courseCategorySelectorController);

    function courseCategorySelectorController($q, $rootScope, $scope, $uibModalInstance, trainingInnerService, categoryItem) {
        var vm = this;
        vm.cancel = cancel;
        vm.itemSelected = itemSelected;

        onInit();

        function onInit() {
            console.log('categoryItem:', categoryItem);
            vm.courseCategory = categoryItem;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function itemSelected(item) {
            var result = [];
            //courseItem.selectedItemName = item.showName;
            result.push(item);
            $uibModalInstance.close(result);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('courseListSelectorController', courseListSelectorController);

    function courseListSelectorController($q, $rootScope, $scope, $uibModalInstance, trainingInnerService, courseItem) {
        var vm = this;
        vm.cancel = cancel;
        vm.itemSelected = itemSelected;

        onInit();

        function onInit() {
            //console.log('courseItem:', courseItem);
            vm.courseList = courseItem.courseList;
            console.log('vm.courseList:', vm.courseList);
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function itemSelected(list, item) {
            var result = [];

            // courseItem.selectedItemName = item.showName;

            result.push(list);
            result.push(item);
            $uibModalInstance.close(result);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('myTrainingExteriorTimeModalController', myTrainingExteriorTimeModalController);

    function myTrainingExteriorTimeModalController($rootScope, $scope, $uibModalInstance, modalService, $q, saveList) {
        var vm = this;
        vm.ok = ok;
        vm.removeClassRange = removeClassRange;
        vm.saveAndNext = saveAndNext;
        vm.cancel = cancel;
        vm.tabDayOfMonth = tabDayOfMonth;
        vm.tabDayOfWeek = tabDayOfWeek;
        vm.openTimeSelector = openTimeSelector;
        //====Main====
        onInit();
        //============
        function dataInit() {
            //有空維護請將本頁面所使用到全部變數放置這裡視為宣告
            vm.checkView = {
                classDateValid: false,
                classTimeValid: false,
                LunchTimeValid: false,
                weekDayValid: false,
                formSubmited: false
            };
            vm.data = {
                times: [],
                hours: ['06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '00', '01', '02', '03', '04', '05'],
                mins: ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'],
                cycleTypeList: [{
                    value: 'week',
                    name: $rootScope.translate.tsunWeek || 'Week'
                }, {
                    value: 'month',
                    name: $rootScope.translate.tsunMonth || 'Month'
                }, {
                    value: 'year',
                    name: $rootScope.translate.tsunYear || 'Year'
                }],
                weekdays: {
                    '1': {
                        name: $rootScope.translate.tsunWeekMonday || 'Monday',
                        checked: false
                    },
                    '2': {
                        name: $rootScope.translate.tsunWeekTuesday || 'Tuesday',
                        checked: false
                    },
                    '3': {
                        name: $rootScope.translate.tsunWeekWednesday || 'Wednesday',
                        checked: false
                    },
                    '4': {
                        name: $rootScope.translate.tsunWeekThusday || 'Thusday',
                        checked: false
                    },
                    '5': {
                        name: $rootScope.translate.tsunWeekFriday || 'Friday',
                        checked: false
                    },
                    '6': {
                        name: $rootScope.translate.tsunWeekSaturday || 'Saturday',
                        checked: false
                    },
                    '0': {
                        name: $rootScope.translate.tsunWeekSunday || 'Sunday',
                        checked: false
                    }
                },
                cycleList: [{
                    value: 1,
                    name: '1'
                    // name: $rootScope.translate.tsunNumberOne || '一'
                }, {
                    value: 2,
                    name: '2'
                }, {
                    value: 3,
                    name: '3'
                }, {
                    value: 4,
                    name: '4'
                }, {
                    value: 5,
                    name: '5'
                }, {
                    value: 6,
                    name: '6'
                }, {
                    value: 7,
                    name: '7'
                }, {
                    value: 8,
                    name: '8'
                }, {
                    value: 9,
                    name: '9'
                }, {
                    value: 10,
                    name: '10'
                }],
                cycleValue: null,
                cycleType: null,
                hasRestTime: null,
                classDateStart: null,
                classDateEnd: null,
                sessionTimeStartHour: null,
                sessionTimeStartMin: null,
                sessionTimeEndHour: null,
                sessionTimeEndMin: null,
                restTimeStartHour: null,
                restTimeStartMin: null,
                restTimeEndHour: null,
                restTimeEndMin: null,
                saveList: saveList || []
            };
        }

        function onInit() {
            //若要看手機環境請將此參數改成True
            vm.isMobile = modalService.isMobile();

            dataInit();
            clearPageData();
        }

        function tabDayOfMonth() {
            vm.data.week = undefined;
            vm.data.cycleWeek = undefined;
        }

        function tabDayOfWeek() {
            vm.data.day = undefined;
        }

        function ok() {
            vm.checkView.formSubmited = true;
            if (!vm.data.classDateStart && !vm.data.classDateEnd && vm.data.saveList.length > 0) {
                //若無日期設定視為空值
                $uibModalInstance.close(vm.data.saveList);
                return;
            }
            if (!checkFormData()) {
                return;
            }
            return $q.when(pushDataToStore()).then(function () {
                $uibModalInstance.close(vm.data.saveList);
            });
        }

        function saveAndNext() {
            vm.checkView.formSubmited = true;
            if (!checkFormData()) {
                return;
            }
            return $q.when(pushDataToStore()).then(function () {
                clearPageData();
                vm.checkView.formSubmited = false;
                // console.log("vm.data.saveList", vm.data.saveList);
            });
        }

        function pushDataToStore() {
            // console.log("enter pushDataToStore");
            var singleData = {
                cycleValue: null,
                cycleType: null,
                hasRestTime: null,
                classDateStart: null,
                classDateEnd: null,
                sessionTimeStartHour: null,
                sessionTimeStartMin: null,
                sessionTimeEndHour: null,
                sessionTimeEndMin: null,
                restTimeStartHour: null,
                restTimeStartMin: null,
                restTimeEndHour: null,
                restTimeEndMin: null,
                showText: "",
                selectWeekday: [],
                innerDataDate: [],
                innerDataTime: []
            };
            var selectedWeekDayText = '';
            var classDateStartDate;
            var classDateEndDate;
            var cycleTimes = 0;
            var classDateStart;
            var classDateEnd;
            var classTime = [];
            _.forEach(singleData, function (value, key) {
                // console.log("key:", key, "value:", vm.data[key]);
                if (vm.data[key] === undefined) {
                    return;
                }
                singleData[key] = angular.copy(vm.data[key]);
            });
            _.forEach(vm.data.weekdays, function (value, key) {
                if (!value.checked) {
                    return;
                }
                singleData.selectWeekday.push(parseInt(key));
            });
            classDateStart = Date.parse(singleData.classDateStart);
            classDateEnd = Date.parse(singleData.classDateEnd);
            classDateStartDate = new Date(classDateStart);
            classDateEndDate = new Date(classDateEnd);
            if (!singleData.hasRestTime) {
                classTime = [format("{0}:{1}-{2}:{3}", singleData.sessionTimeStartHour, singleData.sessionTimeStartMin, singleData.sessionTimeEndHour, singleData.sessionTimeEndMin)];
            } else {
                classTime = [format("{0}:{1}-{2}:{3}", singleData.sessionTimeStartHour, singleData.sessionTimeStartMin, singleData.restTimeStartHour, singleData.restTimeStartMin), format("{0}:{1}-{2}:{3}", singleData.restTimeEndHour, singleData.restTimeEndMin, singleData.sessionTimeEndHour, singleData.sessionTimeEndMin)];
            }
            for (var date = new Date(classDateStart); date <= classDateEnd; date.setDate(date.getDate() + 1)) {
                var cycleCompareValue;
                var cycleBaseValue;
                switch (singleData.cycleType.type) {
                    case 'week':
                        cycleBaseValue = Math.floor(classDateStartDate.getDate() / 7);
                        cycleCompareValue = Math.floor(date.getDate() / 7);
                        break;
                    case 'month':
                        cycleBaseValue = classDateStartDate.getMonth();
                        cycleCompareValue = date.getMonth();
                        break;
                    case 'year':
                        cycleBaseValue = classDateStartDate.getFullYear();
                        cycleCompareValue = date.getFullYear();
                        break;
                    default:
                        cycleBaseValue = 0;
                        cycleCompareValue = 0;
                        break;

                }
                // console.log("cycleCompareValue", cycleCompareValue);
                // console.log("cycleBaseValue", cycleBaseValue);
                // console.log("singleData.cycleValue.value", singleData.cycleValue.value);
                cycleTimes = cycleCompareValue - cycleBaseValue;
                if (cycleTimes % singleData.cycleValue.value !== 0) {
                    continue;
                }
                if (singleData.selectWeekday.indexOf(date.getDay()) < 0) {
                    continue;
                }
                //==========
                var dateString = '';
                var dateYear = date.getFullYear() + '';
                var dateMonth = date.getMonth() + 1 + '';
                var dateDay = date.getDate() + '';
                dateString += dateYear.length < 2 ? '0' : '' + dateYear;
                dateString += '/' + (dateMonth.length < 2 ? '0' : '') + dateMonth;
                dateString += '/' + (dateDay.length < 2 ? '0' : '') + dateDay;
                for (var classTimeIndex = 0; classTimeIndex < classTime.length; classTimeIndex++) {
                    singleData.innerDataDate.push(dateString);
                    singleData.innerDataTime.push(classTime[classTimeIndex]);
                }
                // _.forEach(classTime, function (value) {
                // });
            }

            // var classDateStartDate;
            // var classDateEndDate;
            singleData.showText += format("{0}/{1}{2}/{3}{4}", classDateStartDate.getFullYear(), classDateStartDate.getMonth() < 9 ? "0" : "", classDateStartDate.getMonth() + 1, classDateStartDate.getDate() < 10 ? "0" : "", classDateStartDate.getDate());
            singleData.showText += format("~{0}/{1}{2}/{3}{4}", classDateEndDate.getFullYear(), classDateEndDate.getMonth() < 9 ? "0" : "", classDateEndDate.getMonth() + 1, classDateEndDate.getDate() < 10 ? "0" : "", classDateEndDate.getDate());

            selectedWeekDayText = '';
            if (singleData.selectWeekday.length < 7) {
                _.forEach(singleData.selectWeekday, function (value) {
                    if (selectedWeekDayText.length > 0) {
                        selectedWeekDayText += ',';
                    }
                    selectedWeekDayText += vm.data.weekdays[value].name;
                });
                selectedWeekDayText = format("<span style='word-break:break-word;'>({0})</span>", selectedWeekDayText);
            }

            if (singleData.cycleValue.value > 1) {
                singleData.showText += "<br/>";
                singleData.showText += format("<span>{0} {1} {2}:</span>{3}", $rootScope.translate.commonEvery, singleData.cycleValue.name, singleData.cycleType.name.toLowerCase(), selectedWeekDayText);
            } else if (selectedWeekDayText.length > 0) {
                singleData.showText += "<br/>";
                singleData.showText += selectedWeekDayText;
            }

            singleData.showText += format("<br/>{0}:{1}-{2}:{3}", singleData.sessionTimeStartHour, singleData.sessionTimeStartMin, singleData.sessionTimeEndHour, singleData.sessionTimeEndMin);
            if (singleData.hasRestTime) {
                singleData.showText += format("<br/>{0}:{1}:{2}-{3}:{4}", "午休", singleData.restTimeStartHour, singleData.restTimeStartMin, singleData.restTimeEndHour, singleData.restTimeEndMin);
            }

            // console.log("singleData", singleData);
            vm.data.saveList.push(singleData);
            // console.log("end pushDataToStore");
        }

        function clearPageData() {
            vm.data.cycleValue = vm.data.cycleValue = vm.data.cycleList[0];
            vm.data.cycleType = vm.data.cycleType = vm.data.cycleTypeList[0];
            vm.data.hasRestTime = false;
            vm.data.classDateStart = "";
            vm.data.classDateEnd = "";
            vm.data.sessionTimeStartHour = vm.data.hours[0];
            vm.data.sessionTimeStartMin = vm.data.mins[0];
            vm.data.sessionTimeEndHour = vm.data.hours[0];
            vm.data.sessionTimeEndMin = vm.data.mins[0];
            vm.data.restTimeStartHour = vm.data.hours[6];
            vm.data.restTimeStartMin = vm.data.mins[0];
            vm.data.restTimeEndHour = vm.data.hours[7];
            vm.data.restTimeEndMin = vm.data.mins[0];
            _.forEach(vm.data.weekdays, function (value) {
                value.checked = true;
            });
            // console.log("clearPageData , vm.data:", vm.data);
        }

        function checkFormData() {
            // console.log("enter checkFormData , vm.data:", vm.data);
            var result = false;
            var classDateStart = Date.parse(vm.data.classDateStart); // 
            var classDateEnd = Date.parse(vm.data.classDateEnd);
            var calssTimeStart = new Date("2000", "01", "01", vm.data.sessionTimeStartHour, vm.data.sessionTimeStartMin, "00");
            var calssTimeEnd = new Date("2000", "01", "01", vm.data.sessionTimeEndHour, vm.data.sessionTimeEndMin, "00");
            var isClassLunchTime = vm.data.hasRestTime;
            var classLunchTimeStart = new Date("2000", "01", "01", vm.data.restTimeStartHour, vm.data.restTimeStartMin, "00");
            var classLunchTimeEnd = new Date("2000", "01", "01", vm.data.restTimeEndHour, vm.data.restTimeEndMin, "00");
            // var cycleType = vm.data.cycleType;
            // var cycleValue = vm.data.cycleValue;
            vm.checkView.classDateValid = false;
            vm.checkView.classTimeValid = false;
            vm.checkView.LunchTimeValid = false;
            vm.checkView.weekDayValid = false;
            if (classDateStart && classDateEnd) {
                //驗證上課日期
                vm.checkView.classDateValid = classDateEnd >= classDateStart;
            }
            if (calssTimeStart && calssTimeEnd) {
                //驗證上課時間
                vm.checkView.classTimeValid = calssTimeEnd > calssTimeStart;
            }
            if (!isClassLunchTime) {
                vm.checkView.LunchTimeValid = true;
            } else if (classLunchTimeStart && classLunchTimeEnd) {
                //驗證午休
                vm.checkView.LunchTimeValid = classLunchTimeEnd > classLunchTimeStart || !isClassLunchTime;
            }
            if (vm.checkView.LunchTimeValid && isClassLunchTime) {
                //驗證午休與上課時間
                vm.checkView.LunchTimeValid = calssTimeEnd >= classLunchTimeEnd && classLunchTimeStart >= calssTimeStart;
            }
            //驗證上課日
            var selectWeekday = [];
            _.forEach(vm.data.weekdays, function (value, key) {
                if (value.checked) {
                    selectWeekday.push(parseInt(key));
                }
            });
            for (var date = new Date(classDateStart); date <= classDateEnd; date.setDate(date.getDate() + 1)) {
                if (vm.checkView.weekDayValid) {
                    break;
                }
                if (selectWeekday.indexOf(date.getDay()) >= 0) {
                    vm.checkView.weekDayValid = true;
                }
            }

            result = vm.checkView.classDateValid && vm.checkView.classTimeValid && vm.checkView.LunchTimeValid && vm.checkView.weekDayValid;

            if (result === false) {
                toastr.warning($rootScope.translate.tsunErrorExteriorTimeEmpty);
            }
            return result;
        }

        function removeClassRange(index) {
            var confirmDialog = modalService.confrimDialog({
                confirmContent: format("{0}\r\n{1}", $rootScope.translate.tsunConfirmRemove, "")
            });
            confirmDialog.result.then(function (result) {
                result = !!result;
                if (result !== true) {
                    return;
                }
                vm.data.saveList.splice(index, 1);
            });
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function openTimeSelector(type, title) {
            var data = null;
            var isCycle = false;
            switch (type) {
                case 'sh': //小時
                case 'eh':
                case 'rsh':
                case 'reh':
                    data = vm.data.hours;
                    break;
                case 'sm': //分鐘
                case 'em':
                case 'rsm':
                case 'rem':
                    data = vm.data.mins;
                    break;
                case 'c':
                    //循環週期
                    data = vm.data.cycleList;
                    isCycle = true;
                    break;
                case 'u':
                    //循環週期單位
                    data = vm.data.cycleTypeList;
                    isCycle = true;
                    break;
            }

            var result = modalService.openOptionSelector(data, title, isCycle);
            console.log('openTimeSelector:', result);
            result.result.then(function (data) {
                switch (type) {
                    case 'sh':
                        //開始小時
                        vm.data.sessionTimeStartHour = data;
                        break;
                    case 'eh':
                        //結束小時
                        vm.data.sessionTimeEndHour = data;
                        break;
                    case 'sm':
                        //開始分鐘
                        vm.data.sessionTimeStartMin = data;
                        break;
                    case 'em':
                        //結束分鐘
                        vm.data.sessionTimeEndMin = data;
                        break;
                    case 'rsh':
                        //休息開始小時
                        vm.data.restTimeStartHour = data;
                        break;
                    case 'reh':
                        //休息結束小時
                        vm.data.restTimeEndHour = data;
                        break;
                    case 'rsm':
                        //休息開始分鐘
                        vm.data.restTimeStartMin = data;
                        break;
                    case 'rem':
                        //休息結束分鐘
                        vm.data.restTimeEndMin = data;
                        break;
                    case 'c':
                        //循環週期
                        //vm.data.cycleValue.value = data.id;
                        //vm.data.cycleValue.name = data.name;
                        vm.data.cycleValue = data;
                        break;
                    case 'u':
                        //循環週期單位
                        //vm.data.cycleType.value = data.id;
                        //vm.data.cycleType.name = data.name;
                        vm.data.cycleType = data;
                        break;
                }
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('myTrainingOrganizerModalController', myTrainingOrganizerModalController);

    function myTrainingOrganizerModalController($scope, $rootScope, $uibModalInstance, params, choiceList, modalService) {
        var vm = this;
        vm.send = send;
        vm.checkboxClick = checkboxClick;
        vm.searchResultEnd = searchResultEnd;
        vm.searchData = searchData;
        vm.cancel = cancel;
        vm.isApp = false;
        onInit();

        function dataInit() {
            vm.data = {
                checkedList: choiceList || [],
                sourceData: params || [],
                listData: [] //.....................主辦單位清單
            };
            vm.view = {
                // showOther: false,
                emptyParams: false, //..........尚未輸入收尋條件
                buttonShow: false, //...........確定按鈕是否出現(包含浮動)
                staticButtonShow: false, //.....確定按鈕是否出現(固定按鈕)
                orgSearchEmpty: false //.......主辦單位清單為空
            };
        }

        function logicInit() {
            vm.search = '';
            _.forEach(vm.data.sourceData, function (item) {
                item.checked = _.findIndex(vm.data.checkedList, { "id": item.id }) > -1;
                item.CheckValue = item.checked;
            });
            // searchData();
        }

        function onInit() {
            if (DEVICE_TOKEN !== null || DEVICE_TYPE !== null) {
                //console.log('isApp:', vm.isApp);
                vm.isApp = true;
            }
            dataInit();
            logicInit();
            Jquery();
        }

        function send() {
            var result = [];
            _.forEach(vm.data.listData, function (item) {
                if (item.Check) {
                    result.push(item);
                }
            });
            $uibModalInstance.close(result);
        }

        function searchData() {
            $(document).trigger('submitSearchStart', {});
            vm.view.buttonShow = false;
            vm.view.emptyParams = false;
            vm.data.listData = [];
            // =====
            vm.search = vm.search || '';
            if (vm.search.length < 1) {
                vm.view.emptyParams = true;
                toastr.warning($rootScope.translate.tsunFormMsgRequiredEmpty);
                return;
            }
            // =====
            if (vm.search) {
                var regExpCompare = new RegExp(vm.search, "g");
                _.forEach(vm.data.sourceData, function (item) {
                    if (item.name.match(regExpCompare)) {
                        vm.data.listData.push(angular.copy(item));
                    }
                });
                vm.view.orgSearchEmpty = vm.data.listData.length < 1;
            } else {
                vm.data.listData = angular.copy(vm.data.sourceData);
            }
            // vm.data.listData.push({ id: 0, name: $rootScope.translate.tsunOther });
        }

        function checkboxClick(item) {
            if (item.checked) {
                return;
            }
            var itemChecked = !item.Check;
            item.Check = itemChecked;
            item.CheckValue = itemChecked;
            checkHasClick();
        }

        function checkHasClick() {
            var checkedItemIndex = _.findIndex(vm.data.listData, { Check: true });
            vm.view.buttonShow = checkedItemIndex > -1;
            // console.log("call checkboxClick , trigger:", vm.view.buttonShow);
            $(document).trigger('checkboxClick', [vm.view.buttonShow]);
        }

        function searchResultEnd() {
            $(document).trigger('submitSearchEnd', {});
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
        //======Jquery
        function Jquery() {
            $(document).off('floatButtonDisplay').on('floatButtonDisplay', function (event, triggerResult) {
                var staticButtonShow = !triggerResult;
                if (vm.view.staticButtonShow !== staticButtonShow) {
                    vm.view.staticButtonShow = staticButtonShow;
                    if (!$scope.$$phase) {
                        $scope.$digest();
                    }
                }
            });
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('myTrainingSelectActionConfirmModalController', myTrainingSelectActionConfirmModalController);

    function myTrainingSelectActionConfirmModalController($uibModalInstance, $interval, $scope, ctmsConfirmTime, loginService, $location, $rootScope, $uibModalStack) {
        var DEFUALT_CONFIRMTIME = 10;
        var vm = this;
        vm.containu = containu;
        //==========
        init();
        //==========

        function init() {
            // console.log("myTrainingSelectActionConfirmModalController,ctmsConfirmTime:", ctmsConfirmTime);
            dataInit();
            logicInit();
        }
        function dataInit() {
            vm.data = {
                ctmsConfirmTime: ctmsConfirmTime || DEFUALT_CONFIRMTIME //.......倒數計時
            };
        }
        function logicInit() {
            var promise = $interval(function () {
                // console.log("ctmsConfirmTime:",ctmsConfirmTime);
                vm.data.ctmsConfirmTime--;
                if (vm.data.ctmsConfirmTime < 1) {
                    // 移除目前所有 modal 視窗 
                    $uibModalStack.dismissAll();
                    $interval.cancel(promise);
                }
            }, 1000, vm.data.ctmsConfirmTime);

            $scope.$on('$destroy', function () {
                $interval.cancel(promise);
            });
        }

        function containu() {
            $uibModalInstance.close();
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('myTrainingSelectActionModalController', myTrainingSelectActionModalController);

    function myTrainingSelectActionModalController($uibModalInstance, $interval, $uibModal, $scope, $sce, $window, trainingInnerService, $timeout, courseService, modalService, $q, viewModel, ctmsService, enumService, $location, loginService, $rootScope, commonService, $anchorScroll, _sessionDecaySecs, $http, headerService, mobileService, apiUrl) {
        var DEFAULT_POPUPTIME = 600; //預設10分鐘
        var default_ctmsCourseTimeInterval = 300; //固定回傳時隔，預設5分鐘
        var vm = this;
        var timer, viewTimeInterval, sessionTimeInterval;
        vm.isMobile = modalService.isMobile();
        vm.setPathUrl = setPathUrl;
        vm.cancel = cancel;
        vm.vgPlayReady = vgPlayReady;
        vm.vgComplete = vgComplete;
        vm.actionSubmit = actionSubmit;
        vm.choiceSelectActive = choiceSelectActive;
        vm.returnActiveList = returnActiveList;
        vm.sessionChoice = sessionChoice;
        vm.tabChange = tabChange;
        vm.goTop = goTop;
        vm.setPercentStyle = setPercentStyle;
        vm.enum = {
            courseType: enumService.courseType
        };
        vm.pdfIsDone = false;
        vm.durationView = durationView;
        vm.postToIos = postToIos;
        vm.setSession = setSession;

        var mobile = {
            Android: function Android() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function BlackBerry() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function iOS() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function Opera() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function Windows() {
                return navigator.userAgent.match(/IEMobile/i);
            },
            any: function any() {
                return mobile.Android() || mobile.BlackBerry() || mobile.iOS() || mobile.Opera() || mobile.Windows();
            }
        };

        function durationView() {
            return intConvertTime(vm.view.viewTime);
        }

        //===Main==
        init();
        window.addEventListener("beforeunload", function (event) {

            postLearningRecord(false, true);
            var confirmationMessage = "\o/";
            (e || event).returnValue = confirmationMessage; //Gecko + IE
            return confirmationMessage; //Webkit, Safari, Chrome etc.
        });
        //=========
        function init() {
            dataInit();
            logicInit();

            $scope.$on('goTop', function () {
                goTop();
            });
            $scope.$on('emitExamSubmit', function () {
                postLearningRecord(false, true);
            });
            $scope.$on('$destroy', function () {
                $interval.cancel(viewTimeInterval);
                $interval.cancel(sessionTimeInterval);
                $timeout.cancel(timer);
            });
            // console.log("vm.view.sessionTime", vm.view.sessionTime);
            // console.log("$rootScope.userInfo",$rootScope.userInfo);
            sessionTimeInterval = $interval(function () {
                loginService.checkToken();
                // console.log("sessionTimeInterval checkToken");
            }, vm.view.sessionTime);
        }

        function dataInit() {
            viewModel = viewModel || {};
            vm.timeConfig = viewModel.timeConfig || {};
            vm.data = {
                pdfUrl: "", //............................正在觀看的pdfUrl
                iframeUrl: "", //.........................正在觀看的IframeUrl
                courseItem: null, //......................正在執行的學習動作教材內容(WS3)
                studyActivity: null, //..................正在觀看的學習動作
                importCourse: viewModel.item || null, //.理論上是清單列傳入的班次課程
                courageItem: null, //.....................學程資料
                courageDetail: null, //...................學程詳細資料
                courageActive: null, //...................學程包含學習動作(WS14)
                courageAction: null, //...................學程包含動作(由courageActive抽出整理)
                sessionItem: null, //.....................班次資料
                sessionDetail: null, //...................班次詳細資料
                sessionActives: null, //..................班次包含學習動作(WS14)
                sessionLms: null, //......................班次包含學習項目(由sessionActives加工整理)
                sessionAction: null, //...................班次包含學習動作(由sessionActives抽出整理)
                ctmsTime: vm.timeConfig.ctmsTime /*8*/ || DEFAULT_POPUPTIME, //.........學習項目觀看時，確認繼續課程的顯示倒數計時(秒)
                ctmsCourseTimeInterval: vm.timeConfig.ctmsCourseTimeInterval || default_ctmsCourseTimeInterval //.........學習項目觀看時，固定回傳時隔

            };
            vm.config = {
                sources: [],
                tracks: [{
                    src: "http://www.videogular.com/assets/subs/pale-blue-dot.vtt",
                    kind: "subtitles",
                    srclang: "en",
                    label: "English",
                    default: ""
                }]
            };
            vm.view = {
                contentCourage: false,
                contentCourse: false,
                isDownload: false,
                isShowPdf: false,
                isShowVideo: false,
                isShowExam: false,
                isShowIframe: false,
                viewTime: 0,
                pageLoad: false,
                sessionTime: 0,
                activeContent: false,
                activeList: false,
                couragePage: false, //.............學程頁面
                sessionPage: false //.............班次頁面
            };
            vm.vgApi = null;
            vm.tabSelected = 1;
        }

        function logicInit() {
            vm.view.sessionTime = ($rootScope.userInfo.sessionTime <= 3 ? 20 : $rootScope.userInfo.sessionTime) * 60000;
            vm.view.sessionTime -= 1000 * 120; //TODO 不懂為何要減掉。
            vm.view.sessionTime = vm.view.sessionTime || _sessionDecaySecs;
            switch (vm.data.importCourse.courseType) {
                case 7:
                    //學程
                    courageInit(vm.data.importCourse).then(function () {
                        Accordion();
                        vm.view.couragePage = true;
                    });
                    break;
                default:
                    //非學程就直接處理課程資訊
                    sessionInit(vm.data.importCourse).then(function () {
                        Accordion();
                        vm.view.sessionPage = true;
                    });
                    break;
            }
        }

        function courageInit(importItem) {

            vm.data.courageItem = null;
            vm.data.courageDetail = null;
            vm.data.courageActive = null;
            vm.data.courageAction = null;
            if (!importItem) {
                return;
            }
            vm.data.courageItem = angular.copy(importItem);
            var selectActive = trainingInnerService.getSelectActive(vm.data.courageItem);
            var courseDetail = trainingInnerService.getCourseDetail(vm.data.courageItem);
            // console.log("translate:", $rootScope.translate);
            return $q.all([selectActive, courseDetail]).then(function (data) {
                var selectActiveResult = data[0];
                var courseDetailResult = data[1];
                vm.data.courageDetail = detailFormat(courseDetailResult);
                vm.data.courageActive = selectActiveResult;
                vm.data.courageAction = actionItemFormat(selectActiveResult.availableActions);
                _.forEach(vm.data.courageDetail.courses, function (courseItem) {
                    if (courseItem.status && courseItem.progress) {
                        return;
                    }
                    trainingInnerService.getSelectActive(courseItem).then(function (data) {
                        courseItem.status = 'get status Error';
                        courseItem.progress = null;
                        if (!data) {
                            return;
                        }
                        courseItem.status = '';
                        courseItem.progress = '';
                        if (data.status) {
                            courseItem.status = statusConvert(data.status);
                        }
                        if (data.progress) {
                            courseItem.progress = data.progress;
                        }
                    });
                });
            });
        }

        function statusConvert(statusCode) {
            //通過狀態的多國語系轉換
            if (!statusCode) {
                return '';
            }
            switch (statusCode + '') {
                case '-1':
                    // return $rootScope.translate.tsunPassStatusValueNotCourage;
                    return '';
                case '0':
                    return $rootScope.translate.tsunPassStatusValueNA;
                case '1':
                    return $rootScope.translate.tsunPassStatusValueExemption;
                case '2':
                    return $rootScope.translate.tsunPassStatusValueOK;
                case '3':
                    return $rootScope.translate.tsunPassStatusValueNotOK;
                default:
                    return '';
            }
        }

        function sessionInit(importItem) {
            vm.data.sessionItem = null;
            vm.data.sessionDetail = null;
            vm.data.sessionActives = null;
            vm.data.sessionAction = null;
            vm.data.sessionLms = null;
            if (!importItem) {
                return;
            }
            vm.data.sessionItem = angular.copy(importItem);
            var selectActive = trainingInnerService.getSelectActive(vm.data.sessionItem);
            var courseDetail = trainingInnerService.getCourseDetail(vm.data.sessionItem);
            return $q.all([selectActive, courseDetail]).then(function (data) {
                // console.log('selectActive:', selectActive);
                // console.log('courseDetail:', courseDetail);
                //console.log('data:', data);
                var selectActiveResult = data[0];
                var courseDetailResult = data[1];
                // console.log("selectActiveResult:",selectActiveResult);
                vm.data.sessionDetail = detailFormat(courseDetailResult);
                vm.data.sessionActives = selectActiveResult;
                vm.data.sessionAction = actionItemFormat(selectActiveResult.availableActions);
                vm.data.sessionLms = lmsItemsFormat(vm.data.sessionItem);
            });
        }

        function detailFormat(sourceData) {
            var detailData = angular.copy(sourceData);
            if (!detailData) {
                return detailData;
            }
            //===========
            var brCheck = /(\r?\n)/g;
            _.forEach(detailData, function (value, key) {
                var isInt = value === parseInt(value, 10);
                var isString = typeof value === "string";
                if (isInt) {
                    var isAsNull = value < 0;

                    if (isAsNull) {
                        detailData[key] = null;
                    } else {
                        detailData[key] = value + '';
                    }
                } else if (isString) {
                    detailData[key] = value.replace(brCheck, "<br/>");
                }
            });
            //===========
            if (detailData.reference) {
                //檢查參考文件格式
                if (!angular.isArray(detailData.reference)) {
                    //參考文件必須是陣列
                    detailData.reference = null;
                }
                if (detailData.reference.length <= 0) {
                    //參考文件必須有內容
                    detailData.reference = null;
                }
            }
            return detailData;
        }

        function sessionChoice(sessionItem) {
            vm.view.couragePage = false;
            vm.view.sessionPage = true;
            if (!sessionItem.courseType) {
                sessionItem.courseType = 1;
            }
            sessionInit(sessionItem).then(function () {
                vm.tabSelected = 1;
                //console.log("typeof Accordion", typeof Accordion);
                //如果有要製作等待頁面讀取中可以在此實作後續機制
            });
        }

        function setPathUrl(filePath) {
            var pathUrl = commonService.ctmsFilePath(filePath);
            return pathUrl;
        }

        function actionItemFormat(actionList) {
            //---處理Sunnet WS14 availableActions屬性
            var result = [];
            _.forEach(actionList, function (value) {
                var perItem = { name: '', action: '' };
                perItem.action = angular.copy(value);
                switch (value.toLowerCase()) {
                    case "enroll":
                        perItem.name = $rootScope.translate.tsunActionEnroll;
                        break;
                    case "cancel":
                        perItem.name = $rootScope.translate.tsunActionCancel;
                        break;
                    case "leave":
                        perItem.name = $rootScope.translate.tsunActionLeave;
                        break;
                    case "exemption":
                        perItem.name = $rootScope.translate.tsunActionExemption;
                        break;
                    default:
                        perItem.name = value;
                        break;
                }
                result.push(perItem);
            });
            return result;
        }

        function lmsItemsFormat(sessionItem) {
            if (!vm.data.sessionActives) {
                return;
            }
            var activeItem = [];
            var perItem;
            //====加入出缺席狀況
            if (sessionItem.courseType === vm.enum.courseType.classCourse || sessionItem.courseType === vm.enum.courseType.externalCourse) {
                perItem = {};
                perItem.isAction = false;
                perItem.itemName = format("【{0}】", $rootScope.translate.tsunAttendanceRate);
                perItem.status = vm.data.sessionActives.attendanceRate + "%";
                perItem.extraInfo = "";
                activeItem.push(angular.copy(perItem));
            }
            //====加入報告繳納資訊
            if (vm.data.sessionActives.reportTotal > 0) {
                perItem = {};
                perItem.isAction = false;
                perItem.itemName = format("【{0}】{1}", $rootScope.translate.tsunReportsInfo, $rootScope.translate.tsunClassReportNote);
                perItem.status = format("{0} / {1}", vm.data.sessionActives.reportSubmitted, vm.data.sessionActives.reportTotal);
                perItem.extraInfo = "";
                activeItem.push(angular.copy(perItem));
            }
            //====加入學習動作
            if (vm.data.sessionActives.lmsItems) {
                _.forEach(vm.data.sessionActives.lmsItems, function (value) {
                    if (value.action) {
                        if (value.action.length < 1) {
                            value.action = null;
                        }
                    }
                    value.isAction = true;
                    activeItem.push(value);
                });
            }

            return activeItem;
        }

        function refreshViewTime() {
            $q.when(viewTimeStop()).then(function () {
                viewTimeStart();
            });
        }

        function viewTimeStart() {
            vm.view.viewTime = 0;
            viewTimeInterval = $interval(function () {
                vm.view.viewTime++;
            }, 1000);
            // console.log("viewTimeInterval", viewTimeInterval);
        }

        function viewTimeStop() {
            $interval.cancel(viewTimeInterval);
            $timeout.cancel(timer);
        }

        function countTimeStart() {
            appCallback('countDown-02_beforeTimer', null);
            timer = $timeout(function () {
                //console.log("timer time out",timer);
                //先改成倒數前送出學習紀錄

                appCallback('countDown-02', null);

                postLearningRecord(false, false);
                confirmForDesktop();
            }, vm.data.ctmsTime * 1000);
            //console.log("timer",timer);
        }

        function confirmForDesktop() {
            if (vm.view.isShowVideo && vm.vgApi) {
                vm.vgApi.pause();
                vm.vgApi.closeFullScreen();
            }
            //======
            var param = {
                SessionId: angular.copy(vm.data.sessionItem.sessionId),
                ItemId: angular.copy(vm.data.studyActivity.itemId),
                Duration: intConvertTime(vm.view.viewTime)
            };
            modalService.selectActionConfirm(vm.timeConfig.ctmsConfirmTime, param).result.then(function (data) {
                // console.log('before postRecord :',data);
                // postLearningRecord(false, false);
                if (data === 'logout') {
                    $uibModalInstance.dismiss('cancel');
                    $location.path('/');
                    return;
                }
                refreshViewTime();
                if (vm.view.isShowVideo) {
                    vm.vgApi.play();
                }
                countTimeStart();
            });
        }

        function cancel() {
            if (vm.view.pageLoad) {
                postLearningRecord(false, true);
            }
            // $uibModalInstance.dismiss('cancel');
            $uibModalInstance.close();
        }

        function vgPlayReady(api) {
            vm.vgApi = api;
        }

        function vgComplete() {
            postLearningRecord(true, false);
        }

        function postLearningRecord(alert, reset) {

            //因內嵌網頁需要，多加一個sessionStorage 變數
            if (sessionStorage.getItem('IsLearningRecordCommit') == 'true') {
                if (!vm.data.studyActivity) {
                    return null;
                }
                if (vm.data.studyActivity.type === '測驗' || vm.data.studyActivity.type === '問卷') {
                    //測驗與問卷不回傳時數。
                    return;
                }

                var param = {
                    SessionId: angular.copy(vm.data.sessionItem.sessionId),
                    ItemId: angular.copy(vm.data.studyActivity.itemId),
                    Duration: intConvertTime(vm.view.viewTime)
                };

                //console.log("enter postLearningRecord");
                var result = trainingInnerService.postLearningRecord(param, alert);
                result.then(function (data) {
                    // toastr.success('ok oh');
                }).catch(function (reason) {
                    // chris: log for mobile
                    // toastr.error(JSON.stringify(reason));
                    toastr.error('發送學習記錄失敗');
                });
                if (reset) {
                    vm.data.studyActivity = null;
                }
                // console.log("end postLearningRecord");
            }
        }

        function actionSubmit(enrollTarget, action) {
            // 申請項目呼叫事件
            // 呼叫完畢要重讀頁面資訊

            trainingInnerService.postSessionAction(enrollTarget, action).then(function () {
                if (enrollTarget.courseType === 7) {
                    courageInit(angular.copy(vm.data.courageItem));
                } else {
                    sessionInit(angular.copy(vm.data.sessionItem));
                }
            });
        }

        function initViewState() {
            clearAll();
            if (vm.data.studyActivity) {
                switch (vm.data.studyActivity.type) {
                    case '影片':
                        trainingInnerService.getCourseItems(vm.data.studyActivity).then(function (data) {
                            vm.data.courseItem = data;
                            changeActivityType();
                        });
                        break;
                    case '課程內容':
                        trainingInnerService.getCourseItems(vm.data.studyActivity).then(function (data) {
                            vm.data.courseItem = data;
                            changeActivityType();
                        });
                        break;
                    case '問卷':
                        changeExam();
                        break;
                    case '測驗':
                        changeExam();
                        break;
                    default:
                        break;
                }
            }
        }

        function changeActivityType() {
            var path = vm.data.courseItem.path || '';
            if (vm.data.courseItem.href && path.length > 0) {
                path = path + '/' + vm.data.courseItem.href;
            } else if (vm.data.courseItem.href) {
                path = vm.data.courseItem.href || '';
            } else {
                // path = path;
            }
            path = path.replace("\\", "/");
            var pathUrl = setPathUrl(path);
            vm.data.courseItem.fileUrl = path;
            // console.log("changeActivityType....courseItem:", vm.data.courseItem, "....pathGo:", pathUrl);
            // $q.when(fileExist(pathUrl)).then(function (result) {


            // 取出已觀看時間 + 放於 session storage 中
            // 寫在這邊是因為不只 mp4 會用到，連 html 都會需要這個參數
            var itemId = vm.data.courseItem.id;
            var sessionLm = _.find(vm.data.sessionLms, function (o) {
                return o.itemId === itemId;
            });
            if (sessionLm) {
                var seconds = moment.duration(sessionLm.viewedTime).asSeconds();
                sessionStorage.setItem('CtmsSeekTime', seconds);
                console.log('target sessionLm:', sessionLm);
            }

            setSession(vm.data.courseItem); //給內嵌網頁的SessionStorage
            fileExist(vm.data.courseItem).then(function (result) {
                var fileExtension = getFileExtension(pathUrl);
                switch (fileExtension) {
                    //case 'mp4':
                    //    appCallback('countDown-01,' + DEVICE_TYPE, null);
                    //    //if (!(mobile.iOS() && window.webkit)) {
                    //    if (!(mobile.iOS() && window.webkit) || DEVICE_TYPE == 'Android') {
                    //        countTimeStart();
                    //    }
                    //    vm.view.isShowVideo = true;
                    //    vm.vgApi.clearMedia();
                    //    var videos = [];
                    //    vm.accessBegin = moment(new Date()).format('YYYY/MM/DD HH:mm:ss');
                    //    videos.push({
                    //        src: pathUrl,
                    //        type: 'video/mp4'
                    //    });
                    //    vm.config.sources = videos;
                    //    // ready for ios video player
                    //    if (mobile.iOS() && window.webkit) {
                    //        //if(true){
                    //        // pass param to ios and open player
                    //        postToIos(vm.data.courseItem, pathUrl);
                    //        returnActiveList();
                    //    } else {
                    //        $timeout(function() {

                    //            // 從 sessoin storage 取出已觀看時間 
                    //            let ctmsSeekTime = parseInt(sessionStorage.getItem('CtmsSeekTime'));
                    //            ctmsSeekTime = !!ctmsSeekTime ? ctmsSeekTime - 120 : 0;  // 需往前兩分鐘
                    //            if (ctmsSeekTime && ctmsSeekTime > 0) {

                    //                // 詢問是否從上次結束觀看影片的地方開始撥放 
                    //                // 只有在 Android 裝置上才需要執行的功能
                    //                var seekTimeConfirm = modalService.confrimDialog({
                    //                    confirmContent: $rootScope.translate.displayVideoFromLastView,
                    //                });

                    //                seekTimeConfirm.result.then(function(result) {
                    //                    if (result) {
                    //                        // 跳至特定時間開始看
                    //                        vm.vgApi.seekTime(ctmsSeekTime, false /*byPercent*/);
                    //                    } 

                    //                    // 撥放影片
                    //                    vm.vgApi.play();
                    //                });
                    //            } else {
                    //                // 沒有觀看紀錄，直接撥放影片
                    //                vm.vgApi.play();
                    //            }


                    //        }, vm.vgApi.isReady);
                    //    }
                    //    break;
                    case 'pdf':
                        countTimeStart();
                        //window.open(ctmsService.getStampFile(vm.data.courseItem.path, vm.data.courseItem.name), '_blank');
                        //console.log("path:", vm.data.courseitem.path);
                        //console.log("name:", vm.data.courseitem.name);
                        vm.url = ctmsService.getStampFile(vm.data.courseItem.path, vm.data.courseItem.name);
                        console.log("vm Url:", vm.url);
                        var a = document.createElement('a');
                        var el = document.body.appendChild(a);
                        el.setAttribute('style', 'display: none');
                        el.href = vm.url;
                        el.click();
                        //console.log("pdf pathUrl:", apiUrl.pafUrl);
                        //vm.data.pdfUrl = pathUrl;
                        /*
                            Johnson 做法用於pdf專屬站台，客戶不接受資安解釋。(//10.20.30.155:11001/?pdf=)
                        //vm.data.pathUrl = apiUrl.pafUrl+pathUrl;
                        */
                        //vm.view.isShowPdf = true;
                        //vm.pdfIsDone = true;
                        break;
                    case 'mp4':
                    case 'html':
                    case 'htm':
                        //內容不明
                        //countTimeStart();
                        vm.data.iframeUrl = pathUrl;
                        vm.view.isShowIframe = true;
                        //要把內嵌網頁觀看邏輯補上
                        break;
                    default:
                        //TODO 下載檔案回報時數?太奇怪了，暫時先取消這邊邏輯
                        vm.downloadItem = {
                            path: pathUrl,
                            name: vm.data.courseItem.name
                        };
                        vm.view.isDownload = true;
                        break;
                }
            }, function errorEvent(result) {
                //顯示檔案不存在並結束
                // console.log("errorResult", result);
                //ios不需要後續動作
                tabChange(1);
                return;
            });
        }

        // 問卷
        function changeExam() {
            countTimeStart();
            vm.view.isShowExam = true;
        }

        function clearAll() {
            if (vm.vgApi) {
                vm.vgApi.stop();
            }
            vm.view.isDownload = false;
            vm.view.isShowPdf = false;
            vm.view.isShowVideo = false;
            vm.view.isShowExam = false;
            vm.view.isShowIframe = false;
        }

        function tabChange(index) {
            postLearningRecord(false, true);
            viewTimeStop();
            clearActive();
            switch (index) {
                case 0:
                    //case 2:
                    vm.view.couragePage = true;
                    vm.view.sessionPage = false;
                    if (vm.data.courageItem) {
                        courageInit(angular.copy(vm.data.courageItem)).then(function () {
                            // if (typeof Accordion === 'function') {
                            //     Accordion();
                            // }
                            //如果有要製作等待頁面讀取中可以在此實作後續機制
                        });
                    }
                    break;
                case 1:
                    vm.view.activeList = true;
                    if (vm.data.sessionItem) {
                        sessionInit(angular.copy(vm.data.sessionItem)).then(function () {
                            // if (typeof Accordion === 'function') {
                            //     Accordion();
                            // }
                            //如果有要製作等待頁面讀取中可以在此實作後續機制
                        });
                    }
                    break;
                default:
                    break;
            }
        }

        function clearActive() {
            viewTimeStop();
            postLearningRecord(false, true);
            clearActiveView();
            clearAll();
        }

        function choiceSelectActive(item) {
            clearActive();
            vm.data.studyActivity = angular.copy(item);
            vm.view.pageLoad = true;
            vm.view.activeContent = true;
            initViewState();
            refreshViewTime();
        }

        function goTop() {
            $location.hash('PageTop');
            $anchorScroll();
            $location.hash('');
        }

        function returnActiveList() {
            //學習動作回清單列
            //console.log("returnActiveList");
            clearActive();

            if (vm.data.sessionItem) {
                sessionInit(angular.copy(vm.data.sessionItem)).then(function () {
                    vm.view.activeList = true;
                });
            }
        }

        function clearActiveView() {
            vm.view.activeContent = false;
            vm.view.activeList = false;
        }

        function setPercentStyle(item) {
            var progress;
            var percentage;
            var style = {};
            if (item.progress && item.progress.length > 0) {
                progress = item.progress.split('/');
                if (progress.length < 2) {
                    item.progress = null;
                    progress = ['0', '1'];
                }
            } else {
                item.progress = null;
                progress = ['0', '1'];
            }
            percentage = 100 * (parseFloat(progress[0]) / parseFloat(progress[1]));
            percentage = parseInt(percentage) + '';
            if (percentage === '0') {
                style = { 'display': 'none' };
            } else {
                style = { 'width': percentage + '%' };
            }
            return style;
        }
        // function fileExist(pathUrl) {
        //     var request = new XMLHttpRequest();
        //     request.open('HEAD', pathUrl, false);
        //     request.send();
        //     // console.log("path", pathUrl);
        //     // console.log("request.status", request.status);
        //     return (request.status === 200);
        // }

        function fileExist(item) {
            //console.log("fileExist,source:", item);
            // return $q.when(true);
            return trainingInnerService.checkItem(item);
        }

        function getFileExtension(fileName) {
            var result = /[.]/.exec(fileName) ? /[^.]+$/.exec(fileName)[0] : undefined;
            if (result) {
                result = (result + '').toLowerCase();
            }
            // console.log("getFileExtension,result:", result);
            return result;
        }
        //======Jquery====
        function Accordion() {
            $(document).off("click", ".accordion .title");

            $(document).on("click", ".accordion .title", function (j) {
                var dropDown = $(this).closest('.col-sm-12').find('p.acc-info');
                $(this).closest('.accordion').find('p.acc-info').not(dropDown).slideUp();

                if ($(this).hasClass('active')) {
                    $(this).removeClass('active');
                } else {
                    $(this).closest('.accordion').find('a.active').removeClass('active');
                    $(this).addClass('active');
                }

                dropDown.stop(false, true).slideToggle();

                j.preventDefault();
            });
        }

        function postToIos(item, url) {

            var ctmsSeekTime = parseInt(sessionStorage.getItem('CtmsSeekTime'));

            var param = {
                Command: 'playVideo',
                SessionId: angular.copy(vm.data.sessionItem.sessionId),
                ItemId: angular.copy(vm.data.studyActivity.itemId),
                LanguageCode: sessionStorage.getItem('userLang'),
                UserId: $rootScope.userInfo.userAccount,
                Tkn: sessionStorage.getItem('token'),
                FileUrl: url.replace("\\", "/"),
                CtmsTime: vm.data.ctmsTime, //訓練系統timeout 時數
                CtmsConfirmTime: vm.timeConfig.ctmsConfirmTime, //觀看影片時，如遇到timeout，會彈出一確認視窗，這時數就是確認視窗的倒數計時
                CtmsCourseTimeInterval: vm.data.ctmsCourseTimeInterval, //觀看影片固定回傳時隔
                CtmsSeekTime: !!ctmsSeekTime ? ctmsSeekTime : 0 //影片已觀看的秒數
            };
            console.log('postToIos:', param);
            //mobileService.postCourseInfo(param);
            window.webkit.messageHandlers.msgHandler.postMessage(JSON.stringify(param));
            //return param;
        }

        function setSession(item) {
            //console.log('setSession');
            sessionStorage.setItem('sessionId', angular.copy(vm.data.sessionItem.sessionId));
            sessionStorage.setItem('itemId', angular.copy(vm.data.studyActivity.itemId));
            sessionStorage.setItem('userId', $rootScope.userInfo.userAccount);
            sessionStorage.setItem('IsLearningRecordCommit', true);

            // sessionStorage.setItem('sessionId',1);
            // sessionStorage.setItem('itemId',2);
            // sessionStorage.setItem('userId',3);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app').controller('optionSelectorController', optionSelectorController);

    function optionSelectorController($rootScope, $scope, $uibModalInstance, keyValueList, titleTranslate, isCycle) {
        var vm = this;
        vm.cancel = cancel;
        vm.dataSelected = dataSelected;
        vm.title = titleTranslate;
        vm.isCycle = isCycle;
        onInit();
        $scope.list = GetList(keyValueList);

        function onInit() {
            dataInit();
        }

        function dataInit() {
            vm.isKeyValueList = false;
        }

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }

        function GetList(keyValueList) {
            //console.log('GetList:',keyValueList);
            var list = [];
            if (Object.prototype.isPrototypeOf(keyValueList[0]) && !vm.isCycle) {
                for (var i = 0; i <= keyValueList.length - 1; i++) {
                    list.push({ id: keyValueList[i].id, name: keyValueList[i].name });
                }
                vm.isKeyValueList = true;
                // console.log('result:',list);
                return list;
                //}else if(vm.isCycle){
                // for (var i = 0; i <= keyValueList.length - 1; i++) {
                //     list.push({ value: keyValueList[i].id, name: keyValueList[i].name });
                // }
                // vm.isKeyValueList = true;
                // console.log('result:',list);
                // return list;
            } else {
                //console.log('result:',keyValueList);
                return keyValueList;
            }
        }

        function dataSelected(data) {
            $uibModalInstance.close(data);
        }
    }
})();
'use strict';

(function () {
    'use strict';

    angular.module('app.directive').directive('taiAskExam', taiAskExam);

    function taiAskExam() {
        var directive = {
            bindToController: true,
            controllerAs: 'vm',
            controller: ControllerController,
            link: link,
            restrict: 'E',
            templateUrl: 'controller/tsun/training/myTraining/modal/taiAskExam.html',
            scope: {
                showView: '=',
                sessionId: '=',
                courseActiveItem: '='
            }
        };
        return directive;

        function link() {}
    }
    /* @ngInject */
    function ControllerController($rootScope, $scope, trainingInnerService, modalService, $q, $interval) {
        var vm = this;
        vm.submitExam = submitExam;
        vm.retryTest = retryTest;
        vm.reviewContent = reviewContent;
        vm.reviewResult = reviewResult;
        vm.countingTimeShowing = countingTimeShowing;
        init();
        //================
        function init() {
            $q.when(dataInit()).then(function () {});
            $scope.$watch('vm.showView', function (newValue) {
                // if (newValue === oldValue) { return; }
                if (vm.courseActiveItem && newValue) {
                    elementLoad();
                } else {
                    if (vm.countingSecsInterval) {
                        $interval.cancel(vm.countingSecsInterval);
                    }
                }
            });
        }

        function dataInit() {
            //該頁會使用變數都在這裡
            vm.view = {
                show: false, //............這個元件是否應該顯示
                content: false, //..........試題頁
                examInfo: false, //.........測驗額外資訊
                result: false, //...........測驗回傳結果
                resultTest: false, //.......回傳結果顯示頁面(測試)
                resultQuest: false, //......回傳結果顯示頁面(問卷)
                dataLoadSucess: false, //...畫面讀取成功
                dataLoadFail: false, //.....畫面讀取失敗
                hasSubmit: false, //........是否送出過
                canRetry: false //.........是否能重新受測
            };
            vm.importData = {
                //為避免雙向綁定造成的一些狀況，要將來源資料保存
                courseActiveItem: null,
                sessionId: null
            };
            vm.data = {
                countingSecs: 0,
                examContent: null,
                examContentGroup: null,
                examContentRefer: null,
                result: null
            };
            vm.courseActiveItem = vm.courseActiveItem || null;
            vm.sessionId = vm.sessionId || null;
            vm.showView = vm.showView || false;
            if (vm.countingSecsInterval) {
                $interval.cancel(vm.countingSecsInterval);
            }
        }

        function elementLoad() {
            $q.when(dataInit()).then(function () {
                if (!vm.courseActiveItem || !vm.sessionId) {
                    return;
                }
                if (vm.courseActiveItem.type !== "測驗" && vm.courseActiveItem.type !== "問卷") {
                    return;
                }
                vm.view.show = true;
                vm.importData.courseActiveItem = angular.copy(vm.courseActiveItem);
                vm.importData.sessionId = angular.copy(vm.sessionId);
                //=====
                var examItemOrder;
                trainingInnerService.getExamSurveyContent(vm.importData.sessionId, vm.importData.courseActiveItem).then(function (data) {
                    if (!data) {
                        vm.view.dataLoadFail = true;
                        return;
                    }
                    vm.data.examContent = data;
                    vm.data.examContent.limitTimesText = limitTimesFormat(vm.data.examContent.limitTimes);
                    if (vm.data.examContent.remainingTimes > vm.data.examContent.limitTimes) {
                        vm.data.examContent.remainingTimes = vm.data.examContent.limitTimes;
                    }
                    if (vm.courseActiveItem.type === "測驗") {
                        vm.view.examInfo = true;
                    }
                    if (vm.data.examContent.remainingMins > 0) {
                        vm.countingSecsInterval = $interval(function () {
                            if (vm.data.countingSecs < 1) {
                                vm.data.countingSecs = 0;
                                submitExam(true, true);
                            } else {
                                vm.data.countingSecs--;
                            }
                        }, 1000);
                    }
                    vm.data.countingSecs = remainingMinsFormat(vm.data.examContent.remainingMins);
                    vm.view.content = true;
                    vm.view.canRetry = vm.data.examContent.remainingTimes < 0 || vm.data.examContent.remainingTimes > 1;
                    vm.data.examContentRefer = {}; // 作為類似DIctionary的索引
                    vm.data.examContentGroup = _.chain(vm.data.examContent.questions).groupBy("groupName").map(function (examList) {
                        examItemOrder = 1;
                        _.forEach(examList, function (examItem) {
                            //===索引製作===
                            if (!vm.data.examContentRefer[examItem.questionId]) {
                                vm.data.examContentRefer[examItem.questionId] = [];
                            }
                            vm.data.examContentRefer[examItem.questionId].push(examItem);
                            //=============
                            //===自訂屬性===
                            examItem.order = examItemOrder++;
                            examItem.value = null;
                            examItem.typeText = '';
                            examItem.isCorrect = null;
                            examItem.showOrder = false;
                            examItem.choiceStyle = {
                                Line: false,
                                Layer: false
                            };
                            _.forEach(examItem.options, function (optionItem) {
                                optionItem.textValue = ''; //..........專門給選擇題帶問答區塊使用(像是其他)
                                optionItem.preTitle = false; //........標題是否要前置
                                optionItem.correctAnswer = null; //....代表為正確答案
                            });
                            //=============
                            switch (examItem.questionType) {
                                case 2:
                                    //複選
                                    examItem.choiceStyle.Layer = true;
                                    examItem.typeText = $rootScope.translate.tsunTestTypeMulti;
                                    if (!examItem.options) {
                                        break;
                                    }
                                    examItem.value = [null]; //預設位置0為NULL(因為照ORDER處理)
                                    // _.forEach(examItem.options, function (optionItem) {
                                    //     if (optionItem.value) {
                                    //         examItem.value[optionItem.order] = true;
                                    //     }
                                    //     else {
                                    //         examItem.value[optionItem.order] = false;
                                    //     }
                                    // });
                                    break;
                                case 3:
                                    //問答
                                    examItem.choiceStyle.Layer = true;
                                    examItem.typeText = $rootScope.translate.tsunTestTypeEssay;
                                    examItem.value = "";
                                    // if (examItem.options.length > 0) {
                                    //     examItem.value = examItem.options[0].value;
                                    // }
                                    break;
                                case 7:
                                    //填充
                                    examItem.choiceStyle.Layer = true;
                                    examItem.typeText = $rootScope.translate.tsunTestTypeBlankFill;
                                    examItem.value = "";
                                    // if (examItem.options.length > 0) {
                                    //     examItem.value = examItem.options[0].value;
                                    // }
                                    break;
                                case 1:
                                case 6:
                                    //單選
                                    //是非題
                                    examItem.choiceStyle.Layer = true;
                                    examItem.typeText = $rootScope.translate.tsunTestTypeSingle;
                                    examItem.value = 0;
                                    // _.forEach(examItem.options, function (optionItem) {
                                    //     if (examItem.value < 1 && optionItem.value && optionItem.order > 0) {
                                    //         examItem.value = optionItem.order;
                                    //     }
                                    // });
                                    break;
                                case 4:
                                case 5:
                                    examItem.showOrder = true;
                                    examItem.options[0].preTitle = true;
                                    examItem.choiceStyle.Line = true;
                                    examItem.typeText = '';
                                    examItem.value = 0;
                                    // _.forEach(examItem.options, function (optionItem) {
                                    //     if (examItem.value < 1 && optionItem.value && optionItem.order > 0) {
                                    //         examItem.value = optionItem.order;
                                    //     }
                                    // });
                                    break;
                                default:
                                    //其餘
                                    examItem.choiceStyle.Line = true;
                                    examItem.typeText = '';
                                    examItem.value = 0;
                                    // _.forEach(examItem.options, function (optionItem) {
                                    //     if (examItem.value < 1 && optionItem.value && optionItem.order > 0) {
                                    //         examItem.value = optionItem.order;
                                    //     }
                                    // });
                                    break;
                            }
                        });
                        return {
                            'key': examList[0].groupName,
                            'value': examList
                        };
                    }).value();
                    vm.view.dataLoadSucess = true;

                    // 解決表單有時在IE無法輸入問題
                    fixIeNotAbleToInput('.modal');
                });
            });
        }

        function countingTimeShowing(timeSpan) {
            if (timeSpan !== parseInt(timeSpan, 10)) {
                //如果有特別顯示字樣就不處理了。
                return timeSpan;
            }
            var sec_num;
            try {
                sec_num = parseInt(timeSpan, 10); // don't forget the second param
            } catch (exp) {
                sec_num = 0;
            }
            var minutes = Math.floor(sec_num / 60);
            var seconds = sec_num - minutes * 60;
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }
            return minutes + ':' + seconds;
        }

        function submitExam(finish, forceSubmit) {
            if (!finish) {
                return;
            }
            if (vm.countingSecsInterval) {
                $interval.cancel(vm.countingSecsInterval);
            }
            var itemType;
            var questRequiredUnAnswer = '';
            var questRequiredUnAnswerPerGroup = {};
            var questUnAnswer = '';
            var questUnAnswerPerGroup = {};
            var strEmptyGroupName = '';
            var otherAns = ''; // 其他答案的自填答案
            itemType = vm.importData.courseActiveItem ? vm.importData.courseActiveItem.type : '';
            vm.data.examContent.finish = finish ? 1 : 0;
            vm.data.examContent.answers = [];
            _.forEach(vm.data.examContent.questions, function (examItem) {

                if (!examItem.groupName || examItem.groupName.lenght < 1) {
                    examItem.groupName = strEmptyGroupName;
                }
                var perAnswer = '';
                var examItemAnswer = '';
                if (angular.isArray(examItem.value)) {
                    _.forEach(examItem.value, function (value, valueIndex) {
                        //console.log('examItem:', examItem);
                        if (value && valueIndex > 0) {
                            if (examItemAnswer) {
                                examItemAnswer += ',';
                            }
                            examItemAnswer += valueIndex;
                        }
                    });
                    //加上其他答案(複選)
                    if (examItem.options[examItem.options.length - 1].textValue) {
                        otherAns = examItem.options[examItem.options.length - 1].textValue;
                        examItemAnswer += ',clOtherAnswer=' + otherAns;
                    }
                    if (!examItemAnswer) {
                        examItemAnswer = 0;
                    }
                    //console.log('examItemAnswer:', examItemAnswer);
                } else {
                    examItemAnswer = angular.copy(examItem.value);
                    //加上其他答案 (單選)
                    if (examItem.options[examItem.options.length - 1].textValue) {
                        otherAns = examItem.options[examItem.options.length - 1].textValue;
                        examItemAnswer += ',clOtherAnswer=' + otherAns;
                    }
                    //console.log('examItem22:', examItemAnswer);
                }
                //console.log("exam order:", examItem.order, ".....examItemAnswer:", examItemAnswer);
                if (!examItemAnswer || examItemAnswer.length < 1) {
                    examItemAnswer = '0';
                    if (examItem.questionType === 3 || examItem.questionType === 7) {
                        examItemAnswer = '\0';
                    }
                    if (examItem.required) {
                        if (!questRequiredUnAnswerPerGroup[examItem.groupName]) {
                            questRequiredUnAnswerPerGroup[examItem.groupName] = '';
                        }
                        if (questRequiredUnAnswerPerGroup[examItem.groupName].length > 0) {
                            questRequiredUnAnswerPerGroup[examItem.groupName] += ',';
                        }
                        questRequiredUnAnswerPerGroup[examItem.groupName] += examItem.order;
                    } else {
                        if (!questUnAnswerPerGroup[examItem.groupName]) {
                            questUnAnswerPerGroup[examItem.groupName] = '';
                        }
                        if (questUnAnswerPerGroup[examItem.groupName].length > 0) {
                            questUnAnswerPerGroup[examItem.groupName] += ',';
                        }
                        questUnAnswerPerGroup[examItem.groupName] += examItem.order;
                    }
                }
                if (examItemAnswer) {
                    perAnswer = examItemAnswer;
                    perAnswer = examItem.questionId + "_" + perAnswer;
                }
                if (perAnswer) {
                    vm.data.examContent.answers.push(perAnswer);
                }
            });
            //======必填欄位驗證
            _.forEach(questRequiredUnAnswerPerGroup, function (value, key) {
                if (key.lenght > 0) {
                    questRequiredUnAnswer += key + ':';
                }
                questRequiredUnAnswer += value + '\n';
            });
            if (questRequiredUnAnswer.length > 0 && vm.data.examContent.finish === 1 && !forceSubmit) {
                toastr.warning($rootScope.translate.tsunTest + '\n' + questRequiredUnAnswer + $rootScope.translate.tsunTestRequiredAlert);
                return;
            }
            //=====未填欄位確認
            _.forEach(questUnAnswerPerGroup, function (value, key) {
                if (key.lenght > 0) {
                    questUnAnswer += key + ':';
                }
                questUnAnswer += value + '\n';
            });

            vm.data.examContent.activeItemtype = itemType; //TODO 這邊加入是為了測試環境的簡單互動，若要移除測試環境時可以將此行拿掉。
            if (questUnAnswer.length > 0 && vm.data.examContent.finish === 1 && !forceSubmit) {

                var confirmDialog = modalService.confrimDialog({
                    confirmContent: $rootScope.translate.tsunTest + '\n' + questUnAnswer + $rootScope.translate.tsunTestComfirm
                });
                confirmDialog.result.then(function (result) {
                    result = !!result;
                    if (result !== true) {
                        return;
                    }
                    return postExamSurveyContent(finish, itemType);
                });
            } else {
                return postExamSurveyContent(finish, itemType);
            }
        }

        function postExamSurveyContent(finish, itemType) {
            console.log("examContent :", vm.data.examContent);
            var resultPost = trainingInnerService.postExamSurveyContent(vm.importData.sessionId, vm.data.examContent);
            return resultPost.then(function (result) {
                console.log("postExamSurveyContent result:", result);
                if (!result) {
                    return;
                }
                vm.data.result = result;
                viewShowContentFormat();
                vm.view.hasSubmit = true;
                vm.view.examInfo = false;

                // 問卷後續會 emit 報名課程作業，因此由那邊顯示成功或失敗訊息即可
                if (finish && itemType === '測驗') {
                    console.log('yo-postExamSurveyContent:', result);
                    //應台新要求將發送成功的訊息拿掉
                    //toastr.success($rootScope.translate.tsunSendSuccess); 
                }

                if (itemType === '測驗') {
                    vm.view.resultTest = true;
                }
                if (itemType === '問卷') {
                    vm.view.resultQuest = true;
                }
                if (itemType === '測驗' && vm.data.examContent.finish === 1) {
                    vm.view.result = true;
                    //測驗結果顯示
                    _.forEach(vm.data.result.questionResults, function (resultItem) {
                        var referData;
                        //===資料檢核===
                        if (!vm.data.examContentRefer[resultItem.questionId]) {
                            return;
                        }
                        if (!angular.isArray(vm.data.examContentRefer[resultItem.questionId])) {
                            return;
                        }
                        //=============
                        referData = vm.data.examContentRefer[resultItem.questionId];
                        _.forEach(referData, function (examItem) {
                            var resultCorrectAnswerForMulti = resultItem.correctAnswer.split(',');
                            examItem.isCorrect = resultItem.correctAnswer === resultItem.studentAnswer;
                            examItem.value = null;
                            //=====處理學生填答=====
                            if (examItem.questionType === 3 || examItem.questionType === 7) {
                                examItem.value = resultItem.studentAnswer;
                            } else if (examItem.questionType === 2) {
                                var resultStudentAnswer = resultItem.studentAnswer.split(',');
                                examItem.value = [];
                                _.forEach(resultStudentAnswer, function (answerItem) {
                                    examItem.value[answerItem] = true;
                                });
                            } else {
                                examItem.value = resultItem.studentAnswer;
                            }
                            //===================
                            //=====正確答案處理=====
                            //若resultItem.correctAnswer為空應該就是沒有正確答案 = 不用處理
                            if (resultItem.correctAnswer.length < 1) {
                                return;
                            }
                            _.forEach(examItem.options, function (optionItem) {
                                var optionOrder = optionItem.order + '';

                                if (examItem.questionType === 3 || examItem.questionType === 7) {
                                    // 移除此行避免用戶輸入的資料變成正確資料
                                    // examItem.value = resultItem.correctAnswer;
                                    optionItem.correctAnswer = resultItem.correctAnswer;
                                    //console.log('examItem:', examItem);
                                } else if (examItem.questionType === 2) {
                                    _.forEach(resultCorrectAnswerForMulti, function (answerItem) {
                                        //console.log('answerItem:',answerItem);
                                        //optionItem.correctAnswer = false; //
                                        if (optionOrder === answerItem) {
                                            optionItem.correctAnswer = true;
                                        }
                                    });
                                } else {
                                    optionItem.correctAnswer = optionOrder === resultItem.correctAnswer;
                                }
                            });

                            //=====================
                        });
                    });
                }

                // 觸發 emitExamSubmit 執行報名作業
                // courseDetailModalController enroll
                $scope.$emit('emitExamSubmit', '');
            });
        }

        function viewShowContentFormat() {
            vm.view.resultTest = false;
            vm.view.resultQuest = false;
            vm.view.content = false;
        }

        function retryTest() {
            elementLoad();
            $scope.$emit('goTop', '');
        }

        function reviewContent() {
            viewShowContentFormat();
            vm.view.content = true;
        }

        function reviewResult() {
            viewShowContentFormat();
            vm.view.resultTest = true;
        }

        function limitTimesFormat(times) {
            var result = times;
            if (parseInt(times) < 0) {
                result = $rootScope.translate.tsunNoLimit;
            }
            return result;
        }

        function remainingMinsFormat(remainMins) {
            var result = '';
            if (remainMins > -1) {
                result = remainMins;
            } else {
                result = $rootScope.translate.tsunNoLimit;
            }
            return result;
        }
    }
})();